/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Emitted by tools/generate-api-client.mjs (generator 1.0.0) from the
 * pinned OpenAPI document src/api/spec/openapi.json, spec version 0.129.0.
 *
 * 12-development-plan §2.4 control 2: the client is generated from a named spec version,
 * committed, and bumped by an explicit pull request. `npm run api:check` fails the build
 * when this file no longer reproduces from the pinned spec, so a hand edit here is not a
 * shortcut — it is a build failure with your name on it.
 */

import type {
  AbsenceVocabulary,
  ActivityAction,
  ActivityApp,
  ActivityPage,
  AdoptionReceipt,
  AdoptionRequest,
  AlertAssignees,
  AlertAssignmentRequest,
  AlertDepartmentFamilies,
  AlertDispositionRequest,
  AlertDispositionSummary,
  AlertEventSummary,
  AlertGroupActionRequest,
  AlertGroupActionResult,
  AlertGroupDimension,
  AlertGroupPage,
  AlertOrder,
  AlertPage,
  AlertPrecisionReport,
  AlertQueue,
  AlertReasonOption,
  AlertReopenRequest,
  AlertSnoozeRequest,
  AlertState,
  AllocateRequestModel,
  AllocateResponseModel,
  AnalogueRequest,
  AnalogueStripResponse,
  AppendVersionRequest,
  ApprovalOutcome,
  ApprovalRequest,
  AssembledMarkdownFrontier,
  AssembledMarkdownPath,
  AssistantStatus,
  AttributesRequest,
  AttributesResponseModel,
  AuthorReply,
  BaselineReconciliation,
  BridgeRequest,
  BridgeResponse,
  BulkActionSummary,
  BulkApproveRequest,
  BulkDispositionRequestModel,
  BulkDispositionResponseModel,
  BuyDiagnoseRequest,
  BuyDiagnoseResponse,
  CadenceDisposition,
  CadenceOverrideRequest,
  CalendarReceipt,
  CampaignResponseView,
  CampaignResultsView,
  CampaignSimulationRequest,
  CampaignSimulationView,
  CandidateQueueRequest,
  CandidateQueueResponse,
  CapabilitiesResponse,
  CascadeRequest,
  CascadeResponse,
  CellsSummaryResponse,
  ChangeReceipt,
  ClosureReasonOption,
  ClosureRequest,
  ClusterSchemeAcceptance,
  CommitGuardRequest,
  CommitGuardResponse,
  CompactionRequest,
  CompactionResponse,
  ConfirmationReceipt,
  ConfirmationRequest,
  ConsolidationDecisionPage,
  ConsolidationDispositionRequest,
  ConsolidationDispositionSummary,
  ConsolidationDoorPage,
  ConsolidationLinePage,
  ConsolidationResidualDistribution,
  ConsolidationRunDigestSummary,
  ControlTotalsResponse,
  CostToServeRequest,
  CostToServeResponse,
  CreatePlanRequest,
  CreatePlanResponse,
  CreateScenarioRequest,
  CursorPageAccuracyRow,
  CursorPageAlertEventSummary,
  CursorPageAllocationVersionModel,
  CursorPageAttributeHoldoutRow,
  CursorPageAttributeIndexRow,
  CursorPageAutonomySummary,
  CursorPageBenefitMeasurement,
  CursorPageBuyLineSummary,
  CursorPageCadenceProposalSummary,
  CursorPageCampaignSimulationView,
  CursorPageCapacityConfirmationRow,
  CursorPageCellReportRow,
  CursorPageChangeItemRow,
  CursorPageChangeSetSummary,
  CursorPageClusterDemandShapePoint,
  CursorPageClusterMembershipSummary,
  CursorPageClusterSchemeSummary,
  CursorPageConsolidationLaneOptionSummary,
  CursorPageConsolidationOptionSummary,
  CursorPageConsolidationReportRow,
  CursorPageConsolidationRunSummary,
  CursorPageCoreRunCoverageRow,
  CursorPageCostToServeRow,
  CursorPageCycleRow,
  CursorPageCycleRunSummary,
  CursorPageD4EvidenceRow,
  CursorPageDeclaredCapacityRow,
  CursorPageDefinitionRow,
  CursorPageDemandGapRow,
  CursorPageDriverContribution,
  CursorPageElasticityEstimate,
  CursorPageElasticityRefusal,
  CursorPageEntryView,
  CursorPageEnvelopeRow,
  CursorPageExceptionSummary,
  CursorPageExitPlanSummary,
  CursorPageExitSimulationView,
  CursorPageFeedCertificationState,
  CursorPageFeedStatus,
  CursorPageFeedbackReport,
  CursorPageFitSummaryView,
  CursorPageFootprintOptionRow,
  CursorPageGateD2EvidenceRow,
  CursorPageGateState,
  CursorPageHandoverReadinessSummary,
  CursorPageHierarchyNodeGrantValue,
  CursorPageHoldoutView,
  CursorPageLadderInForce,
  CursorPageLadderVersionView,
  CursorPageLaunchOptionModel,
  CursorPageLifecyclePhaseModel,
  CursorPageLifecycleProjection,
  CursorPageLocalisationCell,
  CursorPageLostSalesPotentialRow,
  CursorPageMaterialDecisionSummary,
  CursorPageMeasureSummary,
  CursorPageMeioPolicySummary,
  CursorPageMoveCapDeferral,
  CursorPageMoveRunSimulationView,
  CursorPageMoveRunSummary,
  CursorPageNodeSummary,
  CursorPageOpenPositionSummary,
  CursorPageOptionEconomicsSummary,
  CursorPageOptionPlanSummary,
  CursorPageOutletRecommendationModel,
  CursorPageOutletRunModel,
  CursorPageOutletTransferItemModel,
  CursorPageOutletTransferRunModel,
  CursorPageOverridePairRow,
  CursorPageOverrideRate,
  CursorPageParameterKeyEntry,
  CursorPageParameterRow,
  CursorPageParameterSummary,
  CursorPageParameterVersion,
  CursorPagePeriodPlanTerms,
  CursorPagePeriodVersionView,
  CursorPagePlanVersionSummary,
  CursorPagePositionRefusalRow,
  CursorPagePriceActionSummary,
  CursorPagePricingReportRow,
  CursorPagePromotionRow,
  CursorPageProposalModel,
  CursorPageRecoveryCoverageRow,
  CursorPageRecoveryRunRow,
  CursorPageRecoveryScoreRow,
  CursorPageRefreshRow,
  CursorPageReplenishmentReportRow,
  CursorPageReservationRow,
  CursorPageReturnDispositionSummary,
  CursorPageRouteRealisation,
  CursorPageRoutingSummary,
  CursorPageRuleSummary,
  CursorPageRunConfiguration,
  CursorPageRunConfigurationVersion,
  CursorPageScenarioSummary,
  CursorPageSchemeSummary,
  CursorPageScopeValueRow,
  CursorPageScorecardRow,
  CursorPageSeasonReviewRow,
  CursorPageSeasonRow,
  CursorPageSellProbabilityRow,
  CursorPageServiceExchangeRunSummary,
  CursorPageShadowSeasonCount,
  CursorPageSimulationView,
  CursorPageSizeAvailabilityCell,
  CursorPageSizeCurveSummary,
  CursorPageStateCensusRow,
  CursorPageStockPositionSummary,
  CursorPageStoredIndifference,
  CursorPageStoredPosition,
  CursorPageStoredStrandedLot,
  CursorPageSupplierReservationRow,
  CursorPageSupplierScorecardRow,
  CursorPageSupplyScenarioSummary,
  CursorPageTerminalPositionSummary,
  CursorPageTransferExplanationReportRow,
  CursorPageTransferMoveDiff,
  CursorPageTransferReportRow,
  CursorPageTransferSummary,
  CursorPageTransitionRecommendationModel,
  CursorPageTransitionRunModel,
  CursorPageTriageReport,
  CursorPageUncoveredReportRow,
  CursorPageUnforecastSizeRow,
  CursorPageUnsignedPlanSummary,
  CursorPageWaveState,
  CursorPageWithdrawalItemModel,
  CursorPageWithdrawalRunModel,
  CursorPageWriteBackState,
  CycleRunsResponse,
  DecisionSummary,
  DemandPanelResponse,
  DepletionRateRequest,
  DepletionRateResponse,
  DiagnoseRequest,
  DispositionOption,
  DispositionReasonModel,
  DispositionRequest,
  DispositionSummary,
  DoorAvailabilityModel,
  DoorSubcategoriesModel,
  DoubleCountedPartitionView,
  DueRunsView,
  EffectiveParameter,
  ElasticityBand,
  ElasticityModelVersion,
  EntryDetailView,
  EnvelopeRequest,
  EnvelopeResponse,
  ExceptionRuleSummary,
  ExecutionPack,
  ExitPlanSummary,
  ExitSimulationRequest,
  ExitSimulationView,
  ExpiringParameters,
  FeedCertificationState,
  FeedContractReportRequest,
  FeedContractReportResponse,
  FeedSequenceResponse,
  FeedbackDetail,
  FeedbackKind,
  FeedbackReport,
  FeedbackRequest,
  FeedbackStatus,
  FiledVia,
  FilingOutcome,
  FilingRequest,
  FilterDispositionRequest,
  FilterDispositionSummary,
  ForecastBasisSummary,
  ForecastExplanationSummary,
  GapReport,
  HealthGroupBy,
  HealthReportModel,
  HealthResponse,
  HierarchySchemeDelivery,
  HorizonRequest,
  HorizonResponse,
  ImportCalendarRequest,
  ImportResultView,
  InSeasonRunDigest,
  IndifferenceRequest,
  IndifferenceResponse,
  InfeasibilityResponse,
  JobRunPage,
  JobRunRequest,
  JobRunView,
  LandingBatchStatusResponse,
  LandingResponse,
  LaneEconomicsRequest,
  LaneEconomicsResponse,
  LaneExplanationSummary,
  LaneRankingRequest,
  LaneRankingResponse,
  LaneReasonCodes,
  LatestRecoveryRunResponse,
  LifecyclePhaseHistoryModel,
  LifecyclePhaseSummaryModel,
  LookupRequest,
  LookupResponseModel,
  MarkdownRegistryValue,
  MarkdownRequest,
  MarkdownResponse,
  MarketExecutionPack,
  MeCapabilities,
  MessageOutcome,
  ModulesResponse,
  MonthlyReport,
  MonthlyReportMonth,
  MoveCapDeferralSummary,
  MoveCapStage,
  MoveLedgerPage,
  MoveLineDispositionRequest,
  MoveLineDispositionSummary,
  MoveListPage,
  MoveRunExportKind,
  MoveRunReportView,
  MoveRunSimulationRelaunch,
  MoveRunSimulationRequest,
  MoveRunSimulationView,
  MoveRunWorkbook,
  MoveState,
  MoveStockOwner,
  MoveWhyView,
  NetworkHealthDimension,
  NetworkHealthPage,
  NetworkHealthSizes,
  NetworkHealthState,
  ObjectiveAuditResponse,
  ObjectiveKind,
  OtbRequest,
  OtbResponse,
  OutboxAcknowledgementRequest,
  OutboxAcknowledgementView,
  OutboxBatchPage,
  OutboxEventPage,
  OutboxManifestPage,
  OutletDecisionReasonsModel,
  OutletDispositionRequest,
  OutletDispositionResponse,
  OutletRecommendationEvidenceModel,
  OverlayKeysView,
  OverrideOutcomes,
  PackStateFilter,
  ParameterSetSummary,
  ParametersInForceSummary,
  PenaltyBasis,
  PlanVersionSummary,
  PreviewRequest,
  PreviewView,
  PriceActionDispositionRequest,
  PriceActionDispositionSummary,
  PriceEditRequest,
  PriceEditResponse,
  PricePathsResponse,
  PriceReasonOption,
  PriceStepExplanationSummary,
  ProcessCalendarView,
  ProductImageReferences,
  ProductImageSet,
  ProductImageSets,
  ProfilePreferencesInput,
  ProgrammeSummary,
  ProjectionRequest,
  ProjectionResponse,
  PromoteRequest,
  PromotedBatchResponse,
  PromotionCalendarModel,
  PromotionMechanicsModel,
  PromotionWindowsModel,
  ProposalGroupsResponse,
  ProposalPage,
  ProposalReasonOption,
  ProposalsByDoorSizeResponse,
  ProposeCalendarRequest,
  ProposeExceptionRulesRequest,
  ProposeLadderRequest,
  ProposeObjectiveRequest,
  ProposeRequest,
  ProposeRunScopeRequest,
  QueueDepthModel,
  RankedPriceStepsResponse,
  RankedProposalsResponse,
  RankedTransfersResponse,
  RebalanceSummary,
  RecomputeRequest,
  RecomputeResponse,
  ReconcileRequest,
  ReconcileResponse,
  RecoveryCoverageOrder,
  RecoveryRequest,
  RecoveryResponse,
  RecoverySeasonTotalResponse,
  RelaunchAdmission,
  ReplenishmentByStorePage,
  ReviewSummaryRequest,
  RouteLotRequest,
  RoutingSummary,
  RunConfiguration,
  RunConfigurationCreate,
  RunConfigurationRevision,
  RunConfigurationVersion,
  RunNamesResponse,
  RunProvenanceSummary,
  RunSalesHistory,
  RunScopeChangeView,
  RunScopeReceipt,
  RunScopeRunView,
  RunSurface,
  SalesHistory,
  SalesHistoryGrain,
  SandboxRequest,
  ScenarioSummary,
  ScheduleStateRequest,
  ScheduleStateResponse,
  SchedulesResponse,
  ScopeArticlesView,
  ScopeCountView,
  ScopeOptionsView,
  ScorecardComponentsResponse,
  SeasonReviewRow,
  SelectionPreview,
  SelectionQueue,
  ServiceExchangeModel,
  SimulationComparisonView,
  SimulationRequest,
  SimulationRowsView,
  SimulationValuesView,
  SimulationView,
  SizeCurveApplyRequest,
  SizeCurveApplyResponse,
  SizeRunReportModel,
  StockByPairResponse,
  StockByStorePage,
  StockSummary,
  StoredCandidateQueue,
  StrandedCountResponse,
  StrandedRequest,
  StrandedResponse,
  TariffScenarioRequest,
  TariffScenarioResponse,
  TeamMessage,
  TemplateView,
  TerminalStockRequest,
  TerminalStockResponse,
  TradeOffRequest,
  TradeOffResponse,
  TransferDispositionRequest,
  TransferDispositionSummary,
  TransferExplanationSummary,
  TransferReasonOption,
  TransfersByStorePage,
  TransitionDecisionReasonsModel,
  TransitionDispositionRequest,
  TransitionDispositionResponse,
  TransitionRecommendationEvidenceModel,
  TriageDetail,
  TriageOutcome,
  TriageRequest,
  TurnLog,
  TurnRequest,
  TurnResponse,
  UncoveredPairsPage,
  UnitsSentReportModel,
  UserActionPage,
  UserActivityPage,
  UserActivitySort,
  UserLastAccessList,
  UserProfile,
  UserSessionPage,
  VarianceRequest,
  VarianceResponse,
  VersionResponse,
  VocabulariesView,
  VocabularyTermsResponse,
  WhereUsedView,
  WindowArticlesModel,
  WindowDoorsModel,
  WorkCounts,
  WriteBackCancellationRequest,
  WriteBackConfirmationRequest,
  WriteBackConfirmationSummary,
  WriteBackGroupDimension,
  WriteBackGroupPage,
  WriteBackGroupTransitionRequest,
  WriteBackGroupTransitionResult,
  WriteBackStateCode,
  WriteBackSubjectKind,
  WriteBackSummary,
  WriteBackTransitionRequest,
  WriteBackTransitionSummary,
} from './types';

/** HTTP methods this spec uses. */
export type HttpMethod = "DELETE" | "GET" | "PATCH" | "POST" | "PUT";

/**
 * One operation, as data.
 *
 * A descriptor carries no behaviour: it names the method, the URL template, which
 * parameters go where, and whether there is a body. `src/api/http.ts` executes it. That
 * split is what lets this whole file be regenerated without overwriting a decision —
 * every transport decision (base URL, Accept-Language, Idempotency-Key, the RFC 9457
 * parse, cursor pagination) lives in the hand-written transport, which has no
 * per-endpoint code to drift.
 */
export interface OperationDescriptor {
  readonly operationId: string;
  readonly method: HttpMethod;
  /** URL template with `{name}` placeholders for the path parameters. */
  readonly path: string;
  /** The router that owns it. */
  readonly tag: string;
  readonly pathParams: readonly string[];
  readonly queryParams: readonly string[];
  readonly hasBody: boolean;
}

/**
 * A descriptor that also carries its parameter and result types.
 *
 * `params` and `result` are phantom: they exist to carry the types and are never read
 * at runtime, which is why both are optional and neither is ever assigned.
 */
export interface OperationSpec<TParams, TResult> extends OperationDescriptor {
  readonly params?: TParams;
  readonly result?: TResult;
}

/** The parameter object an operation takes. */
export type ParamsOf<S> = S extends { readonly params?: infer P } ? P : never;

/** What an operation resolves to. */
export type ResultOf<S> = S extends { readonly result?: infer R } ? R : never;

/** `POST /api/v1/preseason/cluster-schemes/{scheme_id}/{version_id}/acceptance` — Accept Cluster Scheme — Accept a fitted cluster scheme version: freeze it and publish it (ADR 4002). docs/17 P1: the scheme owner accepts a fit only after the reqs/07 §3.3 discrimination test passes and full door coverage is asserted, and acceptance sets ``frozen``. Both checks are the ones the fit recorded; this route recomputes neither. Accepting also writes the version as an inert M5 location hierarchy, so the frozen membership is reachable through the hierarchy model (ADR 0031) without a second fit. Refused with 404 for a version not in the caller's markets, 409 ``cluster_scheme_frozen`` for one already frozen, and 409 ``cluster_scheme_checks_failed`` (``failingChecks``) for one whose checks are missing or failed. Authorised as ``plan_version`` / ``approve``. */
export type AcceptClusterSchemeParams = {
  readonly path: {
    readonly scheme_id: string;
    readonly version_id: string;
  };
};

/** `POST /api/v1/preseason/cluster-schemes/{scheme_id}/{version_id}/acceptance` */
export const acceptClusterScheme: OperationSpec<AcceptClusterSchemeParams, ClusterSchemeAcceptance> = {
  operationId: "accept_cluster_scheme_api_v1_preseason_cluster_schemes__scheme_id___version_id__acceptance_post",
  method: "POST",
  path: "/api/v1/preseason/cluster-schemes/{scheme_id}/{version_id}/acceptance",
  tag: "preseason",
  pathParams: ["scheme_id", "version_id"],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/outbox/batches/{batch_id}/acknowledgement` — Acknowledge Batch — Record that the subscriber holds a published batch whole (ADR 1011). Accepted only when the subscriber's checksum, row count and control totals are the batch's own, so the row is a proof and not a claim. The retention prune deletes nothing an acknowledgement does not cover. Repeating an acknowledgement that matches the recorded one answers it and writes nothing; one that differs is refused. */
export type AcknowledgeBatchParams = {
  readonly path: {
    readonly batch_id: string;
  };
  readonly body: OutboxAcknowledgementRequest;
};

/** `POST /api/v1/outbox/batches/{batch_id}/acknowledgement` */
export const acknowledgeBatch: OperationSpec<AcknowledgeBatchParams, OutboxAcknowledgementView> = {
  operationId: "acknowledge_batch_api_v1_outbox_batches__batch_id__acknowledgement_post",
  method: "POST",
  path: "/api/v1/outbox/batches/{batch_id}/acknowledgement",
  tag: "outbox",
  pathParams: ["batch_id"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/simulations/{simulation_id}/adopt` — Adopt Simulation — Propose the overlay as a parameter change set — step one of two, never a write. Composed through ``POST /registry/changes``' own seam, under the caller's own ``propose`` grant on the registry, with change id ``simulation.<id>``: a second adoption of one simulation is that route's 409. The set lands in pending approvals; nothing reaches the registry until somebody else approves it. **One scope (W2-8, ADR 6046).** Each overlaid key is proposed at ``scope`` only — the estate row by default — and the answer lists the rows of those keys at other scopes that stay in force, and whether each still overrides the adopted value. */
export type AdoptSimulationParams = {
  readonly path: {
    readonly simulation_id: string;
  };
  readonly body: AdoptionRequest;
};

/** `POST /api/v1/inseason/simulations/{simulation_id}/adopt` */
export const adoptSimulation: OperationSpec<AdoptSimulationParams, AdoptionReceipt> = {
  operationId: "adopt_simulation_api_v1_inseason_simulations__simulation_id__adopt_post",
  method: "POST",
  path: "/api/v1/inseason/simulations/{simulation_id}/adopt",
  tag: "inseason",
  pathParams: ["simulation_id"],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/foundations/exceptions/{alert_id}/history` — Alert History — One alert's append-only event log, oldest first (ADR 2102). Scope-rewritten on the alert's country: an alert outside the caller's scope, or absent, has an empty history — one answer for both (G3.3). */
export type AlertHistoryParams = {
  readonly path: {
    readonly alert_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/foundations/exceptions/{alert_id}/history` */
export const alertHistory: OperationSpec<AlertHistoryParams, CursorPageAlertEventSummary> = {
  operationId: "alert_history_api_v1_foundations_exceptions__alert_id__history_get",
  method: "GET",
  path: "/api/v1/foundations/exceptions/{alert_id}/history",
  tag: "foundations",
  pathParams: ["alert_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/foundations/exceptions/reason-codes` — Alert Reason Vocabulary — The reason codes a planner may record against an alert decision, with prose. ``reasonCode`` is mandatory on ``POST /foundations/exceptions/{alertId}/dispositions``; this is where a caller fills it from (:mod:`planning.exception.reasons`). Prose is resolved against ``Accept-Language`` on ADR 0057's terms. */
export type AlertReasonVocabularyParams = Record<string, never>;

/** `GET /api/v1/foundations/exceptions/reason-codes` */
export const alertReasonVocabulary: OperationSpec<AlertReasonVocabularyParams, readonly (AlertReasonOption)[]> = {
  operationId: "alert_reason_vocabulary_api_v1_foundations_exceptions_reason_codes_get",
  method: "GET",
  path: "/api/v1/foundations/exceptions/reason-codes",
  tag: "foundations",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/launch/allocate` — Compute a launch allocation — Run the shared engine over a launch stated in the payload. Commits nothing. */
export type AllocateParams = {
  readonly body: AllocateRequestModel;
};

/** `POST /api/v1/launch/allocate` */
export const allocate: OperationSpec<AllocateParams, AllocateResponseModel> = {
  operationId: "allocate_api_v1_launch_allocate_post",
  method: "POST",
  path: "/api/v1/launch/allocate",
  tag: "launch",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/foundations/plans/{plan_id}/versions` — Append Plan Version — Append an immutable version to a plan (reqs/00 F3, §8.3). The response is the same :class:`PlanVersionSummary` the list route serves, so a client renders what it just created with the model it already has. **This is the endpoint that can refuse for a reason nobody can fix from the request.** ``kind`` and ``status`` are validated against the governed vocabulary read from the effective-dated parameter registry, and this estate has never had one authored — so the honest answer today is a 409 naming the five missing registry keys rather than a 201 recording a status no governance decision admits. */
export type AppendPlanVersionParams = {
  readonly path: {
    readonly plan_id: string;
  };
  readonly body: AppendVersionRequest;
};

/** `POST /api/v1/foundations/plans/{plan_id}/versions` */
export const appendPlanVersion: OperationSpec<AppendPlanVersionParams, PlanVersionSummary> = {
  operationId: "append_plan_version_api_v1_foundations_plans__plan_id__versions_post",
  method: "POST",
  path: "/api/v1/foundations/plans/{plan_id}/versions",
  tag: "foundations",
  pathParams: ["plan_id"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/preseason/size-curve/apply` — Apply Size Curve — Split a quantity across a size run, conserving units exactly (reqs/02 §3.5). The endpoint §3's size-aware allocation calls with an allocation quantity instead of a buy quantity. One arithmetic, one endpoint, one place a conservation defect could appear (G11). */
export type ApplySizeCurveParams = {
  readonly body: SizeCurveApplyRequest;
};

/** `POST /api/v1/preseason/size-curve/apply` */
export const applySizeCurve: OperationSpec<ApplySizeCurveParams, SizeCurveApplyResponse> = {
  operationId: "apply_size_curve_api_v1_preseason_size_curve_apply_post",
  method: "POST",
  path: "/api/v1/preseason/size-curve/apply",
  tag: "preseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/registry/changes/{change_id}/approvals` — Approve Change — `17` §4 step 2 — approve, seal and apply, in one transaction. The approver is the verified principal. **Any administrator may approve their own proposal, in every family** (owner ruling 2026-10-09, ADR 9026, retiring DEC-03's family overlay and its ``platform.registry.self_approval_refused``). The approval is still its own step after the proposal, and the approver is recorded beside the author. A category rule that forbade self-approval would refuse it with ``proposer_is_approver`` in ``change_refused``'s list; none does today. Every `17` §3 defect comes back in the same list so that a submission is fixed once. **Who may approve.** ``administer`` on ``parameter`` (the administrator), or — owner ruling R-4, ADR 9102 — ``approve`` on ``exception_rule`` (the country manager) for a set wholly in the ``exception`` family: a P4 set, or a P7 set whose every key is ``exception.*``. Any other set under that grant is 403 ``platform.registry.approval_outside_exception_family`` naming its families, and nothing is written. Self-approval is permitted under both grants (ADR 9026). There is no payload. Everything this step needs is on the record already, and a body would be an invitation to restate one of its fields differently. */
export type ApproveChangeParams = {
  readonly path: {
    readonly change_id: string;
  };
};

/** `POST /api/v1/registry/changes/{change_id}/approvals` */
export const approveChange: OperationSpec<ApproveChangeParams, ChangeReceipt> = {
  operationId: "approve_change_api_v1_registry_changes__change_id__approvals_post",
  method: "POST",
  path: "/api/v1/registry/changes/{change_id}/approvals",
  tag: "registry",
  pathParams: ["change_id"],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/feedback/{code}/approval` — Approve Report — Approve a ``ready`` defect or evolution for development, on the content digest read. Only a named approver (``feedback_approver_subjects``; nobody when it is empty). The report must be ``ready``, of kind ``incident`` or ``enhancement``, complete, and its content must still be the one ``content_digest`` names (409 ``platform.feedback.content_changed``). An approver may approve a report they filed (owner ruling 2026-10-21). One history row with the digest and one audit row (recorder ``feedback_approval``), in one transaction. */
export type ApproveReportParams = {
  readonly path: {
    readonly code: string;
  };
  readonly body: ApprovalRequest;
};

/** `POST /api/v1/feedback/{code}/approval` */
export const approveReport: OperationSpec<ApproveReportParams, ApprovalOutcome> = {
  operationId: "approve_report_api_v1_feedback__code__approval_post",
  method: "POST",
  path: "/api/v1/feedback/{code}/approval",
  tag: "feedback",
  pathParams: ["code"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/run-configurations/{configuration_id}/archive` — Archive Run Configuration — Take a configuration out of the default listing. Nothing is deleted. */
export type ArchiveRunConfigurationParams = {
  readonly path: {
    readonly configuration_id: string;
  };
};

/** `POST /api/v1/run-configurations/{configuration_id}/archive` */
export const archiveRunConfiguration: OperationSpec<ArchiveRunConfigurationParams, RunConfiguration> = {
  operationId: "archive_run_configuration_api_v1_run_configurations__configuration_id__archive_post",
  method: "POST",
  path: "/api/v1/run-configurations/{configuration_id}/archive",
  tag: "run-configurations",
  pathParams: ["configuration_id"],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/assistant/turns` — Ask — Answer one question from the knowledge base, in a conversation. Plain text, its sources, the gate's verdict, and the intake: the request's kind, the draft, what it misses and, when it is complete, the confirmation that files it. Not recorded in the idempotency ledger (``Cache-Control: no-store``): a retry asks again. At most ``assistant_turns_per_day`` per person in a rolling 24 hours: beyond it, 429 ``platform.assistant.quota_exceeded`` with ``Retry-After``. */
export type AskParams = {
  readonly body: TurnRequest;
};

/** `POST /api/v1/assistant/turns` */
export const ask: OperationSpec<AskParams, TurnResponse> = {
  operationId: "ask_api_v1_assistant_turns_post",
  method: "POST",
  path: "/api/v1/assistant/turns",
  tag: "assistant",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/transfer/cost-to-serve` — Assess Cost To Serve — Run gate D2's per-country assessment from the payload (reqs/08 §8). The enablement decision is returned alongside the evidence, so a caller cannot record one without the other — which is the whole reason the gate is a row rather than a configuration flag. */
export type AssessCostToServeParams = {
  readonly body: CostToServeRequest;
};

/** `POST /api/v1/inseason/transfer/cost-to-serve` */
export const assessCostToServe: OperationSpec<AssessCostToServeParams, CostToServeResponse> = {
  operationId: "assess_cost_to_serve_api_v1_inseason_transfer_cost_to_serve_post",
  method: "POST",
  path: "/api/v1/inseason/transfer/cost-to-serve",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/exit/consolidation/lane-economics` — Price one consolidation lane and say whether it pays — reqs/05 §3.4's cost test, callable with no estate. A lane whose cost has not landed is **refused rather than costed at zero**: a zero freight cost makes every transfer look profitable, which is the over-consolidation failure reqs/05 §7 names, and `awaiting_lane_cost` is a different answer from `lane_below_cost_hurdle`. */
export type AssessLaneEconomicsParams = {
  readonly body: LaneEconomicsRequest;
};

/** `POST /api/v1/exit/consolidation/lane-economics` */
export const assessLaneEconomics: OperationSpec<AssessLaneEconomicsParams, LaneEconomicsResponse> = {
  operationId: "assess_lane_economics_api_v1_exit_consolidation_lane_economics_post",
  method: "POST",
  path: "/api/v1/exit/consolidation/lane-economics",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/assistant/gaps` — Assistant Gaps — What OPTIMA could not answer, by screen and class, for the owner (ADR 2138). The questions whose answer was ``not-documented`` or withheld by a gate, within what the retention job still holds, opened from their seal, grouped by the screen they were asked on and the class the model gave. Only a person named in ``feedback_approver_subjects`` (403 ``platform.forbidden`` for anyone else, and for everyone when the list is empty). The asker is never carried. The read is audited, because it opens personal text. ``Cache-Control: no-store``. */
export type AssistantGapsParams = {
  readonly query?: {
    readonly days?: number | null;
  };
};

/** `GET /api/v1/assistant/gaps` */
export const assistantGaps: OperationSpec<AssistantGapsParams, GapReport> = {
  operationId: "assistant_gaps_api_v1_assistant_gaps_get",
  method: "GET",
  path: "/api/v1/assistant/gaps",
  tag: "assistant",
  pathParams: [],
  queryParams: ["days"],
  hasBody: false,
};

/** `GET /api/v1/assistant/log` — Assistant Log — Every turn OPTIMA answered, question and answer opened from their seal, for the owner. Newest first, within what the retention job still holds (``retention.assistant_turn_months``). Only a person named in ``feedback_approver_subjects`` (403 ``platform.forbidden`` for anyone else, and for everyone when the list is empty). Each turn names its asker: the pseudonym resolved through its salt to the subject, and the subject's profile to a name and an email (owner ruling 2026-10-27). An erased person stays unnamed. The read is audited, because it opens personal text. ``Cache-Control: no-store``. */
export type AssistantLogParams = {
  readonly query?: {
    readonly days?: number | null;
    readonly conversation_id?: string | null;
    readonly limit?: number;
  };
};

/** `GET /api/v1/assistant/log` */
export const assistantLog: OperationSpec<AssistantLogParams, TurnLog> = {
  operationId: "assistant_log_api_v1_assistant_log_get",
  method: "GET",
  path: "/api/v1/assistant/log",
  tag: "assistant",
  pathParams: [],
  queryParams: ["days", "conversation_id", "limit"],
  hasBody: false,
};

/** `GET /api/v1/assistant/status` — Assistant Status — Whether OPTIMA answers on this deployment, the model it runs, the phase, and whether it prepares reports. */
export type AssistantStatusParams = Record<string, never>;

/** `GET /api/v1/assistant/status` */
export const assistantStatus: OperationSpec<AssistantStatusParams, AssistantStatus> = {
  operationId: "assistant_status_api_v1_assistant_status_get",
  method: "GET",
  path: "/api/v1/assistant/status",
  tag: "assistant",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/internal/authorise` — Authorise Internal Surface — Caddy's ``forward_auth`` target for ``/internal/grafana/*`` and ``/internal/dagster/*``. A bearer principal (``request.state.principal``, attached by :class:`~services.api.security.AuthenticationMiddleware` if the caller presented one) is preferred over the cookie when both are present — a bearer token is the fresher, directly-verified credential; the cookie is the fallback a plain browser navigation actually has. This route is the one entry in :data:`~services.api.security.SELF_AUTHENTICATING_PATHS`: a bearer token is mandatory everywhere else, and a cookie-only caller has none to present. Only the *requirement* is lifted — a token that is presented is still verified and still attaches a principal, which is why the branch above can prefer it. The refusal below is what enforces identity here instead, and it is the same ``UnauthenticatedError`` rendered as the same 401. One caveat on "either credential": a bearer token that is *present but invalid* is rejected by ``AuthenticationMiddleware`` itself with a 401 before this handler ever runs (``services/api/security.py``'s ``AuthenticationMiddleware.__call__`` returns early on a bad token), so the cookie fallback below never gets a chance to run for that request even if a valid session cookie is also present. Not reachable from a plain browser navigation (which never attaches an ``Authorization`` header of its own), so left as a documented caveat rather than a change to shared middleware behaviour that every other route also depends on. */
export type AuthoriseInternalSurfaceParams = {
  readonly query?: {
    readonly role?: string;
  };
};

/** `GET /api/v1/internal/authorise` */
export const authoriseInternalSurface: OperationSpec<AuthoriseInternalSurfaceParams, unknown> = {
  operationId: "authorise_internal_surface_api_v1_internal_authorise_get",
  method: "GET",
  path: "/api/v1/internal/authorise",
  tag: "internal",
  pathParams: [],
  queryParams: ["role"],
  hasBody: false,
};

/** `POST /api/v1/foundations/bridge` — Bridge — Decompose a variance into volume, price, mix and phasing (reqs/07 §3.6). ``residual`` is reported rather than hidden. It is zero for anything this endpoint computes; a non-zero value could only come from a restated bridge, and that is a finding a planner must see. */
export type BridgeParams = {
  readonly body: BridgeRequest;
};

/** `POST /api/v1/foundations/bridge` */
export const bridge: OperationSpec<BridgeParams, BridgeResponse> = {
  operationId: "bridge_api_v1_foundations_bridge_post",
  method: "POST",
  path: "/api/v1/foundations/bridge",
  tag: "foundations",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/exit/cadence-proposals/bulk-approve` — Dispose of a filtered set of cadence proposals in one action — reqs/05 §4 Phase 2's bulk approve. The whole set is written in one transaction or none of it is: a bulk action that recorded thirty-nine of forty would leave the planner believing they had approved forty. */
export type BulkApproveParams = {
  readonly body: BulkApproveRequest;
};

/** `POST /api/v1/exit/cadence-proposals/bulk-approve` */
export const bulkApprove: OperationSpec<BulkApproveParams, BulkActionSummary> = {
  operationId: "bulk_approve_api_v1_exit_cadence_proposals_bulk_approve_post",
  method: "POST",
  path: "/api/v1/exit/cadence-proposals/bulk-approve",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/launch/bulk-groups` — Proposal groups for bulk disposal — Proposal identifiers grouped by reason code and door, in queue order. */
export type BulkGroupsParams = {
  readonly query?: {
    readonly allocation_version_id?: string;
  };
};

/** `GET /api/v1/launch/bulk-groups` */
export const bulkGroups: OperationSpec<BulkGroupsParams, {
  readonly [key: string]: readonly (string)[];
}> = {
  operationId: "bulk_groups_api_v1_launch_bulk_groups_get",
  method: "GET",
  path: "/api/v1/launch/bulk-groups",
  tag: "launch",
  pathParams: [],
  queryParams: ["allocation_version_id"],
  hasBody: false,
};

/** `POST /api/v1/inseason/write-back/{command_id}/cancellation` — Cancel Write Back — A planner withdraws a command still to execute, with a governed reason (ADR 6105). From ``approved``, ``dispatched`` or ``partially_executed``; the executed part of a partly executed command stays recorded. A second cancellation appends nothing; any other state is 409 out of order. The reason must be in ``GET /inseason/write-back/cancellation-reason-codes`` — empty until the owner's registry row is in force (ADR 6107), so this is refused by name until then. Authorised as ``approve`` on the plan: withdrawing an approval is the approver's act. */
export type CancelWriteBackParams = {
  readonly path: {
    readonly command_id: string;
  };
  readonly body: WriteBackCancellationRequest;
};

/** `POST /api/v1/inseason/write-back/{command_id}/cancellation` */
export const cancelWriteBack: OperationSpec<CancelWriteBackParams, WriteBackConfirmationSummary> = {
  operationId: "cancel_write_back_api_v1_inseason_write_back__command_id__cancellation_post",
  method: "POST",
  path: "/api/v1/inseason/write-back/{command_id}/cancellation",
  tag: "inseason",
  pathParams: ["command_id"],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/write-back/cancellation-reason-codes` — Cancellation Reason Codes — The governed reasons a command may be cancelled with (ADR 6105, ADR 6107). The owner's starter set (R-5: ``stock_no_longer_available``, ``store_cannot_receive``, ``replaced_by_manual_action``, ``approved_in_error``) narrowed by the ``inseason.write_back.cancellation_reason_vocabulary`` registry row in force. **Empty while no row is in force**: the vocabulary is ratified through the registry, so every cancellation is then refused with ``planning.inseason.cancellation_reason_not_governed``, and a client renders that rather than offering a code the platform would refuse. */
export type CancellationReasonCodesParams = Record<string, never>;

/** `GET /api/v1/inseason/write-back/cancellation-reason-codes` */
export const cancellationReasonCodes: OperationSpec<CancellationReasonCodesParams, readonly (string)[]> = {
  operationId: "cancellation_reason_codes_api_v1_inseason_write_back_cancellation_reason_codes_get",
  method: "GET",
  path: "/api/v1/inseason/write-back/cancellation-reason-codes",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/system/capabilities` — Capabilities — Report the routers, locales and problem codes this build exposes. */
export type CapabilitiesParams = Record<string, never>;

/** `GET /api/v1/system/capabilities` */
export const capabilities: OperationSpec<CapabilitiesParams, CapabilitiesResponse> = {
  operationId: "capabilities_api_v1_system_capabilities_get",
  method: "GET",
  path: "/api/v1/system/capabilities",
  tag: "system",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/strategic/cascade` — Cascade — Push a target down the hierarchy and roll it back up, exactly. */
export type CascadeParams = {
  readonly body: CascadeRequest;
};

/** `POST /api/v1/strategic/cascade` */
export const cascade: OperationSpec<CascadeParams, CascadeResponse> = {
  operationId: "cascade_api_v1_strategic_cascade_post",
  method: "POST",
  path: "/api/v1/strategic/cascade",
  tag: "strategic",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/cells` — Cells Report — Every cell one run recorded, with what became of it (ADR 6197). The uncovered report widened to every recorded cell: a line written, a need left uncovered with its reason, already covered, or never measured — and every size the run named without a forecast (ADR 6182), with its reason (amendment of 2026-10-23). Ordered by store, article, then size in run order. A fixed number of statements per page (ADR 9018). ``store_key`` and ``article_key`` narrow it to one store, one article or one store x article — every size of a pair, recorded or named (ADR 2138; public since ADR 6207). 404 when the run does not exist or is outside the caller's scope. */
export type CellsReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly store_key?: string | null;
    readonly article_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/cells` */
export const cellsReport: OperationSpec<CellsReportParams, CursorPageCellReportRow> = {
  operationId: "cells_report_api_v1_inseason_runs__run_id__report_replenishment_cells_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/report/replenishment/cells",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["store_key", "article_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/cells/summary` — Cells Summary — The run's cells counted by outcome, with Network health's served and stock-out cards. The cells read (``GET /{run_id}/report/replenishment/cells``) summed in the store by one grouped statement: cells and need pairs per ``outcome`` (a line written, each target-0 and covered reason, each reason that stopped a need), the pairs proposed, and the stock-outs with and without cover. Served, stock-outs and uncovered are Network health's own definitions, so they equal its cards for the run (ADR 6200). Scope and permission are the cells read's. 404 when the run does not exist or is outside the caller's scope. */
export type CellsSummaryParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/cells/summary` */
export const cellsSummary: OperationSpec<CellsSummaryParams, CellsSummaryResponse> = {
  operationId: "cells_summary_api_v1_inseason_runs__run_id__report_replenishment_cells_summary_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/report/replenishment/cells/summary",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/registry/closure-reasons` — Closure Reason Vocabulary — The reasons a pending set may be rejected or withdrawn with, and which act takes each. ``reasonCode`` is required on ``POST /changes/{change_id}/rejections`` and ``/withdrawals``; this is where a caller fills it from (W2-1). The vocabulary is :mod:`planning.principles.closure`'s; the prose is resolved against ``Accept-Language`` on ADR 0057's terms. */
export type ClosureReasonVocabularyParams = Record<string, never>;

/** `GET /api/v1/registry/closure-reasons` */
export const closureReasonVocabulary: OperationSpec<ClosureReasonVocabularyParams, readonly (ClosureReasonOption)[]> = {
  operationId: "closure_reason_vocabulary_api_v1_registry_closure_reasons_get",
  method: "GET",
  path: "/api/v1/registry/closure-reasons",
  tag: "registry",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/compare` — Compare Simulation — The base run's digest beside the scenario's, and every measure's delta. 409 until the simulation's run has succeeded. Each digest is ADR 6039's, over its own run's stored rows; the deltas are the platform's, with declared polarity. */
export type CompareSimulationParams = {
  readonly path: {
    readonly simulation_id: string;
  };
  readonly query?: {
    readonly top?: number;
    readonly depth_band_points?: number;
  };
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/compare` */
export const compareSimulation: OperationSpec<CompareSimulationParams, SimulationComparisonView> = {
  operationId: "compare_simulation_api_v1_inseason_simulations__simulation_id__compare_get",
  method: "GET",
  path: "/api/v1/inseason/simulations/{simulation_id}/compare",
  tag: "inseason",
  pathParams: ["simulation_id"],
  queryParams: ["top", "depth_band_points"],
  hasBody: false,
};

/** `POST /api/v1/preseason/otb` — Compute Otb — Compute an OTB ledger from a set of period plans (reqs/02 §3.1). Callable with no estate at all, which is how §4.3 can develop against the same object before a feed is certified — and it is the *same* object, not a copy: reqs/02 §6 makes in-season re-planning a second lifecycle stage of this ledger rather than a second ledger. */
export type ComputeOtbParams = {
  readonly body: OtbRequest;
};

/** `POST /api/v1/preseason/otb` */
export const computeOtb: OperationSpec<ComputeOtbParams, OtbResponse> = {
  operationId: "compute_otb_api_v1_preseason_otb_post",
  method: "POST",
  path: "/api/v1/preseason/otb",
  tag: "preseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/exit/cadence/required-rate` — The required weekly depletion rate — reqs/05 §3.2 step 1. Negative where the position is already inside its target, which is the signal that the option should leave the markdown stream rather than a value to clamp at zero. */
export type ComputeRequiredRateParams = {
  readonly body: DepletionRateRequest;
};

/** `POST /api/v1/exit/cadence/required-rate` */
export const computeRequiredRate: OperationSpec<ComputeRequiredRateParams, DepletionRateResponse> = {
  operationId: "compute_required_rate_api_v1_exit_cadence_required_rate_post",
  method: "POST",
  path: "/api/v1/exit/cadence/required-rate",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/supplier/capacity-confirmations` — Confirm or amend the capacity the platform declared for this supplier — The portal's only write. It refuses a caller bound to no supplier and a caller bound to a different one, then hands the figure to the capacity ledger, which refuses a cut below what has already been booked against it. An amendment is a new row naming the one it supersedes; nothing is updated in place. */
export type ConfirmCapacityParams = {
  readonly body: ConfirmationRequest;
};

/** `POST /api/v1/supplier/capacity-confirmations` */
export const confirmCapacity: OperationSpec<ConfirmCapacityParams, ConfirmationReceipt> = {
  operationId: "confirm_capacity_api_v1_supplier_capacity_confirmations_post",
  method: "POST",
  path: "/api/v1/supplier/capacity-confirmations",
  tag: "supplier",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/write-back/{command_id}/confirmations` — Confirm Write Back Units — A planner confirms how many of a command's units are executed so far (ADR 6105). ``executed_units`` is the cumulative total to date. Equal to what the decision authorised, the command is ``acknowledged``; fewer, ``partially_executed``, and the remainder stays in the backlog (``GET /inseason/execution-pack?state=open``). From ``dispatched`` or ``partially_executed`` only — 409 out of order otherwise. A total that falls or exceeds the authorised units is 422 ``planning.inseason.executed_units_invalid``; a price step, which carries no units, is 422 ``planning.inseason.write_back_units_not_applicable``. The same total twice appends nothing (``recorded: false``). Authorised as ``commit`` on the plan, as the full confirmation is. */
export type ConfirmWriteBackUnitsParams = {
  readonly path: {
    readonly command_id: string;
  };
  readonly body: WriteBackConfirmationRequest;
};

/** `POST /api/v1/inseason/write-back/{command_id}/confirmations` */
export const confirmWriteBackUnits: OperationSpec<ConfirmWriteBackUnitsParams, WriteBackConfirmationSummary> = {
  operationId: "confirm_write_back_units_api_v1_inseason_write_back__command_id__confirmations_post",
  method: "POST",
  path: "/api/v1/inseason/write-back/{command_id}/confirmations",
  tag: "inseason",
  pathParams: ["command_id"],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/supplier/capacity-confirmations` — The calling supplier's append-only confirmation chain, in one period — Every confirmation and amendment the supplier has made for the period, oldest first. An amendment names the confirmation it supersedes; nothing is ever edited, so the record of what was first said survives (reqs/01 §7 risk 5). */
export type ConfirmationsParams = {
  readonly query?: {
    readonly period_key?: string;
    readonly as_of_period?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/supplier/capacity-confirmations` */
export const confirmations: OperationSpec<ConfirmationsParams, CursorPageCapacityConfirmationRow> = {
  operationId: "confirmations_api_v1_supplier_capacity_confirmations_get",
  method: "GET",
  path: "/api/v1/supplier/capacity-confirmations",
  tag: "supplier",
  pathParams: [],
  queryParams: ["period_key", "as_of_period", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/conformance/exceptions` — List Exceptions — The exception register. Expired rows are served, never filtered away. reqs/07 R4's mitigation is that expired exceptions fail the release, so a register that hid them would be a demonstration of the failure mode rather than its control. */
export type ConformanceListExceptionsParams = {
  readonly query?: {
    readonly rule_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/conformance/exceptions` */
export const conformanceListExceptions: OperationSpec<ConformanceListExceptionsParams, CursorPageExceptionSummary> = {
  operationId: "list_exceptions_api_v1_conformance_exceptions_get",
  method: "GET",
  path: "/api/v1/conformance/exceptions",
  tag: "conformance",
  pathParams: [],
  queryParams: ["rule_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/runs/{run_id}/report/lines` — Consolidation Lines Report — One consolidation run's lines report, one line per row, one page at a time. Proposed and withheld lines alike, as ``GET /exit/consolidation/lines`` serves them. Ordered by source door, article, size in run order, destination and line. Both doors' stock before and after the run's decided lanes at the line's size, from the stock measured on the run's ``as_of``. A fixed number of statements per page, whatever its size (ADR 9018). 404 when the run does not exist or is outside the caller's scope. */
export type ConsolidationLinesReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/consolidation/runs/{run_id}/report/lines` */
export const consolidationLinesReport: OperationSpec<ConsolidationLinesReportParams, CursorPageConsolidationReportRow> = {
  operationId: "consolidation_lines_report_api_v1_exit_consolidation_runs__run_id__report_lines_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/runs/{run_id}/report/lines",
  tag: "exit",
  pathParams: ["run_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/strategic/cost-to-serve` — Cost To Serve Rows — Published cost-to-serve by country × channel, with its reconciliation. */
export type CostToServeRowsParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/strategic/cost-to-serve` */
export const costToServeRows: OperationSpec<CostToServeRowsParams, CursorPageCostToServeRow> = {
  operationId: "cost_to_serve_rows_api_v1_strategic_cost_to_serve_get",
  method: "GET",
  path: "/api/v1/strategic/cost-to-serve",
  tag: "strategic",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `POST /api/v1/internal/session` — Create Internal Session — Mint the internal-surface cookie for the caller's already-verified token. 401s the same way any other route needing a principal does (:func:`~services.api.security.current_principal`) — there is nothing to mint a cookie *for* without one. A caller with no ``internal_session_secret`` configured (never true in production — ``assert_internal_session_configured`` refuses to boot without it) gets a 204 with no cookie set, since minting an unverifiable cookie would be worse than minting none. */
export type CreateInternalSessionParams = Record<string, never>;

/** `POST /api/v1/internal/session` */
export const createInternalSession: OperationSpec<CreateInternalSessionParams, void> = {
  operationId: "create_internal_session_api_v1_internal_session_post",
  method: "POST",
  path: "/api/v1/internal/session",
  tag: "internal",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/foundations/plans` — Create Plan Header — Create the plan header a version hangs from. Separate from appending a version, and not folded into it, because the two are different rows with different lifetimes: a header is created once and a plan accumulates versions forever. A single endpoint that did both would have to decide, silently, whether a second call meant "append" or "conflict". */
export type CreatePlanHeaderParams = {
  readonly body: CreatePlanRequest;
};

/** `POST /api/v1/foundations/plans` */
export const createPlanHeader: OperationSpec<CreatePlanHeaderParams, CreatePlanResponse> = {
  operationId: "create_plan_header_api_v1_foundations_plans_post",
  method: "POST",
  path: "/api/v1/foundations/plans",
  tag: "foundations",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/run-configurations` — Create Run Configuration — Save a new configuration as its version 1. */
export type CreateRunConfigurationParams = {
  readonly body: RunConfigurationCreate;
};

/** `POST /api/v1/run-configurations` */
export const createRunConfiguration: OperationSpec<CreateRunConfigurationParams, RunConfiguration> = {
  operationId: "create_run_configuration_api_v1_run_configurations_post",
  method: "POST",
  path: "/api/v1/run-configurations",
  tag: "run-configurations",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/foundations/scenarios` — Create Scenario Branch — Branch a scenario from a plan version (reqs/00 D5). ``overlayCells`` comes back zero and that is the measurement, not a placeholder: reqs/00 D5's copy-on-write claim is that a scenario costs one row until somebody edits it, and this endpoint has just created one that nobody has edited. */
export type CreateScenarioBranchParams = {
  readonly body: CreateScenarioRequest;
};

/** `POST /api/v1/foundations/scenarios` */
export const createScenarioBranch: OperationSpec<CreateScenarioBranchParams, ScenarioSummary> = {
  operationId: "create_scenario_branch_api_v1_foundations_scenarios_post",
  method: "POST",
  path: "/api/v1/foundations/scenarios",
  tag: "foundations",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/simulations/scenarios` — Create Simulation Sandbox — The base run's market's simulation sandbox: 201 when created, 200 when it existed. ADR 6053. A run that read no plan version has no D5 branch to be simulated in, and a governed plan version needs a vocabulary nobody has authored. The sandbox is one **system** plan, version and scenario per market, which ``GET /inseason/simulations/scenarios`` then offers with ``sandbox: true`` and ``POST /inseason/simulations`` accepts for every run of that market. It is never a plan: no plan reader lists it, no version or branch may be authored on it, and it is never submitted, sealed or promoted. What a simulation writes into it is fenced from every live read exactly as any scenario's rows are (ADR 6041). Authorised as ``POST /inseason/simulations`` is (``propose`` on the plan, on the base run's market): whoever may run a simulation may create the sandbox it runs in. 404 ``base_run_not_found`` for a run that is unknown or outside the caller's scope. */
export type CreateSimulationSandboxParams = {
  readonly body: SandboxRequest;
};

/** `POST /api/v1/inseason/simulations/scenarios` */
export const createSimulationSandbox: OperationSpec<CreateSimulationSandboxParams, ScenarioSummary> = {
  operationId: "create_simulation_sandbox_api_v1_inseason_simulations_scenarios_post",
  method: "POST",
  path: "/api/v1/inseason/simulations/scenarios",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/strategic/cycles` — Cycles — The IBP cycles and their gate state. */
export type CyclesParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/strategic/cycles` */
export const cycles: OperationSpec<CyclesParams, CursorPageCycleRow> = {
  operationId: "cycles_api_v1_strategic_cycles_get",
  method: "GET",
  path: "/api/v1/strategic/cycles",
  tag: "strategic",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/lifecycle-transitions/decision-reasons` — Decision Reasons — The governed reasons for a transition decision, on the day of the request. */
export type DecisionReasonsParams = Record<string, never>;

/** `GET /api/v1/exit/lifecycle-transitions/decision-reasons` */
export const decisionReasons: OperationSpec<DecisionReasonsParams, TransitionDecisionReasonsModel> = {
  operationId: "decision_reasons_api_v1_exit_lifecycle_transitions_decision_reasons_get",
  method: "GET",
  path: "/api/v1/exit/lifecycle-transitions/decision-reasons",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/decision-summary` — Decision Summary — How many of one run's proposals and transfers still wait on a planner (ADR 6030). Counts over the run's whole book, not a page of it. 404 when the run does not exist or is outside the caller's scope. ``transfers_pending`` counts the undecided lines of the market's newest live completed move run, named by ``transfers_pending_move_run_id`` (platform ADR 9049, amendment 2026-10-31). */
export type DecisionSummaryParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/decision-summary` */
export const decisionSummary: OperationSpec<DecisionSummaryParams, DecisionSummary> = {
  operationId: "decision_summary_api_v1_inseason_runs__run_id__decision_summary_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/decision-summary",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/supplier/capacity` — Declared and confirmed capacity for the calling supplier, in one period — The supplier's own capacity ceiling as the platform declares it, beside what the supplier has confirmed. `periodKey` is required: a capacity list spanning every period ever declared is the unbounded collection read G16 forbids. */
export type DeclaredCapacityParams = {
  readonly query?: {
    readonly period_key?: string;
    readonly as_of_period?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/supplier/capacity` */
export const declaredCapacity: OperationSpec<DeclaredCapacityParams, CursorPageDeclaredCapacityRow> = {
  operationId: "declared_capacity_api_v1_supplier_capacity_get",
  method: "GET",
  path: "/api/v1/supplier/capacity",
  tag: "supplier",
  pathParams: [],
  queryParams: ["period_key", "as_of_period", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/strategic/demand-gap` — Demand Gap — Unconstrained against constrained demand, per cell. Both numbers on one row rather than two endpoints, because reqs/01 D5's whole point is that they are read together. */
export type DemandGapParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/strategic/demand-gap` */
export const demandGap: OperationSpec<DemandGapParams, CursorPageDemandGapRow> = {
  operationId: "demand_gap_api_v1_strategic_demand_gap_get",
  method: "GET",
  path: "/api/v1/strategic/demand-gap",
  tag: "strategic",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/recovery/demand-panel` — The unconstrained-demand panel for a named set of doors and weeks — ADR 0091 D1's shared reference. Bounded by door and week because a curve is fitted over a named panel rather than over whatever the store holds (G16). Carries the basis verdict and the count of weeks with no recovered value, so a consumer can refuse rather than fit on censored sales. */
export type DemandPanelParams = {
  readonly query?: {
    readonly season?: string;
    readonly locationKeys?: readonly (string)[];
    readonly fiscalWeeks?: readonly (string)[];
    readonly articleKeys?: readonly (string)[];
  };
};

/** `GET /api/v1/postseason/recovery/demand-panel` */
export const demandPanel: OperationSpec<DemandPanelParams, DemandPanelResponse> = {
  operationId: "demand_panel_api_v1_postseason_recovery_demand_panel_get",
  method: "GET",
  path: "/api/v1/postseason/recovery/demand-panel",
  tag: "postseason",
  pathParams: [],
  queryParams: ["season", "locationKeys", "fiscalWeeks", "articleKeys"],
  hasBody: false,
};

/** `POST /api/v1/preseason/buy/diagnose` — Diagnose Buy — Check a buy assignment and name the constraints it breaks (reqs/02 §3.6). "Infeasibility is surfaced as a named exception identifying the binding constraint, never silently relaxed." The response therefore carries the reasons and the scopes — "supplier capacity, week 34" — rather than a bare boolean, and the same call diagnoses a planner's manual override as diagnoses a solver's answer. The minimum order quantity is checked from the suppliers' terms (:func:`~planning.buy.constraints.diagnose_with_terms`), and the request is refused when they cannot be read. The supplier capacity is checked per ``<supplierKey>|<receiptPeriodKey>``, and a key that names nothing a candidate draws on is refused rather than skipped. */
export type DiagnoseBuyParams = {
  readonly body: BuyDiagnoseRequest;
};

/** `POST /api/v1/preseason/buy/diagnose` */
export const diagnoseBuy: OperationSpec<DiagnoseBuyParams, BuyDiagnoseResponse> = {
  operationId: "diagnose_buy_api_v1_preseason_buy_diagnose_post",
  method: "POST",
  path: "/api/v1/preseason/buy/diagnose",
  tag: "preseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/markdown/diagnose` — Why no price path qualified, and the smallest edits that clear it — reqs/04 §4.4's why-not panel. The refusal read back for its binding constraint — a guardrail with an owner, the weeks that are gone, or an exit-route floor that means the lot should be routed rather than priced — with the smallest costed edits that restore a path. A refusal with no edit attached is a defect, so the engine never produces one. The edits are scenarios a merchant may adopt; adopting one is a parameter change or a decision with an approval, never a silent relaxation. */
export type DiagnoseMarkdownParams = {
  readonly body: DiagnoseRequest;
};

/** `POST /api/v1/inseason/markdown/diagnose` */
export const diagnoseMarkdown: OperationSpec<DiagnoseMarkdownParams, InfeasibilityResponse> = {
  operationId: "diagnose_markdown_api_v1_inseason_markdown_diagnose_post",
  method: "POST",
  path: "/api/v1/inseason/markdown/diagnose",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/launch/dispositions` — Dispose of launch proposals in bulk — Approve, adjust, reject or defer a filtered set in one action, with a governed reason. Recorded under the verified principal; `actor` and `decided_at` in the body are ignored. */
export type DisposeProposalsParams = {
  readonly body: BulkDispositionRequestModel;
};

/** `POST /api/v1/launch/dispositions` */
export const disposeProposals: OperationSpec<DisposeProposalsParams, BulkDispositionResponseModel> = {
  operationId: "dispose_proposals_api_v1_launch_dispositions_post",
  method: "POST",
  path: "/api/v1/launch/dispositions",
  tag: "launch",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/launch/dispositions/reason-codes` — Reason codes a planner may record on a launch disposition — The governed proposal-disposition vocabulary, each with the dispositions it may carry and its label in the caller's language. Not the engine's codes. */
export type DispositionReasonCodesParams = Record<string, never>;

/** `GET /api/v1/launch/dispositions/reason-codes` */
export const dispositionReasonCodes: OperationSpec<DispositionReasonCodesParams, readonly (DispositionReasonModel)[]> = {
  operationId: "disposition_reason_codes_api_v1_launch_dispositions_reason_codes_get",
  method: "GET",
  path: "/api/v1/launch/dispositions/reason-codes",
  tag: "launch",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/dispositions/vocabulary` — Disposition Vocabulary — The four dispositions a planner may record, with prose for this caller. Served rather than documented. The vocabulary is closed — G1 sanctions four interactions and no market extends them — but the *labels* are catalogue entries, and a client that carried its own would be a second source of wording for a decision that goes into an audit trail. ADR 0057: the prose is resolved here against ``Accept-Language`` so a caller needs no share of this repository's key space to render it. */
export type DispositionVocabularyParams = Record<string, never>;

/** `GET /api/v1/inseason/dispositions/vocabulary` */
export const dispositionVocabulary: OperationSpec<DispositionVocabularyParams, readonly (DispositionOption)[]> = {
  operationId: "disposition_vocabulary_api_v1_inseason_dispositions_vocabulary_get",
  method: "GET",
  path: "/api/v1/inseason/dispositions/vocabulary",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/door-availability` — Door Availability — Per door, size availability and weeks of cover over the run's window (bata-platform#570). The window is **the 13 complete retail weeks ending at the run's stock as-of week**, the stock ``asOf`` being the newest over the run's recorded positions (as the network-health read takes it). There is no date parameter and no default date: a run that recorded no position has no window, and the read answers 409 rather than choosing one. Rows are the landed ``door_availability_week`` feed, one in-force batch per week. Scope-rewritten on the run's market; 404 when the run does not exist or is outside the caller's scope. 404 ``door_availability_unavailable`` when no source is installed or no week of the window has landed. */
export type DoorAvailabilityParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/door-availability` */
export const doorAvailability: OperationSpec<DoorAvailabilityParams, DoorAvailabilityModel> = {
  operationId: "door_availability_api_v1_inseason_runs__run_id__door_availability_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/door-availability",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/strategic/driver-bridge` — Driver Bridge — The driver decomposition behind one plan version. reqs/01 §8 criterion 1's auditable bridge, at the grain it was computed at. ``plan_id`` and ``version_id`` are required rather than optional, and that is the point of the endpoint rather than a restriction on it: a bridge is a decomposition *of a version*, and the previous signature — which named none — could only ever have answered from an unbounded read over every version in the estate (G16). ADR 0104 records the bump. */
export type DriverBridgeParams = {
  readonly query?: {
    readonly plan_id?: string;
    readonly version_id?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/strategic/driver-bridge` */
export const driverBridge: OperationSpec<DriverBridgeParams, CursorPageDriverContribution> = {
  operationId: "driver_bridge_api_v1_strategic_driver_bridge_get",
  method: "GET",
  path: "/api/v1/strategic/driver-bridge",
  tag: "strategic",
  pathParams: [],
  queryParams: ["plan_id", "version_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/registry/parameters/effective` — Effective Parameter — The value ``parameter_key`` takes for one context on ``as_of``, and where it comes from. One resolver, the engines' own (ADR 9007): the answer here is the answer a reader holding the same facts gets. A ``store`` implies its country, format and channel from the location master, and an ``article`` its ancestors in the pinned product hierarchy, unless the caller states them. ``product_node`` may be repeated to state an ancestor chain directly, most specific first. ``department_family`` is a family of the market's class scheme (ADR 9055); nothing implies it, so it is stated. ``as_of`` is required for the reason ``GET /parameters`` gives; ``known_at`` asks as the registry held it then (ADR 9006). */
export type EffectiveParameterParams = {
  readonly query?: {
    readonly parameter_key?: string;
    readonly as_of?: string;
    readonly known_at?: string | null;
    readonly country?: string | null;
    readonly format?: string | null;
    readonly cluster?: string | null;
    readonly store?: string | null;
    readonly article?: string | null;
    readonly product_node?: readonly (string)[] | null;
    readonly lifecycle_class?: string | null;
    readonly season?: string | null;
    readonly channel?: string | null;
    readonly currency?: string | null;
    readonly department_family?: string | null;
  };
};

/** `GET /api/v1/registry/parameters/effective` */
export const effectiveParameter: OperationSpec<EffectiveParameterParams, EffectiveParameter> = {
  operationId: "effective_parameter_api_v1_registry_parameters_effective_get",
  method: "GET",
  path: "/api/v1/registry/parameters/effective",
  tag: "registry",
  pathParams: [],
  queryParams: ["parameter_key", "as_of", "known_at", "country", "format", "cluster", "store", "article", "product_node", "lifecycle_class", "season", "channel", "currency", "department_family"],
  hasBody: false,
};

/** `GET /api/v1/inseason/elasticity/model-version` — Elasticity Model Version — The fit generation in force, so a caller can name it without guessing it. **This does not weaken the rule that a caller must name one.** :func:`list_elasticity_estimates` and ``GET /markdown/path`` both require ``model_version_id`` because "a query that silently followed the newest fit would re-derive last season's markdown with this season's coefficients". That rule is about which generation a *recommendation* is derived from, and it survives intact: the caller still names the version on every request. What it could not do before was find out what to name — the id lives in a registry row only ``administrator`` and ``auditor`` may read, so a planner's only route to it was for somebody to tell them the string ``elasticity-fit-v2-2026-09-11``. A picker that had to be told cannot be offered. ``None`` until boot resolves one, on the same terms as :func:`elasticity_sanity_band`: a version invented here would send a caller to coefficients no fit ever wrote, and an empty answer is the honest one. */
export type ElasticityModelVersionParams = Record<string, never>;

/** `GET /api/v1/inseason/elasticity/model-version` */
export const elasticityModelVersion: OperationSpec<ElasticityModelVersionParams, ElasticityModelVersion | null> = {
  operationId: "elasticity_model_version_api_v1_inseason_elasticity_model_version_get",
  method: "GET",
  path: "/api/v1/inseason/elasticity/model-version",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/elasticity/sanity-band` — Elasticity Sanity Band — The band a category coefficient must sit in, as the registry holds it. ``None`` until the registry row is loaded. That is the honest answer and the one G1 requires: inventing a band here would put a commercial judgement in source, and a client that received an invented band would silently accept every implausible coefficient the band exists to catch. */
export type ElasticitySanityBandParams = Record<string, never>;

/** `GET /api/v1/inseason/elasticity/sanity-band` */
export const elasticitySanityBand: OperationSpec<ElasticitySanityBandParams, ElasticityBand | null> = {
  operationId: "elasticity_sanity_band_api_v1_inseason_elasticity_sanity_band_get",
  method: "GET",
  path: "/api/v1/inseason/elasticity/sanity-band",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/strategic/envelope-preview` — Envelope Preview — Derive an envelope without releasing it. The release is a commercial commitment and follows reqs/07 §3.5; this is the arithmetic a planner iterates on before proposing one. */
export type EnvelopePreviewParams = {
  readonly body: EnvelopeRequest;
};

/** `POST /api/v1/strategic/envelope-preview` */
export const envelopePreview: OperationSpec<EnvelopePreviewParams, EnvelopeResponse> = {
  operationId: "envelope_preview_api_v1_strategic_envelope_preview_post",
  method: "POST",
  path: "/api/v1/strategic/envelope-preview",
  tag: "strategic",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/strategic/envelopes` — Envelopes — The released, version-stamped OTB envelopes §2.1 plans against, for a season. ``season_key`` is required for the reason ``driver_bridge``'s identifiers are: the selector that answers this read is bounded by a season, and an envelope list that spanned every season it had ever released would be the unbounded collection read G16 forbids. */
export type EnvelopesParams = {
  readonly query?: {
    readonly season_key?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/strategic/envelopes` */
export const envelopes: OperationSpec<EnvelopesParams, CursorPageEnvelopeRow> = {
  operationId: "envelopes_api_v1_strategic_envelopes_get",
  method: "GET",
  path: "/api/v1/strategic/envelopes",
  tag: "strategic",
  pathParams: [],
  queryParams: ["season_key", "limit", "cursor"],
  hasBody: false,
};

/** `POST /api/v1/conformance/commit-guard` — Evaluate Commit Guard — Offer a material decision to the guard without committing it (reqs/07 §3.6 (a)). A dry run: it writes nothing and raises nothing, so a screen can show what is missing before a planner presses commit. The refusing path is :func:`services.api.commit.commit_decision`, which the owning chapter's commit endpoint calls — the guard is a precondition of the write, and a caller that consulted this endpoint and then wrote directly is exactly what the standing audit in ``services.repositories.scenario`` looks for. */
export type EvaluateCommitGuardParams = {
  readonly body: CommitGuardRequest;
};

/** `POST /api/v1/conformance/commit-guard` */
export const evaluateCommitGuard: OperationSpec<EvaluateCommitGuardParams, CommitGuardResponse> = {
  operationId: "evaluate_commit_guard_api_v1_conformance_commit_guard_post",
  method: "POST",
  path: "/api/v1/conformance/commit-guard",
  tag: "conformance",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/exit/position/compaction` — How scattered this position is — reqs/05 §3.8. Residual units weighted by the run completeness at each door, over the doors holding them: concentrating the same residual raises it and breaking the runs that hold it lowers it. Null on zero residual and never zero. Nothing here returns a threshold — the alert level is registered unset with an owner, and the measure's value is the trend rather than the level. */
export type EvaluateCompactionParams = {
  readonly body: CompactionRequest;
};

/** `POST /api/v1/exit/position/compaction` */
export const evaluateCompaction: OperationSpec<EvaluateCompactionParams, CompactionResponse> = {
  operationId: "evaluate_compaction_api_v1_exit_position_compaction_post",
  method: "POST",
  path: "/api/v1/exit/position/compaction",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/exit/indifference/evaluate` — Is it cheaper to move this lot, or to discount it where it stands — reqs/05 §3.7. Chapter 04's optimiser is solved twice — on the doors that hold the lot now, and on the consolidated position — and the per-unit lane cost at which the two are equal is the indifference point. Both figures are returned or neither is. A market held by gate D2 is still scored, emits no transfer line, and carries the margin points the prevented transfer would have saved. An uncosted lane draws no curve rather than an estimated cost. The response states whether it was computed now or read from a stored job output: the estate-scale version is a job output, because it is two solves per lot. */
export type EvaluateIndifferenceParams = {
  readonly body: IndifferenceRequest;
};

/** `POST /api/v1/exit/indifference/evaluate` */
export const evaluateIndifference: OperationSpec<EvaluateIndifferenceParams, IndifferenceResponse> = {
  operationId: "evaluate_indifference_api_v1_exit_indifference_evaluate_post",
  method: "POST",
  path: "/api/v1/exit/indifference/evaluate",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/exit/routing/evaluate` — Score the permitted exit routes for one lot — Brand protection gates before scoring, so a forbidden route never appears as one that lost on price. Every surviving route is returned with its realisation decomposed, and the highest net realisation wins (reqs/05 §3.5). */
export type EvaluateRoutingParams = {
  readonly body: RouteLotRequest;
};

/** `POST /api/v1/exit/routing/evaluate` */
export const evaluateRouting: OperationSpec<EvaluateRoutingParams, RoutingSummary> = {
  operationId: "evaluate_routing_api_v1_exit_routing_evaluate_post",
  method: "POST",
  path: "/api/v1/exit/routing/evaluate",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/exit/position/stranded` — Whether this lot can be discounted, moved, or neither — reqs/05 §3.8's join: a lot at its price floor, with no permitted route scorable, inside the handover alert lead. Each state alone is routine; the conjunction is a lot that cannot be discounted further, cannot be moved and is running out of weeks, and it is the most operationally urgent row the chapter produces. Where one of the three was never established the verdict is undetermined, which is never counted as safe. The row uses reason codes already in force and mints none. */
export type EvaluateStrandedParams = {
  readonly body: StrandedRequest;
};

/** `POST /api/v1/exit/position/stranded` */
export const evaluateStranded: OperationSpec<EvaluateStrandedParams, StrandedResponse> = {
  operationId: "evaluate_stranded_api_v1_exit_position_stranded_post",
  method: "POST",
  path: "/api/v1/exit/position/stranded",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/exit/terminal-stock/evaluate` — Evaluate a projected residual against the terminal-stock ceiling — The predicate chapter 04's markdown optimisation solves against. A projected residual at or below the ceiling satisfies the constraint; an overshoot is a violation and a shortfall is reported because clearing to zero implies the cadence discounted harder than the plan required. */
export type EvaluateTerminalStockParams = {
  readonly body: TerminalStockRequest;
};

/** `POST /api/v1/exit/terminal-stock/evaluate` */
export const evaluateTerminalStock: OperationSpec<EvaluateTerminalStockParams, TerminalStockResponse> = {
  operationId: "evaluate_terminal_stock_api_v1_exit_terminal_stock_evaluate_post",
  method: "POST",
  path: "/api/v1/exit/terminal-stock/evaluate",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/runs/{run_id}/execution-pack` — Execution Pack — One run's approved lines to execute in Oracle, with provenance (ADR 6037). Every approved proposal (and adjusted one), approved transfer and approved price step of the run carries a write-back command minted with its decision; this is those commands, grouped DC → store, donor → recipient and article × week, each with its state verbatim and the run, decision, actor, time and reason behind it. ``state`` narrows to one command state — ``approved`` is what is left to export, ``dispatched`` what is exported and awaits confirmation. ``store_key`` and ``subject_kind`` narrow to one write-back group's commands (ADR 6054). 404 when the run does not exist or is outside the caller's scope. Authorised as ``export`` on the plan. A read: it mints nothing, so a re-export never re-mints. */
export type ExecutionPackParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly state?: WriteBackStateCode | null;
    readonly store_key?: string | null;
    readonly subject_kind?: WriteBackSubjectKind | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/execution-pack` */
export const executionPack: OperationSpec<ExecutionPackParams, ExecutionPack> = {
  operationId: "execution_pack_api_v1_inseason_runs__run_id__execution_pack_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/execution-pack",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["state", "store_key", "subject_kind"],
  hasBody: false,
};

/** `GET /api/v1/exit/dispositions/vocabulary` — The dispositions a planner may record on a cadence proposal — The same four codes chapter 04 publishes, served here so a client of the exit queue does not have to know that. An unconstrained string on an audited decision is how a reason-code audit rots: the vocabulary is now a schema type and the labels are resolved for the caller's Accept-Language (ADR 0057). */
export type ExitDispositionVocabularyParams = Record<string, never>;

/** `GET /api/v1/exit/dispositions/vocabulary` */
export const exitDispositionVocabulary: OperationSpec<ExitDispositionVocabularyParams, readonly (DispositionOption)[]> = {
  operationId: "exit_disposition_vocabulary_api_v1_exit_dispositions_vocabulary_get",
  method: "GET",
  path: "/api/v1/exit/dispositions/vocabulary",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/exit/lifecycle-transitions/runs` — List Runs — The market's transition runs, oldest first, each with its evidence and refusal. */
export type ExitListRunsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly effective_month?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/lifecycle-transitions/runs` */
export const exitListRuns: OperationSpec<ExitListRunsParams, CursorPageTransitionRunModel> = {
  operationId: "list_runs_api_v1_exit_lifecycle_transitions_runs_get",
  method: "GET",
  path: "/api/v1/exit/lifecycle-transitions/runs",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "effective_month", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/registry/parameters/expiring` — Expiring Parameters — Rows in force on ``as_of`` whose window ends, or whose review falls due, soon (W2-3). "Soon" is ``registry.expiry_warning_horizon_days`` — a registry key, with no default. Until a row of it is in force the answer is ``horizonStatus: not_set`` and no rows: a warning horizon this service chose would be the one number on the screen nobody decided. ``as_of`` is required for the reason ``GET /parameters`` gives. */
export type ExpiringParametersParams = {
  readonly query?: {
    readonly as_of?: string;
  };
};

/** `GET /api/v1/registry/parameters/expiring` */
export const expiringParameters: OperationSpec<ExpiringParametersParams, ExpiringParameters> = {
  operationId: "expiring_parameters_api_v1_registry_parameters_expiring_get",
  method: "GET",
  path: "/api/v1/registry/parameters/expiring",
  tag: "registry",
  pathParams: [],
  queryParams: ["as_of"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/cells/export` — Every cell of a run as a CSV file — `GET /{run_id}/report/replenishment/cells` as one file: the same statement, order and columns, for every cell the run recorded and every size it named without a forecast, with no ceiling (ADR 6197). Read a page at a time and streamed as it is read (UTF-8 with a BOM, RFC 4180), so a run of hundreds of thousands of cells is never resident (ADR 6194). The first page is read before the response starts, so a refusal is an RFC 9457 problem and never a truncated file. `X-Bata-Row-Count` states the rows the file holds; a walk that writes a different number ends the response without its final chunk, so it reads as cut (ADR 6201). */
export type ExportCellsReportParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/cells/export` */
export const exportCellsReport: OperationSpec<ExportCellsReportParams, void> = {
  operationId: "export_cells_report_api_v1_inseason_runs__run_id__report_replenishment_cells_export_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/report/replenishment/cells/export",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/doors/export` — The door positions of a run as a CSV file — `GET /consolidation/doors` as a file: the same filters, the same statement, the same order and the same columns (every field of a page's item), for every row the filters match -- `matching` rows, with no ceiling. The store is read a page at a time and the CSV (UTF-8 with a BOM, RFC 4180) streams as it is read, so a run of hundreds of thousands of option x door rows is never resident. CSV is the only format; a client wanting a workbook builds it from this file (ADR 6194). */
export type ExportConsolidationDoorsParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly option_id?: string | null;
    readonly country_key?: string | null;
    readonly cluster_id?: string | null;
    readonly store_key?: string | null;
    readonly as_of?: string | null;
    readonly run_is_broken?: boolean | null;
    readonly sell_through_absent?: boolean | null;
  };
};

/** `GET /api/v1/exit/consolidation/doors/export` */
export const exportConsolidationDoors: OperationSpec<ExportConsolidationDoorsParams, void> = {
  operationId: "export_consolidation_doors_api_v1_exit_consolidation_doors_export_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/doors/export",
  tag: "exit",
  pathParams: [],
  queryParams: ["run_id", "option_id", "country_key", "cluster_id", "store_key", "as_of", "run_is_broken", "sell_through_absent"],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/lines/export` — The candidate consolidation movements of a run as a CSV file — `GET /consolidation/lines` as a file: the same filters, the same statement, the same order and the same columns (every field of a page's item), for every row the filters match -- `matching` rows, with no ceiling. The store is read a page at a time and the CSV (UTF-8 with a BOM, RFC 4180) streams as it is read. CSV is the only format; a client wanting a workbook builds it from this file (ADR 6194). */
export type ExportConsolidationLinesParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly option_id?: string | null;
    readonly country_key?: string | null;
    readonly source_store_key?: string | null;
    readonly destination_store_key?: string | null;
    readonly size_key?: string | null;
    readonly is_proposed?: boolean | null;
    readonly reason_code?: string | null;
    readonly as_of?: string | null;
    readonly action_id?: string | null;
    readonly repairs_size_run?: boolean | null;
    readonly lane_cost_absent?: boolean | null;
    readonly lane_priced?: boolean | null;
  };
};

/** `GET /api/v1/exit/consolidation/lines/export` */
export const exportConsolidationLines: OperationSpec<ExportConsolidationLinesParams, void> = {
  operationId: "export_consolidation_lines_api_v1_exit_consolidation_lines_export_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/lines/export",
  tag: "exit",
  pathParams: [],
  queryParams: ["run_id", "option_id", "country_key", "source_store_key", "destination_store_key", "size_key", "is_proposed", "reason_code", "as_of", "action_id", "repairs_size_run", "lane_cost_absent", "lane_priced"],
  hasBody: false,
};

/** `GET /api/v1/compacting/runs/{run_id}/export` — Export Move Run — One list of the run as a CSV (UTF-8 with a BOM, RFC 4180), streamed (ADR 6194). ``moves``: the one list — proposed and held lines in the run's order, with ``state``. ``held``: its held lines. ``refusals``: the candidates refused by name. ``ledger``: the store-week ledger. The columns are the page's fields, in its order; the rows are the page reads walked to the end, so the file is the list, row for row. ``X-Bata-Row-Count`` states the rows before the first is sent. 404 ``move_run_not_found`` for a run the caller cannot see. */
export type ExportMoveRunParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly kind?: MoveRunExportKind;
    readonly stock_owner?: MoveStockOwner | null;
    readonly purpose?: string | null;
    readonly origin?: string | null;
    readonly destination?: string | null;
    readonly article?: string | null;
    readonly disposition?: string | null;
    readonly store_key?: string | null;
  };
};

/** `GET /api/v1/compacting/runs/{run_id}/export` */
export const exportMoveRun: OperationSpec<ExportMoveRunParams, void> = {
  operationId: "export_move_run_api_v1_compacting_runs__run_id__export_get",
  method: "GET",
  path: "/api/v1/compacting/runs/{run_id}/export",
  tag: "compacting",
  pathParams: ["run_id"],
  queryParams: ["kind", "stock_owner", "purpose", "origin", "destination", "article", "disposition", "store_key"],
  hasBody: false,
};

/** `POST /api/v1/me/feedback` — File My Report — File a report: a malfunction, an enhancement request, a question or a doubted figure. Committed with its audit row and the first line of its history. ``Idempotency-Key`` is required, so a retried POST answers the first response and files one report. At most ``feedback_reports_per_day`` per person in a rolling 24 hours: beyond it, 429 ``platform.feedback.quota_exceeded`` with ``Retry-After``. A body with structured fields, or of a kind new to ADR 1020, must satisfy the rubric of its kind (422 ``platform.feedback.incomplete`` with ``missing``). */
export type FileMyReportParams = {
  readonly body: FeedbackRequest;
};

/** `POST /api/v1/me/feedback` */
export const fileMyReport: OperationSpec<FileMyReportParams, FeedbackReport> = {
  operationId: "file_my_report_api_v1_me_feedback_post",
  method: "POST",
  path: "/api/v1/me/feedback",
  tag: "feedback",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/assistant/conversations/{conversation_id}/tickets` — File Ticket — File the report prepared in this conversation, on the person's confirmation (ADR 2137). Only with the single-use confirmation the platform gave the application for this exact draft, from the person it was given to: 404 ``platform.assistant.conversation_not_found`` for a conversation that is not theirs, 409 ``platform.assistant.confirmation_invalid`` for a confirmation used, expired, superseded or for another draft. The rubric runs again (422 ``platform.assistant.draft_incomplete``), the markets are checked against the person's reach again, and the reports' quota counts it (429 ``platform.feedback.quota_exceeded``). The report is filed ``received`` (nothing else is possible), as the person, ``filed_via = optima``, with its first history line and an audit row (recorder ``assistant_filing``, actor pseudonymised) in one transaction. ``Idempotency-Key`` is required; the answer carries no text. */
export type FileTicketParams = {
  readonly path: {
    readonly conversation_id: string;
  };
  readonly body: FilingRequest;
};

/** `POST /api/v1/assistant/conversations/{conversation_id}/tickets` */
export const fileTicket: OperationSpec<FileTicketParams, FilingOutcome> = {
  operationId: "file_ticket_api_v1_assistant_conversations__conversation_id__tickets_post",
  method: "POST",
  path: "/api/v1/assistant/conversations/{conversation_id}/tickets",
  tag: "assistant",
  pathParams: ["conversation_id"],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/strategic/footprint-options` — Footprint Options — The evaluated footprint scenarios, cheapest first. reqs/07 §3.6 requires a material decision to be committed from a comparison of at least two alternatives, so the rejected options are served beside the recommended one rather than discarded. */
export type FootprintOptionsParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/strategic/footprint-options` */
export const footprintOptions: OperationSpec<FootprintOptionsParams, CursorPageFootprintOptionRow> = {
  operationId: "footprint_options_api_v1_strategic_footprint_options_get",
  method: "GET",
  path: "/api/v1/strategic/footprint-options",
  tag: "strategic",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/forecast-basis` — Forecast Basis — The forecast basis of one run's rates at one door x article (ADR 6101). **Only what the run recorded.** The archive header is the one the run's ``forecast_run_id`` names; the forecast version is the one on the run's own proposals; the rate method holds wherever the run stored a rate. The pull tunables — service target, central level, review and lead-time periods — are recorded on no row, so each is ``null`` with ``not_recorded_by_run``: re-reading the registry now would publish a value the run may never have read. 404 when the run does not exist or is outside the caller's scope. */
export type ForecastBasisParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly store_key?: string;
    readonly article_key?: string;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/forecast-basis` */
export const forecastBasis: OperationSpec<ForecastBasisParams, ForecastBasisSummary> = {
  operationId: "forecast_basis_api_v1_inseason_runs__run_id__forecast_basis_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/forecast-basis",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["store_key", "article_key"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/forecast-explanation` — Forecast Explanation — How one run's store x article line was forecast, step by step, to its proposal (ADR 6218). The why screen's «Cómo se calculó»: the window weeks with raw sales before and after returns and recovered demand, the median, the seasonal index, the k2 cap and the central value the pull read (or a fallback store x article's own steps), each size's landed share and evidence, and the run's targets, positions, needs and lines. Every figure as the producer landed it or the run stored it. 404 when the run does not exist or is outside the caller's scope; an explanation not recorded is a 200 with its reason. */
export type ForecastExplanationParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly store_key?: string;
    readonly article_key?: string;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/forecast-explanation` */
export const forecastExplanation: OperationSpec<ForecastExplanationParams, ForecastExplanationSummary> = {
  operationId: "forecast_explanation_api_v1_inseason_runs__run_id__forecast_explanation_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/forecast-explanation",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["store_key", "article_key"],
  hasBody: false,
};

/** `GET /api/v1/foundations/exceptions` — List Exceptions — The exception queue. G1 makes this the only inbox — there is no other path. **Paged in the store, with a count (ADR 2129).** One page is one statement — the order, the cursor and the limit are in it — and ``total`` is a second, a ``COUNT`` over the same filters; the queue is never read whole. ``order`` is ``raised`` unless asked otherwise, so a client that names none reads what it always read. ``total_by_severity`` (ADR 2130) is a third, the same filters grouped by severity code. **The department filter (owner ruling R-12, ADR 2106).** ``department_family`` is derived at read, not stored: the market's pinned product class scheme applied to the attribute master on the request date — the in-season drill's classification (ADR 6038). It needs exactly one market, named by ``country_key``, and is refused without one (``alert_department_needs_market``, 422) rather than applied under a scheme chosen for the caller; a market with no usable scheme is refused too (``alert_department_scheme_not_pinned`` / ``_refused``, 409), never answered with an empty page. Alerts with no ``article_key`` (a failed cycle, a store-level rule) never match a family. **The queues (W3-4, ADR 2103).** ``queue=mine`` is what is assigned to the caller; ``queue=claimable`` is unassigned, undecided, and raised by a rule whose owner is one of the caller's roles (DEC-13, recipient by role); ``queue=unassigned`` is every alert with no assignee, whatever its state or rule — the rows the grouped read counts as ``unassignedCount`` (ADR 6194), and no caller is needed; ``queue=all`` (or none) narrows nothing. ``state`` is ``open`` / ``snoozed`` / ``decided`` on today's date, and when it is given ``open_only`` is ignored. ``overdue``, ``store_key``, ``rule_id`` and ``severity`` (the alert's own code, ADR 6194) narrow further. A named queue with no signed-in caller is empty. ``assignee`` is **deprecated**: its *assigned to X or unassigned* reading is kept for one release and then removed; ``queue`` replaces it. ``assignee`` narrows to one planner's inbox *and the unassigned*, because an unowned alert must be visible to somebody or G1's "only inbox" has a hole in it. It is not a permission: the scope is what bounds the read, and the register is where it comes from. ``open_only=false`` returns decided alerts too, each with its disposition state (ADR 2004); on an open alert those four fields are ``null``. */
export type FoundationsListExceptionsParams = {
  readonly query?: {
    readonly open_only?: boolean;
    readonly assignee?: string | null;
    readonly queue?: AlertQueue | null;
    readonly state?: AlertState | null;
    readonly overdue?: boolean | null;
    readonly store_key?: string | null;
    readonly rule_id?: string | null;
    readonly severity?: readonly (string)[] | null;
    readonly country_key?: string | null;
    readonly department_family?: string | null;
    readonly article_key?: string | null;
    readonly order?: AlertOrder;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/foundations/exceptions` */
export const foundationsListExceptions: OperationSpec<FoundationsListExceptionsParams, AlertPage> = {
  operationId: "list_exceptions_api_v1_foundations_exceptions_get",
  method: "GET",
  path: "/api/v1/foundations/exceptions",
  tag: "foundations",
  pathParams: [],
  queryParams: ["open_only", "assignee", "queue", "state", "overdue", "store_key", "rule_id", "severity", "country_key", "department_family", "article_key", "order", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/foundations/parameters` — List Parameters — The effective-dated parameter registry (G1). Every tunable is here or nowhere. */
export type FoundationsListParametersParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/foundations/parameters` */
export const foundationsListParameters: OperationSpec<FoundationsListParametersParams, CursorPageParameterSummary> = {
  operationId: "list_parameters_api_v1_foundations_parameters_get",
  method: "GET",
  path: "/api/v1/foundations/parameters",
  tag: "foundations",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/vocabularies/{vocabulary}` — The labels of a vocabulary's codes, in the caller's language — Labels for ``vocabulary``'s codes, resolved for the caller's ``Accept-Language``. The labels are registry rows ``vocabulary.label.<vocabulary>.<locale>.<code>`` (ADR 2125), authored as a governed change set; the first row found walking the G6 fallback chain wins. 503 ``platform.foundations.vocabularies_unavailable`` when nothing is wired. */
export type FoundationsReadVocabularyParams = {
  readonly path: {
    readonly vocabulary: string;
  };
  readonly query?: {
    readonly code?: readonly (string)[] | null;
  };
};

/** `GET /api/v1/vocabularies/{vocabulary}` */
export const foundationsReadVocabulary: OperationSpec<FoundationsReadVocabularyParams, VocabularyTermsResponse> = {
  operationId: "read_vocabulary_api_v1_vocabularies__vocabulary__get",
  method: "GET",
  path: "/api/v1/vocabularies/{vocabulary}",
  tag: "foundations",
  pathParams: ["vocabulary"],
  queryParams: ["code"],
  hasBody: false,
};

/** `GET /api/v1/health/availability` — Get Availability — Availability: cells served in stock, out or broken, broken size runs, full price. The newest distribute run of the market (or ``run_id``), counted as the network-health cockpit counts it (move-aware). Full-price availability is the share of served cells in stock over the full-price subset (docs/25 §5.3 A2.3): its ``breakdown`` counts the articles in it and each reason the others are out; at ``group_by=article`` each row's full-price figure carries ``fullPrice``, ``rangedStores`` and ``inForceStores``. Trend: the last eight cycle periods, the newest run of each. Pending: undecided proposals, undecided moves of the tick's move run, open ``inseason.size_run_broken`` alerts. */
export type GetAvailabilityParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly group_by?: HealthGroupBy;
    readonly department_family?: string | null;
    readonly run_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/health/availability` */
export const getAvailability: OperationSpec<GetAvailabilityParams, HealthReportModel> = {
  operationId: "get_availability_api_v1_health_availability_get",
  method: "GET",
  path: "/api/v1/health/availability",
  tag: "health",
  pathParams: [],
  queryParams: ["country_key", "group_by", "department_family", "run_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/programme/reconciliation` — Get Baseline Reconciliation — D0's evidence — the standing reconciliation baseline against the estate. This reports. The assertion that fails a build lives in ``bata-data``: a dbt singular test tagged ``baseline`` and a pytest under ``xfail(strict=True)`` naming M2 and D0, so that the moment the estate reconciles the marker must be removed in the same pull request that certifies the feeds. An xfail that silently starts passing is how a deferral becomes permanent, and that mechanism is deliberately not reimplemented here. */
export type GetBaselineReconciliationParams = Record<string, never>;

/** `GET /api/v1/programme/reconciliation` */
export const getBaselineReconciliation: OperationSpec<GetBaselineReconciliationParams, BaselineReconciliation | null> = {
  operationId: "get_baseline_reconciliation_api_v1_programme_reconciliation_get",
  method: "GET",
  path: "/api/v1/programme/reconciliation",
  tag: "programme",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/residual-distribution` — One position run's residual units ranked by option, over the whole run — The Pareto read behind the consolidation screen (V6-07): how many options hold half and 80% of the run's residual units, and the cumulative curve by rank, over **every** option of the run rather than the pages a screen has read. The population is the run's door rows at the run's own `as_of`, rolled up per option as `/consolidation/options` rolls them up. Ranked by residual descending, `option_id` ascending at a tie — the tie order changes no figure. Nothing is excluded; options holding zero rank last and are counted. The curve is downsampled to at most `max_points` ranks and always carries rank 1, the last rank and both threshold ranks; the share is `cumulative_residual_units / total_residual_units`. `option_id_prefix` adds a count of the options whose id starts with it — a breakdown, never a filter. `run_id` must name an `exit.consolidation_position` run; an `exit.consolidation_run` run is refused with `planning.exit.not_a_position_run` (pass its `position_run_id`). */
export type GetConsolidationResidualDistributionParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly max_points?: number;
    readonly option_id_prefix?: string | null;
  };
};

/** `GET /api/v1/exit/consolidation/residual-distribution` */
export const getConsolidationResidualDistribution: OperationSpec<GetConsolidationResidualDistributionParams, ConsolidationResidualDistribution> = {
  operationId: "get_consolidation_residual_distribution_api_v1_exit_consolidation_residual_distribution_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/residual-distribution",
  tag: "exit",
  pathParams: [],
  queryParams: ["run_id", "max_points", "option_id_prefix"],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/runs/{run_id}/digest` — One consolidation run's lanes by reason and its residual, for charts — bata-ui#148 step 4.1, ADR 7023. One request powers the Cockpit's exit charts: the run's lanes, proposed lanes, units and net benefit (per currency) by reason, and the residual of its position run — the run itself, or a decision run's `position_run_id` — at that run's `as_of`, by door role and broken size run. Computed on read from the rows `/consolidation/lines` and `/consolidation/doors` page over, never the job's output. A lane with no recorded net benefit is counted, never summed as 0; a residual with no position run is `null` with its reason; residual by markdown rung is `null` with `planning.exit.digest.rung_not_recorded`. 404 when the run does not exist or is outside the caller's scope. */
export type GetConsolidationRunDigestParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/exit/consolidation/runs/{run_id}/digest` */
export const getConsolidationRunDigest: OperationSpec<GetConsolidationRunDigestParams, ConsolidationRunDigestSummary> = {
  operationId: "get_consolidation_run_digest_api_v1_exit_consolidation_runs__run_id__digest_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/runs/{run_id}/digest",
  tag: "exit",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/runs/{run_id}/parameters` — The value in force of every registry key one consolidation run read — bata-reqs ADR 9001 decision 5 and ADR 9000: what the «Parametri in vigore» sheet of a Compacting workbook is built from. Any run `/consolidation/runs` lists (position, decision, lane move, a simulation's). Recorded by the job runner when the run succeeded, from every registry read it made: each key's rows in force on the day it was read, as the registry was known at the run's pinned instant, with scope, change set and validity. **Never today's registry:** a run without a record answers `recorded: false` with `not_recorded_by_run`. 404 when the run does not exist or is outside the caller's scope. */
export type GetConsolidationRunParametersParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/exit/consolidation/runs/{run_id}/parameters` */
export const getConsolidationRunParameters: OperationSpec<GetConsolidationRunParametersParams, ParametersInForceSummary> = {
  operationId: "get_consolidation_run_parameters_api_v1_exit_consolidation_runs__run_id__parameters_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/runs/{run_id}/parameters",
  tag: "exit",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/health/coverage` — Get Coverage — Coverage: cells low on cover, aged stock, median weeks of cover, open cover alerts. Run figures come from the run (``cycle_period`` trend); the aged-stock share comes from the monthly cover panel, in the registry's bands (``month`` trend), with each band, the non-selling units and the unmeasurable units in its ``breakdown``. Pending adds the month's undecided lifecycle transition and outlet recommendations. ``distribution`` counts the run's reported cells and their units on hand by weeks-of-cover band (the market's ``health.coverage.cover_band_weeks``, default ``2,4,8,13,26``), and each group of the page carries its own; ``provenance.coverDistributionSource`` says whether the edges are a registry row or the default. */
export type GetCoverageParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly group_by?: HealthGroupBy;
    readonly department_family?: string | null;
    readonly run_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/health/coverage` */
export const getCoverage: OperationSpec<GetCoverageParams, HealthReportModel> = {
  operationId: "get_coverage_api_v1_health_coverage_get",
  method: "GET",
  path: "/api/v1/health/coverage",
  tag: "health",
  pathParams: [],
  queryParams: ["country_key", "group_by", "department_family", "run_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/programme/feeds/{feed_id}` — Get Feed Certification — One feed's certification state, its blockers and the capabilities it unblocks. ``blockedOn`` is the field that matters on this response and it is deliberately a free string naming a deliverable or an open question — an M1 deliverable, a `13` open question, a vocabulary registry that does not exist. A feed blocked on a named thing is a feed somebody can unblock; a feed blocked on "data quality" is a feed nobody owns. */
export type GetFeedCertificationParams = {
  readonly path: {
    readonly feed_id: string;
  };
};

/** `GET /api/v1/programme/feeds/{feed_id}` */
export const getFeedCertification: OperationSpec<GetFeedCertificationParams, FeedCertificationState> = {
  operationId: "get_feed_certification_api_v1_programme_feeds__feed_id__get",
  method: "GET",
  path: "/api/v1/programme/feeds/{feed_id}",
  tag: "programme",
  pathParams: ["feed_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/lines/{line_id}/explanation` — Why one consolidation lane: its decision and both doors as the run read them — One lane's reason, economics and forecast basis, and its two doors' positions from the paired position run and roles from the decision run (ADR 6128). 404 when the lane is unseen. */
export type GetLaneExplanationParams = {
  readonly path: {
    readonly line_id: string;
  };
};

/** `GET /api/v1/exit/consolidation/lines/{line_id}/explanation` */
export const getLaneExplanation: OperationSpec<GetLaneExplanationParams, LaneExplanationSummary> = {
  operationId: "get_lane_explanation_api_v1_exit_consolidation_lines__line_id__explanation_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/lines/{line_id}/explanation",
  tag: "exit",
  pathParams: ["line_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/health/markdown-exposure` — Get Markdown Exposure — Markdown exposure: the pairs forecast to remain when each MAIN article enters Zona Sale. bata-reqs#66 B (owner rulings 2026-11-02, ADR 9053 amended 2026-11-03). Markdown is an article moving from MAIN to Zona Sale, on the first of the month it has ``exit.lifecycle_transition.minimum_age_months`` complete months of life (its 7th month with 6; ``parameters`` names the key and its value). Snapshot: ``markdown_exposure_units`` -- stock on hand at stores and distribution centres less forecast sales to the entry month, floored at nought per article (``known`` of ``total`` MAIN articles with stock; the unforecast and those with no first selling week are counted in ``breakdown``); ``markdown_exposure_at_cost`` -- the same pairs at landed cost (uncosted pairs counted, never valued); ``zona_sales_stock_units`` and ``outlet_stock_units`` -- the stock already in those phases, with ``atCost``. ``monthsToZona`` breaks the headline down by month of entry, ``0`` being due now (entry this month or overdue). The forecast is the newest distribute run's weekly rate of sale, extended flat beyond its horizon (``provenance.forecastHorizonDays``). Trend: eight ISO weeks of stock days. Distribution-centre stock has no store: a ``store`` or ``cluster`` grouping answers ``absentReason``. ``proxy`` is false. */
export type GetMarkdownExposureParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly group_by?: HealthGroupBy;
    readonly department_family?: string | null;
    readonly price_run_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/health/markdown-exposure` */
export const getMarkdownExposure: OperationSpec<GetMarkdownExposureParams, HealthReportModel> = {
  operationId: "get_markdown_exposure_api_v1_health_markdown_exposure_get",
  method: "GET",
  path: "/api/v1/health/markdown-exposure",
  tag: "health",
  pathParams: [],
  queryParams: ["country_key", "group_by", "department_family", "price_run_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/programme/parameter-set` — Get Measurement Parameter Set — The effective-dated parameter set every measurement on this API was produced under. Exposed as its own resource rather than embedded, because G9 requires a published number to re-derive from a named parameter set and a caller must be able to fetch the set by id and get the same answer next year. The recapture rate is on it, and reqs/08 §5's range — "20-30%, not 100%" — is what its review date exists to revisit. */
export type GetMeasurementParameterSetParams = Record<string, never>;

/** `GET /api/v1/programme/parameter-set` */
export const getMeasurementParameterSet: OperationSpec<GetMeasurementParameterSetParams, ParameterSetSummary | null> = {
  operationId: "get_measurement_parameter_set_api_v1_programme_parameter_set_get",
  method: "GET",
  path: "/api/v1/programme/parameter-set",
  tag: "programme",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/programme/reports/monthly` — Get Monthly Report — The monthly management pack for one market and one closed month (ADR 9016). 404 ``programme.report_not_frozen`` until the ``programme.monthly_report`` job has frozen it, and for a market outside the caller's scope alike (G3.3). Nothing is computed here. */
export type GetMonthlyReportParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly month?: number;
  };
};

/** `GET /api/v1/programme/reports/monthly` */
export const getMonthlyReport: OperationSpec<GetMonthlyReportParams, MonthlyReport> = {
  operationId: "get_monthly_report_api_v1_programme_reports_monthly_get",
  method: "GET",
  path: "/api/v1/programme/reports/monthly",
  tag: "programme",
  pathParams: [],
  queryParams: ["country_key", "month"],
  hasBody: false,
};

/** `GET /api/v1/compacting/runs/{run_id}/parameters` — Get Move Run Parameters — The value in force of every registry key the run read: the «Parametri in vigore» sheet. bata-reqs ADR 9001 decision 5: recorded by the job runner for the run's job run, as the registry was known at the run's pinned instant. **Never today's registry:** a run without a record answers ``recorded: false`` with ``not_recorded_by_run``. 404 ``move_run_not_found`` for a run the caller cannot see. */
export type GetMoveRunParametersParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/compacting/runs/{run_id}/parameters` */
export const getMoveRunParameters: OperationSpec<GetMoveRunParametersParams, ParametersInForceSummary> = {
  operationId: "get_move_run_parameters_api_v1_compacting_runs__run_id__parameters_get",
  method: "GET",
  path: "/api/v1/compacting/runs/{run_id}/parameters",
  tag: "compacting",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/compacting/runs/{run_id}` — Get Move Run Report — One run's report: header, ownership, gates, invariants, refusals by code, KPIs. Computed on read from the rows ``…/moves`` pages over. KPI totals are always numbers: they sum what is recorded (0 over nothing), and ``lines_valued`` / ``lines_unvalued`` state the coverage the ``note`` explains. 404 ``move_run_not_found`` for a run that does not exist or is outside the caller's scope. */
export type GetMoveRunReportParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/compacting/runs/{run_id}` */
export const getMoveRunReport: OperationSpec<GetMoveRunReportParams, MoveRunReportView> = {
  operationId: "get_move_run_report_api_v1_compacting_runs__run_id__get",
  method: "GET",
  path: "/api/v1/compacting/runs/{run_id}",
  tag: "compacting",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/compacting/runs/{run_id}/workbook` — Get Move Run Workbook — The run's «Perché» workbook: one per run, its sheets and the read behind each. Moves (the one merged list, with a state column), Held back, Refused, Ledger and «Parametri in vigore» (from the run's provenance, never today's registry). The server sends CSV only (ADR 6194: a workbook cannot be streamed), so the client builds the workbook from these reads, in this order, under these titles. 404 ``move_run_not_found`` for a run the caller cannot see. */
export type GetMoveRunWorkbookParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/compacting/runs/{run_id}/workbook` */
export const getMoveRunWorkbook: OperationSpec<GetMoveRunWorkbookParams, MoveRunWorkbook> = {
  operationId: "get_move_run_workbook_api_v1_compacting_runs__run_id__workbook_get",
  method: "GET",
  path: "/api/v1/compacting/runs/{run_id}/workbook",
  tag: "compacting",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/compacting/moves/{line_id}/why` — Get Move Why — Why one row of the merged list is what it is. A line's value terms, owner and basis, place in the one list, hold or refusal, every planner decision on it and — for a forced line — its weekly releases. ``line_id`` may name a refused candidate (its refusal id). 404 ``move_line_not_found`` for a row of no run the caller can see. */
export type GetMoveWhyParams = {
  readonly path: {
    readonly line_id: string;
  };
};

/** `GET /api/v1/compacting/moves/{line_id}/why` */
export const getMoveWhy: OperationSpec<GetMoveWhyParams, MoveWhyView> = {
  operationId: "get_move_why_api_v1_compacting_moves__line_id__why_get",
  method: "GET",
  path: "/api/v1/compacting/moves/{line_id}/why",
  tag: "compacting",
  pathParams: ["line_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/me/profile` — Get My Profile — The caller's own profile. Never writes: a never-saved one answers ``saved: false``. */
export type GetMyProfileParams = Record<string, never>;

/** `GET /api/v1/me/profile` */
export const getMyProfile: OperationSpec<GetMyProfileParams, UserProfile> = {
  operationId: "get_my_profile_api_v1_me_profile_get",
  method: "GET",
  path: "/api/v1/me/profile",
  tag: "profile",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/programme/override-outcomes` — Get Override Outcomes — Override rate and outcome per decision class over the governed window (ADR 9015). Five classes, the in-season queues and the exit decisions whose trails exist. Every decided line is paired with the projection its recommendation was written with; none has a realised figure yet, and each class says why rather than showing a zero. */
export type GetOverrideOutcomesParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly as_of?: string;
  };
};

/** `GET /api/v1/programme/override-outcomes` */
export const getOverrideOutcomes: OperationSpec<GetOverrideOutcomesParams, OverrideOutcomes> = {
  operationId: "get_override_outcomes_api_v1_programme_override_outcomes_get",
  method: "GET",
  path: "/api/v1/programme/override-outcomes",
  tag: "programme",
  pathParams: [],
  queryParams: ["country_key", "as_of"],
  hasBody: false,
};

/** `GET /api/v1/programme/summary` — Get Programme Summary — Counts for the scorecard header. No aggregate status, deliberately. There is no single green/amber/red. reqs/08 §6 makes certification binary and reqs/08 §8 gives each gate its own failure action — "do not start Wave 1", "hold transfers in that market", "keep markdown as guided reporting". Rolling six different failure actions into one light discards precisely the information that makes them actionable. */
export type GetProgrammeSummaryParams = Record<string, never>;

/** `GET /api/v1/programme/summary` */
export const getProgrammeSummary: OperationSpec<GetProgrammeSummaryParams, ProgrammeSummary> = {
  operationId: "get_programme_summary_api_v1_programme_summary_get",
  method: "GET",
  path: "/api/v1/programme/summary",
  tag: "programme",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/run-configurations/{configuration_id}` — Get Run Configuration — One configuration and its current version. Archived ones are still readable. */
export type GetRunConfigurationParams = {
  readonly path: {
    readonly configuration_id: string;
  };
};

/** `GET /api/v1/run-configurations/{configuration_id}` */
export const getRunConfiguration: OperationSpec<GetRunConfigurationParams, RunConfiguration> = {
  operationId: "get_run_configuration_api_v1_run_configurations__configuration_id__get",
  method: "GET",
  path: "/api/v1/run-configurations/{configuration_id}",
  tag: "run-configurations",
  pathParams: ["configuration_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/run-configurations/{configuration_id}/versions/{version}` — Get Run Configuration Version — One version, exactly as it was saved. */
export type GetRunConfigurationVersionParams = {
  readonly path: {
    readonly configuration_id: string;
    readonly version: number;
  };
};

/** `GET /api/v1/run-configurations/{configuration_id}/versions/{version}` */
export const getRunConfigurationVersion: OperationSpec<GetRunConfigurationVersionParams, RunConfigurationVersion> = {
  operationId: "get_run_configuration_version_api_v1_run_configurations__configuration_id__versions__version__get",
  method: "GET",
  path: "/api/v1/run-configurations/{configuration_id}/versions/{version}",
  tag: "run-configurations",
  pathParams: ["configuration_id", "version"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/health/sell-through` — Get Sell Through — Sell-through: season to date leads (O4); full price; share of sales; the week's units. From the landed ``inseason_sell_through_week``: every share re-divided from summed units, so a store or family is weighted by its stock. The base is opening + intake, derived intake included (bata-data derives a store's intake from its stock change plus sales, a proxy): ``known`` of ``total`` counts the rows whose intake was a measured receipt, and ``breakdown.derivedIntakeRows`` the rows whose intake was derived. Trend: the last eight fiscal weeks, with the week's own sell-through (``sell_through_week``). Pending: the tick's undecided price steps and the month's lifecycle recommendations. */
export type GetSellThroughParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly group_by?: HealthGroupBy;
    readonly department_family?: string | null;
    readonly week?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/health/sell-through` */
export const getSellThrough: OperationSpec<GetSellThroughParams, HealthReportModel> = {
  operationId: "get_sell_through_api_v1_health_sell_through_get",
  method: "GET",
  path: "/api/v1/health/sell-through",
  tag: "health",
  pathParams: [],
  queryParams: ["country_key", "group_by", "department_family", "week", "limit", "cursor"],
  hasBody: false,
};

/** `GET /health` — Health — Liveness probe. Never logged, never traced (G8). */
export type HealthParams = Record<string, never>;

/** `GET /health` */
export const health: OperationSpec<HealthParams, HealthResponse> = {
  operationId: "health_health_get",
  method: "GET",
  path: "/health",
  tag: "platform",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/strategic/horizon` — Horizon — The rolling horizon for one cycle. Refuses a calendar that is too short. */
export type HorizonParams = {
  readonly body: HorizonRequest;
};

/** `POST /api/v1/strategic/horizon` */
export const horizon: OperationSpec<HorizonParams, HorizonResponse> = {
  operationId: "horizon_api_v1_strategic_horizon_post",
  method: "POST",
  path: "/api/v1/strategic/horizon",
  tag: "strategic",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/registry/process-calendar/imports` — Import Calendar — Bata's commercial plan for a market's year, imported from the template (ADR 2136 §4). The workbook's rows are the year's periods. A row matching a period of the same type and start edits it, or leaves it unchanged; a row matching none creates a period; a future period of the year no row names is removed; a locked period is never changed (a row changing one is refused with its sheet row, one the plan omits is kept). The changes are checked exactly as a hand edit's. ``dryRun`` previews them; otherwise they are recorded as one change set that waits for its approval. */
export type ImportCalendarParams = {
  readonly body: ImportCalendarRequest;
};

/** `POST /api/v1/registry/process-calendar/imports` */
export const importCalendar: OperationSpec<ImportCalendarParams, ImportResultView> = {
  operationId: "import_calendar_api_v1_registry_process_calendar_imports_post",
  method: "POST",
  path: "/api/v1/registry/process-calendar/imports",
  tag: "registry",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/proposals` — List Proposals — Replenishment and push-allocation recommendations for one cycle, best first. ``run_id`` is required, and its absence is why this endpoint answered from an empty reader for three milestones: ``inseason.proposals_statement`` takes a run and a scope, and a route that named neither could not call it. ADR 0104 records the bump. The filters narrow the run's rows inside the scope-rewritten statement, so one store's proposals are one page walk rather than the whole run's (bata-ui#148 step 3.2). ``total`` is how many lines the same filters match (ADR 6171): one ``COUNT`` over the same narrowing, so a filtered view states its size at once. */
export type InseasonListProposalsParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly store_key?: string | null;
    readonly article_key?: string | null;
    readonly department_family?: string | null;
    readonly reason_code?: string | null;
    readonly disposition?: string | null;
    readonly lines?: "served" | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/proposals` */
export const inseasonListProposals: OperationSpec<InseasonListProposalsParams, ProposalPage> = {
  operationId: "list_proposals_api_v1_inseason_proposals_get",
  method: "GET",
  path: "/api/v1/inseason/proposals",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id", "store_key", "article_key", "department_family", "reason_code", "disposition", "lines", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs` — List Runs — The cycle directory — which runs exist, and which of them may be trusted. Newest first, because the run a planner wants is almost always the last one and a picker that opened on the oldest would be a picker they scroll past. "Newest" is ``recorded_at desc, run_id`` (ADR 6034): the instant the run was written, so two ticks inside one monthly window resolve in write order. Stale-partition runs are **returned, not filtered**. A run computed on a quarantined partition is a real run whose proposals were really generated, and hiding it would leave a planner unable to explain why a proposal they remember approving is not on any list they can reach. The flag is on the row so the picker can say so; §14 §5 O4's refusal belongs on the command path. */
export type InseasonListRunsParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs` */
export const inseasonListRuns: OperationSpec<InseasonListRunsParams, CursorPageCycleRunSummary> = {
  operationId: "list_runs_api_v1_inseason_runs_get",
  method: "GET",
  path: "/api/v1/inseason/runs",
  tag: "inseason",
  pathParams: [],
  queryParams: ["country_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/internal/jobs/{job_name}/runs` — List Runs — One job's runs for one country, newest first (bata-platform #387). Exists so ``bata-data`` can match a published batch to the scope its run was requested with, which ADR 0105 forbids it to read from ``plan.platform_job_run`` directly. Bounded like every other read: one country per call (required), an optional window, and a page of at most :data:`MAXIMUM_PAGE_SIZE`. Same role as :func:`read_run`. */
export type InternalListRunsParams = {
  readonly path: {
    readonly job_name: string;
  };
  readonly query?: {
    readonly country_key?: string;
    readonly status?: string | null;
    readonly window_from?: string | null;
    readonly window_to?: string | null;
    readonly limit?: number;
    readonly page_token?: string | null;
  };
};

/** `GET /api/v1/internal/jobs/{job_name}/runs` */
export const internalListRuns: OperationSpec<InternalListRunsParams, JobRunPage> = {
  operationId: "list_runs_api_v1_internal_jobs__job_name__runs_get",
  method: "GET",
  path: "/api/v1/internal/jobs/{job_name}/runs",
  tag: "internal",
  pathParams: ["job_name"],
  queryParams: ["country_key", "status", "window_from", "window_to", "limit", "page_token"],
  hasBody: false,
};

/** `POST /api/v1/landing/article-lifecycle-phase-inferred` — Land Article Lifecycle Phase Inferred — Land one ``article_lifecycle_phase_inferred`` batch. All-or-nothing. bata-reqs issue 35 (ADR 6072): the phase bata-data infers per article × calendar month, the interim proxy markdown per item is gated on until planners' decisions exist. **A register restated whole**: each batch carries every article × month for the country, the newest promoted batch is the one in force, and G-4 refuses a delivery that shrinks the register in force beyond the declared tolerance (ADR 2008). */
export type LandArticleLifecyclePhaseInferredParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly basis: string;
      readonly country_key: string;
      readonly discounted_unit_share?: number | null;
      readonly lifecycle_class?: string | null;
      readonly month_start: string;
      readonly outlet_unit_share?: number | null;
      readonly phase: "MAIN" | "ZONA_SALES" | "OUTLET";
      readonly row_id: string;
      readonly weeks_observed: number;
    })[];
  };
};

/** `POST /api/v1/landing/article-lifecycle-phase-inferred` */
export const landArticleLifecyclePhaseInferred: OperationSpec<LandArticleLifecyclePhaseInferredParams, LandingResponse> = {
  operationId: "land_article_lifecycle_phase_inferred_api_v1_landing_article_lifecycle_phase_inferred_post",
  method: "POST",
  path: "/api/v1/landing/article-lifecycle-phase-inferred",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/article-size-slots` — Land Article Size Slots — Land one ``article_size_slot`` batch. All-or-nothing, in one transaction. A register restated whole on every delivery, and **replaced** rather than appended: a promoted batch deletes the map in force and writes its own rows in the gate's transaction, so ``article_size_slot`` is exactly the newest promoted batch. A quarantined batch writes nothing. G-4 refuses a batch that shrinks the map beyond the register tolerance (ADR 2008), so a truncated extract cannot wipe it. ADR 2139. */
export type LandArticleSizeSlotsParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly row_id: string;
      readonly size_group_cd: string;
      readonly size_key: string;
      readonly slot: number;
    })[];
  };
};

/** `POST /api/v1/landing/article-size-slots` */
export const landArticleSizeSlots: OperationSpec<LandArticleSizeSlotsParams, LandingResponse> = {
  operationId: "land_article_size_slots_api_v1_landing_article_size_slots_post",
  method: "POST",
  path: "/api/v1/landing/article-size-slots",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/clearance-positions` — Land Clearance Positions — Land one ``exit_clearance_position`` batch. All-or-nothing, in one transaction. Its own route rather than a ``feed`` parameter, for the reason ADR 0119 gives and its four predecessors here follow: a single "land any feed" endpoint would branch on a caller-supplied table name and let a mislabelled batch reach a table this router never named. **This is the feed that makes ``exit.consolidation_position`` do work.** That job is written, registered and has never produced a row, because ``door_residuals`` had no source: the measure it ranks doors on is not derivable from anything the plan store holds. With this edge the job's measurement half runs on real doors. Its *decision* half stays withheld — the consolidation engine run and reqs/05 §5 D8's lane costs are still absent, so every candidate movement is written ``is_proposed`` false with a reason code rather than being dropped or, worse, proposed against a zero freight cost. */
export type LandClearancePositionsParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly as_of_date: string;
      readonly cluster_key?: string | null;
      readonly country_key: string;
      readonly door_key: string;
      readonly longest_contiguous_run: number;
      readonly option_key: string;
      readonly residual_units: number;
      readonly row_id: string;
      readonly run_is_broken: boolean;
      readonly run_length?: number | null;
      readonly sell_through_per_capacity?: number | null;
      readonly size_scale?: string | null;
      readonly sizes_in_stock: number;
    })[];
  };
};

/** `POST /api/v1/landing/clearance-positions` */
export const landClearancePositions: OperationSpec<LandClearancePositionsParams, LandingResponse> = {
  operationId: "land_clearance_positions_api_v1_landing_clearance_positions_post",
  method: "POST",
  path: "/api/v1/landing/clearance-positions",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/commercial-calendar-week` — Land Commercial Calendar Week — Land one ``commercial_calendar_week`` batch. All-or-nothing, in one transaction. bata-platform#580: Bata's weekly commercial headline per country × calendar year × commercial week, parsed into descriptive columns, with the proposed mechanic code (bata-data ADR 8006/8008). Read by ``GET /postseason/promotions/calendar`` and as the labels of ``GET /postseason/promotions/windows``. */
export type LandCommercialCalendarWeekParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly bannerScope: string | null;
      readonly batchId: string;
      readonly buyQuantity: number | null;
      readonly calendarYear: number;
      readonly channelScope: string | null;
      readonly commercialWeek: number;
      readonly countryKey: string;
      readonly excludesSaleZone: boolean | number;
      readonly isBlackEvent: boolean | number;
      readonly isHotDay: boolean | number;
      readonly isSchoolOnly: boolean | number;
      readonly labelDepthPct: number | null;
      readonly labelMechanic: string;
      readonly mechanicCode: string | null;
      readonly metricsVersion: string;
      readonly modelVersion: string;
      readonly payQuantity: number | null;
      readonly productScope: string | null;
      readonly promotionText: string;
      readonly row_id: string;
      readonly statedDepthsPct: readonly (number)[];
      readonly weekEndDate: string;
      readonly weekStartDate: string;
    })[];
  };
};

/** `POST /api/v1/landing/commercial-calendar-week` */
export const landCommercialCalendarWeek: OperationSpec<LandCommercialCalendarWeekParams, LandingResponse> = {
  operationId: "land_commercial_calendar_week_api_v1_landing_commercial_calendar_week_post",
  method: "POST",
  path: "/api/v1/landing/commercial-calendar-week",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/demand-exclusion-windows` — Land Demand Exclusion Windows — Land one ``demand_exclusion_window`` batch. All-or-nothing, in one transaction. A register: each batch restates every window in force for its country, and :func:`~services.repositories.demand_exclusion.load` reads the newest promoted batch. The platform's demand readers of ``sales_transaction`` treat each window's days as absent. Not ``restates_register``: the register is MEANT to shrink as doors trade again and when Q53 retires the ruling. ADR 9024. */
export type LandDemandExclusionWindowsParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly country_key: string;
      readonly evidence_ref: string;
      readonly excluded_through?: string | null;
      readonly reason_code: string;
      readonly row_id: string;
      readonly ruled_by: string;
      readonly ruled_on: string;
      readonly silent_from: string;
      readonly store_key: string;
      readonly trades_again_on?: string | null;
    })[];
  };
};

/** `POST /api/v1/landing/demand-exclusion-windows` */
export const landDemandExclusionWindows: OperationSpec<LandDemandExclusionWindowsParams, LandingResponse> = {
  operationId: "land_demand_exclusion_windows_api_v1_landing_demand_exclusion_windows_post",
  method: "POST",
  path: "/api/v1/landing/demand-exclusion-windows",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/door-availability-week` — Land Door Availability Week — Land one ``door_availability_week`` batch. All-or-nothing, in one transaction. bata-platform#570: one row per country × week × door — the live articles' sizes in stock against those offered, pairs on hand and pairs sold — for the network-health door scatter (``GET /inseason/runs/{run_id}/door-availability``). One batch per country × week; a full-refresh batch restates its week and supersedes the one in force. */
export type LandDoorAvailabilityWeekParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly batchId: string;
      readonly countryKey: string;
      readonly liveArticles: number;
      readonly metricsVersion: string;
      readonly modelVersion: string;
      readonly observationBasis: "weekly_snapshot" | "daily";
      readonly observedDays: number;
      readonly onHandPairs: number;
      readonly pairsSold: number;
      readonly row_id: string;
      readonly sizesInStock: number;
      readonly sizesOffered: number;
      readonly storeKey: string;
      readonly weekStartDate: string;
    })[];
  };
};

/** `POST /api/v1/landing/door-availability-week` */
export const landDoorAvailabilityWeek: OperationSpec<LandDoorAvailabilityWeekParams, LandingResponse> = {
  operationId: "land_door_availability_week_api_v1_landing_door_availability_week_post",
  method: "POST",
  path: "/api/v1/landing/door-availability-week",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/feed-contracts` — Land Feed Contracts — Record bata-data's feed contracts (ADR 1003, W1-1). The thresholds ``GET /foundations/feeds`` judges freshness against, and the only source of a feed's certification stage. Same role as every landing write. Idempotent on ``(reported_at, contracts_digest)``; the same key with different content is a ``409`` and nothing is recorded. */
export type LandFeedContractsParams = {
  readonly body: FeedContractReportRequest;
};

/** `POST /api/v1/landing/feed-contracts` */
export const landFeedContracts: OperationSpec<LandFeedContractsParams, FeedContractReportResponse> = {
  operationId: "land_feed_contracts_api_v1_landing_feed_contracts_post",
  method: "POST",
  path: "/api/v1/landing/feed-contracts",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/forecast-explanations` — Land Forecast Explanations — Land how one store x article forecast run's numbers were made. All-or-nothing (ADR 6218). The house gate, auth and streamed body. One row per store x article of the forecast run the manifest's ``explanation_run`` names, its window weeks nested. Checked before the transaction (``platform.landing.invalid_forecast_explanation``: one run, one window, each row's own rules) and inside it: the forecast run must be landed and in force, the rows must be exactly its store x articles, and the numbers they share with it must equal the landed ones. A promoted batch replaces any earlier explanation of the same forecast run; a refusal writes nothing. The explanation is kept while its forecast run can be read and for at most ``retention.forecast_explanation_days`` days. */
export type LandForecastExplanationsParams = {
  readonly body: {
    /** `14` §2.2's manifest, one field wider: the forecast run the batch explains (ADR 6218). */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      /** The manifest's ``explanation_run``: which forecast run, its window and its settings. */
      readonly explanation_run: {
        readonly as_of_date: string;
        readonly category_rate_chain: number;
        readonly central_index_damping: number;
        readonly central_shrink_weeks: number;
        readonly fallback: {
          readonly max_weekly: number;
          readonly min_weekly: number;
          readonly new_arrival_days: number;
          readonly new_arrival_uplift: number;
          readonly prior_stock_day: string | null;
          readonly stock_day: string | null;
          readonly store_strength_cap: number;
          readonly store_strength_floor: number;
        } | null;
        readonly forecast_run_id: string;
        readonly forecast_sales_basis?: "gross";
        readonly min_observed_weeks: number;
        readonly min_valued_weeks: number;
        readonly model_version_id: string;
        readonly periods: readonly (string)[];
        readonly recent_sales_weeks: readonly (string)[];
        readonly seasonal_index: boolean;
        readonly skipped_weeks: readonly ({
          readonly reason: "excluded" | "held_until_landed";
          readonly week_start: string;
        })[];
        readonly window_weeks: readonly (string)[];
      };
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly basis: "window" | "recent_few_weeks" | "recent_observed" | "fallback_article_peers" | "fallback_category_rate";
      readonly category_code: string;
      readonly central: {
        readonly cap_applies: boolean;
        readonly cap_bound: boolean;
        readonly cap_index_damping: number | null;
        readonly cap_recovered_units: number | null;
        readonly cap_shrink_weeks: number | null;
        readonly cap_value: number | null;
        readonly cap_valued_weeks: number | null;
        readonly category_rate: number | null;
        readonly category_rate_category_code: string | null;
        readonly category_rate_source: "category" | "chain" | null;
        readonly central_value: number;
        readonly damped_index_factor: number | null;
        readonly shrunk_mean: number | null;
        readonly start_from: "median" | "mean_where_median_zero";
        readonly start_value: number;
      } | null;
      readonly fallback: {
        readonly article_rate_per_store: number | null;
        readonly chain_category_rate_per_article: number | null;
        readonly curve_basis: string;
        readonly estimate: number;
        readonly held_before: boolean;
        readonly ladder_method: "poisson_of_central";
        readonly parts_total: number;
        readonly rate: number;
        readonly sizes_capped: number;
        readonly sizes_dropped: number;
        readonly store_category_rate_per_article: number;
        readonly store_strength: number | null;
        readonly store_strength_basis: "ratio" | "floored" | "capped" | "chain_rate_zero" | null;
        readonly store_strength_unclipped: number | null;
        readonly uplift: number;
      } | null;
      readonly fallback_sizes: readonly ({
        readonly capped: boolean;
        readonly curve_share: number;
        readonly kept: boolean;
        readonly part: number;
        readonly part_before_cap: number;
        readonly size_key: string;
      })[];
      readonly forecast_run_id: string;
      /** The keep rules' evidence over the window weeks, and the first rule that failed. */
      readonly keep: {
        readonly nonzero_weeks: number;
        readonly observed_weeks: number;
        readonly recent_units: number;
        readonly rescue_rule_failed: "no_recent_sales" | "no_nonzero_week" | "no_sold_week" | null;
        readonly sold_weeks: number;
        readonly valued_weeks: number;
        readonly weeks_in_mart: number;
        readonly window_rule_failed: "no_record_in_window" | "valued_weeks_below_minimum" | "no_nonzero_week" | "observed_weeks_below_minimum" | null;
      };
      readonly model_version_id: string;
      readonly quantiles: {
        readonly index_category_code: string;
        readonly index_source: "category" | "chain" | "none";
        readonly index_value: number;
        readonly mean_units: number;
        readonly mean_value: number;
        readonly mean_weeks: number;
        readonly p50: number;
        readonly p80: number;
        readonly p90: number;
        readonly raw_mean: number;
        readonly raw_p50: number;
        readonly raw_p80: number;
        readonly raw_p90: number;
        readonly series: "recovered_demand" | "sales_floored_at_zero";
        readonly weeks_read: number;
      } | null;
      readonly row_id: string;
      readonly store_key: string;
      readonly subject_id: string;
      readonly weeks: readonly ({
        readonly in_mart: boolean;
        readonly observed: boolean;
        readonly quantile_input: number | null;
        readonly recovered_demand_units: number | null;
        readonly returns_units: number | null;
        readonly sales_floored_to_zero: boolean;
        readonly sales_gross_units: number | null;
        readonly sales_net_units: number | null;
        readonly sizes_observed: number;
        readonly sizes_recorded: number;
        readonly sizes_valued: number;
        readonly status: "counted" | "dropped_no_recovered_value" | "no_record" | "not_read_fallback";
        readonly valued: boolean;
        readonly week_start: string;
      })[];
    })[];
  };
};

/** `POST /api/v1/landing/forecast-explanations` */
export const landForecastExplanations: OperationSpec<LandForecastExplanationsParams, LandingResponse> = {
  operationId: "land_forecast_explanations_api_v1_landing_forecast_explanations_post",
  method: "POST",
  path: "/api/v1/landing/forecast-explanations",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/forecast-quantiles` — Land Forecast Quantiles — Land one run of a producer's quantile forecast. All-or-nothing. The pilot's demand distribution for in-season pull replenishment (bata-platform#360, contract C2): `bata-data` estimates per store x article x size x week and lands the ladder here, into :data:`~services.repositories.foundations.forecast_quantile` — the table the platform's own quantile job writes, under a model version of its own. Same gate, same auth, same streamed body as every route in this module. What is particular to it: * **the ladder is checked before the transaction** — one run per batch, no duplicate or missing level, no crossing, one horizon per ladder — and a failure is a ``422`` naming the reason and the ladder (:class:`InvalidQuantileLadderError`); * **it replaces rather than appends**, because the store's key has no ``run_id``: the run's own earlier rows, and any earlier run's rows for the weeks this run forecasts, are deleted in the same transaction (:func:`~services.repositories.mlplatform.replace_forecast_run`). Landing a run twice leaves it once; * **what a decided run read is archived first** (ADR 2121): the rows of every forecast run a pinned in-season run of the market read are copied to ``inseason_pull_forecast_archive`` before the replacement, and the market's archived runs no pinned run reads any more are purged; * **the run is recorded against its batch** in ``forecast_quantile_run`` with the manifest's ``provenance``, which is what lets the reader find the latest run (:func:`~services.repositories.mlplatform. latest_forecast_run_statement`). */
export type LandForecastQuantilesParams = {
  readonly body: {
    /** `14` §2.2's manifest, one field wider: the producer's provenance. ``provenance`` is how the estimate was made — its basis, its source relation, its training window, the weeks it excluded and any known bias — stored beside the run in ``forecast_quantile_run`` as canonical JSON and not interpreted. Optional: a manifest without it lands, and says nothing. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly provenance?: {
        readonly [key: string]: string | number | boolean | readonly (string)[] | null;
      } | null;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly basis?: string | null;
      readonly central_value?: number | null;
      readonly curve_basis?: string | null;
      readonly horizon: number;
      readonly mean_value?: number | null;
      readonly model_version_id: string;
      readonly own_p50?: number | null;
      readonly own_p80?: number | null;
      readonly own_p90?: number | null;
      readonly own_window_units?: number | null;
      readonly period: string;
      readonly quantile_level?: number | null;
      readonly row_id: string;
      readonly run_id: string;
      readonly size_share?: number | null;
      readonly subject_id: string;
      readonly value?: number | null;
    })[];
  };
};

/** `POST /api/v1/landing/forecast-quantiles` */
export const landForecastQuantiles: OperationSpec<LandForecastQuantilesParams, LandingResponse> = {
  operationId: "land_forecast_quantiles_api_v1_landing_forecast_quantiles_post",
  method: "POST",
  path: "/api/v1/landing/forecast-quantiles",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/hierarchy-schemes` — Land Hierarchy Scheme — Receive one hierarchy scheme version. All-or-nothing, in one transaction. **Not a row feed, and deliberately not shaped like one.** The four feeds above land rows into a landing table that something later promotes, because their rows are measurements that accumulate and supersede. A scheme version is neither: it is immutable, it is identified by ``(scheme_id, version_id)``, and a second delivery of the same version is a mistake rather than a correction. So there is no landing table, no manifest, no supersession ledger and no promotion step — the version is written straight into the three tables that are its home, and the thing that makes it safe is that it arrives INERT. **Landing is not adoption.** ``is_active`` is written ``False`` (``services/repositories/hierarchy_write.py``). Which version planning reads re-parents every plan keyed on it and has a commercial owner, so adoption is a governed act through the registry rather than a consequence of an upstream view changing overnight. **The tree is validated before anything is written**, by ``planning.hierarchy.model.build_scheme`` — the same function every reader in the estate trusts, not a second check written here (G11). A cycle, a node with two parents, an edge naming an undelivered node, or a leaf arriving with no parent is a 422 naming the rule, and nothing reaches the store. */
export type LandHierarchySchemeParams = {
  readonly body: HierarchySchemeDelivery;
};

/** `POST /api/v1/landing/hierarchy-schemes` */
export const landHierarchyScheme: OperationSpec<LandHierarchySchemeParams, LandingResponse> = {
  operationId: "land_hierarchy_scheme_api_v1_landing_hierarchy_schemes_post",
  method: "POST",
  path: "/api/v1/landing/hierarchy-schemes",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/landed-cost` — Land Landed Costs — Land one ``landed_cost`` batch. All-or-nothing, in one transaction. The fifth feed on the fifth route, and the one that finally sources a **mandatory** field of ``planning.markdown.optimise.Problem``. ``optimise.py`` argues why the field is mandatory: §4.4's degrading gap ③ warns that a revenue objective "must be stated plainly on every output, or the business will read it as a margin claim", so the cost is carried rather than defaulted — and there has been nowhere in the plan store for one to come from. ``bata_facts.fact_cost`` holds 108,116 rows joining 99.84% of sales; this is where they land. **Not read out of ClickHouse.** That is `14` §1's forbidden fifth edge pointing backwards along B3, and it would make every markdown run depend on whatever the analytical store held the moment it ran — where a landed batch re-derives from ``batch_id``, ``content_digest`` and ``produced_at``, which is what G1 test *d*'s run-it-twice comparison needs. **A batch carries overlapping validity windows, and that is correct.** ``fact_cost`` is time-variant and the producer scans "every version whose window overlaps this partition's month", so one article may land with several cost versions. :func:`~services.repositories.inseason. landed_unit_costs_statement` returns all of them that cover a given date rather than picking one: reducing several versions to the single ``Fraction`` ``Problem`` wants is a costing decision with a name, and a ``SELECT`` cannot explain the one it made. **This route does not resolve an article to an option, and must not.** The wire carries no option key, and a resolution invented here would be a key the plan store then treats as authoritative — a markdown problem priced against another option's cost is monotone, on-ladder, optimal and wrong. */
export type LandLandedCostsParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly cost_provenance?: string | null;
      readonly currency_code?: string | null;
      readonly landed_cost_amount: number;
      readonly row_id: string;
      readonly standard_cost_amount?: number | null;
      readonly valid_from?: string | null;
      readonly valid_to?: string | null;
    })[];
  };
};

/** `POST /api/v1/landing/landed-cost` */
export const landLandedCosts: OperationSpec<LandLandedCostsParams, LandingResponse> = {
  operationId: "land_landed_costs_api_v1_landing_landed_cost_post",
  method: "POST",
  path: "/api/v1/landing/landed-cost",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/lane-rate-cards` — Land Lane Rate Cards — Land one ``exit_lane_rate_card`` batch. All-or-nothing, in one transaction. Its own route rather than a ``feed`` parameter, for the reason ADR 0119 gives and its five predecessors here follow: a single "land any feed" endpoint would branch on a caller-supplied table name and let a mislabelled batch reach a table this router never named. **This is the edge that stops every candidate movement being withheld.** ``exit.consolidation_position`` writes each one ``is_proposed`` false with ``lane_not_costed``, and it does so because reqs/04 D9 had no source at all — not because any lane was judged too dear. With a card landed, ``services/api/wiring.py`` builds :class:`~planning.exit.clearance.TransferLane` objects from these rows and the job can tell "this lane does not pay" from "we cannot price this lane", which is the distinction ``docs/05`` §3.2 ③ insists on: "a zero freight cost makes every transfer look profitable". **Amounts land as sent and are never converted here.** The client converted 20 USD per pallet at an ``actual`` rate of 3126.08 dated 2026-09-05 and sends COP; the rate and its date arrive beside the amount as provenance. Converting at read instead would put the estate one missing FX row away from free carriage — ``fact_fx_rate`` ends 2026-09-09, production ClickHouse runs ``join_use_nulls = 0``, and a missing row there yields 0 rather than an error. */
export type LandLaneRateCardsParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly carriage_capacity_units: number;
      readonly carriage_cost_amount: number;
      readonly country_key: string;
      readonly currency_code: string;
      readonly destination_door_key?: string | null;
      readonly effective_date: string;
      readonly fixed_cost_amount?: number;
      readonly fx_rate?: number | null;
      readonly fx_rate_date?: string | null;
      readonly fx_rate_type?: string | null;
      readonly handling_cost_per_unit_amount: number;
      readonly origin_door_key?: string | null;
      readonly row_id: string;
      readonly source_amount?: number | null;
      readonly source_currency_code?: string | null;
      readonly transit_days: number;
    })[];
  };
};

/** `POST /api/v1/landing/lane-rate-cards` */
export const landLaneRateCards: OperationSpec<LandLaneRateCardsParams, LandingResponse> = {
  operationId: "land_lane_rate_cards_api_v1_landing_lane_rate_cards_post",
  method: "POST",
  path: "/api/v1/landing/lane-rate-cards",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/lifecycle-curve-assignments` — Land Lifecycle Curve Assignments — Land one ``inseason_lifecycle_curve_assignment`` batch. All-or-nothing. Its own route, on ADR 0119's "one feed, one route": every sold option's assignment down the fallback chain, landed beside the curves it names. */
export type LandLifecycleCurveAssignmentsParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly country_key: string;
      readonly curve_id?: string | null;
      readonly department_family?: string | null;
      readonly fit_level: "department_family_price_band" | "department_family" | "price_band" | "unavailable";
      readonly is_complete_lifecycle: boolean;
      readonly library_id: string;
      readonly lifecycle_exclusion?: string | null;
      readonly model_version_id: string;
      readonly option_key: string;
      readonly price_band?: string | null;
      readonly row_id: string;
      readonly unavailable_reason?: string | null;
      readonly units_sold_total: number;
      readonly variant: "sales_only_uncensored" | "stockout_corrected";
    })[];
  };
};

/** `POST /api/v1/landing/lifecycle-curve-assignments` */
export const landLifecycleCurveAssignments: OperationSpec<LandLifecycleCurveAssignmentsParams, LandingResponse> = {
  operationId: "land_lifecycle_curve_assignments_api_v1_landing_lifecycle_curve_assignments_post",
  method: "POST",
  path: "/api/v1/landing/lifecycle-curve-assignments",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/lifecycle-curves` — Land Lifecycle Curves — Land one ``inseason_lifecycle_curve`` batch. All-or-nothing, in one transaction. **The route that gives ``curve_library`` a producer** (bata-data#265, ADR 6015). It lands what bata-data fitted. It does not decide whether the library is in force: ``services/api/wiring.py`` installs it only when the assignment batch shares its ``library_id`` and the registry's ``inseason.reforecast.model_version_id`` names its version. So landing a library never changes what a run cites. */
export type LandLifecycleCurvesParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly cluster_key: string;
      readonly country_key: string;
      readonly curve_id: string;
      readonly department_family?: string | null;
      readonly fit_level: "department_family_price_band" | "department_family" | "price_band";
      readonly library_id: string;
      readonly minimum_lifecycles_per_cell: number;
      readonly model_version_id: string;
      readonly price_band?: string | null;
      readonly row_id: string;
      readonly sample_lifecycles: number;
      readonly share: number;
      readonly variant: "sales_only_uncensored" | "stockout_corrected";
      readonly week_index: number;
      readonly week_key: string;
    })[];
  };
};

/** `POST /api/v1/landing/lifecycle-curves` */
export const landLifecycleCurves: OperationSpec<LandLifecycleCurvesParams, LandingResponse> = {
  operationId: "land_lifecycle_curves_api_v1_landing_lifecycle_curves_post",
  method: "POST",
  path: "/api/v1/landing/lifecycle-curves",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/location-master` — Land Location Master — Land one ``location_master`` batch. All-or-nothing, in one transaction. The third feed, on the third route, for the reason ADR 0119 gave when it refused a generic "land any feed" endpoint: these three carry different rows, measure different quality fields and land in different tables, so one route would have to branch on a caller-supplied table name and would let a mislabelled batch reach a table this router never named. **A register, not a measurement, and the read side is where that matters.** Both neighbours land observations that accumulate or supersede; this one restates the whole estate each time, so :func:`~services.repositories.inseason.latest_promoted_location_batch_statement` reads exactly one batch. Two batches concatenated would not double a number — they would double the *doors*, and a door appearing twice with two capacities is one the engine allocates into twice. **This route does not fill `transport_frequency_days`, and must not.** The field has no source, ``master_data_defects`` raises below 1, and every door therefore fails the engine's master check today. Defaulting it here would put an operational cadence nobody owns into the one layer that has no way to review it; the standing-in value belongs in the parameter registry with an owner and a review date, exactly as the stock staleness tolerance does. **A delivery may not shrink the register in force beyond a declared bound** (ADR 2008). Because the newest batch *replaces* the register, a truncated extract would silently remove doors from every allocation. G-4 quarantines a batch that loses more than the larger of :data:`~services.integrations.landing.REGISTER_SHRINK_TOLERANCE_RATE` of the doors in force and :data:`~services.integrations.landing.REGISTER_SHRINK_ALLOWANCE_ROWS`, as ``register_shrink``; a country's first landing has nothing to shrink from. */
export type LandLocationMasterParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly as_of_date: string;
      readonly capacity_units?: number | null;
      readonly channel_key: string;
      readonly climate_zone_code?: string | null;
      readonly closing_date?: string | null;
      readonly dc_assignment_key?: string | null;
      readonly district_code?: string | null;
      readonly format_code?: string | null;
      readonly has_sale_zone?: boolean | null;
      readonly key_account_flag?: boolean | null;
      readonly lead_time_days?: number | null;
      readonly location_key: string;
      readonly location_type: string;
      readonly opening_date?: string | null;
      readonly presentation_minimum_units?: number | null;
      readonly row_id: string;
      readonly store_name?: string | null;
      readonly transport_frequency_days?: number | null;
    })[];
  };
};

/** `POST /api/v1/landing/location-master` */
export const landLocationMaster: OperationSpec<LandLocationMasterParams, LandingResponse> = {
  operationId: "land_location_master_api_v1_landing_location_master_post",
  method: "POST",
  path: "/api/v1/landing/location-master",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/outlet-door-position` — Land Outlet Door Position — Land one ``outlet_door_position`` batch: one country's outlet doors on one stock day. bata-platform issue 650 (ADR 7032): the stock and demand the monthly outlet exit (ADR 7028) and the outlet markdown read at the ``OUTLET`` doors, which the in-season stock ledger does not carry by design. One batch per country × stock day (``period_key`` ``YYYYMMDD``, the window both ends that day), restating the day whole; the reader takes the newest day on or before the day it asks for. All-or-nothing. */
export type LandOutletDoorPositionParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly as_of_date: string;
      readonly country_key: string;
      readonly demand_weeks: number;
      readonly demand_window_end: string;
      readonly demand_window_start: string;
      readonly door_reported: boolean;
      readonly on_hand_negative: boolean;
      readonly on_hand_units?: number | null;
      readonly row_id: string;
      readonly size_key: string;
      readonly store_key: string;
      readonly units_returned?: number | null;
      readonly units_sold?: number | null;
      readonly weekly_demand?: number | null;
    })[];
  };
};

/** `POST /api/v1/landing/outlet-door-position` */
export const landOutletDoorPosition: OperationSpec<LandOutletDoorPositionParams, LandingResponse> = {
  operationId: "land_outlet_door_position_api_v1_landing_outlet_door_position_post",
  method: "POST",
  path: "/api/v1/landing/outlet-door-position",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/postseason-availability-census` — Land Postseason Availability Census — Land one ``postseason_availability_census`` batch. All-or-nothing, in one transaction. bata-platform#332: the never-offered cells per store x channel x week that the availability panel no longer carries, so the stored state census can count them as ``not_ranged``. Published by ``bata-data``, one batch per week, as the panel. */
export type LandPostseasonAvailabilityCensusParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly channel_key: string;
      readonly country_key: string;
      readonly location_key: string;
      readonly metrics_version: string;
      readonly model_version: string;
      readonly not_ranged_cells: number;
      readonly period_key: number;
      readonly reported_days: number;
      readonly row_id: string;
      readonly week_start_date: string;
    })[];
  };
};

/** `POST /api/v1/landing/postseason-availability-census` */
export const landPostseasonAvailabilityCensus: OperationSpec<LandPostseasonAvailabilityCensusParams, LandingResponse> = {
  operationId: "land_postseason_availability_census_api_v1_landing_postseason_availability_census_post",
  method: "POST",
  path: "/api/v1/landing/postseason-availability-census",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/postseason-availability-week` — Land Postseason Availability Week — Land one ``postseason_availability_week`` batch. All-or-nothing, in one transaction. ADR 8000: the weekly availability panel ``postseason.reconstruct_unconstrained_demand`` fits over, published by ``bata-data`` because this repository has no read path into the analytical store (`14` §1). It lands what the producer reports; the job decides, at read time and for an explicit store list, what to fit. */
export type LandPostseasonAvailabilityWeekParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly availability_state: "available" | "stocked_out" | "not_ranged" | "not_reported";
      readonly available_days: number;
      readonly country_key: string;
      readonly fiscal_week: string;
      readonly is_ranged: boolean;
      readonly is_reported: boolean;
      readonly location_key: string;
      readonly metrics_version: string;
      readonly model_version: string;
      readonly on_hand_units?: number | null;
      readonly period_key: number;
      readonly row_id: string;
      readonly sales_source_system?: string | null;
      readonly size_key: string;
      readonly units_sold: number;
      readonly week_days: number;
      readonly week_start_date: string;
    })[];
  };
};

/** `POST /api/v1/landing/postseason-availability-week` */
export const landPostseasonAvailabilityWeek: OperationSpec<LandPostseasonAvailabilityWeekParams, LandingResponse> = {
  operationId: "land_postseason_availability_week_api_v1_landing_postseason_availability_week_post",
  method: "POST",
  path: "/api/v1/landing/postseason-availability-week",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/postseason-availability-week-to-date` — Land Postseason Availability Week To Date — Land one ``postseason_availability_week_to_date`` batch. All-or-nothing. bata-reqs ADR 8000: the availability of a week to date (``week_start_date`` the week's Monday, ``week_days`` the days to date), which the daily score reads on Tuesday to Sunday. The rows of ``/postseason-availability-week``, in a landing of its own, so a partial week never becomes the batch in force for a door-week any other reader reads. */
export type LandPostseasonAvailabilityWeekToDateParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly availability_state: "available" | "stocked_out" | "not_ranged" | "not_reported";
      readonly available_days: number;
      readonly country_key: string;
      readonly fiscal_week: string;
      readonly is_ranged: boolean;
      readonly is_reported: boolean;
      readonly location_key: string;
      readonly metrics_version: string;
      readonly model_version: string;
      readonly on_hand_units?: number | null;
      readonly period_key: number;
      readonly row_id: string;
      readonly sales_source_system?: string | null;
      readonly size_key: string;
      readonly units_sold: number;
      readonly week_days: number;
      readonly week_start_date: string;
    })[];
  };
};

/** `POST /api/v1/landing/postseason-availability-week-to-date` */
export const landPostseasonAvailabilityWeekToDate: OperationSpec<LandPostseasonAvailabilityWeekToDateParams, LandingResponse> = {
  operationId: "land_postseason_availability_week_to_date_api_v1_landing_postseason_availability_week_to_date_post",
  method: "POST",
  path: "/api/v1/landing/postseason-availability-week-to-date",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/price-ladder` — Land Price Ladders — Land one ``price_ladder`` batch. All-or-nothing, in one transaction. The fourth feed on the fourth route, and the write path ADR 0059 named and did not build: "the write path is the B1 landing edge every other received master uses — ``services/integrations/landing.py``, the same path ``price_observation`` lands through. It is not built in this decision, and nothing here pretends it is." **What lands, and what a reader still cannot do with it.** `13` M7 publishes depths, not prices, because no list price exists in the estate to resolve a depth against (`15` G7). The rungs, their factors, their streams, the owner, the review date and the ratification scope all land and are reviewable; the currency amounts do not, and :func:`~services.repositories.inseason.load_price_ladder` refuses the ladder by name (:class:`~services.repositories.inseason.UnpricedLadderError`) rather than building one the optimiser would price a garment at 0.8 of a peso against. §4.4's hard constraint is therefore still unenforceable in currency after this route ships, and it is now unenforceable *visibly*, which it was not while the table was empty. **The tables carry no ``batch_id``**, and this handler does not pretend otherwise. :data:`~services.repositories.inseason.price_ladder`'s note works the consequence through; here it means three things. The gate runs in full and a quarantined batch writes no ladder, exactly as for every other feed. ``rows_written`` counts **headers plus rungs**, so it deliberately does not equal ``manifest.row_count``, which counts rungs. And ``manifest.supersedes_batch_id`` has no effect on ladder rows: a replacement ladder is a later ``valid_from``, per ADR 0059, and a re-delivery repeating a ``(country_key, brand_key, valid_from)`` triple is refused by ``ladder_effective_identity`` inside this transaction rather than quarantined on the record. **No ladder is seeded, here or anywhere.** ADR 0059: "the rungs are a commercial decision with a named owner, and a seeded ladder would be a hard pricing constraint nobody approved." */
export type LandPriceLaddersParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly brand_key: string;
      readonly country_key: string;
      readonly currency_code: string;
      readonly discount_pct: string;
      readonly ladder_id: string;
      readonly ladder_purpose?: "markdown" | "zona_sales" | null;
      readonly owner: string;
      readonly price_amount?: string | null;
      readonly price_factor: string;
      readonly ratification_scope?: string | null;
      readonly review_date: string;
      readonly row_id: string;
      readonly rung_count: number;
      readonly rung_label?: string | null;
      readonly rung_ordinal: number;
      readonly stream_key: string;
      readonly valid_from: string;
      readonly valid_to: string;
    })[];
  };
};

/** `POST /api/v1/landing/price-ladder` */
export const landPriceLadders: OperationSpec<LandPriceLaddersParams, LandingResponse> = {
  operationId: "land_price_ladders_api_v1_landing_price_ladder_post",
  method: "POST",
  path: "/api/v1/landing/price-ladder",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/price-observations` — Land Price Observations — Land one ``price_observation`` batch. All-or-nothing, in one transaction. Runs the manifest through :func:`services.integrations.landing.land` — G-1 through G-4, unchanged from any other B1 caller — and, only if the batch is **promoted**, appends the rows to :data:`~services.repositories.inseason. price_observation`. A quarantined batch is recorded at the manifest level (``feed_batch``/``feed_gate_failure``) and its rows are never written, so a reader of the landing table never has to re-derive "was this usable" from row content — the same rule PR #18 established for every other B1 feed. **Reads its own body.** There is no ``body`` parameter, deliberately: a declared one is what made FastAPI build the whole batch in memory before this function ran. The published request schema is unchanged and is :class:`LandingRequest` either way. */
export type LandPriceObservationsParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly channel_key: string;
      readonly cluster_key: string;
      readonly is_promotional?: boolean;
      readonly option_key: string;
      readonly period_key: string;
      readonly price_amount: number;
      readonly price_currency: string;
      readonly row_id: string;
      readonly units: number;
    })[];
  };
};

/** `POST /api/v1/landing/price-observations` */
export const landPriceObservations: OperationSpec<LandPriceObservationsParams, LandingResponse> = {
  operationId: "land_price_observations_api_v1_landing_price_observations_post",
  method: "POST",
  path: "/api/v1/landing/price-observations",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/product-attribute-master` — Land Product Attribute Master — Land one ``product_attribute_master`` batch. All-or-nothing, in one transaction. Its own route, not a ``feed`` parameter on one of the five above — ADR 0119's rule, unchanged, and the reason is the same one it always was: these feeds carry different rows, measure different quality fields and land in different tables, so a single route would have to branch on a caller-supplied string and would let a mislabelled batch reach a table this router never named. **This is the route that makes a product key resolvable.** The plan store has 210 tables and one master; ``article_key`` and ``option_key`` appear on twelve of them and every one is a fact or a decision. reqs/07 §3.2 forbids SKU or article as an object's only grouping key, which cannot be satisfied while no attribute is reachable from the plan store at all. **A delta, not a register, and the read side is where that matters.** ``location_master`` restates the whole estate on every delivery, so :func:`~services.repositories.inseason.latest_promoted_location_batch_statement` reads exactly one batch. This feed's contract declares ``frequency: daily_delta``, so :func:`~services.repositories.inseason.landed_product_attributes_statement` reads *every* unsuperseded promoted batch and resolves one row per article by ``valid_from``. Copying the door master's single-batch read would have collapsed 110,063 articles to the few hundred re-attributed that day, with every gate green. **This route does not fill an unattributed field, and must not.** The governed way to say "sought and not found" is 13 §4.3's registered ``UNKNOWN``, which counts *against* the fill rate; an omitted field means the row was never attributed. Defaulting either into the other here would put a value nobody owns into the one layer that has no way to review it — and a defaulted ``colour_family`` is not a missing value but a wrong one, which every attribute-based forecast and every Gower distance would then read as evidence. */
export type LandProductAttributeMasterParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly age_group?: string | null;
      readonly article_desc?: string | null;
      readonly article_key: string;
      readonly brand?: string | null;
      readonly brand_tier?: string | null;
      readonly carry_over_flag?: boolean | null;
      readonly category_code?: string | null;
      readonly category_desc?: string | null;
      readonly colour?: string | null;
      readonly colour_family?: string | null;
      readonly construction?: string | null;
      readonly gender?: string | null;
      readonly heel_height_band?: string | null;
      readonly is_footwear?: boolean | null;
      readonly item_type?: string | null;
      readonly last_fit_family?: string | null;
      readonly launch_date?: string | null;
      readonly lifecycle_class?: string | null;
      readonly major_category_desc?: string | null;
      readonly material_sole?: string | null;
      readonly material_upper?: string | null;
      readonly occasion?: string | null;
      readonly price_band?: string | null;
      readonly risk_desc?: string | null;
      readonly row_id: string;
      readonly season_code?: string | null;
      readonly silhouette?: string | null;
      readonly sub_category_code?: string | null;
      readonly sub_category_desc?: string | null;
      readonly valid_from: string;
    })[];
  };
};

/** `POST /api/v1/landing/product-attribute-master` */
export const landProductAttributeMaster: OperationSpec<LandProductAttributeMasterParams, LandingResponse> = {
  operationId: "land_product_attribute_master_api_v1_landing_product_attribute_master_post",
  method: "POST",
  path: "/api/v1/landing/product-attribute-master",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/product-image-index` — Land Product Image Index — Land one ``product_image_index`` batch. All-or-nothing, in one transaction. Its own route, as every feed here has (ADR 0119). A register: each batch restates the whole index, and :func:`~services.repositories.productimage.in_force_batches_statement` reads the newest promoted batch per country. ADR 2001. */
export type LandProductImageIndexParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_in_master: boolean;
      readonly article_key: string;
      readonly available_width_count?: number | null;
      readonly content_type: string;
      readonly country_key: string;
      readonly is_presignable: boolean;
      readonly is_primary_sequence: boolean;
      readonly object_bytes: number;
      readonly object_key: string;
      readonly object_sha256: string;
      readonly rendition_height_px: number;
      readonly rendition_role: string;
      readonly rendition_width_px: number;
      readonly row_id: string;
      readonly sequence: number;
      readonly source_retrieved_at?: string | null;
      readonly source_sha256?: string | null;
      readonly source_url?: string | null;
    })[];
  };
};

/** `POST /api/v1/landing/product-image-index` */
export const landProductImageIndex: OperationSpec<LandProductImageIndexParams, LandingResponse> = {
  operationId: "land_product_image_index_api_v1_landing_product_image_index_post",
  method: "POST",
  path: "/api/v1/landing/product-image-index",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/programme-cover-and-terminal-stock` — Land Programme Cover And Terminal Stock — Land one cover-and-terminal-stock batch (reqs/08 §5, the cover-reduction row). Control total ``terminal_stock_units`` is required. */
export type LandProgrammeCoverAndTerminalStockParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly closing_on_hand_units: number;
      readonly country_key: string;
      readonly cover_weeks?: number | null;
      readonly currency_code?: string | null;
      readonly days_since_last_sale?: number | null;
      readonly metrics_version: string;
      readonly model_version: string;
      readonly observed_days: number;
      readonly period_key: number;
      readonly realised_asp?: number | null;
      readonly row_id: string;
      readonly store_key: string;
      readonly terminal_stock_units: number;
      readonly units: number;
      readonly weekly_rate_of_sale?: number | null;
    })[];
  };
};

/** `POST /api/v1/landing/programme-cover-and-terminal-stock` */
export const landProgrammeCoverAndTerminalStock: OperationSpec<LandProgrammeCoverAndTerminalStockParams, LandingResponse> = {
  operationId: "land_programme_cover_and_terminal_stock_api_v1_landing_programme_cover_and_terminal_stock_post",
  method: "POST",
  path: "/api/v1/landing/programme-cover-and-terminal-stock",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/programme-gate-evidence` — Land Programme Gate Evidence — Land one D0 gate-evidence batch — one row, restating the reconciliation. Control total ``observed_units`` is required. */
export type LandProgrammeGateEvidenceParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly baseline_country_key: string;
      readonly baseline_currency_code: string;
      readonly expected_net_value_amount: number;
      readonly expected_units: number;
      readonly metrics_version: string;
      readonly model_version: string;
      readonly net_value_variance_rate?: number | null;
      readonly observed_net_value_amount?: number | null;
      readonly observed_rows?: number | null;
      readonly observed_units?: number | null;
      readonly reconciles_exactly: boolean;
      readonly row_id: string;
      readonly units_variance_rate?: number | null;
      readonly window_end: string;
      readonly window_start: string;
    })[];
  };
};

/** `POST /api/v1/landing/programme-gate-evidence` */
export const landProgrammeGateEvidence: OperationSpec<LandProgrammeGateEvidenceParams, LandingResponse> = {
  operationId: "land_programme_gate_evidence_api_v1_landing_programme_gate_evidence_post",
  method: "POST",
  path: "/api/v1/landing/programme-gate-evidence",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/programme-lost-units` — Land Programme Lost Units — Land one lost-units-at-size-position batch (reqs/08 §5, rank 1's sizing method). Control total ``estimated_lost_units`` is required. */
export type LandProgrammeLostUnitsParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly article_realised_asp?: number | null;
      readonly article_units?: number | null;
      readonly available_days: number;
      readonly country_key: string;
      readonly estimated_lost_units?: number | null;
      readonly expected_units?: number | null;
      readonly is_position_broken: boolean;
      readonly metrics_version: string;
      readonly model_version: string;
      readonly observed_days: number;
      readonly period_key: number;
      readonly row_id: string;
      readonly size_code: string;
      readonly size_scale: string;
      readonly store_key: string;
      readonly units: number;
    })[];
  };
};

/** `POST /api/v1/landing/programme-lost-units` */
export const landProgrammeLostUnits: OperationSpec<LandProgrammeLostUnitsParams, LandingResponse> = {
  operationId: "land_programme_lost_units_api_v1_landing_programme_lost_units_post",
  method: "POST",
  path: "/api/v1/landing/programme-lost-units",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/programme-matched-control-panel` — Land Programme Matched Control Panel — Land one matched-control panel batch — the panel every benefit claim is measured on. Its reader is the cohort freeze's and the benefit measurement's pre- and post-period panel (reqs/08 §8: "matched control stores, never year-over-year comparison"). Control totals ``units`` and ``net_value_amount`` are required. */
export type LandProgrammeMatchedControlPanelParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly availability_rate?: number | null;
      readonly availability_rate_size_run_v1?: number | null;
      readonly channel_key: string;
      readonly country_key: string;
      readonly currency_code: string;
      readonly discount_value_amount?: number | null;
      readonly gross_value_amount: number;
      readonly metrics_version: string;
      readonly model_version: string;
      readonly net_value_amount: number;
      readonly period_key: number;
      readonly realised_asp?: number | null;
      readonly row_id: string;
      readonly store_key: string;
      readonly trading_days: number;
      readonly units: number;
    })[];
  };
};

/** `POST /api/v1/landing/programme-matched-control-panel` */
export const landProgrammeMatchedControlPanel: OperationSpec<LandProgrammeMatchedControlPanelParams, LandingResponse> = {
  operationId: "land_programme_matched_control_panel_api_v1_landing_programme_matched_control_panel_post",
  method: "POST",
  path: "/api/v1/landing/programme-matched-control-panel",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/programme-seasonal-naive-baseline` — Land Programme Seasonal Naive Baseline — Land one seasonal-naive baseline batch — the bar reqs/08 §5 says #7 must beat. Control total ``wape_denominator_units`` is required. */
export type LandProgrammeSeasonalNaiveBaselineParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly actual_units: number;
      readonly article_key: string;
      readonly country_key: string;
      readonly fiscal_week: number;
      readonly fiscal_year: number;
      readonly has_seasonal_naive_prediction: boolean;
      readonly metrics_version: string;
      readonly model_version: string;
      readonly period_key: number;
      readonly row_id: string;
      readonly seasonal_naive_absolute_error?: number | null;
      readonly seasonal_naive_units?: number | null;
      readonly wape_denominator_units: number;
    })[];
  };
};

/** `POST /api/v1/landing/programme-seasonal-naive-baseline` */
export const landProgrammeSeasonalNaiveBaseline: OperationSpec<LandProgrammeSeasonalNaiveBaselineParams, LandingResponse> = {
  operationId: "land_programme_seasonal_naive_baseline_api_v1_landing_programme_seasonal_naive_baseline_post",
  method: "POST",
  path: "/api/v1/landing/programme-seasonal-naive-baseline",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/promotion-article-day` — Land Promotion Article Day — Land one ``promotion_article_day`` batch: one country × business day, all-or-nothing. bata-reqs#33 (campaign simulation), bata-data ADR 8010: the store-day promotion panel split by article, booked and basket-allocated net side by side. ``period_key`` is the day as ``YYYYMMDD``; a batch restates its day whole (``is_full_refresh``) and supersedes the day's batch in force. Read by the campaign response fit, summed to door × channel × day (ADR 6064), and by article from phase 3. */
export type LandPromotionArticleDayParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly allocatedDiscountValueAmount: number;
      readonly allocatedNetValueAmount: number;
      readonly allocationBasis: "allocated" | "no_multibuy" | "booked_only_no_invoice_key" | "booked_only_not_computed";
      readonly articleKey: string;
      readonly bookedDiscountValueAmount: number;
      readonly bookedNetValueAmount: number;
      readonly brandCode: string | null;
      readonly brandSourceLabel: string | null;
      readonly businessDate: string;
      readonly category: string | null;
      readonly channelKey: string;
      readonly costAmount: number | null;
      readonly costBasis: string;
      readonly costValidFrom: string | null;
      readonly countryKey: string;
      readonly currencyCode: string;
      readonly grossValueAmount: number;
      readonly majorCategory: string | null;
      readonly metricsVersion: string;
      readonly modelVersion: string;
      readonly pooledUnits: number | null;
      readonly promotionalUnits: number;
      readonly row_id: string;
      readonly saleZoneBasis: "unpooled_discount_share_trailing_days" | "not_computed_before_allocation";
      readonly saleZoneDiscountedUnits: number | null;
      readonly saleZoneInferred: boolean | number | null;
      readonly saleZoneUnpooledUnits: number | null;
      readonly storeKey: string;
      readonly subCategory: string | null;
      readonly unitCostAmount: number | null;
      readonly units: number;
      readonly windowBasis: string;
      readonly windowClass: string | null;
      readonly windowEndDate: string | null;
      readonly windowId: string | null;
      readonly windowKey: string | null;
      readonly windowLineDepthPct: number | null;
      readonly windowStartDate: string | null;
    })[];
  };
};

/** `POST /api/v1/landing/promotion-article-day` */
export const landPromotionArticleDay: OperationSpec<LandPromotionArticleDayParams, LandingResponse> = {
  operationId: "land_promotion_article_day_api_v1_landing_promotion_article_day_post",
  method: "POST",
  path: "/api/v1/landing/promotion-article-day",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/promotion-mechanic-impact` — Land Promotion Mechanic Impact — Land one ``promotion_mechanic_impact`` batch. All-or-nothing, in one transaction. bata-platform#580: per inferred mechanic × store channel, the geometric-mean uplift over the comparable windows and its spread (bata-data ADR 8007). Retrospective measurement only. */
export type LandPromotionMechanicImpactParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly batchId: string;
      readonly channelKey: string;
      readonly countryKey: string;
      readonly discountPerIncrementalNet: number | null;
      readonly discountRateChange: number | null;
      readonly grossMarginRateChange: number | null;
      readonly mechanicCode: string | null;
      readonly metricsVersion: string;
      readonly modelVersion: string;
      readonly netUpliftGeomean: number;
      readonly netUpliftLogSd: number | null;
      readonly netUpliftLogSe: number | null;
      readonly row_id: string;
      readonly windowCount: number;
      readonly windowKey: string;
    })[];
  };
};

/** `POST /api/v1/landing/promotion-mechanic-impact` */
export const landPromotionMechanicImpact: OperationSpec<LandPromotionMechanicImpactParams, LandingResponse> = {
  operationId: "land_promotion_mechanic_impact_api_v1_landing_promotion_mechanic_impact_post",
  method: "POST",
  path: "/api/v1/landing/promotion-mechanic-impact",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/promotion-window` — Land Promotion Window — Land one ``promotion_window`` batch. All-or-nothing, in one transaction. bata-platform#580: the promotion windows the tills show (bata-data ADR 8006), one row per country × window with the commercial weeks it overlaps. INFERRED, never a planned campaign. */
export type LandPromotionWindowParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly batchId: string;
      readonly countryKey: string;
      readonly freeItemShareMean: number;
      readonly labelAgreesWithTills: boolean | number | null;
      readonly lineDepthPct: number | null;
      readonly mechanicCode: string | null;
      readonly metricsVersion: string;
      readonly modelVersion: string;
      readonly overlappingWeeks: readonly ({
        readonly calendarYear: number;
        readonly commercialWeek: number;
        readonly sharedDays: number;
      })[];
      readonly row_id: string;
      readonly topDepthShareMean: number;
      readonly windowBasis: string;
      readonly windowClass: string;
      readonly windowDays: number;
      readonly windowEndDate: string;
      readonly windowId: string;
      readonly windowStartDate: string;
    })[];
  };
};

/** `POST /api/v1/landing/promotion-window` */
export const landPromotionWindow: OperationSpec<LandPromotionWindowParams, LandingResponse> = {
  operationId: "land_promotion_window_api_v1_landing_promotion_window_post",
  method: "POST",
  path: "/api/v1/landing/promotion-window",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/promotion-window-door` — Land Promotion Window Door — Land one ``promotion_window_door`` batch. All-or-nothing, in one transaction. ADR 8016 (bata-data ADR 8012): per window × store channel × door, the door's trading days in the window and on the neighbouring days and whether it entered the comparison — the reference perimeter behind each impact's ``doorsCompared``. Retrospective measurement only. */
export type LandPromotionWindowDoorParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly batchId: string;
      readonly channelKey: string;
      readonly countryKey: string;
      readonly currency: string;
      readonly isCompared: boolean | number;
      readonly metricsVersion: string;
      readonly modelVersion: string;
      readonly neighbourTradingDays: number;
      readonly notComparedReason: string | null;
      readonly row_id: string;
      readonly storeKey: string;
      readonly windowId: string;
      readonly windowNetValueAmount: number;
      readonly windowTradingDays: number;
      readonly windowUnits: number;
    })[];
  };
};

/** `POST /api/v1/landing/promotion-window-door` */
export const landPromotionWindowDoor: OperationSpec<LandPromotionWindowDoorParams, LandingResponse> = {
  operationId: "land_promotion_window_door_api_v1_landing_promotion_window_door_post",
  method: "POST",
  path: "/api/v1/landing/promotion-window-door",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/promotion-window-door-subcategory` — Land Promotion Window Door Subcategory — Land one ``promotion_window_door_subcategory`` batch. All-or-nothing, in one transaction. ADR 8017 (bata-data ADR 8013): per window × store channel × door × sub-category, the booked units and net on the window's days and on the neighbouring days, and the uplift against them in the same door. ONE WINDOW per batch, ``period_key`` its first day as ``YYYYMMDD``, superseding that window's previous batch. Retrospective measurement only. */
export type LandPromotionWindowDoorSubcategoryParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly batchId: string;
      readonly category: string | null;
      readonly categoryCode: string | null;
      readonly channelKey: string;
      readonly countryKey: string;
      readonly currency: string;
      readonly isCompared: boolean | number;
      readonly metricsVersion: string;
      readonly modelVersion: string;
      readonly neighbourDays: number;
      readonly neighbourNetValueAmount: number;
      readonly neighbourTradingDays: number;
      readonly neighbourUnits: number;
      readonly netUplift: number | null;
      readonly netUpliftAbsentReason: string | null;
      readonly notComparedReason: string | null;
      readonly row_id: string;
      readonly storeKey: string;
      readonly subCategory: string | null;
      readonly subCategoryCode: string | null;
      readonly unitsUplift: number | null;
      readonly unitsUpliftAbsentReason: string | null;
      readonly windowId: string;
      readonly windowNetValueAmount: number;
      readonly windowTradingDays: number;
      readonly windowUnits: number;
    })[];
  };
};

/** `POST /api/v1/landing/promotion-window-door-subcategory` */
export const landPromotionWindowDoorSubcategory: OperationSpec<LandPromotionWindowDoorSubcategoryParams, LandingResponse> = {
  operationId: "land_promotion_window_door_subcategory_api_v1_landing_promotion_window_door_subcategory_post",
  method: "POST",
  path: "/api/v1/landing/promotion-window-door-subcategory",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/promotion-window-impact` — Land Promotion Window Impact — Land one ``promotion_window_impact`` batch. All-or-nothing, in one transaction. bata-platform#580: per window × store channel, the window against the neighbouring days in the same doors (bata-data ADR 8007). Retrospective measurement only. */
export type LandPromotionWindowImpactParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly batchId: string;
      readonly channelKey: string;
      readonly countryKey: string;
      readonly currency: string;
      readonly doorsCompared: number;
      readonly doorsInWindow: number;
      readonly grossMarginUplift: number | null;
      readonly identification: string;
      readonly incrementalDiscountValueAmount: number | null;
      readonly incrementalNetValueAmount: number | null;
      readonly isComparable: boolean | number;
      readonly metricsVersion: string;
      readonly modelVersion: string;
      readonly neighbourDiscountRate: number | null;
      readonly neighbourGrossMarginRate: number | null;
      readonly netUplift: number | null;
      readonly postWindowNetChange: number | null;
      readonly row_id: string;
      readonly touchesPeakMonth: boolean | number;
      readonly unitsUplift: number | null;
      readonly windowDiscountRate: number | null;
      readonly windowGrossMarginRate: number | null;
      readonly windowId: string;
      readonly windowNetValueAmount: number;
    })[];
  };
};

/** `POST /api/v1/landing/promotion-window-impact` */
export const landPromotionWindowImpact: OperationSpec<LandPromotionWindowImpactParams, LandingResponse> = {
  operationId: "land_promotion_window_impact_api_v1_landing_promotion_window_impact_post",
  method: "POST",
  path: "/api/v1/landing/promotion-window-impact",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/reforecast-signal-weeks` — Land Reforecast Signal Weeks — Land one ``inseason_reforecast_signal_week`` batch: one retail week. All-or-nothing. **The route that gives ``signals`` a producer** (bata-data#265, ADR 6018). One batch is one week, and the reader accumulates weeks: see :func:`~services.repositories.forecast.landed_reforecast_signal_batches_statement`. It lands what bata-data measured and decides nothing about a projection. */
export type LandReforecastSignalWeeksParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly availability_state: "available" | "not_stocked" | "unknown";
      readonly cluster_key: string;
      readonly country_key: string;
      readonly door_sizes_available: number;
      readonly door_sizes_reported: number;
      readonly doors_available: number;
      readonly first_sale_week_ordinal: number;
      readonly first_sale_week_start: string;
      readonly lifecycle_week: number;
      readonly option_key: string;
      readonly row_id: string;
      readonly stock_observation_days: number;
      readonly units_sold: number;
      readonly unknown_reason?: "no_stock_observation" | "option_not_reported" | null;
      readonly week_end_date: string;
      readonly week_ordinal: number;
      readonly week_start_date: string;
    })[];
  };
};

/** `POST /api/v1/landing/reforecast-signal-weeks` */
export const landReforecastSignalWeeks: OperationSpec<LandReforecastSignalWeeksParams, LandingResponse> = {
  operationId: "land_reforecast_signal_weeks_api_v1_landing_reforecast_signal_weeks_post",
  method: "POST",
  path: "/api/v1/landing/reforecast-signal-weeks",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/retail-calendar` — Land Retail Calendar — Land one ``retail_calendar`` batch. All-or-nothing, in one transaction. **This is the edge that turns three route parameters back into estate data.** ``weeks_remaining``, ``handover_date`` and ``ship_weeks`` are supplied by the caller today, because the retail calendar lives in ClickHouse and a *job* has no caller to supply them. That single fact is why §4.4's batch markdown cannot assemble ``markdown_problems`` in a job and why ``exit.calendar`` is named-empty on every boot. With a batch landed, ``services/repositories/calendar.py`` answers the week series from the plan store and a job resolves its own horizon. **Not read out of ClickHouse.** That is `14` §1's forbidden fifth edge pointing backwards along B3, and it would make every markdown run depend on whatever the analytical store held the moment it ran — where a landed batch re-derives from ``batch_id``, ``content_digest`` and ``produced_at``, which is what G1 test *d*'s run-it-twice comparison needs. **A calendar batch is a restatement, not an accumulation.** 13 M6 allows "in-year amendments on change", and an amendment restates which fiscal week a date belongs to. So the reader takes the single latest promoted unsuperseded batch rather than unioning promoted ones: two batches in force would put one date in two weeks, and every period-over-period measure computed across the union would be wrong by however much the amendment moved — silently, and contiguously. An amendment therefore names its predecessor in ``supersedes_batch_id``. **A quarantined batch returns 201.** ``state`` on the response is the verdict, not the status code, and a producer that branches on the code alone will treat a refused calendar as a landed one. */
export type LandRetailCalendarParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly calendar_convention: string;
      readonly calendar_date: string;
      readonly country_key: string;
      readonly fiscal_period: number;
      readonly fiscal_quarter: number;
      readonly fiscal_week: number;
      readonly fiscal_year: number;
      readonly is_floor_set?: boolean;
      readonly is_holiday?: boolean;
      readonly is_peak_month?: boolean;
      readonly is_provisional_convention: boolean;
      readonly period_key: number;
      readonly phase_in_date?: string | null;
      readonly phase_out_date?: string | null;
      readonly planned_weeks_on_sale?: number | null;
      readonly row_id: string;
      readonly season_code: string;
      readonly season_end_date?: string | null;
      readonly season_start_date?: string | null;
      readonly week_start_date: string;
    })[];
  };
};

/** `POST /api/v1/landing/retail-calendar` */
export const landRetailCalendar: OperationSpec<LandRetailCalendarParams, LandingResponse> = {
  operationId: "land_retail_calendar_api_v1_landing_retail_calendar_post",
  method: "POST",
  path: "/api/v1/landing/retail-calendar",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/retail-price` — Land Retail Prices — Land one ``retail_price`` batch. All-or-nothing, in one transaction. `13` M7's price half, the companion of :func:`land_landed_costs` and the same protocol: one batch per country, the versions in force over the partition's month, ``delivery_seq`` from :func:`read_retail_price_sequence`, a re-publication naming the batch it supersedes (ADR 2009). A batch that passes G-1..G-4 is promoted in this transaction; the newest promoted, unsuperseded batch is the one :func:`~services.repositories.inseason.retail_prices_in_force_statement` reads, and the transfers report carries the price in force (ADR 6130). */
export type LandRetailPricesParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly currency_code?: string | null;
      readonly includes_vat?: boolean | null;
      readonly price_kind?: "list" | "ticket" | null;
      readonly price_provenance?: string | null;
      readonly retail_price_amount: number;
      readonly row_id: string;
      readonly valid_from?: string | null;
      readonly valid_to?: string | null;
      readonly vat_rate?: number | null;
    })[];
  };
};

/** `POST /api/v1/landing/retail-price` */
export const landRetailPrices: OperationSpec<LandRetailPricesParams, LandingResponse> = {
  operationId: "land_retail_prices_api_v1_landing_retail_price_post",
  method: "POST",
  path: "/api/v1/landing/retail-price",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/returns-transactions` — Land Returns Transactions — Land one ``returns_transaction`` batch. All-or-nothing, in one transaction. **A separate feed and a separate table, because a return is a distinct fact.** ``returns_transaction.yml`` fixes the convention: units are always positive here, a return is not a negative sale, and a consumer deriving net units sums the two feeds independently and subtracts. Landing returns as negative rows on the sales table would have made gross and net the same number with no column able to say which — and would have made ``units_non_negative`` on the sales feed unenforceable in the same stroke. **What this feed cannot answer, stated here rather than discovered downstream.** It carries no ``discount_type``, because the in-store source carries no discount column; for that leg ``net_value_amount`` equals ``gross_value_amount`` as a documented gap and not a verified fact. A consumer computing markdown recovery on returns is therefore reading an upper bound for in-store and an exact figure for e-commerce, and the ``channel_key`` on the row is how it can tell which it has. Its gate, auth, size limit and streaming ingest are the ones every other feed on this router uses. */
export type LandReturnsTransactionsParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly business_date: string;
      readonly channel_key: string;
      readonly cost_value_amount?: number | null;
      readonly country_key: string;
      readonly currency_code: string;
      readonly gross_value_amount: number;
      readonly net_value_amount: number;
      readonly row_id: string;
      readonly size_code: string;
      readonly size_run_position: number;
      readonly size_scale: string;
      readonly source_document_id?: string | null;
      readonly store_key: string;
      readonly units: number;
    })[];
  };
};

/** `POST /api/v1/landing/returns-transactions` */
export const landReturnsTransactions: OperationSpec<LandReturnsTransactionsParams, LandingResponse> = {
  operationId: "land_returns_transactions_api_v1_landing_returns_transactions_post",
  method: "POST",
  path: "/api/v1/landing/returns-transactions",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/sales-transactions` — Land Sales Transactions — Land one ``sales_transaction`` batch. All-or-nothing, in one transaction. **The base fact, and the largest single gap in the plan store until now.** Every availability, sell-through, margin and markdown measure resolves through this feed, and three phases — pre-season's size curve and localisation index, post-season's recovery and accuracy measurement, in-season re-forecasting — have each been taking their history from a caller or a fixture because nothing in this store carried a unit that had been sold. **Its own route, and its own table, per ADR 0119.** No ``feed`` parameter, no shared "land any feed" endpoint, and no branch on a caller-supplied string. **This feed accumulates; it does not supersede by default.** ``bata-data`` writes it one ``(country, period)`` partition per batch, so :func:`~services.repositories.sales.promoted_sales_batches_statement` returns *every* promoted unsuperseded batch rather than the latest one. A re-landed month replaces its predecessor only by naming it in ``supersedes_batch_id`` — without that pointer the month is counted twice, and a doubled month of sales is a doubled sell-through that no gate here can see. **The amounts are landed as exact decimal text, and this route does not do the conversion.** :func:`~services.repositories.sales.append_sales_transactions` does, after the gate: G-1 recomputes the digest over the values handed to it and the producer hashed a JSON number. **A quarantined batch returns 201.** ``state`` on the response is the verdict, not the status code, and a producer branching on the code alone will treat a refused month of sales as a landed one. */
export type LandSalesTransactionsParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly business_date: string;
      readonly channel_key: string;
      readonly country_key: string;
      readonly currency_code: string;
      readonly discount_type: string;
      readonly gross_value_amount: number;
      readonly net_value_amount: number;
      readonly row_id: string;
      readonly size_code: string;
      readonly size_run_position: number;
      readonly size_scale: string;
      readonly store_key: string;
      readonly units: number;
    })[];
  };
};

/** `POST /api/v1/landing/sales-transactions` */
export const landSalesTransactions: OperationSpec<LandSalesTransactionsParams, LandingResponse> = {
  operationId: "land_sales_transactions_api_v1_landing_sales_transactions_post",
  method: "POST",
  path: "/api/v1/landing/sales-transactions",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/schedule-state` — Land Schedule State — Record the orchestrator's schedule state (ADR 6035). ``bata-data``'s schedule sensor posts one set per evaluation; the platform keeps the newest report per schedule (and a short history) in ``platform_schedule_state``, and ``GET /foundations/cycle-runs`` publishes it. Same role as every other landing write. Idempotent on ``(schedule_name, reported_at)``: a resent report is counted in ``already_recorded`` and written once; the same key with different content is a ``409`` naming the schedules, and nothing in the set is recorded. */
export type LandScheduleStateParams = {
  readonly body: ScheduleStateRequest;
};

/** `POST /api/v1/landing/schedule-state` */
export const landScheduleState: OperationSpec<LandScheduleStateParams, ScheduleStateResponse> = {
  operationId: "land_schedule_state_api_v1_landing_schedule_state_post",
  method: "POST",
  path: "/api/v1/landing/schedule-state",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/season-intakes` — Land Season Intakes — Land one ``exit_season_intake`` batch. All-or-nothing, in one transaction. Its own route, as every feed here has (ADR 0119). This is the denominator the CO exit-plan record producer reads (bata-platform#238): without it no plan record can be built, because ``exit_plan_record.intake_units`` is ``NOT NULL`` and nothing else in the plan store measures it. */
export type LandSeasonIntakesParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly as_of_date: string;
      readonly country_key: string;
      readonly intake_definition_id: string;
      readonly intake_units: number;
      readonly lifecycle_class?: string | null;
      readonly option_key: string;
      readonly row_id: string;
      readonly season_code?: string | null;
    })[];
  };
};

/** `POST /api/v1/landing/season-intakes` */
export const landSeasonIntakes: OperationSpec<LandSeasonIntakesParams, LandingResponse> = {
  operationId: "land_season_intakes_api_v1_landing_season_intakes_post",
  method: "POST",
  path: "/api/v1/landing/season-intakes",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/sell-through-week` — Land Sell Through Week — Land one ``sell_through_week`` batch. All-or-nothing, in one transaction. bata-reqs docs/25 §5.3 A2.1: one row per country × fiscal week × store × article — the week's opening stock, intake, units sold and full-price units, and the same season to date — for ``GET /health/sell-through`` and the monthly pack's Health section. One batch per country × week; a full-refresh batch restates its week and supersedes the one in force. Refused before the transaction (``422``): full-price units above units sold (week or season to date), a season starting after its week, a batch of two weeks or one store × article twice (``platform.landing.sell_through_week_grain``), and a season-to-date figure below the previous week's in force (``platform.landing.sell_through_week_season_to_date_decreased``). */
export type LandSellThroughWeekParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly closing_on_hand_units: number;
      readonly country_key: string;
      readonly department_family_key?: string | null;
      readonly fiscal_week: number;
      readonly fiscal_year: number;
      readonly full_price_sell_through_rate?: number | null;
      readonly full_price_share_of_sales?: number | null;
      readonly full_price_units: number;
      readonly intake_basis: "derived_stock_delta_plus_sales" | "measured_receipt";
      readonly intake_units: number;
      readonly metrics_version: string;
      readonly model_version: string;
      readonly opening_on_hand_units: number;
      readonly row_id: string;
      readonly season_code: string;
      readonly season_start_date: string;
      readonly sell_through_rate_constrained?: number | null;
      readonly std_full_price_units: number;
      readonly std_intake_units: number;
      readonly std_opening_on_hand_units: number;
      readonly std_units_sold: number;
      readonly store_key: string;
      readonly units_sold: number;
      readonly week_start_date: string;
    })[];
  };
};

/** `POST /api/v1/landing/sell-through-week` */
export const landSellThroughWeek: OperationSpec<LandSellThroughWeekParams, LandingResponse> = {
  operationId: "land_sell_through_week_api_v1_landing_sell_through_week_post",
  method: "POST",
  path: "/api/v1/landing/sell-through-week",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/preseason-size-availability-week` — Land Size Availability Week — Land one ``preseason_size_availability_week`` batch. All-or-nothing, in one transaction. Its own route, on ADR 0119's "one feed, one route" — the same reason every feed in this router gets one rather than branching on a caller-supplied name. **This is the route that makes ``planning.sizecurve.fit.ScopePanel`` have a producer.** ``services/api/wiring.py``'s ch02 installer has recorded, since the size-curve job was written, that no selector returned one because nothing had ever landed the door-grain availability panel it is assembled from. ``services/repositories/preseason.py``'s ``size_curve_scope_panels`` is the selector this route feeds; ``services/jobs/preseason.py``'s ``_sourced_panels`` is its caller. ``LabsLtd/bata-platform#189``. **What this does not do.** It lands what `bata-data` reports; it does not resolve a channel or a season for a row, and it does not decide whether a door or a week is usable — those are the selector's job, at read time, against ``location_master`` and ``retail_calendar``. Nor does it build the producer that would post to it: that is `bata-data`'s, tracked separately, and this route has no rows until one exists. */
export type LandSizeAvailabilityWeekParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly availability_state: "not_ranged" | "in_stock" | "stocked_out";
      readonly country_key: string;
      readonly is_censored: boolean;
      readonly is_in_stock: boolean;
      readonly is_not_ranged: boolean;
      readonly location_key: string;
      readonly metrics_version: string;
      readonly model_version: string;
      readonly period_key: number;
      readonly row_id: string;
      readonly size_key: string;
      readonly size_scale: string;
      readonly units_sold: number;
      readonly week_start_date: string;
    })[];
  };
};

/** `POST /api/v1/landing/preseason-size-availability-week` */
export const landSizeAvailabilityWeek: OperationSpec<LandSizeAvailabilityWeekParams, LandingResponse> = {
  operationId: "land_size_availability_week_api_v1_landing_preseason_size_availability_week_post",
  method: "POST",
  path: "/api/v1/landing/preseason-size-availability-week",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/size-dimension` — Land Size Dimension — Land one ``size_dimension`` batch. All-or-nothing, in one transaction. A register: each batch restates the whole dimension, and :func:`~services.repositories.dimensions.in_force_size_batch_statement` reads the newest promoted batch. It is what every read that carries a ``size_key`` names the size by (``size_code``, ``size_scale``, ``size_run_position``). ADR 2006. */
export type LandSizeDimensionParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly normalised_size?: number | null;
      readonly row_id: string;
      readonly run_length: number;
      readonly size_code: string;
      readonly size_key: string;
      readonly size_run_position: number;
      readonly size_scale: string;
    })[];
  };
};

/** `POST /api/v1/landing/size-dimension` */
export const landSizeDimension: OperationSpec<LandSizeDimensionParams, LandingResponse> = {
  operationId: "land_size_dimension_api_v1_landing_size_dimension_post",
  method: "POST",
  path: "/api/v1/landing/size-dimension",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/stock-positions` — Land Stock Positions — Land one ``stock_position`` batch. All-or-nothing, in one transaction. **Its own route, not a ``feed`` parameter on the one above.** ADR 0119 rejected a generic "land any feed" endpoint taking a table name from the caller, and this is where that decision earns its keep: the two feeds carry different rows, measure different quality fields and land in different tables, so a single route would have to branch on a caller-supplied string and would let a mislabelled batch reach a table this router never named. The batch is run through :func:`services.integrations.landing.land` — G-1 through G-4, unchanged from any other B1 caller — and its rows are appended only if the batch is **promoted**, the same rule :func:`land_price_observations` follows. **This route does not resolve the unresolved-size problem, on purpose.** `bata-data` measured 91,428 of 990,045 production rows carrying an empty ``size_key``, folding into 63,215 ``(location, article)`` pairs, and refuses such a batch at the producer. That refusal belongs there — it fires on the presence of a bad key, where the fact table can name the pairs — and an aggregation here that folded the blanks together would be the defect it exists to prevent: the plan store keys a position on ``(run, store, article, size)``, so several unresolved sizes of one article in one door collapse onto one key and their units are summed, reporting a door as holding every size's stock, with every gate green. **This is the route the streaming ingest was built for.** `bata-data`'s measured first production batch is ~990,045 rows and ~225 MB for one country-day, against a 2 GB container; the rows now arrive one at a time and the row-count refusal fires while the body is still on the wire. **And it is the one feed whose rows must fall inside the window its manifest declares** — see :data:`_STOCK_WINDOW_FIELD`. The landing table is range-partitioned on ``as_of_date`` and the reader bounds on the batch's window, so a row outside it would land promoted and never be read back. G-1 now quarantines the batch instead, naming the bound and the extreme value that breached it. */
export type LandStockPositionsParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly article_key: string;
      readonly as_of_date: string;
      readonly committed_units?: number | null;
      readonly in_transit_units?: number | null;
      readonly location_key: string;
      readonly location_type: string;
      readonly on_hand_units?: number | null;
      readonly position_state: string;
      readonly row_id: string;
      readonly size_key: string;
    })[];
  };
};

/** `POST /api/v1/landing/stock-positions` */
export const landStockPositions: OperationSpec<LandStockPositionsParams, LandingResponse> = {
  operationId: "land_stock_positions_api_v1_landing_stock_positions_post",
  method: "POST",
  path: "/api/v1/landing/stock-positions",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/landing/preseason-store-feature-panel` — Land Store Feature Panel — Land one ``preseason_store_feature_panel`` batch. All-or-nothing, in one transaction. ADR 4000 (bata-platform#433): the door feature panel ``preseason.cluster_fit`` clusters, published by ``bata-data`` because this repository has no read path into the analytical store (`14` §1). It lands what the producer reports; the fit decides, at read time, which doors and which features it may use. */
export type LandStoreFeaturePanelParams = {
  readonly body: {
    /** `14` §2.2's manifest, over the wire. ``partial_channels``/``partial_reason`` are the pair `bata-platform`#335 adds for an owner-accepted PARTIAL day (`bata-data` ADR 2000): the source channels a batch has no rows for, and why the batch lands anyway rather than being refused. **Both absent, on every batch that is not partial** — the default this pair leaves the wire at is exactly the wire as it was before this pair existed, so a producer that never names a partial day changes nothing about what it sends. Declared here rather than only on ``stock_position``'s own request model because every landing route shares this one manifest model (ADR 0119's "one feed, one route" is about the *routes*, not about a second manifest per feed) — a future feed that also needs to carry an accepted gap does not wait for its own field. */
    readonly manifest: {
      readonly batch_id: string;
      readonly checksum: string;
      readonly contract_version: string;
      readonly control_totals?: {
        readonly [key: string]: number;
      };
      readonly country_key: string;
      readonly delivery_seq: number;
      readonly feed_id: string;
      readonly is_full_refresh?: boolean;
      readonly partial_channels?: readonly (string)[] | null;
      readonly partial_reason?: string | null;
      readonly period_key: number;
      readonly produced_at: string;
      readonly row_count: number;
      readonly source_system: string;
      readonly source_version: string;
      readonly supersedes_batch_id?: string | null;
      readonly window_end: string;
      readonly window_start: string;
    };
    readonly rows: readonly ({
      readonly country_key: string;
      readonly discount_dependency?: number | null;
      readonly distinct_articles: number;
      readonly is_fully_attributed: boolean;
      readonly location_key: string;
      readonly metrics_version: string;
      readonly model_version: string;
      readonly row_id: string;
      readonly store_key: string;
      readonly trading_weeks: number;
      readonly transaction_features_are_available: boolean;
      readonly transactions_per_week?: number | null;
      readonly units: number;
      readonly units_per_trading_week?: number | null;
      readonly units_per_transaction?: number | null;
      readonly window_end_date: string;
      readonly window_start_date: string;
    })[];
  };
};

/** `POST /api/v1/landing/preseason-store-feature-panel` */
export const landStoreFeaturePanel: OperationSpec<LandStoreFeaturePanelParams, LandingResponse> = {
  operationId: "land_store_feature_panel_api_v1_landing_preseason_store_feature_panel_post",
  method: "POST",
  path: "/api/v1/landing/preseason-store-feature-panel",
  tag: "landing",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/exit/consolidation/reason-codes` — The governed reason codes for an exit-lane decision — ADR 6104/6107: exit's own `exit.lane_decision_reason_vocabulary` registry row when one is in force (R-7, bounded by every code a lane-book line can carry: the clearance engine's lane codes and, since ADR 7030, `zona_sales_withdrawal` and `outlet_exit_transfer`, which are offered only when the row names them); otherwise the clearance engine's lane codes, narrowed by the `exit.reason_code_vocabulary` registry row when one is in force (ADR 7005/7007). `POST /exit/consolidation/dispositions` refuses any other code with 422 `planning.exit.lane_reason_not_governed`. */
export type LaneReasonCodesParams = Record<string, never>;

/** `GET /api/v1/exit/consolidation/reason-codes` */
export const laneReasonCodes: OperationSpec<LaneReasonCodesParams, LaneReasonCodes> = {
  operationId: "lane_reason_codes_api_v1_exit_consolidation_reason_codes_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/reason-codes",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/postseason/recovery/latest` — The newest recovery run for a season — The run identifier and method version chapter 02's size-curve fit pins to. Empty identifiers with hasRun false where the season has no run — a state, not an error. */
export type LatestRecoveryRunParams = {
  readonly query?: {
    readonly season?: string;
  };
};

/** `GET /api/v1/postseason/recovery/latest` */
export const latestRecoveryRun: OperationSpec<LatestRecoveryRunParams, LatestRecoveryRunResponse> = {
  operationId: "latest_recovery_run_api_v1_postseason_recovery_latest_get",
  method: "GET",
  path: "/api/v1/postseason/recovery/latest",
  tag: "postseason",
  pathParams: [],
  queryParams: ["season"],
  hasBody: false,
};

/** `GET /api/v1/launch/options` — List options a launch screen can be scoped to — The option directory for this chapter, filterable by cluster and class. */
export type LaunchListOptionsParams = {
  readonly query?: {
    readonly cluster_id?: string | null;
    readonly class_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/launch/options` */
export const launchListOptions: OperationSpec<LaunchListOptionsParams, CursorPageLaunchOptionModel> = {
  operationId: "list_options_api_v1_launch_options_get",
  method: "GET",
  path: "/api/v1/launch/options",
  tag: "launch",
  pathParams: [],
  queryParams: ["cluster_id", "class_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/launch/proposals` — List launch proposals — Proposed shipment lines for one allocation version, filterable by reason code. */
export type LaunchListProposalsParams = {
  readonly query?: {
    readonly allocation_version_id?: string;
    readonly reason_code?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/launch/proposals` */
export const launchListProposals: OperationSpec<LaunchListProposalsParams, CursorPageProposalModel> = {
  operationId: "list_proposals_api_v1_launch_proposals_get",
  method: "GET",
  path: "/api/v1/launch/proposals",
  tag: "launch",
  pathParams: [],
  queryParams: ["allocation_version_id", "reason_code", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/lifecycle-phases/{article_key}/history` — One article's lifecycle phase month by month, with both sources — One article's history in one market (ADR 7031). Bounded by the article: one row per month its sources span (about forty since the inference's first month), so it is one document rather than a page. 404 ``lifecycle_phases.article_not_found`` when neither source names it. */
export type LifecyclePhaseHistoryParams = {
  readonly path: {
    readonly article_key: string;
  };
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/exit/lifecycle-phases/{article_key}/history` */
export const lifecyclePhaseHistory: OperationSpec<LifecyclePhaseHistoryParams, LifecyclePhaseHistoryModel> = {
  operationId: "lifecycle_phase_history_api_v1_exit_lifecycle_phases__article_key__history_get",
  method: "GET",
  path: "/api/v1/exit/lifecycle-phases/{article_key}/history",
  tag: "exit",
  pathParams: ["article_key"],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /api/v1/exit/lifecycle-phases/summary` — How many articles are in each lifecycle phase for a month, per source — The register's census for one market and month (ADR 7031). 404 as the list. */
export type LifecyclePhaseSummaryParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly month?: string;
  };
};

/** `GET /api/v1/exit/lifecycle-phases/summary` */
export const lifecyclePhaseSummary: OperationSpec<LifecyclePhaseSummaryParams, LifecyclePhaseSummaryModel> = {
  operationId: "lifecycle_phase_summary_api_v1_exit_lifecycle_phases_summary_get",
  method: "GET",
  path: "/api/v1/exit/lifecycle-phases/summary",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "month"],
  hasBody: false,
};

/** `GET /api/v1/postseason/accuracy` — Forecast accuracy and bias by grain, horizon, model version and owner — The accuracy warehouse (reqs/06 6.3), computed on unconstrained demand. WAPE, MASE against the seasonal-naive baseline, forecast value added and the tracking signal. MAPE is excluded by design and is not obtainable here. 404 `planning.postseason.read_not_published` while no producer persists its rows (DEC-111). */
export type ListAccuracyParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/accuracy` */
export const listAccuracy: OperationSpec<ListAccuracyParams, CursorPageAccuracyRow> = {
  operationId: "list_accuracy_api_v1_postseason_accuracy_get",
  method: "GET",
  path: "/api/v1/postseason/accuracy",
  tag: "postseason",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/foundations/exceptions/assignees` — List Alert Assignees — Who can take alerts in a market, by name — the assignment picker (DEC-102, ADR 2110). A person is listed when their profile has copied their access claims (any ``PUT /me/profile`` since DEC-102 — a person who has never saved their profile is not known to the platform and is not listed) and the permission register, read with those claims, grants them ``assign`` on ``alert`` over the market (ADR 2107). With ``rule_id``, only those whose roles include the rule's owner role. Authorised as the assignment act (``assign`` on ``alert``): 401 without identity, 403 without the grant. A market outside the caller's scope lists nobody. */
export type ListAlertAssigneesParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly rule_id?: string | null;
  };
};

/** `GET /api/v1/foundations/exceptions/assignees` */
export const listAlertAssignees: OperationSpec<ListAlertAssigneesParams, AlertAssignees> = {
  operationId: "list_alert_assignees_api_v1_foundations_exceptions_assignees_get",
  method: "GET",
  path: "/api/v1/foundations/exceptions/assignees",
  tag: "foundations",
  pathParams: [],
  queryParams: ["country_key", "rule_id"],
  hasBody: false,
};

/** `GET /api/v1/foundations/exceptions/groups` — List Alert Groups — The exception queue read one alert type at a time (owner ruling DEC-101, ADR 2109). A group is one rule in one value of ``group_by``: ``country`` (the market), ``store`` or ``department`` — the market's pinned product class scheme on today's date, so ``group_by=department`` needs ``country_key`` and is refused as the department filter is (422 ``alert_department_needs_market``; 409 ``alert_department_scheme_not_pinned`` / ``_refused``). Every other filter means exactly what it means on ``GET /foundations/exceptions``, because the groups are counted over that read's own statement, in the store. Ordered by severity (``critical``, ``serious``, ``warning``, then any other code by its spelling), then ``overdueCount`` and ``alertCount`` descending, then ``groupKey``. ``totals`` counts every group, alert and overdue alert the filters match, not only this page's. **The no-value bucket.** A group whose ``dimensionKey`` is ``null`` is selected by the filter value ``-``: ``store_key=-`` (no store), ``department_family=-`` (no article, or an article in no family), ``article_key=-`` (no article). The market's null bucket (alerts raised before W3-1 carry no market) cannot be selected. */
export type ListAlertGroupsParams = {
  readonly query?: {
    readonly group_by?: AlertGroupDimension;
    readonly open_only?: boolean;
    readonly queue?: AlertQueue | null;
    readonly state?: AlertState | null;
    readonly overdue?: boolean | null;
    readonly store_key?: string | null;
    readonly rule_id?: string | null;
    readonly country_key?: string | null;
    readonly department_family?: string | null;
    readonly article_key?: string | null;
    readonly cursor?: string | null;
    readonly limit?: number;
  };
};

/** `GET /api/v1/foundations/exceptions/groups` */
export const listAlertGroups: OperationSpec<ListAlertGroupsParams, AlertGroupPage> = {
  operationId: "list_alert_groups_api_v1_foundations_exceptions_groups_get",
  method: "GET",
  path: "/api/v1/foundations/exceptions/groups",
  tag: "foundations",
  pathParams: [],
  queryParams: ["group_by", "open_only", "queue", "state", "overdue", "store_key", "rule_id", "country_key", "department_family", "article_key", "cursor", "limit"],
  hasBody: false,
};

/** `GET /api/v1/postseason/attribute-holdout` — Attributes against the category average on held-out options — reqs/07 §3.2 test (e), published rather than left inside the job that computes it. Both error figures travel with the verdict; `passes` is null where no options were held out, which is a test that did not run rather than a test that failed. */
export type ListAttributeHoldoutParams = {
  readonly query?: {
    readonly season?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/attribute-holdout` */
export const listAttributeHoldout: OperationSpec<ListAttributeHoldoutParams, CursorPageAttributeHoldoutRow> = {
  operationId: "list_attribute_holdout_api_v1_postseason_attribute_holdout_get",
  method: "GET",
  path: "/api/v1/postseason/attribute-holdout",
  tag: "postseason",
  pathParams: [],
  queryParams: ["season", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/attributes` — Versioned attribute performance indices — Attribute indices at season x cluster x attribute value (reqs/06 6.2), versioned per season. Consumers pin the version rather than reading the live table, and the significance flag is published so a thin cell is weighted rather than trusted. 404 `planning.postseason.read_not_published` while no producer persists its rows (DEC-111). */
export type ListAttributeIndicesParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/attributes` */
export const listAttributeIndices: OperationSpec<ListAttributeIndicesParams, CursorPageAttributeIndexRow> = {
  operationId: "list_attribute_indices_api_v1_postseason_attributes_get",
  method: "GET",
  path: "/api/v1/postseason/attributes",
  tag: "postseason",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/conformance/autonomy-register` — List Autonomy Register — The decision-class autonomy register (reqs/07 §3.5). **Sorted here for the reason ``list_material_decisions`` is**: this is process state installed by ``use_decision_class_register``, not an estate read, so there is no statement to order it and it was served in install order while its cursor keyed on ``(decision_class, country_key)``. A plain key function rather than a :class:`~services.paging.PageKey`, because ``country_key`` is nullable — a register row may be estate-wide — and ``PageKey`` refuses nulls. It refuses them for statements, where SQL's null placement and Python's comparison rules diverge silently. Here one function both sorts the rows and builds the cursor, so the coercion cannot disagree with itself and the objection does not apply. */
export type ListAutonomyRegisterParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/conformance/autonomy-register` */
export const listAutonomyRegister: OperationSpec<ListAutonomyRegisterParams, CursorPageAutonomySummary> = {
  operationId: "list_autonomy_register_api_v1_conformance_autonomy_register_get",
  method: "GET",
  path: "/api/v1/conformance/autonomy-register",
  tag: "conformance",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/preseason/buy-lines` — List Buy Lines — Time-phased buy lines, with the chain references reqs/07 §3.1 requires. */
export type ListBuyLinesParams = {
  readonly query?: {
    readonly receipt_period_key?: string | null;
    readonly cluster_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/buy-lines` */
export const listBuyLines: OperationSpec<ListBuyLinesParams, CursorPageBuyLineSummary> = {
  operationId: "list_buy_lines_api_v1_preseason_buy_lines_get",
  method: "GET",
  path: "/api/v1/preseason/buy-lines",
  tag: "preseason",
  pathParams: [],
  queryParams: ["receipt_period_key", "cluster_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/cadence-proposals` — Rung-change proposals — Every proposal traceable to the required rate, the forecast rate, the chosen rung and the elasticity used, per reqs/05 §8.4. Protected carry-over options never appear on this list. `country_key` and `as_of_date` are the pair `/exit/cadence-proposals/bulk-approve` requires, and they are readable here rather than having to be known out of band; an omitted `as_of_date` means every week the scope allows, and never today. */
export type ListCadenceProposalsParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly as_of_date?: string | null;
    readonly option_id?: string | null;
    readonly cluster_id?: string | null;
    readonly proposal_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/cadence-proposals` */
export const listCadenceProposals: OperationSpec<ListCadenceProposalsParams, CursorPageCadenceProposalSummary> = {
  operationId: "list_cadence_proposals_api_v1_exit_cadence_proposals_get",
  method: "GET",
  path: "/api/v1/exit/cadence-proposals",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "as_of_date", "option_id", "cluster_id", "proposal_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/campaigns/response/backtest` — List Campaign Response Backtest — A fit's held-out windows of one method, in window order. 404 for an unseen fit. */
export type ListCampaignResponseBacktestParams = {
  readonly query?: {
    readonly fit_id?: string;
    readonly method?: "rolling_origin" | "leave_one_out";
    readonly channel_key?: string | null;
    readonly mechanic_code?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/campaigns/response/backtest` */
export const listCampaignResponseBacktest: OperationSpec<ListCampaignResponseBacktestParams, CursorPageHoldoutView> = {
  operationId: "list_campaign_response_backtest_api_v1_inseason_campaigns_response_backtest_get",
  method: "GET",
  path: "/api/v1/inseason/campaigns/response/backtest",
  tag: "inseason",
  pathParams: [],
  queryParams: ["fit_id", "method", "channel_key", "mechanic_code", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/campaigns/response/fits` — List Campaign Response Fits — The market's fits, newest first, each with the channel × mechanic gates it opened. */
export type ListCampaignResponseFitsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/campaigns/response/fits` */
export const listCampaignResponseFits: OperationSpec<ListCampaignResponseFitsParams, CursorPageFitSummaryView> = {
  operationId: "list_campaign_response_fits_api_v1_inseason_campaigns_response_fits_get",
  method: "GET",
  path: "/api/v1/inseason/campaigns/response/fits",
  tag: "inseason",
  pathParams: [],
  queryParams: ["country_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/campaigns/simulations` — List Campaign Simulations — One base run's campaign simulations, newest first. Bounded by the run (G16). */
export type ListCampaignSimulationsParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/campaigns/simulations` */
export const listCampaignSimulations: OperationSpec<ListCampaignSimulationsParams, CursorPageCampaignSimulationView> = {
  operationId: "list_campaign_simulations_api_v1_inseason_campaigns_simulations_get",
  method: "GET",
  path: "/api/v1/inseason/campaigns/simulations",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/registry/changes/{change_id}/items` — List Change Items — The sealed contents of one change set — what it wrote, before and after. */
export type ListChangeItemsParams = {
  readonly path: {
    readonly change_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/registry/changes/{change_id}/items` */
export const listChangeItems: OperationSpec<ListChangeItemsParams, CursorPageChangeItemRow> = {
  operationId: "list_change_items_api_v1_registry_changes__change_id__items_get",
  method: "GET",
  path: "/api/v1/registry/changes/{change_id}/items",
  tag: "registry",
  pathParams: ["change_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/registry/changes` — List Changes — The change record (`17` §3), optionally filtered. Superseded and expired sets are served, never filtered away. `17` §5's staleness census and §3's "appended, never edited" both depend on the record staying readable after it stops being in force, and a register that hid its own history would answer "who changed this number" with silence. The filters (W2-2) narrow and never widen: ``state`` (``proposed``, ``approved``, ``promoted``, ``rejected``, ``withdrawn``), ``author``, ``family`` — a set touching the family on any item, by DEC-26's rule — ``parameter_key`` on any item, and ``proposed_from``/``proposed_to``, inclusive, on ``proposedOn``. */
export type ListChangesParams = {
  readonly query?: {
    readonly state?: string | null;
    readonly author?: string | null;
    readonly family?: string | null;
    readonly parameter_key?: string | null;
    readonly proposed_from?: string | null;
    readonly proposed_to?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/registry/changes` */
export const listChanges: OperationSpec<ListChangesParams, CursorPageChangeSetSummary> = {
  operationId: "list_changes_api_v1_registry_changes_get",
  method: "GET",
  path: "/api/v1/registry/changes",
  tag: "registry",
  pathParams: [],
  queryParams: ["state", "author", "family", "parameter_key", "proposed_from", "proposed_to", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/preseason/cluster-schemes/{scheme_id}/{version_id}/demand-shape` — List Cluster Demand Shape — A scheme version's weekly demand shape, per cluster (reqs/02 §3.2). Bounded by scheme *and* version in the path, as the membership read is and for the same reason: several schemes coexist by design, and shapes drawn from two of them on one axis compare clusters that were never fitted against each other. */
export type ListClusterDemandShapeParams = {
  readonly path: {
    readonly scheme_id: string;
    readonly version_id: string;
  };
  readonly query?: {
    readonly cluster_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/cluster-schemes/{scheme_id}/{version_id}/demand-shape` */
export const listClusterDemandShape: OperationSpec<ListClusterDemandShapeParams, CursorPageClusterDemandShapePoint> = {
  operationId: "list_cluster_demand_shape_api_v1_preseason_cluster_schemes__scheme_id___version_id__demand_shape_get",
  method: "GET",
  path: "/api/v1/preseason/cluster-schemes/{scheme_id}/{version_id}/demand-shape",
  tag: "preseason",
  pathParams: ["scheme_id", "version_id"],
  queryParams: ["cluster_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/preseason/cluster-schemes/{scheme_id}/{version_id}/membership` — List Cluster Membership — A scheme version's store → cluster membership rows. */
export type ListClusterMembershipParams = {
  readonly path: {
    readonly scheme_id: string;
    readonly version_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/cluster-schemes/{scheme_id}/{version_id}/membership` */
export const listClusterMembership: OperationSpec<ListClusterMembershipParams, CursorPageClusterMembershipSummary> = {
  operationId: "list_cluster_membership_api_v1_preseason_cluster_schemes__scheme_id___version_id__membership_get",
  method: "GET",
  path: "/api/v1/preseason/cluster-schemes/{scheme_id}/{version_id}/membership",
  tag: "preseason",
  pathParams: ["scheme_id", "version_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/preseason/cluster-schemes` — List Cluster Schemes — List coexisting cluster schemes, optionally for one department family. */
export type ListClusterSchemesParams = {
  readonly query?: {
    readonly department_family?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/cluster-schemes` */
export const listClusterSchemes: OperationSpec<ListClusterSchemesParams, CursorPageClusterSchemeSummary> = {
  operationId: "list_cluster_schemes_api_v1_preseason_cluster_schemes_get",
  method: "GET",
  path: "/api/v1/preseason/cluster-schemes",
  tag: "preseason",
  pathParams: [],
  queryParams: ["department_family", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/decisions` — One consolidation run's per-door decisions, each flagged if superseded — bata-reqs ADR 0124, ADR 7019 and ADR 7020: the role `exit.consolidation_run` gave each door (`source`, `destination` or `neither`), under the request cluster it was posed in. `run_id` is required, and it names an `exit.consolidation_run` run from `/consolidation/runs`. It returns everything the run decided that is still stored (history per run, bounded to 30 runs per market by the retention purge), and each row's `superseded` is true when a later decision run of the same market decided that door again. `decision_count` is what the run's header says it wrote, `current_decision_count` is how many stored rows are not superseded, and `superseded_decision_count` is the difference. They describe the run, not the page or the filters, and they are null when `run_id` names no decision run the caller may see. */
export type ListConsolidationDecisionsParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly option_id?: string | null;
    readonly country_key?: string | null;
    readonly store_key?: string | null;
    readonly node_role?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/consolidation/decisions` */
export const listConsolidationDecisions: OperationSpec<ListConsolidationDecisionsParams, ConsolidationDecisionPage> = {
  operationId: "list_consolidation_decisions_api_v1_exit_consolidation_decisions_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/decisions",
  tag: "exit",
  pathParams: [],
  queryParams: ["run_id", "option_id", "country_key", "store_key", "node_role", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/doors` — Door residual positions and size-run integrity — reqs/05 §3.4's consolidation position: residual units per door, how much of the size scale each still carries, and the longest contiguous run left. Doors with an unmeasured clearance sell-through per unit of capacity carry a null rather than a zero — an unranked door is not a door that ranked last. A door with no cluster assignment carries a null cluster for the same reason: reqs/02 §2.2's scheme does not exist yet, null means unknown, and it is neither the empty string — which means every cluster — nor a group the nulls may be ranked within. `matching` is how many doors the filters match over the whole run, the same on every page (ADR 6194). */
export type ListConsolidationDoorsParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly option_id?: string | null;
    readonly country_key?: string | null;
    readonly cluster_id?: string | null;
    readonly store_key?: string | null;
    readonly as_of?: string | null;
    readonly run_is_broken?: boolean | null;
    readonly sell_through_absent?: boolean | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/consolidation/doors` */
export const listConsolidationDoors: OperationSpec<ListConsolidationDoorsParams, ConsolidationDoorPage> = {
  operationId: "list_consolidation_doors_api_v1_exit_consolidation_doors_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/doors",
  tag: "exit",
  pathParams: [],
  queryParams: ["run_id", "option_id", "country_key", "cluster_id", "store_key", "as_of", "run_is_broken", "sell_through_absent", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/lane-options` — One run's lane book rolled up to one row per option and date — ADR 7030. The option directory of a run's LINES, where `/consolidation/options` is the directory of a position run's DOORS. A `lane_move` run (`lifecycle.withdrawal`, `lifecycle.outlet_transfer`) has no position run by design, so a lanes screen opens it here: lines, proposed lines and units, lines already decided, source and destination doors, and the planner decision (`action_id`) that ordered them. Serves any run that wrote lines. `run_id` is required. Counts and sums of `/consolidation/lines` bounded the same way. */
export type ListConsolidationLaneOptionsParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly option_id?: string | null;
    readonly country_key?: string | null;
    readonly as_of?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/consolidation/lane-options` */
export const listConsolidationLaneOptions: OperationSpec<ListConsolidationLaneOptionsParams, CursorPageConsolidationLaneOptionSummary> = {
  operationId: "list_consolidation_lane_options_api_v1_exit_consolidation_lane_options_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/lane-options",
  tag: "exit",
  pathParams: [],
  queryParams: ["run_id", "option_id", "country_key", "as_of", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/lines` — Candidate consolidation movements, proposed and withheld — Every candidate lane with the economics that decided it. Withheld lanes are returned, not filtered: a lane withheld because reqs/05 D8's cost has not landed and a lane withheld because it does not pay are different findings with different remedies, and a list of proposals alone shows neither. `matching` is how many lines the filters match over the whole run, the same on every page (ADR 6194). */
export type ListConsolidationLinesParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly option_id?: string | null;
    readonly country_key?: string | null;
    readonly source_store_key?: string | null;
    readonly destination_store_key?: string | null;
    readonly size_key?: string | null;
    readonly is_proposed?: boolean | null;
    readonly reason_code?: string | null;
    readonly as_of?: string | null;
    readonly action_id?: string | null;
    readonly repairs_size_run?: boolean | null;
    readonly lane_cost_absent?: boolean | null;
    readonly lane_priced?: boolean | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/consolidation/lines` */
export const listConsolidationLines: OperationSpec<ListConsolidationLinesParams, ConsolidationLinePage> = {
  operationId: "list_consolidation_lines_api_v1_exit_consolidation_lines_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/lines",
  tag: "exit",
  pathParams: [],
  queryParams: ["run_id", "option_id", "country_key", "source_store_key", "destination_store_key", "size_key", "is_proposed", "reason_code", "as_of", "action_id", "repairs_size_run", "lane_cost_absent", "lane_priced", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/options` — The consolidation position rolled up to one row per option and date — reqs/05 §3.4's position is option x door, which is tens of thousands of rows on one country's date. Consolidation is posed per option, so this is the directory a planner chooses an option from before reading its doors: door count, residual units summed over doors, and the number of doors whose size run is broken, per option and `as_of`. Counts and sums of the doors read and nothing else. `run_id` is required (ADR 7019): pick an `exit.consolidation_position` run from `/consolidation/runs`. */
export type ListConsolidationOptionsParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly option_id?: string | null;
    readonly country_key?: string | null;
    readonly as_of?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/consolidation/options` */
export const listConsolidationOptions: OperationSpec<ListConsolidationOptionsParams, CursorPageConsolidationOptionSummary> = {
  operationId: "list_consolidation_options_api_v1_exit_consolidation_options_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/options",
  tag: "exit",
  pathParams: [],
  queryParams: ["run_id", "option_id", "country_key", "as_of", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/runs` — Consolidation runs, newest first — ADR 7019. Every platform run that wrote consolidation rows, newest first by `recorded_at` (when the run started). `exit.consolidation_position` runs carry the door position and withheld lines, and `exit.consolidation_run` runs carry the per-door decisions, and `lane_move` runs (`lifecycle.withdrawal`, `lifecycle.outlet_transfer`; ADR 7030) carry lines a planner's accepted phase decision ordered, with no position run by design. `run_kind` names which, and filters. A screen picks a run here and passes its `run_id` to the doors, options, lines and decisions reads, each of which requires one. This replaces `/consolidation/doors/latest`: the newest measured `as_of` is not the newest run. */
export type ListConsolidationRunsParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly job_name?: string | null;
    readonly run_kind?: readonly ("position" | "decision" | "lane_move")[] | null;
    readonly simulation?: boolean;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/consolidation/runs` */
export const listConsolidationRuns: OperationSpec<ListConsolidationRunsParams, CursorPageConsolidationRunSummary> = {
  operationId: "list_consolidation_runs_api_v1_exit_consolidation_runs_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/runs",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "job_name", "run_kind", "simulation", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/preseason/core-run-coverage` — List Core Run Coverage — Scorecard Objective 1: store-articles holding a complete core size run. Read at two grains from one population. ``week`` is Objective 1's stated cadence; ``store`` is the per-store panel ``services.repositories.programme.difference_in_differences`` consumes as one period. Both are ratios of sums over the same runs rather than means of ratios, so they total to the same numerator and denominator — which is what lets a reader cut the estate either way and get one answer. Nothing is computed here. Every figure is produced by ``planning.sizecurve.coverage`` against the core run ``planning.allocation.sizerun.core_sizes`` defines, and the difference-in-differences is not taken at this edge at all: it has one home and this route serves what that estimator reads (G11). */
export type ListCoreRunCoverageParams = {
  readonly query?: {
    readonly grain?: string | null;
    readonly scope?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/core-run-coverage` */
export const listCoreRunCoverage: OperationSpec<ListCoreRunCoverageParams, CursorPageCoreRunCoverageRow> = {
  operationId: "list_core_run_coverage_api_v1_preseason_core_run_coverage_get",
  method: "GET",
  path: "/api/v1/preseason/core-run-coverage",
  tag: "preseason",
  pathParams: [],
  queryParams: ["grain", "scope", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/d2-evidence` — List D2 Evidence — Gate D2's stored evidence per market, as at a date. ``docs/04`` asked for this read and ``inseason.gate_d2_evidence_statement`` has answered it since wave 4 with nothing calling it. It is dated rather than current because a gate verdict is a claim about a moment: re-reading it today and re-reading it at the review are the same query only if the date is an argument (G9). Rows where the lanes are uncalibrated are returned, not filtered. They are the finding — "D2 was not measurable in this market" — and dropping them here would leave a caller unable to tell no improvement from no evidence. */
export type ListD2EvidenceParams = {
  readonly query?: {
    readonly as_of?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/d2-evidence` */
export const listD2Evidence: OperationSpec<ListD2EvidenceParams, CursorPageGateD2EvidenceRow> = {
  operationId: "list_d2_evidence_api_v1_inseason_d2_evidence_get",
  method: "GET",
  path: "/api/v1/inseason/d2-evidence",
  tag: "inseason",
  pathParams: [],
  queryParams: ["as_of", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/d4-evidence` — Gate D4's stored evidence — The shadow-versus-incumbent comparison per option and cluster, evaluable rows and inadmissible ones alike. Rows where the gate was not measurable carry null deltas and their reason codes — that is the finding, and filtering them out would leave a caller unable to tell no improvement from no evidence. */
export type ListD4EvidenceParams = {
  readonly query?: {
    readonly season_code?: string | null;
    readonly country_key?: string | null;
    readonly option_id?: string | null;
    readonly cluster_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/d4-evidence` */
export const listD4Evidence: OperationSpec<ListD4EvidenceParams, CursorPageD4EvidenceRow> = {
  operationId: "list_d4_evidence_api_v1_exit_d4_evidence_get",
  method: "GET",
  path: "/api/v1/exit/d4-evidence",
  tag: "exit",
  pathParams: [],
  queryParams: ["season_code", "country_key", "option_id", "cluster_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/definitions` — The frozen definitions register — One canonical definition per measure, frozen in Wave 0. Every measure in the review pack traces to exactly one entry here. */
export type ListDefinitionsParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/definitions` */
export const listDefinitions: OperationSpec<ListDefinitionsParams, CursorPageDefinitionRow> = {
  operationId: "list_definitions_api_v1_postseason_definitions_get",
  method: "GET",
  path: "/api/v1/postseason/definitions",
  tag: "postseason",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/elasticity/estimates` — List Elasticity Estimates — The coefficients one model version published. ``model_version_id`` is required, and pinning the read to it rather than to "the latest fit" is the same G9 argument :func:`~services.repositories.inseason.elasticity_estimates_statement` makes: a recommendation must stay re-derivable, and a query that silently followed the newest fit would re-derive last season's markdown with this season's coefficients. It is load-bearing in practice, not only in principle. Four fits sat in production under the single id ``elasticity-fit-v1-2026-09-08`` while differing materially — promotional observations admitted, series detrended, the sanity band widened — because the version is a registry row and nobody bumped it. Merging those generations into one list is exactly what this parameter exists to prevent, and it is why the id belongs on the request rather than being chosen here. The refusals are read beside these, never instead of them: `08`'s coverage bar is a share of revenue, and a shortfall is only actionable when the missing series are named. That read is not on this surface yet. */
export type ListElasticityEstimatesParams = {
  readonly query?: {
    readonly model_version_id?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/elasticity/estimates` */
export const listElasticityEstimates: OperationSpec<ListElasticityEstimatesParams, CursorPageElasticityEstimate> = {
  operationId: "list_elasticity_estimates_api_v1_inseason_elasticity_estimates_get",
  method: "GET",
  path: "/api/v1/inseason/elasticity/estimates",
  tag: "inseason",
  pathParams: [],
  queryParams: ["model_version_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/elasticity/refusals` — List Elasticity Refusals — The series that generation declined to fit, and why it declined. **The half of `08`'s coverage bar nothing published.** The bar is >=95% of TTM revenue and it is a claim about the estimates and the refusals *together*, so a deployment could read its numerator and not its shortfall. The register has been written by every fit since the chapter existed — :func:`~services.repositories.inseason.elasticity_refusals_statement` has always been there — and no route called it, which made "which series are we missing, and whose problem is each one" a question answerable only with database access. It matters here more than the sentence suggests. On the production panel 5,485 of 7,564 candidate series are refused as thin and exactly one is fitted; a screen that could see only the fitted one would show a model that looks narrow rather than one that is starved. ``model_version_id`` is required, and pinned rather than defaulted to the newest fit, for the reason :func:`list_elasticity_estimates` gives in full: a refusal register read against a different generation than the coefficients beside it describes a fit nobody ran. Scope-rewritten on ``country_key`` in the repository, so this names the markets the caller may already read and is not an enumeration oracle over the ones they may not (G3.3). */
export type ListElasticityRefusalsParams = {
  readonly query?: {
    readonly model_version_id?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/elasticity/refusals` */
export const listElasticityRefusals: OperationSpec<ListElasticityRefusalsParams, CursorPageElasticityRefusal> = {
  operationId: "list_elasticity_refusals_api_v1_inseason_elasticity_refusals_get",
  method: "GET",
  path: "/api/v1/inseason/elasticity/refusals",
  tag: "inseason",
  pathParams: [],
  queryParams: ["model_version_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/foundations/exception-rules` — List Exception Rules — Every exception rule, its activation, severity, SLA and perimeter (ADR 9101). Not paginated: the rule catalogue is a governed register of a handful of rows, not an estate read. Empty when nothing is wired. */
export type ListExceptionRulesParams = Record<string, never>;

/** `GET /api/v1/foundations/exception-rules` */
export const listExceptionRules: OperationSpec<ListExceptionRulesParams, readonly (ExceptionRuleSummary)[]> = {
  operationId: "list_exception_rules_api_v1_foundations_exception_rules_get",
  method: "GET",
  path: "/api/v1/foundations/exception-rules",
  tag: "foundations",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/simulations` — List Exit Simulations — The simulations the caller may see, newest first; one market when ``country_key``. */
export type ListExitSimulationsParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/consolidation/simulations` */
export const listExitSimulations: OperationSpec<ListExitSimulationsParams, CursorPageExitSimulationView> = {
  operationId: "list_exit_simulations_api_v1_exit_consolidation_simulations_get",
  method: "GET",
  path: "/api/v1/exit/consolidation/simulations",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/programme/feeds` — List Feed Certification — The reqs/08 §6 five-stage board, one row per feed. Filterable by stage and by certification, because the two questions a planner and a programme manager ask are different: "what is not certified" and "what is stuck in Certify". */
export type ListFeedCertificationParams = {
  readonly query?: {
    readonly stage?: string | null;
    readonly certified?: boolean | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/programme/feeds` */
export const listFeedCertification: OperationSpec<ListFeedCertificationParams, CursorPageFeedCertificationState> = {
  operationId: "list_feed_certification_api_v1_programme_feeds_get",
  method: "GET",
  path: "/api/v1/programme/feeds",
  tag: "programme",
  pathParams: [],
  queryParams: ["stage", "certified", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/foundations/feeds` — List Feeds — Feed freshness, certification and last control-total variance (reqs/00 D10). W1-1 (ADR 1003): one row per landing feed and country — the batch in force, its age against the threshold the feed's contract declares, the contract as ``bata-data`` reported it, and W0-3b's count of unsuperseded batches in the in-force partition. Authorised as ``read`` on ``plan_version`` and rewritten on each batch's country; ``country_key`` narrows to one and adds a ``no_batch`` row for every declared feed that country never landed. */
export type ListFeedsParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/foundations/feeds` */
export const listFeeds: OperationSpec<ListFeedsParams, CursorPageFeedStatus> = {
  operationId: "list_feeds_api_v1_foundations_feeds_get",
  method: "GET",
  path: "/api/v1/foundations/feeds",
  tag: "foundations",
  pathParams: [],
  queryParams: ["country_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/programme/gates` — List Gates — The D0-D5 decision points, their evidence and their failure actions. Decision classes are data too. reqs/08 §8 names six today; the register is a table, never an enumeration in code (G5's banned "enumerated roles or channels in code"). */
export type ListGatesParams = {
  readonly query?: {
    readonly wave_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/programme/gates` */
export const listGates: OperationSpec<ListGatesParams, CursorPageGateState> = {
  operationId: "list_gates_api_v1_programme_gates_get",
  method: "GET",
  path: "/api/v1/programme/gates",
  tag: "programme",
  pathParams: [],
  queryParams: ["wave_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/handover-readiness` — Floor-set handover readiness — Projected residual against the space threshold per cluster, with the weeks of alert lead the floor-set go/no-go depends on (reqs/05 §8.8). `as_of_week` used to be supplied once, at boot, from the process's own clock, so a host up for a week answered for the week it started; it is now the caller's and the week is on every row. */
export type ListHandoverReadinessParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly option_id?: string | null;
    readonly cluster_id?: string | null;
    readonly as_of_week?: string | null;
    readonly state?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/handover-readiness` */
export const listHandoverReadiness: OperationSpec<ListHandoverReadinessParams, CursorPageHandoverReadinessSummary> = {
  operationId: "list_handover_readiness_api_v1_exit_handover_readiness_get",
  method: "GET",
  path: "/api/v1/exit/handover-readiness",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "option_id", "cluster_id", "as_of_week", "state", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/foundations/hierarchies` — List Hierarchies — List coexisting hierarchy scheme versions, optionally for one dimension. */
export type ListHierarchiesParams = {
  readonly query?: {
    readonly dimension?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/foundations/hierarchies` */
export const listHierarchies: OperationSpec<ListHierarchiesParams, CursorPageSchemeSummary> = {
  operationId: "list_hierarchies_api_v1_foundations_hierarchies_get",
  method: "GET",
  path: "/api/v1/foundations/hierarchies",
  tag: "foundations",
  pathParams: [],
  queryParams: ["dimension", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/foundations/scope-vocabulary/hierarchy-nodes` — List Hierarchy Node Grant Values — The values the ``bata_hierarchy_node`` scope attribute may be set to (ADR 1006). What an administrator's user-management picker offers, so that a scope grant is a choice from a published vocabulary and never free text (`bata-reqs` ADR 1001 point 8). Countries first, then nodes, each ordered by ``value``. * ``ALL-<countryKey>`` (``kind: country``) — **every hierarchy node in that country**, in every scheme (owner ruling 2026-09-30). One per country with a promoted landing batch; there is no governed country master, so that is the list of countries the platform holds data for. * a node id (``kind: node``) — every node of every landed scheme version, active or not (landing is not adoption, and no production scheme is active). **A node grant narrows nothing today**: no read filters by node, so the holder sees what their geography and channel grants allow, and ``narrowsReads`` is ``false``. Authorised as ``read`` on ``role_permission`` — held unbounded by ``administrator`` and ``auditor`` — not as a plan read: the administrator who sets scope attributes holds no planning role, and a vocabulary of grant values is access configuration rather than plan data. */
export type ListHierarchyNodeGrantValuesParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/foundations/scope-vocabulary/hierarchy-nodes` */
export const listHierarchyNodeGrantValues: OperationSpec<ListHierarchyNodeGrantValuesParams, CursorPageHierarchyNodeGrantValue> = {
  operationId: "list_hierarchy_node_grant_values_api_v1_foundations_scope_vocabulary_hierarchy_nodes_get",
  method: "GET",
  path: "/api/v1/foundations/scope-vocabulary/hierarchy-nodes",
  tag: "foundations",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/foundations/hierarchies/{scheme_id}/{version_id}/nodes` — List Hierarchy Nodes — List the nodes of one scheme version. */
export type ListHierarchyNodesParams = {
  readonly path: {
    readonly scheme_id: string;
    readonly version_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/foundations/hierarchies/{scheme_id}/{version_id}/nodes` */
export const listHierarchyNodes: OperationSpec<ListHierarchyNodesParams, CursorPageNodeSummary> = {
  operationId: "list_hierarchy_nodes_api_v1_foundations_hierarchies__scheme_id___version_id__nodes_get",
  method: "GET",
  path: "/api/v1/foundations/hierarchies/{scheme_id}/{version_id}/nodes",
  tag: "foundations",
  pathParams: ["scheme_id", "version_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/indifference` — The stored markdown-versus-consolidation comparison — reqs/05 §3.7, read from the `exit.indifference` job's output rather than solved in the request. `docs/05` §6.8 puts the comparison outside G2 §2.1's ten-second scenario budget — it is two optimiser solves per lot — so the estate-scale answer is a job output and every row here says `computation: "stored"` and carries the day it is about. Lots with no curve are returned, not filtered: a lane with no reqs/05 §5 D8 cost on record and a solve that refused are different findings with different remedies, and a read returning only the priced lots would make an uncosted estate look like an estate with nothing to consolidate. */
export type ListIndifferenceParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly as_of?: string | null;
    readonly option_key?: string | null;
    readonly cluster_key?: string | null;
    readonly lot_key?: string | null;
    readonly execution_gate?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/indifference` */
export const listIndifference: OperationSpec<ListIndifferenceParams, CursorPageStoredIndifference> = {
  operationId: "list_indifference_api_v1_exit_indifference_get",
  method: "GET",
  path: "/api/v1/exit/indifference",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "as_of", "option_key", "cluster_key", "lot_key", "execution_gate", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/markdown/ladders` — List Ladders In Force — Which country × brand pairs have a ratified ladder on ``as_of``. **A picker cannot offer what it cannot enumerate.** ``GET /markdown/path`` and ``GET /markdown/frontier`` both take ``country_key`` and ``brand_key`` as required parameters, and both refuse with ``platform.inseason.ladder_not_in_force`` for a pair that has none — so without this read the only way to find a workable pair was to guess one and read the refusal, which is a screen operated by trial. ``as_of`` is required rather than defaulted to today, on the same terms as every other dated read in this chapter: a ladder directory answered for "now" and a path solved "as at" some other date would disagree about which ladder is in force, and the disagreement would surface as a refusal on a pair the picker had just offered. Scope-rewritten on ``country_key`` in the repository, so this lists the markets the caller may already read and is not an enumeration oracle over the ones they may not (G3.3). */
export type ListLaddersInForceParams = {
  readonly query?: {
    readonly as_of?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/markdown/ladders` */
export const listLaddersInForce: OperationSpec<ListLaddersInForceParams, CursorPageLadderInForce> = {
  operationId: "list_ladders_in_force_api_v1_inseason_markdown_ladders_get",
  method: "GET",
  path: "/api/v1/inseason/markdown/ladders",
  tag: "inseason",
  pathParams: [],
  queryParams: ["as_of", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/d2-evidence/latest` — List Latest D2 Evidence — Each market's newest gate-D2 assessment, in the caller's scope (ADR 6030). The directory :func:`list_d2_evidence` lacked: that read needs an ``as_of`` and nothing published one, so a client had to guess a date. This answers the newest ``assessed_on`` per market, one row per market, ordered by market; each row carries its own ``assessed_on``, which a caller can pass back to the dated read to reproduce it. Uncalibrated and held markets are returned, not filtered, for the dated read's reason. */
export type ListLatestD2EvidenceParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/d2-evidence/latest` */
export const listLatestD2Evidence: OperationSpec<ListLatestD2EvidenceParams, CursorPageGateD2EvidenceRow> = {
  operationId: "list_latest_d2_evidence_api_v1_inseason_d2_evidence_latest_get",
  method: "GET",
  path: "/api/v1/inseason/d2-evidence/latest",
  tag: "inseason",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/registry/run-scopes` — List Library — The market's library («Perimetri»): each entry's newest version, by kind then id. Scopes, store selections and product selections, the platform's own entries included («Intero paese», «Tutti i prodotti», the default Scope: ``isSystem``, ``label`` in the caller's language). ``kind`` narrows to one kind; a retired entry is left out unless ``include_retired``. A market whose library nothing has written yet lists none: its system entries are written by its first proposal or run (ADR 9033). */
export type ListLibraryParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly kind?: "scope" | "store_selection" | "product_selection" | null;
    readonly include_retired?: boolean;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/registry/run-scopes` */
export const listLibrary: OperationSpec<ListLibraryParams, CursorPageEntryView> = {
  operationId: "list_library_api_v1_registry_run_scopes_get",
  method: "GET",
  path: "/api/v1/registry/run-scopes",
  tag: "registry",
  pathParams: [],
  queryParams: ["country_key", "kind", "include_retired", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/lifecycle-phases` — Each article's lifecycle phase in force for a month, with its source — bata-reqs issue 35 P5 (ADR 7031). One row per article, cursor-paged by article: the phase in force (the latest planner decision effective by `month`, else bata-data's inferred phase; `phaseSource` says which), the entry month of its current spell, the inference beside a decision (`inferredPhase`, `overridesInference`), `excludedFromHeadlinePromotions` (every phase but MAIN), the decision with its `actionId`, and the next `planned` move. `country_key` and `month` (the 1st) are required and never defaulted. `article_key` (repeatable, at most 500) names articles, for example a promotion's; an article with no phase is absent from the page, never MAIN. 404 `lifecycle_phases.register_not_found` when no inferred batch is in force for the market. */
export type ListLifecyclePhasesParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly month?: string;
    readonly article_key?: readonly (string)[] | null;
    readonly phase?: "MAIN" | "ZONA_SALES" | "OUTLET" | null;
    readonly phase_source?: "decision" | "inferred" | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/lifecycle-phases` */
export const listLifecyclePhases: OperationSpec<ListLifecyclePhasesParams, CursorPageLifecyclePhaseModel> = {
  operationId: "list_lifecycle_phases_api_v1_exit_lifecycle_phases_get",
  method: "GET",
  path: "/api/v1/exit/lifecycle-phases",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "month", "article_key", "phase", "phase_source", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/preseason/localisation` — List Localisation — The attribute localisation index, with confidence intervals (reqs/02 §8). */
export type ListLocalisationParams = {
  readonly query?: {
    readonly cluster_id?: string | null;
    readonly significant_only?: boolean;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/localisation` */
export const listLocalisation: OperationSpec<ListLocalisationParams, CursorPageLocalisationCell> = {
  operationId: "list_localisation_api_v1_preseason_localisation_get",
  method: "GET",
  path: "/api/v1/preseason/localisation",
  tag: "preseason",
  pathParams: [],
  queryParams: ["cluster_id", "significant_only", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/lost-sales-potential` — Lost-sales potential per door and class, from the effective runs — Potential demand the stock-out recovery does not count (ADR 8003, 8004), per door and per class: assortment (an article the door never offered) and late ranging (the weeks before the door first offered it). One row per effective run, class and door; the classes are separate findings and are never summed. */
export type ListLostSalesPotentialParams = {
  readonly query?: {
    readonly season?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/lost-sales-potential` */
export const listLostSalesPotential: OperationSpec<ListLostSalesPotentialParams, CursorPageLostSalesPotentialRow> = {
  operationId: "list_lost_sales_potential_api_v1_postseason_lost_sales_potential_get",
  method: "GET",
  path: "/api/v1/postseason/lost-sales-potential",
  tag: "postseason",
  pathParams: [],
  queryParams: ["season", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/conformance/material-decisions` — List Material Decisions — The material-decision list the commit guard reads (reqs/07 §3.6). **Sorted here, because this register has no statement to sort it.** It is a code seed held in memory, and it was served in seed order — the lifecycle order the requirement narrates the seven types in — while its cursor keyed on ``decision_type``. A cursor means "every row whose key is greater than this one", so over rows the key does not order, the second page skipped ``chase_cancel``, ``markdown``, ``carry_over`` and ``exit_channel`` outright: all four sort before ``receipt_phasing``, which page one ended on. Nothing noticed because the default page is 100 and the register holds seven. The contract suite found it by asking for ``limit=5``. Lifecycle order is not a promise this endpoint made — the commit guard reads :func:`material_decision_register` directly and never this route — so the order that makes the cursor correct is the one to serve. */
export type ListMaterialDecisionsParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/conformance/material-decisions` */
export const listMaterialDecisions: OperationSpec<ListMaterialDecisionsParams, CursorPageMaterialDecisionSummary> = {
  operationId: "list_material_decisions_api_v1_conformance_material_decisions_get",
  method: "GET",
  path: "/api/v1/conformance/material-decisions",
  tag: "conformance",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/programme/measurements` — List Measurements — Every reqs/08 §5 measurement, including the ones with insufficient evidence. The insufficient ones are returned rather than filtered out, and a client is expected to render them. A measure omitted from a scorecard reads as "not applicable"; a measure shown as insufficient reads as "not yet measurable", and only the second is true. */
export type ListMeasurementsParams = {
  readonly query?: {
    readonly evidence_state?: string | null;
    readonly parameter_set_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/programme/measurements` */
export const listMeasurements: OperationSpec<ListMeasurementsParams, CursorPageBenefitMeasurement> = {
  operationId: "list_measurements_api_v1_programme_measurements_get",
  method: "GET",
  path: "/api/v1/programme/measurements",
  tag: "programme",
  pathParams: [],
  queryParams: ["evidence_state", "parameter_set_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/foundations/measures` — List Measures — The declared measure graph — inputs and minimum grain (reqs/00 D6, reqs/07 §3.3). */
export type ListMeasuresParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/foundations/measures` */
export const listMeasures: OperationSpec<ListMeasuresParams, CursorPageMeasureSummary> = {
  operationId: "list_measures_api_v1_foundations_measures_get",
  method: "GET",
  path: "/api/v1/foundations/measures",
  tag: "foundations",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/preseason/meio-policies` — List Meio Policies — The size-level safety-stock policy, against its independent-node baseline. */
export type ListMeioPoliciesParams = {
  readonly query?: {
    readonly node_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/meio-policies` */
export const listMeioPolicies: OperationSpec<ListMeioPoliciesParams, CursorPageMeioPolicySummary> = {
  operationId: "list_meio_policies_api_v1_preseason_meio_policies_get",
  method: "GET",
  path: "/api/v1/preseason/meio-policies",
  tag: "preseason",
  pathParams: [],
  queryParams: ["node_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/programme/reports/monthly/months` — List Monthly Report Months — The months this market has a frozen monthly pack for, newest first (ADR 9031). One row per frozen pack, from the table ``GET /programme/reports/monthly`` serves, so a screen that offers a month picker asks once instead of asking for each month and reading a 404 ``programme.report_not_frozen`` back for the ones with no pack. A market outside the caller's scope lists nothing, as its pack reads as absent there (G3.3). Nothing is computed. */
export type ListMonthlyReportMonthsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly limit?: number;
  };
};

/** `GET /api/v1/programme/reports/monthly/months` */
export const listMonthlyReportMonths: OperationSpec<ListMonthlyReportMonthsParams, readonly (MonthlyReportMonth)[]> = {
  operationId: "list_monthly_report_months_api_v1_programme_reports_monthly_months_get",
  method: "GET",
  path: "/api/v1/programme/reports/monthly/months",
  tag: "programme",
  pathParams: [],
  queryParams: ["country_key", "limit"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/move-cap-deferrals` — List Move Cap Deferrals — The moves the weekly move cap deferred for one run's tick, one page at a time. Stored by ``inseason.distribute`` and ``inseason.rebalance`` in the transaction that wrote their other outputs (ADR 6100); the rebalance half is the execution of the run's market and tick (the summary's ``resolved_by``). A deferral is a move the estate had no week to handle, held rather than re-offered: it is why a store received less than the engine proposed. 404 when the run does not exist or is outside the caller's scope. 409 (``move_cap_deferrals_not_recorded``) when none of the requested stages recorded for the run — a run older than the record. An empty page therefore always means the recorded stages deferred nothing that matches; which stages were recorded is ``GET …/move-cap-deferrals/summary``. */
export type ListMoveCapDeferralsParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly store_key?: string | null;
    readonly article_key?: string | null;
    readonly stage?: MoveCapStage | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/move-cap-deferrals` */
export const listMoveCapDeferrals: OperationSpec<ListMoveCapDeferralsParams, CursorPageMoveCapDeferral> = {
  operationId: "list_move_cap_deferrals_api_v1_inseason_runs__run_id__move_cap_deferrals_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/move-cap-deferrals",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["store_key", "article_key", "stage", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/compacting/runs/{run_id}/ledger` — List Move Ledger — The run's store-week budget, one store per row, from the run's own lines. What each store sends and holds, and the moves it keeps and defers at its door. A store's cap is stated where a held line recorded it as the cap that bound there. 404 ``move_run_not_found`` for a run the caller cannot see. */
export type ListMoveLedgerParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly store_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/compacting/runs/{run_id}/ledger` */
export const listMoveLedger: OperationSpec<ListMoveLedgerParams, MoveLedgerPage> = {
  operationId: "list_move_ledger_api_v1_compacting_runs__run_id__ledger_get",
  method: "GET",
  path: "/api/v1/compacting/runs/{run_id}/ledger",
  tag: "compacting",
  pathParams: ["run_id"],
  queryParams: ["store_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/compacting/simulations` — List Move Run Simulations — The market's simulations of the one run, newest first, with who asked and their state. */
export type ListMoveRunSimulationsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/compacting/simulations` */
export const listMoveRunSimulations: OperationSpec<ListMoveRunSimulationsParams, CursorPageMoveRunSimulationView> = {
  operationId: "list_move_run_simulations_api_v1_compacting_simulations_get",
  method: "GET",
  path: "/api/v1/compacting/simulations",
  tag: "compacting",
  pathParams: [],
  queryParams: ["country_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/compacting/runs` — List Move Runs — The one move run's runs, newest first (bata-reqs ADR 9002 stage 3, ADR 9050). Completed and refused runs alike; ``superseded`` says whether a later completed run of the same market and ship-week replaced the run's lines. Live runs only unless ``simulation`` is ``true``, which lists simulations' runs only (each names its ``simulation_id``). 404 ``move_runs_unavailable`` when no source is installed. */
export type ListMoveRunsParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly simulation?: boolean;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/compacting/runs` */
export const listMoveRuns: OperationSpec<ListMoveRunsParams, CursorPageMoveRunSummary> = {
  operationId: "list_move_runs_api_v1_compacting_runs_get",
  method: "GET",
  path: "/api/v1/compacting/runs",
  tag: "compacting",
  pathParams: [],
  queryParams: ["country_key", "simulation", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/compacting/runs/{run_id}/moves` — List Moves — The run's one merged list (stage 3 ruling 2), one page at a time. Every move of the run in the run's order — forced lines first, then decision 1's value — with the article's state on each row; a held line keeps its place. Then the candidates the run refused by name. ``matching`` is how many rows the filters match over the whole run, the same on every page. 404 ``move_run_not_found`` for a run the caller cannot see. */
export type ListMovesParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly state?: readonly (MoveState)[] | null;
    readonly stock_owner?: MoveStockOwner | null;
    readonly purpose?: string | null;
    readonly origin?: string | null;
    readonly destination?: string | null;
    readonly article?: string | null;
    readonly disposition?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/compacting/runs/{run_id}/moves` */
export const listMoves: OperationSpec<ListMovesParams, MoveListPage> = {
  operationId: "list_moves_api_v1_compacting_runs__run_id__moves_get",
  method: "GET",
  path: "/api/v1/compacting/runs/{run_id}/moves",
  tag: "compacting",
  pathParams: ["run_id"],
  queryParams: ["state", "stock_owner", "purpose", "origin", "destination", "article", "disposition", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/me/feedback` — List My Reports — The caller's own reports, newest first, with their status and the team's note. */
export type ListMyReportsParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/me/feedback` */
export const listMyReports: OperationSpec<ListMyReportsParams, CursorPageFeedbackReport> = {
  operationId: "list_my_reports_api_v1_me_feedback_get",
  method: "GET",
  path: "/api/v1/me/feedback",
  tag: "feedback",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/open-to-buy` — List Open Positions — The in-season open position, recomputed on chapter 02's OTB object. **This read refuses, and it refuses because nothing computes what it serves.** `04` §4.3's open-to-buy object is posed against chapter 02's ``OpenToBuy`` protocol and reconciled against ``Actuals`` — but neither type is constructed anywhere in this estate. ``services/api/wiring.py``'s ``"inseason.open_to_buy"`` commentary is explicit: ``packages/planning/replenishment/replan.py`` declares both as the contract chapter 04 was written against, ``packages/planning/otb/`` (``reconcile.py``, ``measures.py``) never implements either — ``ReconciledPlan`` answers a different question — and ``Actuals.received``/``on_order_committed`` appear nowhere else in the estate except as this route's own response schema, which is what a route would *serve*, not what a job reads. There is, today, no installer for this field to be missing an installer of. Until this batch the route answered ``{"items": []}`` on every boot, in every environment, and a caller had no way to tell "genuinely no open position" — itself a real, actionable fact — from "this capability does not exist". That is the same reqs/07 §3.1 failure :func:`list_projections` answers, arriving as a default rather than as an outage. **The remedy is a real ``OpenToBuy``/``Actuals`` producer, not a change here.** This batch fixes the refusal — ``None`` rather than ``()`` on the reader field, matching :func:`list_projections` and :func:`list_write_back` — and stops there: the underlying model does not exist yet, so there is nothing this route could wire a source to even if it tried, and building one is a deeper, separate piece of work than either of those two fields needed. 404 for the reason :data:`PROBLEM_PROJECTIONS_UNAVAILABLE` gives: a GET has no idempotency middleware in front of it to absorb a 5xx, and Schemathesis's server-error check is not excluded (ADR 0010). */
export type ListOpenPositionsParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/open-to-buy` */
export const listOpenPositions: OperationSpec<ListOpenPositionsParams, CursorPageOpenPositionSummary> = {
  operationId: "list_open_positions_api_v1_inseason_open_to_buy_get",
  method: "GET",
  path: "/api/v1/inseason/open-to-buy",
  tag: "inseason",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/preseason/option-economics` — List Option Economics — Per-unit economics per option x cluster, including the margin. The two derived amounts are read off the pure type's own methods rather than subtracted here. A margin recomputed at the edge would be a second definition of the numerator of the critical ratio, and the first time it disagreed with :func:`planning.npi.newsvendor.buy_depth` the disagreement would appear as a depth a merchant could not reconcile to the margin shown beside it. */
export type ListOptionEconomicsParams = {
  readonly query?: {
    readonly option_id?: string | null;
    readonly cluster_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/option-economics` */
export const listOptionEconomics: OperationSpec<ListOptionEconomicsParams, CursorPageOptionEconomicsSummary> = {
  operationId: "list_option_economics_api_v1_preseason_option_economics_get",
  method: "GET",
  path: "/api/v1/preseason/option-economics",
  tag: "preseason",
  pathParams: [],
  queryParams: ["option_id", "cluster_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/outlet-exits` — List Outlet Exits — One month's ZONA_SALES → OUTLET recommendations for one market, ranked (ADR 7028). 404 ``lifecycle_outlet.run_not_found`` when no run recommends moves for the market and month — never an empty list, which would read as "nothing to move". */
export type ListOutletExitsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly effective_month?: string;
    readonly run_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/outlet-exits` */
export const listOutletExits: OperationSpec<ListOutletExitsParams, CursorPageOutletRecommendationModel> = {
  operationId: "list_outlet_exits_api_v1_exit_outlet_exits_get",
  method: "GET",
  path: "/api/v1/exit/outlet-exits",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "effective_month", "run_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/outlet-exits/runs` — List Outlet Runs — The market's outlet exit runs, oldest first, each with its evidence and refusal. */
export type ListOutletRunsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly effective_month?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/outlet-exits/runs` */
export const listOutletRuns: OperationSpec<ListOutletRunsParams, CursorPageOutletRunModel> = {
  operationId: "list_outlet_runs_api_v1_exit_outlet_exits_runs_get",
  method: "GET",
  path: "/api/v1/exit/outlet-exits/runs",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "effective_month", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/outlet-exits/transfers/runs` — List Outlet Transfer Runs — The market's outlet transfer runs, oldest first, each with its evidence and refusal. */
export type ListOutletTransferRunsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly effective_month?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/outlet-exits/transfers/runs` */
export const listOutletTransferRuns: OperationSpec<ListOutletTransferRunsParams, CursorPageOutletTransferRunModel> = {
  operationId: "list_outlet_transfer_runs_api_v1_exit_outlet_exits_transfers_runs_get",
  method: "GET",
  path: "/api/v1/exit/outlet-exits/transfers/runs",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "effective_month", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/outlet-exits/transfers` — List Outlet Transfers — One month's outlet transfer for one market, by article (ADR 7028). 404 ``lifecycle_outlet_transfer.run_not_found`` when no run executed the month. */
export type ListOutletTransfersParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly effective_month?: string;
    readonly run_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/outlet-exits/transfers` */
export const listOutletTransfers: OperationSpec<ListOutletTransfersParams, CursorPageOutletTransferItemModel> = {
  operationId: "list_outlet_transfers_api_v1_exit_outlet_exits_transfers_get",
  method: "GET",
  path: "/api/v1/exit/outlet-exits/transfers",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "effective_month", "run_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/programme/override-outcomes/pairs` — List Override Pairs — The decided lines of the window, each beside its projection; a page at a time. Empty when the window is not set, as ``GET /programme/override-outcomes`` says. ``overridden`` and ``projection_archived`` narrow the list to the lines a class card counts (ADR 6194): with ``decision_class`` named, ``overridden=true`` lists exactly the class's ``overridden`` lines and ``projection_archived=true`` its ``projectionArchived`` ones; they combine. Deferred lines are not decided and are in no list. */
export type ListOverridePairsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly as_of?: string;
    readonly decision_class?: string | null;
    readonly overridden?: boolean | null;
    readonly projection_archived?: boolean | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/programme/override-outcomes/pairs` */
export const listOverridePairs: OperationSpec<ListOverridePairsParams, CursorPageOverridePairRow> = {
  operationId: "list_override_pairs_api_v1_programme_override_outcomes_pairs_get",
  method: "GET",
  path: "/api/v1/programme/override-outcomes/pairs",
  tag: "programme",
  pathParams: [],
  queryParams: ["country_key", "as_of", "decision_class", "overridden", "projection_archived", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/cadence-proposals/override-rate` — Dispositions per reason code — ``docs/05`` §12's adoption measure: how often planners take the cadence's recommendation and how often they override it, split by the reason code the engine gave. reqs/07 §3.5's autonomy register reads this number, so it is defined once, in the statement, rather than per screen. */
export type ListOverrideRateParams = {
  readonly query?: {
    readonly as_of_date?: string;
    readonly country_key?: string | null;
    readonly reason_code?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/cadence-proposals/override-rate` */
export const listOverrideRate: OperationSpec<ListOverrideRateParams, CursorPageOverrideRate> = {
  operationId: "list_override_rate_api_v1_exit_cadence_proposals_override_rate_get",
  method: "GET",
  path: "/api/v1/exit/cadence-proposals/override-rate",
  tag: "exit",
  pathParams: [],
  queryParams: ["as_of_date", "country_key", "reason_code", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/registry/parameter-keys` — List Parameter Keys — Every key the code reads (ADR 9007) — value type, default, honoured scopes, owner. A key with no row in force on ``as_of`` is listed with ``status: unset`` rather than left out: the catalogue is what the code reads, and the register of rows is only what somebody authored. */
export type ListParameterKeysParams = {
  readonly query?: {
    readonly as_of?: string;
    readonly owner_chapter?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/registry/parameter-keys` */
export const listParameterKeys: OperationSpec<ListParameterKeysParams, CursorPageParameterKeyEntry> = {
  operationId: "list_parameter_keys_api_v1_registry_parameter_keys_get",
  method: "GET",
  path: "/api/v1/registry/parameter-keys",
  tag: "registry",
  pathParams: [],
  queryParams: ["as_of", "owner_chapter", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/preseason/period-plans` — List Period Plans — The stored period plan terms ``POST /preseason/otb`` turns into a ledger. The pair is the whole read: these terms go back to ``POST /preseason/otb`` unchanged and the ``openToBuyUnits`` of the returned position is the period's budget. One arithmetic, computed in one place (G11), reachable now by a client that did not author the plan. */
export type ListPeriodPlansParams = {
  readonly query?: {
    readonly node_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/period-plans` */
export const listPeriodPlans: OperationSpec<ListPeriodPlansParams, CursorPagePeriodPlanTerms> = {
  operationId: "list_period_plans_api_v1_preseason_period_plans_get",
  method: "GET",
  path: "/api/v1/preseason/period-plans",
  tag: "preseason",
  pathParams: [],
  queryParams: ["node_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/foundations/plans/{plan_id}/versions` — List Plan Versions — List a plan's immutable versions, oldest first (reqs/00 §8.3). */
export type ListPlanVersionsParams = {
  readonly path: {
    readonly plan_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/foundations/plans/{plan_id}/versions` */
export const listPlanVersions: OperationSpec<ListPlanVersionsParams, CursorPagePlanVersionSummary> = {
  operationId: "list_plan_versions_api_v1_foundations_plans__plan_id__versions_get",
  method: "GET",
  path: "/api/v1/foundations/plans/{plan_id}/versions",
  tag: "foundations",
  pathParams: ["plan_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/plans` — Exit plan records — The per-option exit plan reqs/05 §8.3 requires for every active option: target residual, handover date, price floor, designated route and protect flag, with the merchant and Finance sign-off states shown separately. Every filter is optional and none defaults — an omitted one adds no predicate rather than choosing a perimeter on the caller's behalf. `protected_from_markdown=true` lists the options the cadence queue excludes by rule (reqs/05 §8.7), each with its newest carry-over decision (`carry_over_*` fields; all null when none is recorded). */
export type ListPlansParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly season_code?: string | null;
    readonly option_id?: string | null;
    readonly lifecycle_class?: string | null;
    readonly protected_from_markdown?: boolean | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/plans` */
export const listPlans: OperationSpec<ListPlansParams, CursorPageExitPlanSummary> = {
  operationId: "list_plans_api_v1_exit_plans_get",
  method: "GET",
  path: "/api/v1/exit/plans",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "season_code", "option_id", "lifecycle_class", "protected_from_markdown", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/position` — The trended compaction score and compaction index — reqs/05 §3.8, read from the `exit.position` job's output. `docs/05` §6.9: "its value is the trend, not the level, and a single computed point cannot show one" — which is why this is a GET over a series and not a POST over one instant. `group_key` empty selects the headline score over the whole option x country position; a named cluster selects one of the compaction index's roll-ups, computed by the identical formula over that cluster's own doors. */
export type ListPositionParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly option_key?: string | null;
    readonly group_key?: string | null;
    readonly as_of?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/position` */
export const listPosition: OperationSpec<ListPositionParams, CursorPageStoredPosition> = {
  operationId: "list_position_api_v1_exit_position_get",
  method: "GET",
  path: "/api/v1/exit/position",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "option_key", "group_key", "as_of", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/price-actions` — List Price Actions — Recommended price steps for one cycle. Filtered like the proposals (bata-ui#148 step 3.2), except that a price step is set per cluster and carries no store and no reason of its own: ``cluster_key`` is its location filter and ``reason_code`` matches its recorded decision. ``article_key`` is the option's key, so ``article_key`` with ``cluster_key`` is one option's stored path. ``price_stream`` narrows to one stream's steps (ADR 6193). */
export type ListPriceActionsParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly cluster_key?: string | null;
    readonly article_key?: string | null;
    readonly department_family?: string | null;
    readonly reason_code?: string | null;
    readonly disposition?: string | null;
    readonly price_stream?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/price-actions` */
export const listPriceActions: OperationSpec<ListPriceActionsParams, CursorPagePriceActionSummary> = {
  operationId: "list_price_actions_api_v1_inseason_price_actions_get",
  method: "GET",
  path: "/api/v1/inseason/price-actions",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id", "cluster_key", "article_key", "department_family", "reason_code", "disposition", "price_stream", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/registry/price-ladders` — List Price Ladders — Every stored ladder version — in force on ``as_of`` and past — with its rungs (ADR 6189). The ladders in force and their history, per market and purpose: each version's window as it stands now, its rungs in ladder order (shares off the original price, exact decimal text), whether a bata-data file landed it or a change set authored it, and for the latter who proposed and approved it and why. Pending versions are change sets, read from ``GET /changes?parameter_key=markdown.ladder.<purpose>.<country>.<brand>&state=proposed``. ``as_of`` is required for the reason ``GET /parameters`` gives. Scope-rewritten on the country, as the in-season ladder reads are. Each version carries ``expiry`` (bata-reqs issue 38 second set R3.4): measured on the market's own date now, not on ``as_of``, a ladder in force that ends within ``markdown.ladder_expiry_warning_days`` with no approved successor is ``endsSoon``. The «Scale di sconto» panel and the Cockpit both read it here, so they cannot disagree. */
export type ListPriceLaddersParams = {
  readonly query?: {
    readonly as_of?: string;
    readonly country_key?: string | null;
    readonly purpose?: "markdown" | "zona_sales" | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/registry/price-ladders` */
export const listPriceLadders: OperationSpec<ListPriceLaddersParams, CursorPageLadderVersionView> = {
  operationId: "list_price_ladders_api_v1_registry_price_ladders_get",
  method: "GET",
  path: "/api/v1/registry/price-ladders",
  tag: "registry",
  pathParams: [],
  queryParams: ["as_of", "country_key", "purpose", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/projections` — List Projections — Early-signal re-projections and the winner/loser reclassification. **This read refuses, and it refuses because nothing writes what it serves.** `04` §4.1's re-projection is computed — ``planning.forecast.lifecycle.project`` is written and property-tested, and ``inseason.reforecast`` calls it — but the result goes into the run's byte-stable report and into no table. There is no ``inseason_projection`` table, no statement over one and no writer, in this repository or in ``bata-data``. Until this batch the route answered ``{"items": []}`` on every boot, in every environment, and a caller had no way to distinguish "we re-projected and nothing was reclassified" — which is a finding a merchant would act on — from "this capability does not exist". That is the failure reqs/07 §3.1 is about, arriving as a default rather than as an outage. The remedy is a persisted projection, not a change here: when a table and a writer exist, boot installs a source and this route answers rows. The refusal disappears by the field being installed, which is why the reader field is ``None`` rather than ``()`` — a test or an installer that supplies an empty sequence gets an empty page, exactly as it should. 404 rather than the 503 this was written as: see :data:`PROBLEM_PROJECTIONS_UNAVAILABLE` for the contract gate's argument, and for why the path is kept rather than deleted. */
export type ListProjectionsParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/projections` */
export const listProjections: OperationSpec<ListProjectionsParams, CursorPageLifecycleProjection> = {
  operationId: "list_projections_api_v1_inseason_projections_get",
  method: "GET",
  path: "/api/v1/inseason/projections",
  tag: "inseason",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/promotions` — Champion-challenger decisions, promoted and refused — Every decision under the two-window rule, including the documented no-promotion outcomes, with the reason code that produced each. 404 `planning.postseason.read_not_published` while no producer persists its rows (DEC-111). */
export type ListPromotionsParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/promotions` */
export const listPromotions: OperationSpec<ListPromotionsParams, CursorPagePromotionRow> = {
  operationId: "list_promotions_api_v1_postseason_promotions_get",
  method: "GET",
  path: "/api/v1/postseason/promotions",
  tag: "postseason",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/lifecycle-transitions` — List Recommendations — One month's recommendations for one market, ranked (bata-reqs issue 35 P2a, ADR 7026). Served from the month's newest run unless ``run_id`` names one. 404 ``lifecycle_transition.run_not_found`` when no run recommends moves for the market and month — never an empty list, which would read as "nothing to move". */
export type ListRecommendationsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly effective_month?: string;
    readonly run_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/lifecycle-transitions` */
export const listRecommendations: OperationSpec<ListRecommendationsParams, CursorPageTransitionRecommendationModel> = {
  operationId: "list_recommendations_api_v1_exit_lifecycle_transitions_get",
  method: "GET",
  path: "/api/v1/exit/lifecycle-transitions",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "effective_month", "run_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/recovery/coverage` — Each door's recovery for a season, from the run in force there — One row per door: the newest recovery run not superseded that covers it, with the weeks, cells and units it recovered there. A season is recovered a few doors per run, so this — not /recovery/latest — is the season's coverage. sort=recoveredUnits lists the doors with the most recovered units first. */
export type ListRecoveryCoverageParams = {
  readonly query?: {
    readonly season?: string;
    readonly sort?: RecoveryCoverageOrder;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/recovery/coverage` */
export const listRecoveryCoverage: OperationSpec<ListRecoveryCoverageParams, CursorPageRecoveryCoverageRow> = {
  operationId: "list_recovery_coverage_api_v1_postseason_recovery_coverage_get",
  method: "GET",
  path: "/api/v1/postseason/recovery/coverage",
  tag: "postseason",
  pathParams: [],
  queryParams: ["season", "sort", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/recovery-runs` — Demand-recovery runs and their censoring hold-out error — One row per recovery execution (reqs/06 6.4), carrying the convergence evidence and the hold-out recovery error trended each season. */
export type ListRecoveryRunsParams = {
  readonly query?: {
    readonly season?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/recovery-runs` */
export const listRecoveryRuns: OperationSpec<ListRecoveryRunsParams, CursorPageRecoveryRunRow> = {
  operationId: "list_recovery_runs_api_v1_postseason_recovery_runs_get",
  method: "GET",
  path: "/api/v1/postseason/recovery-runs",
  tag: "postseason",
  pathParams: [],
  queryParams: ["season", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/recovery/scores` — Each door group's newest score of a week, and whether its stock was restated — bata-reqs ADR 8000. For the orchestrator (integration_service): one row per door group, the newest score of the week whose Monday is `week`, with the fit it used, its outcome and the availability checksum it recorded beside the checksum now; `stale` true means the week's stock was restated after the score. */
export type ListRecoveryScoresParams = {
  readonly query?: {
    readonly season?: string;
    readonly week?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/recovery/scores` */
export const listRecoveryScores: OperationSpec<ListRecoveryScoresParams, CursorPageRecoveryScoreRow> = {
  operationId: "list_recovery_scores_api_v1_postseason_recovery_scores_get",
  method: "GET",
  path: "/api/v1/postseason/recovery/scores",
  tag: "postseason",
  pathParams: [],
  queryParams: ["season", "week", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/refreshes` — Cluster and size-profile refresh proposals, drift and sign-off — The seasonal refresh (reqs/06 6.5) with membership stability tracked as a KPI. Adoption requires a recorded human sign-off and may not fall inside the planning window it changes. 404 `planning.postseason.read_not_published` while no producer persists its rows (DEC-111). */
export type ListRefreshesParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/refreshes` */
export const listRefreshes: OperationSpec<ListRefreshesParams, CursorPageRefreshRow> = {
  operationId: "list_refreshes_api_v1_postseason_refreshes_get",
  method: "GET",
  path: "/api/v1/postseason/refreshes",
  tag: "postseason",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/feedback` — List Reports — Every report, newest first, narrowed by the optional status, kind, section, way of filing and market. */
export type ListReportsParams = {
  readonly query?: {
    readonly status?: FeedbackStatus | null;
    readonly kind?: FeedbackKind | null;
    readonly section_id?: string | null;
    readonly filedVia?: FiledVia | null;
    readonly market?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/feedback` */
export const listReports: OperationSpec<ListReportsParams, CursorPageTriageReport> = {
  operationId: "list_reports_api_v1_feedback_get",
  method: "GET",
  path: "/api/v1/feedback",
  tag: "feedback",
  pathParams: [],
  queryParams: ["status", "kind", "section_id", "filedVia", "market", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/returns` — Returns dispositions — Routed returns with the full-price segregation flag on each row, so grade-B and refurbished units are excludable by a predicate rather than by a lookup (reqs/05 §8.9). `segregation` picks the side: `full_price` (default — what re-enters full-price availability, the only answer before DEC-111), `segregated` (held out of it: `counts_toward_full_price` is false on every row) or `all` (both, told apart by that flag). */
export type ListReturnsParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly option_id?: string | null;
    readonly size_key?: string | null;
    readonly route_code?: string | null;
    readonly segregation?: "full_price" | "segregated" | "all";
    readonly realisation_absent?: boolean | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/returns` */
export const listReturns: OperationSpec<ListReturnsParams, CursorPageReturnDispositionSummary> = {
  operationId: "list_returns_api_v1_exit_returns_get",
  method: "GET",
  path: "/api/v1/exit/returns",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "option_id", "size_key", "route_code", "segregation", "realisation_absent", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/routing/{routing_decision_id}/routes` — Every route one decision considered, losers included — reqs/05 §8 criterion 10 — every route considered is published, the losers included, each with its realisation decomposed into gross, handling, freight, re-ticketing and holding. A route the brand rules gated out before scoring carries `permitted: false` and no amounts, so policy and price are never read as the same refusal. A sub-collection rather than a fuller `/exit/routing/{routingDecisionId}`, and the reason is structural: `POST /exit/routing/evaluate` is a published action at that depth, and a `{routingDecisionId}` route would answer a GET to it with 404 where the contract promises 405. The decision itself is reachable from the list with `?routingDecisionId=`, which is the same bookmarkable link by another spelling. */
export type ListRouteValuationsParams = {
  readonly path: {
    readonly routing_decision_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/routing/{routing_decision_id}/routes` */
export const listRouteValuations: OperationSpec<ListRouteValuationsParams, CursorPageRouteRealisation> = {
  operationId: "list_route_valuations_api_v1_exit_routing__routing_decision_id__routes_get",
  method: "GET",
  path: "/api/v1/exit/routing/{routing_decision_id}/routes",
  tag: "exit",
  pathParams: ["routing_decision_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/routing` — Exit route recommendations — One recommendation per residual lot reaching its price floor. The winning route's realisation is on the row; the routes it beat and the routes the brand rules excluded are on `/exit/routing/{routing_decision_id}`, because joining them here would multiply each decision into one row per route and make every count over this list wrong. */
export type ListRoutingParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly option_id?: string | null;
    readonly lot_key?: string | null;
    readonly chosen_route_code?: string | null;
    readonly routing_decision_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/routing` */
export const listRouting: OperationSpec<ListRoutingParams, CursorPageRoutingSummary> = {
  operationId: "list_routing_api_v1_exit_routing_get",
  method: "GET",
  path: "/api/v1/exit/routing",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "option_id", "lot_key", "chosen_route_code", "routing_decision_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/conformance/rules` — List Rules — The six rules of the Planning Design Standard, with the tests that enforce them. ``testIds`` is composed from a second collection rather than carried on the rule row. A rule with no assertion cannot fail a build — which :func:`planning.principles.standard.incomplete_rules` reports as a defect — so an empty list here is a finding a reader must be able to see, and it is one that a join could never produce because a joined rule with no test row would not appear at all. */
export type ListRulesParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/conformance/rules` */
export const listRules: OperationSpec<ListRulesParams, CursorPageRuleSummary> = {
  operationId: "list_rules_api_v1_conformance_rules_get",
  method: "GET",
  path: "/api/v1/conformance/rules",
  tag: "conformance",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/run-configurations/{configuration_id}/versions` — List Run Configuration Versions — Every version of one configuration, newest first. */
export type ListRunConfigurationVersionsParams = {
  readonly path: {
    readonly configuration_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/run-configurations/{configuration_id}/versions` */
export const listRunConfigurationVersions: OperationSpec<ListRunConfigurationVersionsParams, CursorPageRunConfigurationVersion> = {
  operationId: "list_run_configuration_versions_api_v1_run_configurations__configuration_id__versions_get",
  method: "GET",
  path: "/api/v1/run-configurations/{configuration_id}/versions",
  tag: "run-configurations",
  pathParams: ["configuration_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/run-configurations` — List Run Configurations — Saved configurations the caller may see, newest first. ``mine`` narrows to the caller's own; without it the team's configurations in the caller's scope are listed too. Archived ones are left out unless asked for. */
export type ListRunConfigurationsParams = {
  readonly query?: {
    readonly surface?: RunSurface | null;
    readonly country_key?: string | null;
    readonly mine?: boolean;
    readonly include_archived?: boolean;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/run-configurations` */
export const listRunConfigurations: OperationSpec<ListRunConfigurationsParams, CursorPageRunConfiguration> = {
  operationId: "list_run_configurations_api_v1_run_configurations_get",
  method: "GET",
  path: "/api/v1/run-configurations",
  tag: "run-configurations",
  pathParams: [],
  queryParams: ["surface", "country_key", "mine", "include_archived", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/foundations/scenarios` — List Scenarios — List scenarios and the size of each overlay (reqs/00 D5). ``base_version_id`` is new and it is what made this read wireable: :func:`services.repositories.scenario.scenarios_on_base_statement` answers "which scenarios branch from this version", which is the compare view's question and is bounded (G16). A route that offered no way to name the base could only have been served by an unbounded scan of every scenario in the estate. */
export type ListScenariosParams = {
  readonly query?: {
    readonly plan_id?: string | null;
    readonly base_version_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/foundations/scenarios` */
export const listScenarios: OperationSpec<ListScenariosParams, CursorPageScenarioSummary> = {
  operationId: "list_scenarios_api_v1_foundations_scenarios_get",
  method: "GET",
  path: "/api/v1/foundations/scenarios",
  tag: "foundations",
  pathParams: [],
  queryParams: ["plan_id", "base_version_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/registry/scope-values` — List Scope Values — The values one scope dimension admits — what a proposal is validated against. Countries from promoted landing batches; stores, formats and channels from the location master; clusters from fitted memberships; lifecycle classes, seasons and articles from the attribute master and season intake; product nodes from the pinned product hierarchy, each with its parent and level; department families from each market's pinned class scheme, the market as ``parent`` (ADR 9055). ``currency`` answers empty: it has no reference table here and is validated by shape (ADR 9007). */
export type ListScopeValuesParams = {
  readonly query?: {
    readonly dimension?: string;
    readonly as_of?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/registry/scope-values` */
export const listScopeValues: OperationSpec<ListScopeValuesParams, CursorPageScopeValueRow> = {
  operationId: "list_scope_values_api_v1_registry_scope_values_get",
  method: "GET",
  path: "/api/v1/registry/scope-values",
  tag: "registry",
  pathParams: [],
  queryParams: ["dimension", "as_of", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/conformance/scorecard` — List Scorecard — The per-release principle-compliance scorecard (reqs/07 §1, G10). ``release_version`` is required, not defaulted. G16 bounds every query, and the scorecard table is history — one row per assertion per release — so a read with no release named would grow without limit and would answer "how are we doing" with every release at once. */
export type ListScorecardParams = {
  readonly query?: {
    readonly release_version?: string;
    readonly state?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/conformance/scorecard` */
export const listScorecard: OperationSpec<ListScorecardParams, CursorPageScorecardRow> = {
  operationId: "list_scorecard_api_v1_conformance_scorecard_get",
  method: "GET",
  path: "/api/v1/conformance/scorecard",
  tag: "conformance",
  pathParams: [],
  queryParams: ["release_version", "state", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/review` — Season review by option, attribute, cluster and channel — The governed season-review mart (reqs/06 6.1). Demand measures are computed on unconstrained demand with the constrained figure retained alongside for Finance reconciliation; every ratio is null rather than zero where it is undefined. 404 `planning.postseason.read_not_published` while no producer persists its rows (DEC-111). */
export type ListSeasonReviewParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/review` */
export const listSeasonReview: OperationSpec<ListSeasonReviewParams, CursorPageSeasonReviewRow> = {
  operationId: "list_season_review_api_v1_postseason_review_get",
  method: "GET",
  path: "/api/v1/postseason/review",
  tag: "postseason",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/seasons` — The seasons this chapter holds evidence for — The season directory every other post-season read is bounded by. Newest first, scope-rewritten, and derived from the seasons that actually carry a recovery run or a supplier scorecard rather than from a reference list — a season with no evidence is absent because there is nothing to review. */
export type ListSeasonsParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/seasons` */
export const listSeasons: OperationSpec<ListSeasonsParams, CursorPageSeasonRow> = {
  operationId: "list_seasons_api_v1_postseason_seasons_get",
  method: "GET",
  path: "/api/v1/postseason/seasons",
  tag: "postseason",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/service-exchange` — List Service Exchange — Every recorded forecast run, newest period first (bata-platform#571). A run is recorded by ``inseason.service_exchange`` as ``evaluated`` once its period has ended and at least one forecast door's week has landed — over the doors that have (ADR 6062) — and as ``awaiting_actuals`` until then. 404 ``service_exchange_unavailable`` when no source is installed. */
export type ListServiceExchangeParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/service-exchange` */
export const listServiceExchange: OperationSpec<ListServiceExchangeParams, CursorPageServiceExchangeRunSummary> = {
  operationId: "list_service_exchange_api_v1_inseason_service_exchange_get",
  method: "GET",
  path: "/api/v1/inseason/service-exchange",
  tag: "inseason",
  pathParams: [],
  queryParams: ["country_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/shadow-seasons` — Complete shadow seasons per country — The counter behind `05.P2`: reqs/05 §4 Phase 2 requires a full shadow season before the cadence engine drives a live price, and this is the query that decides whether one happened. */
export type ListShadowSeasonsParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/shadow-seasons` */
export const listShadowSeasons: OperationSpec<ListShadowSeasonsParams, CursorPageShadowSeasonCount> = {
  operationId: "list_shadow_seasons_api_v1_exit_shadow_seasons_get",
  method: "GET",
  path: "/api/v1/exit/shadow-seasons",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/simulations/scenarios` — List Simulation Scenarios — The D5 branches a simulation of this run may write into (ADR 6049). Exactly the set ``POST /inseason/simulations`` accepts for this base — a plan of the run's market or of no market — by the same predicate. Bounded by the run (G16); 404 ``base_run_not_found`` for a run that is unknown or outside the caller's scope. ``overlayCells`` is 0, as on ``GET /foundations/scenarios``: this read does not count. */
export type ListSimulationScenariosParams = {
  readonly query?: {
    readonly base_run_id?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/simulations/scenarios` */
export const listSimulationScenarios: OperationSpec<ListSimulationScenariosParams, CursorPageScenarioSummary> = {
  operationId: "list_simulation_scenarios_api_v1_inseason_simulations_scenarios_get",
  method: "GET",
  path: "/api/v1/inseason/simulations/scenarios",
  tag: "inseason",
  pathParams: [],
  queryParams: ["base_run_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/simulations` — List Simulations — One live run's simulations, newest first. Bounded by the run (G16). */
export type ListSimulationsParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/simulations` */
export const listSimulations: OperationSpec<ListSimulationsParams, CursorPageSimulationView> = {
  operationId: "list_simulations_api_v1_inseason_simulations_get",
  method: "GET",
  path: "/api/v1/inseason/simulations",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/preseason/size-availability` — List Size Availability — Availability by door and size, in reqs/00 D8's three states. reqs/08 §5 names size-position availability the confirming evidence for the whole capability, and D8 requires its three states to survive "all the way to the pixel" — so the state is a column and never a rendering convention. */
export type ListSizeAvailabilityParams = {
  readonly query?: {
    readonly store_key?: string | null;
    readonly size_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/size-availability` */
export const listSizeAvailability: OperationSpec<ListSizeAvailabilityParams, CursorPageSizeAvailabilityCell> = {
  operationId: "list_size_availability_api_v1_preseason_size_availability_get",
  method: "GET",
  path: "/api/v1/preseason/size-availability",
  tag: "preseason",
  pathParams: [],
  queryParams: ["store_key", "size_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/preseason/size-curves` — List Size Curves — Published size curves — the object §3 and §4.5 consume unchanged. */
export type ListSizeCurvesParams = {
  readonly query?: {
    readonly category_key?: string | null;
    readonly cluster_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/size-curves` */
export const listSizeCurves: OperationSpec<ListSizeCurvesParams, CursorPageSizeCurveSummary> = {
  operationId: "list_size_curves_api_v1_preseason_size_curves_get",
  method: "GET",
  path: "/api/v1/preseason/size-curves",
  tag: "preseason",
  pathParams: [],
  queryParams: ["category_key", "cluster_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/state-census` — Store-weeks by availability state, per recovery run — The census behind /postseason/vocabulary's state names (reqs/06 6.4). Counted per run rather than per season, because a re-fit is a second opinion about the same weeks and summing two runs would double every week they share. */
export type ListStateCensusParams = {
  readonly query?: {
    readonly season?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/state-census` */
export const listStateCensus: OperationSpec<ListStateCensusParams, CursorPageStateCensusRow> = {
  operationId: "list_state_census_api_v1_postseason_state_census_get",
  method: "GET",
  path: "/api/v1/postseason/state-census",
  tag: "postseason",
  pathParams: [],
  queryParams: ["season", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/stock-positions` — List Stock Positions — On-hand, weeks of cover and partition freshness for one cycle. Bounded by ``run_id`` for the same reason the proposals are: a position is a claim about a moment, and the moment is the run's stock partition. Reading "current" stock beside a proposal generated on Tuesday's partition would produce a cover figure that never justified any recommendation on the screen. ``store_key`` and ``article_key`` narrow the run's rows inside the scope rewrite, as the proposals' do (ADR 6038), so a store or article drill is one page walk rather than the whole run's. Neither is validated: a key the run never read is an empty page. ``stock_out=counted`` narrows to the positions the run's stock summary counts as stock-outs, by the predicate it counts them with, so the rows of the list are its ``counted_stock_outs`` (ADR 6193). */
export type ListStockPositionsParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly store_key?: string | null;
    readonly article_key?: string | null;
    readonly stock_out?: "counted" | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/stock-positions` */
export const listStockPositions: OperationSpec<ListStockPositionsParams, CursorPageStockPositionSummary> = {
  operationId: "list_stock_positions_api_v1_inseason_stock_positions_get",
  method: "GET",
  path: "/api/v1/inseason/stock-positions",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id", "store_key", "article_key", "stock_out", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/stranded` — The stored per-lot stranded verdict — reqs/05 §3.8's join, read from the `exit.position` job's output. `undetermined` rows are returned rather than filtered: a lot the join could not settle is not a lot that is safe, and this read is where an operator finds it. See `GET /exit/stranded/count-by-country` for the number the landing surface leads with. */
export type ListStrandedParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly option_key?: string | null;
    readonly as_of?: string | null;
    readonly lot_key?: string | null;
    readonly verdict?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/stranded` */
export const listStranded: OperationSpec<ListStrandedParams, CursorPageStoredStrandedLot> = {
  operationId: "list_stranded_api_v1_exit_stranded_get",
  method: "GET",
  path: "/api/v1/exit/stranded",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "option_key", "as_of", "lot_key", "verdict", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/postseason/suppliers` — Supplier scorecards per supplier per season — OTIF, fill rate, lead-time mean and variance, defect rate and first-pass yield, with a weighted composite (reqs/06 6.6). A rate is null where it was not measured; an unmeasured supplier is never ranked as a perfect one. */
export type ListSupplierScorecardsParams = {
  readonly query?: {
    readonly season?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/postseason/suppliers` */
export const listSupplierScorecards: OperationSpec<ListSupplierScorecardsParams, CursorPageSupplierScorecardRow> = {
  operationId: "list_supplier_scorecards_api_v1_postseason_suppliers_get",
  method: "GET",
  path: "/api/v1/postseason/suppliers",
  tag: "postseason",
  pathParams: [],
  queryParams: ["season", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/preseason/supply-scenarios` — List Supply Scenarios — The named supply plans per buy — reqs/07 §3.6's scenario set. */
export type ListSupplyScenariosParams = {
  readonly query?: {
    readonly buy_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/supply-scenarios` */
export const listSupplyScenarios: OperationSpec<ListSupplyScenariosParams, CursorPageSupplyScenarioSummary> = {
  operationId: "list_supply_scenarios_api_v1_preseason_supply_scenarios_get",
  method: "GET",
  path: "/api/v1/preseason/supply-scenarios",
  tag: "preseason",
  pathParams: [],
  queryParams: ["buy_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/terminal-stock` — Measured terminal stock — reqs/05 §8.2's measurement, as a read. `/exit/terminal-stock/evaluate` publishes the *predicate* and answers entirely from its payload, so a client that wanted the estate's own terminal stock ratio had to re-post every input it would have had to know already — and got its own arithmetic back. This returns what the chapter recorded: saleable units, stocking doors, the stored ratio and the stored breach verdict, with the target beside them and the intake definition that makes the ratio reconcilable. Under this platform's store-only perimeter the residual is a store-side residual. */
export type ListTerminalStockParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly option_id?: string | null;
    readonly season_code?: string | null;
    readonly cluster_id?: string | null;
    readonly as_of_week?: string | null;
    readonly exit_plan_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/terminal-stock` */
export const listTerminalStock: OperationSpec<ListTerminalStockParams, CursorPageTerminalPositionSummary> = {
  operationId: "list_terminal_stock_api_v1_exit_terminal_stock_get",
  method: "GET",
  path: "/api/v1/exit/terminal-stock",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "option_id", "season_code", "cluster_id", "as_of_week", "exit_plan_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/transfers` — List Transfers — Transfer proposals for one cycle, with the net benefit that justified each. Each row carries its disposition, or ``null`` while pending (ADR 6031). ``store_key`` matches either end of a move; a transfer carries no reason code of its own, so ``reason_code`` matches its recorded decision (bata-ui#148 step 3.2). ``net_benefit`` narrows to the moves above nothing (``pays``) or below it (``costs``), by :func:`~services.repositories.inseason.transfer_net_benefit_condition` (ADR 6193). */
export type ListTransfersParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly store_key?: string | null;
    readonly article_key?: string | null;
    readonly department_family?: string | null;
    readonly reason_code?: string | null;
    readonly disposition?: string | null;
    readonly net_benefit?: "pays" | "costs" | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/transfers` */
export const listTransfers: OperationSpec<ListTransfersParams, CursorPageTransferSummary> = {
  operationId: "list_transfers_api_v1_inseason_transfers_get",
  method: "GET",
  path: "/api/v1/inseason/transfers",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id", "store_key", "article_key", "department_family", "reason_code", "disposition", "net_benefit", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/plans/unsigned` — Exit plans still missing a signature — reqs/05 §8.3's gap list — the plans a merchant or Finance has not signed. The two signatures are reported separately because which one is outstanding decides who the row goes to. Reported rather than blocked: the block belongs on the commit path, and this is the list a planner works through to remove it. */
export type ListUnsignedPlansParams = {
  readonly query?: {
    readonly country_key?: string | null;
    readonly season_code?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/plans/unsigned` */
export const listUnsignedPlans: OperationSpec<ListUnsignedPlansParams, CursorPageUnsignedPlanSummary> = {
  operationId: "list_unsigned_plans_api_v1_exit_plans_unsigned_get",
  method: "GET",
  path: "/api/v1/exit/plans/unsigned",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "season_code", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/launch/versions` — List allocation versions — Every engine run for an option, oldest first, scope-filtered server side. */
export type ListVersionsParams = {
  readonly query?: {
    readonly option_id?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/launch/versions` */
export const listVersions: OperationSpec<ListVersionsParams, CursorPageAllocationVersionModel> = {
  operationId: "list_versions_api_v1_launch_versions_get",
  method: "GET",
  path: "/api/v1/launch/versions",
  tag: "launch",
  pathParams: [],
  queryParams: ["option_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/programme/waves` — List Waves — The reqs/08 §4 wave calendar, which is `12` §5's spine. Waves are data (G5). Adding one is a configuration row, and the sequence rather than the name is what orders them — "Wave 0" is a label, not an index. */
export type ListWavesParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/programme/waves` */
export const listWaves: OperationSpec<ListWavesParams, CursorPageWaveState> = {
  operationId: "list_waves_api_v1_programme_waves_get",
  method: "GET",
  path: "/api/v1/programme/waves",
  tag: "programme",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/lifecycle-transitions/withdrawals/runs` — List Withdrawal Runs — The market's withdrawal runs, oldest first, each with its evidence and refusal. */
export type ListWithdrawalRunsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly effective_month?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/lifecycle-transitions/withdrawals/runs` */
export const listWithdrawalRuns: OperationSpec<ListWithdrawalRunsParams, CursorPageWithdrawalRunModel> = {
  operationId: "list_withdrawal_runs_api_v1_exit_lifecycle_transitions_withdrawals_runs_get",
  method: "GET",
  path: "/api/v1/exit/lifecycle-transitions/withdrawals/runs",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "effective_month", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/lifecycle-transitions/withdrawals` — List Withdrawals — One month's forced-donor withdrawal for one market, by article (issue 35 P2b, ADR 7027). Each accepted move to ``ZONA_SALES`` the run read: lines written, or the refusal by name (``no_stock_to_withdraw``, ``no_recipient_in_range``, ``withdrawal_already_written``), with every door named (moved and where, no recipient in range, not measured, emptied since the recommendation, or of unknown zona-sales area). 404 ``lifecycle_withdrawal.run_not_found`` when no run executed the month. */
export type ListWithdrawalsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly effective_month?: string;
    readonly run_id?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/exit/lifecycle-transitions/withdrawals` */
export const listWithdrawals: OperationSpec<ListWithdrawalsParams, CursorPageWithdrawalItemModel> = {
  operationId: "list_withdrawals_api_v1_exit_lifecycle_transitions_withdrawals_get",
  method: "GET",
  path: "/api/v1/exit/lifecycle-transitions/withdrawals",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "effective_month", "run_id", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/write-back` — List Write Back — Delivery state of approved commands, uncollapsed (§14 test E10). **This read finally has a producer.** Until this batch it answered an empty page in every environment, because nothing in the platform ever wrote a command: the chain reqs/07 §3.5 describes stopped at ``decision``. An approved price action now mints one — see :func:`record_price_action_dispositions` — so an empty page here means "no approval has been dispatched", which is a fact about the estate rather than about the wiring. ``sla_elapsed`` is three-valued on the way in and the route does not flatten it: ``null`` means no SLA is configured for this target, which is a different finding from a deadline that has not yet passed. ``needs_attention`` narrows to the commands ``GET /inseason/write-back/summary`` counts under its figure of that name, by the predicate it counts them with (ADR 6193). */
export type ListWriteBackParams = {
  readonly query?: {
    readonly needs_attention?: boolean | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/write-back` */
export const listWriteBack: OperationSpec<ListWriteBackParams, CursorPageWriteBackState> = {
  operationId: "list_write_back_api_v1_inseason_write_back_get",
  method: "GET",
  path: "/api/v1/inseason/write-back",
  tag: "inseason",
  pathParams: [],
  queryParams: ["needs_attention", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/write-back/groups` — List Write Back Groups — The write-back backlog read one group at a time (owner ruling DEC-105, ADR 6054). A group is one value of ``group_by`` in the market: ``store`` (the store the goods arrive at — a proposal's door, a transfer's recipient, an exit lane's destination; a price step has none), ``subject_kind`` or ``run``. Counted by one ``GROUP BY`` in the store over every command the filters match, scope-rewritten on the command's market. Ordered by ``slaElapsedCount`` and ``unknownCount`` descending, then ``oldestAt``, then ``groupKey``. ``totals`` counts every group the filters match, not only this page. Authorised as ``read`` on the plan, as ``GET /inseason/write-back`` is; a market outside the caller's scope is no group. A group's commands are listed by the market pack with the same filters (``GET /inseason/execution-pack?country_key=&store_key=&subject_kind=`` ``&run_id=&state=``). */
export type ListWriteBackGroupsParams = {
  readonly query?: {
    readonly group_by?: WriteBackGroupDimension;
    readonly country_key?: string;
    readonly run_id?: string | null;
    readonly state?: PackStateFilter | null;
    readonly sla_elapsed?: boolean | null;
    readonly store_key?: string | null;
    readonly subject_kind?: WriteBackSubjectKind | null;
    readonly cursor?: string | null;
    readonly limit?: number;
  };
};

/** `GET /api/v1/inseason/write-back/groups` */
export const listWriteBackGroups: OperationSpec<ListWriteBackGroupsParams, WriteBackGroupPage> = {
  operationId: "list_write_back_groups_api_v1_inseason_write_back_groups_get",
  method: "GET",
  path: "/api/v1/inseason/write-back/groups",
  tag: "inseason",
  pathParams: [],
  queryParams: ["group_by", "country_key", "run_id", "state", "sla_elapsed", "store_key", "subject_kind", "cursor", "limit"],
  hasBody: false,
};

/** `POST /api/v1/inseason/markdown/analogues` — The closest historical analogues, with what actually happened to them — reqs/04 §4.4's evidence strip. The library §4.1's early-signal re-projection already fits every option against, shown to a merchant with the realised markdown cadence, weeks to exit and terminal stock of each analogue. Ranked by the same distance the classification used. Never padded: where fewer than the wanted number clear the threshold, fewer are returned and the shortfall is stated, because a weak analogue presented as evidence is worse than an empty panel. The strip is evidence and carries no action. */
export type MarkdownAnaloguesParams = {
  readonly body: AnalogueRequest;
};

/** `POST /api/v1/inseason/markdown/analogues` */
export const markdownAnalogues: OperationSpec<MarkdownAnaloguesParams, AnalogueStripResponse> = {
  operationId: "markdown_analogues_api_v1_inseason_markdown_analogues_post",
  method: "POST",
  path: "/api/v1/inseason/markdown/analogues",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/markdown/candidates` — The markdown candidate queue, ranked by what waiting costs — reqs/05 §3.2's queue order. Ranking by residual units ranks by size and ranking by weeks remaining ranks by urgency; neither ranks by what the planner's attention is worth. The cost of waiting is the signed currency difference between acting now and holding at the current rung, and it is null rather than zero where either branch has no price — those lots come back in their own named group. The response states whether it was computed now or read from a stored job output. */
export type MarkdownCandidatesParams = {
  readonly body: CandidateQueueRequest;
};

/** `POST /api/v1/inseason/markdown/candidates` */
export const markdownCandidates: OperationSpec<MarkdownCandidatesParams, CandidateQueueResponse> = {
  operationId: "markdown_candidates_api_v1_inseason_markdown_candidates_post",
  method: "POST",
  path: "/api/v1/inseason/markdown/candidates",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/markdown/frontier` — Markdown Frontier — The margin-versus-cash frontier for one option × cluster, from the estate. **The read `bata-ui`'s trade-off panel has been waiting for.** That panel renders illustrative rows behind a notice, and ADR 0053 recorded why: the frontier is a planning measure, and computing it in the browser would give realised price and contribution a second producer (G11). ``POST /markdown/trade-off`` has existed for some time and did **not** discharge that — it is an unassembled calculator wanting twenty caller-supplied fields, so a screen calling it would be authoring Bata's commercial policy in the front end and presenting the result as the platform's. This route assembles the problem here, over ``packages/planning/``, exactly as ``GET /markdown/path`` does for the price path, and the screen supplies only what identifies the question. **The same problem as the path, at several costs of carry.** It shares :func:`_assemble_from_estate` with ``/markdown/path`` rather than re-reading the plan store, so the two screens cannot disagree about the same option's list price, baseline or terminal target. The path is the frontier's incumbent point: pose one and you have posed the other. **The rates are a registry row, and there is no default.** ``markdown.trade_off .carrying_cost_rates`` holds the set finance authored, comma-separated, and an absent row is a refusal rather than a frontier built from the single objective rate. §4.4 requires competing scenarios; one scenario presented as a frontier is the hidden weighting of margin against cash this endpoint exists to prevent, and reqs/07 §3.6 requires ≥2 alternatives for a material decision. Each entry is a rate on value and is multiplied by the option's landed cost here, so one registry row governs every option rather than a peso sweep that would mean something different for a sandal and a boot. **No recommended point is returned, by design.** Which point on the frontier Bata wants is a finance decision taken against a bridge, with an owner. This route publishes the whole frontier and lets the screen show it. ``infeasible_rates`` carries the rates no permitted path could satisfy, as rates on value — the form the caller supplied and the registry holds, not the per-unit amounts the solver saw. A rate omitted silently reads as one nobody asked about, when it is in fact the finding that at that cost of carry the option cannot reach chapter 05's terminal target at all. **A GET, and nothing is written**, for the reason :func:`markdown_path` gives: the frontier derives from rows already in force, and a read that created decision rows would make every screen refresh a planning act. */
export type MarkdownFrontierParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly brand_key?: string;
    readonly option_key?: string;
    readonly cluster_key?: string;
    readonly channel_key?: string;
    readonly model_version_id?: string;
    readonly as_of?: string;
    readonly weeks_remaining?: number;
    readonly minor_unit?: number;
    readonly price_rounding_quantum?: number | null;
    readonly opening_units?: number | null;
    readonly objective_kind?: ObjectiveKind | null;
    readonly salvage_fraction?: number | null;
    readonly penalty_basis?: PenaltyBasis | null;
  };
};

/** `GET /api/v1/inseason/markdown/frontier` */
export const markdownFrontier: OperationSpec<MarkdownFrontierParams, AssembledMarkdownFrontier> = {
  operationId: "markdown_frontier_api_v1_inseason_markdown_frontier_get",
  method: "GET",
  path: "/api/v1/inseason/markdown/frontier",
  tag: "inseason",
  pathParams: [],
  queryParams: ["country_key", "brand_key", "option_key", "cluster_key", "channel_key", "model_version_id", "as_of", "weeks_remaining", "minor_unit", "price_rounding_quantum", "opening_units", "objective_kind", "salvage_fraction", "penalty_basis"],
  hasBody: false,
};

/** `GET /api/v1/inseason/markdown/path` — Markdown Path — The recommended price path for one option × cluster, solved from the estate. **The read `bata-ui`'s markdown screen has been waiting for.** That screen renders its price path from a fixture and says so, and its own note explains why it does not call ``POST /markdown/optimise`` instead: ``MarkdownRequest`` has nineteen caller-supplied fields — the elasticity, the permitted price points, the carrying cost per unit-week, the terminal target — and a browser that invented them would be authoring Bata's commercial policy in the front end and presenting the result as the platform's recommendation. So the assembly happens here, over ``packages/planning/``, and the screen supplies only what identifies the question. **This route requires a principal, and it is the first planning route that does.** Twelve of the fifteen routers declare no identity at all, so a request arriving with no ``Authorization`` header is served as an anonymous caller. A new route publishing an option's cost, margin and price path must not join them. The scope comes from the register rather than from this function — :func:`~services.api.security.authorised_scope` is the only sanctioned constructor, and a bare ``Scope`` built here would fail the access conformance check by design. **The resource it authorises against needs confirming.** A price path is a computed planning recommendation at option × cluster, which is the shape of ``allocation_run``, so that row is reused rather than a fourteenth resource being added to a register whose preamble counts thirteen and whose every refusal is asserted. Adding one is a governance act with an owner (`17` §P6) and does not belong in a feature branch. If the register's owner wants ``price_path`` as a resource of its own, this one line is what changes. **What the caller still supplies, and why none of it is policy.** ``weeks_remaining`` is the planner's horizon and ``minor_unit`` is the currency's from `13`'s reference. Neither is read here because neither is reachable from this process: the retail calendar and the currency reference are not in the plan store. Those are gaps with names rather than a design, and each closes when its feed does — at which point the parameter is removed, not defaulted. **``opening_units`` was the third of those gaps and is now closed**, which is why it is optional rather than gone. The daily stock position no longer lands only in ClickHouse: `bata-data`'s B1 ``stock_position`` feed puts it in ``plan.stock_position`` — 990,045 rows for Colombia's batch in force — so omitting the parameter now asks the platform to resolve the sellable on-hand position for the option and it does. It stays accepted, because the two requests are different questions: a caller that states a position is posing its own problem, and a caller that omits it is asking the estate what the position is. ``provenance.opening_units`` says which happened, and ``opening_units`` on the response echoes the number either way so the path stays re-derivable. **The parameter is not simply removed, and that is the honest reading rather than a compatibility hedge.** Removing it would say the estate can position every markdown question, and it cannot: the landed position carries no cluster and no channel, so an option × *cluster* path outside the unclustered key is refused (``platform.inseason.cluster_positions_absent``) and stating the position by hand is the only way to ask it at all. **A GET, and nothing is written.** The path derives from rows already in force, so two calls with the same arguments on the same day give the same answer. Writing the result as an ``inseason_price_action`` is ``inseason.price``'s job and stays there — a read that quietly created decision rows would make every screen refresh a planning act. ``model_version_id`` is required for the reason :func:`list_elasticity_estimates` gives: a recommendation must stay re-derivable, and a query that silently followed the newest fit would re-derive last season's markdown with this season's coefficients. **Most calls refuse today, and the refusal is the useful answer.** Three of this problem's inputs have not landed in production — the ladder, the landed cost, and the registry rows the assembly is posed with — and each refusal names which, in the problem document's ``planningCode``. */
export type MarkdownPathParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly brand_key?: string;
    readonly option_key?: string;
    readonly cluster_key?: string;
    readonly channel_key?: string;
    readonly model_version_id?: string;
    readonly as_of?: string;
    readonly weeks_remaining?: number;
    readonly minor_unit?: number;
    readonly price_rounding_quantum?: number | null;
    readonly opening_units?: number | null;
    readonly objective_kind?: ObjectiveKind | null;
    readonly salvage_fraction?: number | null;
    readonly penalty_basis?: PenaltyBasis | null;
  };
};

/** `GET /api/v1/inseason/markdown/path` */
export const markdownPath: OperationSpec<MarkdownPathParams, AssembledMarkdownPath> = {
  operationId: "markdown_path_api_v1_inseason_markdown_path_get",
  method: "GET",
  path: "/api/v1/inseason/markdown/path",
  tag: "inseason",
  pathParams: [],
  queryParams: ["country_key", "brand_key", "option_key", "cluster_key", "channel_key", "model_version_id", "as_of", "weeks_remaining", "minor_unit", "price_rounding_quantum", "opening_units", "objective_kind", "salvage_fraction", "penalty_basis"],
  hasBody: false,
};

/** `GET /api/v1/inseason/markdown/registry-values` — Markdown Registry Values — Which registry rows a markdown solve reads, what they say, and who owns them. **G1's second half, published.** "Every threshold lives in an effective-dated, versioned table with an owner and a review date" — this platform honours the storage and defaults none of them, and until now published none of the accountability. The consequences were concrete. ``GET /markdown/path`` and ``GET /markdown/frontier`` both require a ``minor_unit`` the caller cannot discover, because the row holding it lives in a register only ``administrator`` and ``auditor`` may read. And every refusal those routes raise names a key in ``missingInput`` that had no published meaning: a planner told ``registry_row_absent:markdown.terminal_residual_share`` had no way to find out whose row that is or when it lapsed. **Every key is returned, in force or not.** The absent ones are the finding. A read that listed only what exists would answer "everything you can see is fine" to the exact question a refused caller is asking. ``as_of`` is required and is never defaulted to today, on the same terms as every other dated read in this chapter: G9 makes a stored value a claim about a moment, and a path solved as at one date beside a registry answered for another is two different problems reported as one. ``currency_code`` is optional and narrows only the currency-scoped minor unit; omitted, every priced currency's row comes back, so a caller can see which currencies are priced at all. **Authorised on the grant a markdown solve already needs**, and read unscoped behind it, exactly as ``_assemble_from_estate`` reads the same rows. That is the decision worth naming: a caller who may pose a markdown problem may see the parameters it will be posed with, and a caller who may not never reaches the register. Serving it under the parameter register's own grant instead would have made it unreadable by every planner it exists for — which is the state ``GET /inseason/elasticity/model-version`` was written to escape. Not paginated: the set is nine keys plus up to two rows per priced currency (``markdown.currency_minor_unit``, required, and ``markdown.price_rounding_quantum``, optional — issue #165 ruling 2), and it is a fixed roster rather than a collection that grows with the estate. */
export type MarkdownRegistryValuesParams = {
  readonly query?: {
    readonly as_of?: string;
    readonly currency_code?: string | null;
  };
};

/** `GET /api/v1/inseason/markdown/registry-values` */
export const markdownRegistryValues: OperationSpec<MarkdownRegistryValuesParams, readonly (MarkdownRegistryValue)[]> = {
  operationId: "markdown_registry_values_api_v1_inseason_markdown_registry_values_get",
  method: "GET",
  path: "/api/v1/inseason/markdown/registry-values",
  tag: "inseason",
  pathParams: [],
  queryParams: ["as_of", "currency_code"],
  hasBody: false,
};

/** `POST /api/v1/inseason/markdown/trade-off` — Markdown Trade Off — The margin-versus-cash frontier for one option × cluster (§4.4). **A POST, and the reason is the payload.** Every one of the twenty inputs is caller-supplied and none has a default, because G1 makes a tunable in source a defect and an API default is source. A GET carrying twenty required parameters and two repeated lists is the same computation with a worse contract, and the sibling ``/markdown/optimise`` already established the shape. Nothing is committed, and the ``Idempotency-Key`` the middleware requires costs a caller one header — ADR 0058. The frontier is computed by ``packages/planning/`` and nowhere else. A client that re-solved the problem at a range of rates in the browser would make realised price and contribution have two producers, and the two would disagree the first time the solver changed (G11). */
export type MarkdownTradeOffParams = {
  readonly body: TradeOffRequest;
};

/** `POST /api/v1/inseason/markdown/trade-off` */
export const markdownTradeOff: OperationSpec<MarkdownTradeOffParams, TradeOffResponse> = {
  operationId: "markdown_trade_off_api_v1_inseason_markdown_trade_off_post",
  method: "POST",
  path: "/api/v1/inseason/markdown/trade-off",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/execution-pack` — Market Execution Pack — One market's commands across its runs, exit lane included (ADR 6104, DEC-15). The per-run pack (``GET /inseason/runs/{run_id}/execution-pack``) is one run's; a market's planner executes what is approved whichever run it came from, and an approval survives a newer run's supersession of its undecided neighbours (ADR 6048, ASK-10). So this is every command of the market — replenishment origin → store, transfers donor → recipient, price steps article × week, and exit lanes source → destination — each line naming its run. ``run_id``, ``store_key`` and ``subject_kind`` narrow it to one write-back group's commands (DEC-105, ADR 6054). Authorised as ``export`` on the plan, as the per-run pack is; a market outside the caller's scope is an empty pack, never a refusal that would confirm it exists (G3.3). A read: it mints nothing. */
export type MarketExecutionPackParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly state?: PackStateFilter | null;
    readonly run_id?: string | null;
    readonly store_key?: string | null;
    readonly subject_kind?: WriteBackSubjectKind | null;
  };
};

/** `GET /api/v1/inseason/execution-pack` */
export const marketExecutionPack: OperationSpec<MarketExecutionPackParams, MarketExecutionPack> = {
  operationId: "market_execution_pack_api_v1_inseason_execution_pack_get",
  method: "GET",
  path: "/api/v1/inseason/execution-pack",
  tag: "inseason",
  pathParams: [],
  queryParams: ["country_key", "state", "run_id", "store_key", "subject_kind"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/move-cap-deferrals/summary` — Move Cap Deferral Summary — What the weekly move cap held back for one run's tick, per stage (ADR 6100). 404 when the run does not exist or is outside the caller's scope. Each stage says whether it was ``recorded``; an unrecorded stage has ``null`` figures, never 0. */
export type MoveCapDeferralSummaryParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/move-cap-deferrals/summary` */
export const moveCapDeferralSummary: OperationSpec<MoveCapDeferralSummaryParams, MoveCapDeferralSummary> = {
  operationId: "move_cap_deferral_summary_api_v1_inseason_runs__run_id__move_cap_deferrals_summary_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/move-cap-deferrals/summary",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/compacting/simulations/overlay-keys` — Move Run Simulation Overlay Keys — The keys an overlay of the one run admits, with the grant each needs, and those refused. */
export type MoveRunSimulationOverlayKeysParams = Record<string, never>;

/** `GET /api/v1/compacting/simulations/overlay-keys` */
export const moveRunSimulationOverlayKeys: OperationSpec<MoveRunSimulationOverlayKeysParams, OverlayKeysView> = {
  operationId: "move_run_simulation_overlay_keys_api_v1_compacting_simulations_overlay_keys_get",
  method: "GET",
  path: "/api/v1/compacting/simulations/overlay-keys",
  tag: "compacting",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/me/capabilities` — My Capabilities — Every declared act, and whether *this* caller may take it and where. Always every entry, allowed or not, so a client can tell "not permitted" from "not asked". Decided by the route's own wired grant, so the answer and the route agree. */
export type MyCapabilitiesParams = Record<string, never>;

/** `GET /api/v1/me/capabilities` */
export const myCapabilities: OperationSpec<MyCapabilitiesParams, MeCapabilities> = {
  operationId: "my_capabilities_api_v1_me_capabilities_get",
  method: "GET",
  path: "/api/v1/me/capabilities",
  tag: "capabilities",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/me/work-counts` — My Work Counts — How much is waiting for the caller, per kind, inside their scope. The alert counts use the same predicates as ``GET /foundations/exceptions?queue=…``, so the badge and the queue it opens cannot disagree. */
export type MyWorkCountsParams = Record<string, never>;

/** `GET /api/v1/me/work-counts` */
export const myWorkCounts: OperationSpec<MyWorkCountsParams, WorkCounts> = {
  operationId: "my_work_counts_api_v1_me_work_counts_get",
  method: "GET",
  path: "/api/v1/me/work-counts",
  tag: "work",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/network-health` — Network Health — Every served combination of one run, with its interventions (DEC-107, ADR 6055). **Served = in assortment.** No assortment source exists yet, so a cell (store × article × size) is served when it is **in the run's stock partition and its `position_state` is not `not_ranged`** — an approximation the screen must state. Stock-out is counted per size (`cellsOos`) and per store × article (`storeArticlesOos`, every served size out). Cover and size gap are the exception sweep's own observations of this run (`exception_observation` with `source_ref` = the run), the newest per subject, judged against each rule's threshold in force on the run's stock `asOf`; a subject the sweep never observed for this run reads `not_observed_for_run`. Interventions are the run's proposals and transfers without a recorded rejection, the market's undecided alerts and the run's price steps. The run's store-to-store moves are the lines of the tick's move run (`interventionRuns.move`), or its own transfer rows on a run recorded before the move run (ADR 6055, amended 2026-10-31). The **uncovered** counts are the problems with no proposal and no inbound move on that size (owner rulings F1/F2, 2026-10-05): a price step or an undecided alert is shown beside an uncovered cell, never counted as its cover. `uncoveredTotal` counts served cells only (`cellsUncoveredByState` added). Counted by one `GROUP BY` in the store over the run's cells, scope-rewritten on the run's market. Ordered by `uncoveredTotal` descending, then `groupKey`, cursor-paged (`limit` ≤ 500). `totals` counts every group the filters match, not only this page. 404 when the run does not exist or is outside the caller's scope. **`state`** (repeatable) narrows the list to the groups holding served cells in those states and orders it by `stateUncovered` descending, then `stateCells` descending, then `groupKey`: the level-1 list a level-0 card (stock-outs, low cover, broken size runs) opens. Summed over every group, `stateCells` and `stateUncovered` are the level-0 counts of those states (`cellsByState`, `cellsUncoveredByState`). Without it the order, the cursor and the response are the ones above, and the two fields are `null`. */
export type NetworkHealthParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly group_by?: NetworkHealthDimension;
    readonly store_key?: string | null;
    readonly article_key?: string | null;
    readonly department_family?: string | null;
    readonly state?: readonly (NetworkHealthState)[] | null;
    readonly cursor?: string | null;
    readonly limit?: number;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/network-health` */
export const networkHealth: OperationSpec<NetworkHealthParams, NetworkHealthPage> = {
  operationId: "network_health_api_v1_inseason_runs__run_id__network_health_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/network-health",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["group_by", "store_key", "article_key", "department_family", "state", "cursor", "limit"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/network-health/sizes` — Network Health Sizes — One store × article of the run, every size, with stock, demand and the run's lines. The article's sizes are every size the run's stock partition holds for the article at **any** store, and any size a line of the run names at this store × article — the scale as the run knows it. A size of the article's declared scale the run never read anywhere is not listed (resolving the declared scale is the sweep's ADR 2105 path, which reads the market's sales evidence). Each size carries this store's stored position (``GET /inseason/stock-positions``' row, unchanged), the run's proposal units and its transfer units in and out — the lines without a recorded rejection, as the cockpit counts them — and the size-gap observation. Bounded by one article's sizes; not paged. 404 when the run does not exist or is outside the caller's scope. */
export type NetworkHealthSizesParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly store_key?: string;
    readonly article_key?: string;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/network-health/sizes` */
export const networkHealthSizes: OperationSpec<NetworkHealthSizesParams, NetworkHealthSizes> = {
  operationId: "network_health_sizes_api_v1_inseason_runs__run_id__network_health_sizes_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/network-health/sizes",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["store_key", "article_key"],
  hasBody: false,
};

/** `GET /api/v1/conformance/objective-audit` — Objective Audit — reqs/07 §3.4 test *(a)* — no engine holds a local objective. A source audit rather than a data query, which is why it answers with no estate. Not paginated: the audited set is the objective-bearing modules of one repository, which is bounded by the repository (G16). */
export type ObjectiveAuditParams = Record<string, never>;

/** `GET /api/v1/conformance/objective-audit` */
export const objectiveAudit: OperationSpec<ObjectiveAuditParams, ObjectiveAuditResponse> = {
  operationId: "objective_audit_api_v1_conformance_objective_audit_get",
  method: "GET",
  path: "/api/v1/conformance/objective-audit",
  tag: "conformance",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/inseason/markdown/optimise` — Optimise Markdown — Solve one option × cluster's markdown problem from the payload. Callable with no estate, which is what lets ``bata-ui`` and chapter 05 develop against this chapter before a feed is certified (G3.5 headless use). A problem with no feasible path raises rather than returning a best effort — the terminal target is chapter 05's constraint, not a preference. */
export type OptimiseMarkdownParams = {
  readonly body: MarkdownRequest;
};

/** `POST /api/v1/inseason/markdown/optimise` */
export const optimiseMarkdown: OperationSpec<OptimiseMarkdownParams, MarkdownResponse> = {
  operationId: "optimise_markdown_api_v1_inseason_markdown_optimise_post",
  method: "POST",
  path: "/api/v1/inseason/markdown/optimise",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/exit/outlet-exits/decision-reasons` — Outlet Decision Reasons — The governed reasons for an outlet exit decision, on the day of the request. */
export type OutletDecisionReasonsParams = Record<string, never>;

/** `GET /api/v1/exit/outlet-exits/decision-reasons` */
export const outletDecisionReasons: OperationSpec<OutletDecisionReasonsParams, OutletDecisionReasonsModel> = {
  operationId: "outlet_decision_reasons_api_v1_exit_outlet_exits_decision_reasons_get",
  method: "GET",
  path: "/api/v1/exit/outlet-exits/decision-reasons",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/exit/outlet-exits/{recommendation_id}` — Outlet Recommendation Evidence — One recommendation's evidence: both readings and every door, with its run. */
export type OutletRecommendationEvidenceParams = {
  readonly path: {
    readonly recommendation_id: string;
  };
};

/** `GET /api/v1/exit/outlet-exits/{recommendation_id}` */
export const outletRecommendationEvidence: OperationSpec<OutletRecommendationEvidenceParams, OutletRecommendationEvidenceModel> = {
  operationId: "outlet_recommendation_evidence_api_v1_exit_outlet_exits__recommendation_id__get",
  method: "GET",
  path: "/api/v1/exit/outlet-exits/{recommendation_id}",
  tag: "exit",
  pathParams: ["recommendation_id"],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/exit/cadence-proposals/{proposal_id}/override` — Override one cadence proposal, with its reason code — A reason-coded override of a single proposal. The reason code is mandatory: ``docs/05`` §7 makes it the bulk unit, and an override without one is an action with no unit rather than a poorly documented one. */
export type OverrideProposalParams = {
  readonly path: {
    readonly proposal_id: string;
  };
  readonly body: CadenceOverrideRequest;
};

/** `POST /api/v1/exit/cadence-proposals/{proposal_id}/override` */
export const overrideProposal: OperationSpec<OverrideProposalParams, CadenceDisposition> = {
  operationId: "override_proposal_api_v1_exit_cadence_proposals__proposal_id__override_post",
  method: "POST",
  path: "/api/v1/exit/cadence-proposals/{proposal_id}/override",
  tag: "exit",
  pathParams: ["proposal_id"],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/registry/parameters/history` — Parameter History — Every stored version of one key's rows, with who recorded it, when and why (W2-2). All scopes and all valid windows, including versions the store no longer believes — a supersession closes a version and records a new one (ADR 9006), so "what was this value in July, and who changed it" is a page of this read. Each version names the change set that authored it, with its author, approvers and rationale. ``known_at`` answers as the store knew it then: only versions recorded at or before it, each ``believed`` as it was at that instant. ``scope_dimension`` and ``scope_value`` narrow to one stored scope. */
export type ParameterHistoryParams = {
  readonly query?: {
    readonly parameter_key?: string;
    readonly known_at?: string | null;
    readonly scope_dimension?: string | null;
    readonly scope_value?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/registry/parameters/history` */
export const parameterHistory: OperationSpec<ParameterHistoryParams, CursorPageParameterVersion> = {
  operationId: "parameter_history_api_v1_registry_parameters_history_get",
  method: "GET",
  path: "/api/v1/registry/parameters/history",
  tag: "registry",
  pathParams: [],
  queryParams: ["parameter_key", "known_at", "scope_dimension", "scope_value", "limit", "cursor"],
  hasBody: false,
};

/** `POST /api/v1/postseason/bridge` — Plan-vs-actual variance, decomposed to the post-season components — Decomposes MFP original to current to actual as two bridges (reqs/06 6.7), splitting volume into underlying demand and availability and price into realised price and markdown. Components sum to the total variance exactly; the residual is zero. */
export type PlanVersusActualParams = {
  readonly body: VarianceRequest;
};

/** `POST /api/v1/postseason/bridge` */
export const planVersusActual: OperationSpec<PlanVersusActualParams, VarianceResponse> = {
  operationId: "plan_versus_actual_api_v1_postseason_bridge_post",
  method: "POST",
  path: "/api/v1/postseason/bridge",
  tag: "postseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/health/attributes` — Post Attributes — Attributes: the article and store labels the Health files carry beside their rows. Each asked article's name, brand, gender, major category, category and risk on the attribute row in force on ``asOf``, and each asked store's name on the market's door master in force, in the order asked; a key neither master lists is answered with its reason. For the by-article files and their drill files (owner answers 2026-11-03); no figure is read here. ``POST`` only because the key lists do not fit a query string: it reads, decides nothing and writes nothing — the same ``read`` grant and market scope as the other Health reads (a market outside the caller's scope is 404 ``planning.health.not_found``), and ``Cache-Control: no-store`` as the lookup's. */
export type PostAttributesParams = {
  readonly body: AttributesRequest;
};

/** `POST /api/v1/health/attributes` */
export const postAttributes: OperationSpec<PostAttributesParams, AttributesResponseModel> = {
  operationId: "post_attributes_api_v1_health_attributes_post",
  method: "POST",
  path: "/api/v1/health/attributes",
  tag: "health",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/health/lookup` — Post Lookup — Lookup: the landed stock and sales of a list of store x article pairs (ADR 9042). For the client's spot checks against its own system: one row per distinct pair, in the order asked, whether or not anything was landed for it. Stock is the market's stock batch that measured ``asOf`` (``stockDay.landed`` false when none did, inside retention); sales and returns are the promoted batches ``GET /inseason/sales-history`` reads, over ``salesFrom`` to ``salesTo`` (both or neither; neither is the 7 days ending on ``asOf``; at most 366 days). Names come from the market's door master and the article attributes in force on ``asOf``; keys neither lists are named in ``unknownStores`` / ``unknownArticles``. ``POST`` only because the pair list does not fit a query string: it reads, decides nothing and writes nothing — the same ``read`` grant and market scope as the other Health reads (a market outside the caller's scope is 404 ``planning.health.not_found``). The response is ``Cache-Control: no-store``, so the idempotency ledger keeps no copy of it and a retry with the same key reads again. */
export type PostLookupParams = {
  readonly body: LookupRequest;
};

/** `POST /api/v1/health/lookup` */
export const postLookup: OperationSpec<PostLookupParams, LookupResponseModel> = {
  operationId: "post_lookup_api_v1_health_lookup_post",
  method: "POST",
  path: "/api/v1/health/lookup",
  tag: "health",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/me/session` — Post My Session — Copy the caller's verified claims into their profile, at sign-in (DEC-102, ADR 2110). No body. Copies ``email``, ``email_verified`` and ``name`` (as ``PUT /me/profile`` does) and the realm roles and scope claims, under a new ``claims_copied_at`` — **never a preference**. Creates the row with the preference defaults when absent. Idempotent; the client calls it once per session so the alert assignee picker knows who has signed in and with which roles. Answers the profile as ``GET /me/profile`` would. */
export type PostMySessionParams = Record<string, never>;

/** `POST /api/v1/me/session` */
export const postMySession: OperationSpec<PostMySessionParams, UserProfile> = {
  operationId: "post_my_session_api_v1_me_session_post",
  method: "POST",
  path: "/api/v1/me/session",
  tag: "profile",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/preseason/options` — List Options — The option plan, groupable by any attribute — reqs/07 §3.2's grouping audit. The ``attribute``/``value`` pair is what makes this endpoint pass that audit: every planning screen must support at least one non-SKU grouping, and here it is the only grouping there is. */
export type PreseasonListOptionsParams = {
  readonly query?: {
    readonly cluster_id?: string | null;
    readonly attribute?: string | null;
    readonly value?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/preseason/options` */
export const preseasonListOptions: OperationSpec<PreseasonListOptionsParams, CursorPageOptionPlanSummary> = {
  operationId: "list_options_api_v1_preseason_options_get",
  method: "GET",
  path: "/api/v1/preseason/options",
  tag: "preseason",
  pathParams: [],
  queryParams: ["cluster_id", "attribute", "value", "limit", "cursor"],
  hasBody: false,
};

/** `POST /api/v1/registry/run-scopes/preview` — Preview Definition — Count an unsaved definition: what the editor shows as a rule set is written. A computation, not a change: nothing is recorded (an ``Idempotency-Key`` is still required, as on every non-GET). The definition is checked as a proposal would check it (the rule language; named selections of the market's library, of the right axis, not retired) and refused in the same words; then counted on the masters as of ``asOf``. */
export type PreviewDefinitionParams = {
  readonly body: PreviewRequest;
};

/** `POST /api/v1/registry/run-scopes/preview` */
export const previewDefinition: OperationSpec<PreviewDefinitionParams, PreviewView> = {
  operationId: "preview_definition_api_v1_registry_run_scopes_preview_post",
  method: "POST",
  path: "/api/v1/registry/run-scopes/preview",
  tag: "registry",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/dispositions/selection` — Preview Selection — What a filter resolves to now, before a decision by it (ADR 6103, DEC-15). The pending lines of ``run_id`` in the caller's scope that the filter matches — "pending" exactly as the queue shows it (undecided, on a run no newer run superseded, ADR 6048) — counted, summed in units and in stored value, digested, and sampled. A read: nothing is written. 404 for an unknown or out-of-scope run. */
export type PreviewSelectionParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly queue?: SelectionQueue;
    readonly store_key?: string | null;
    readonly article_key?: string | null;
    readonly department_family?: string | null;
    readonly reason_code?: string | null;
    readonly value_min?: number | null;
    readonly value_max?: number | null;
  };
};

/** `GET /api/v1/inseason/dispositions/selection` */
export const previewSelection: OperationSpec<PreviewSelectionParams, SelectionPreview> = {
  operationId: "preview_selection_api_v1_inseason_dispositions_selection_get",
  method: "GET",
  path: "/api/v1/inseason/dispositions/selection",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id", "queue", "store_key", "article_key", "department_family", "reason_code", "value_min", "value_max"],
  hasBody: false,
};

/** `POST /api/v1/preseason/assortment/price-edit` — Price Assortment Edit — Price an assortment edit against OTB and return the recompute set. reqs/02 §3.3's live coupling, exposed headlessly per G3.5. The response is a *price*, not a commit: the edit has not touched the plan store, so two candidate edits are two calls and reqs/07 §3.6's scenario comparison is satisfiable without a write. */
export type PriceAssortmentEditParams = {
  readonly body: PriceEditRequest;
};

/** `POST /api/v1/preseason/assortment/price-edit` */
export const priceAssortmentEdit: OperationSpec<PriceAssortmentEditParams, PriceEditResponse> = {
  operationId: "price_assortment_edit_api_v1_preseason_assortment_price_edit_post",
  method: "POST",
  path: "/api/v1/preseason/assortment/price-edit",
  tag: "preseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/runs/{run_id}/price-steps/paths` — Price Paths Report — A run's price steps by path and by week, ranked and paged in the store (ADR 6215). What the markdown calendar folded from every price step of the run in the browser: a page of paths with their steps, and every page's totals and weeks. 404 when the run does not exist or is outside the caller's scope. */
export type PricePathsReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly rank?: "first_week" | "recovery" | "margin_at_stake" | "cost_of_waiting" | "stock_at_risk" | "article" | "depth";
    readonly direction?: "asc" | "desc" | null;
    readonly limit?: number;
    readonly cursor?: string | null;
    readonly cluster_key?: readonly (string)[];
    readonly article_key?: readonly (string)[];
    readonly price_action_id?: readonly (string)[];
    readonly price_stream?: string | null;
    readonly disposition?: string | null;
    readonly effective_week?: string | null;
    readonly department_family?: string | null;
    readonly target?: "on" | "over" | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/price-steps/paths` */
export const pricePathsReport: OperationSpec<PricePathsReportParams, PricePathsResponse> = {
  operationId: "price_paths_report_api_v1_inseason_runs__run_id__price_steps_paths_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/price-steps/paths",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["rank", "direction", "limit", "cursor", "cluster_key", "article_key", "price_action_id", "price_stream", "disposition", "effective_week", "department_family", "target"],
  hasBody: false,
};

/** `GET /api/v1/inseason/price-actions/reason-codes` — Price Reason Vocabulary — The reason codes a planner may record against a price decision, with prose. **What this closes.** ``reason_code`` is mandatory on ``POST /inseason/price-actions/dispositions`` and nothing published a vocabulary a caller could fill it from, so the write was reachable and unusable: every caller either sent a string it made up or did not call. reqs/04 §5 counts **override rate per reason code** as the metric that makes a systematic disagreement visible "before it becomes a habit", and a made-up code is counted as though a planner had chosen it. **Its own route rather than a field on the disposition vocabulary.** They are two vocabularies over one act and they close differently: the four dispositions are fixed — G1 sanctions four planner interactions and no market extends them — while which reasons a deployment governs is a governance decision with an owner, and ``17`` A16 dates the day it becomes reference rows. A closed set and an open one served from one address would have to move together. **Not shared with ``GET /launch/reason-codes``, deliberately.** That route publishes what *bound* an allocation — ``capacity_capped``, ``case_rounded`` — and reqs/04 §14 does share chapter 03's queue and workflow. It does not follow that the vocabularies are one: filing "capped by DC stock" as the reason a markdown step was approved is legible and wrong, which is worse than filing nothing. The prose is resolved against ``Accept-Language`` on ADR 0057's terms, so a caller renders this platform's own wording without owning any part of its key space. */
export type PriceReasonVocabularyParams = Record<string, never>;

/** `GET /api/v1/inseason/price-actions/reason-codes` */
export const priceReasonVocabulary: OperationSpec<PriceReasonVocabularyParams, readonly (PriceReasonOption)[]> = {
  operationId: "price_reason_vocabulary_api_v1_inseason_price_actions_reason_codes_get",
  method: "GET",
  path: "/api/v1/inseason/price-actions/reason-codes",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/price-actions/{price_action_id}/explanation` — Price Step Explanation — Why one price step: drivers, binding constraint, elasticity and the run's path (ADR 6126). **Only what the run recorded.** The drivers, the constraints, the guardrails, the coefficient the solve used and the weekly path are the ones ``inseason.price`` stored when it solved; the path's steps are the price actions the run wrote. Nothing is re-solved and nothing is re-read from today's registry: a run older than the record answers ``not_recorded_by_run``. The fit row is read at the step's own ``elasticity_model_version_id``, never the newest. 404 when the step does not exist in the run, or the run is outside the caller's scope. */
export type PriceStepExplanationParams = {
  readonly path: {
    readonly run_id: string;
    readonly price_action_id: string;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/price-actions/{price_action_id}/explanation` */
export const priceStepExplanation: OperationSpec<PriceStepExplanationParams, PriceStepExplanationSummary> = {
  operationId: "price_step_explanation_api_v1_inseason_runs__run_id__price_actions__price_action_id__explanation_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/price-actions/{price_action_id}/explanation",
  tag: "inseason",
  pathParams: ["run_id", "price_action_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/report/pricing` — Pricing Report — One price run's pricing report, one recommended price step per row, one page at a time. Ordered by article, cluster, channel, effective week and step. The reason and the constraints are the ones the run recorded when it solved (ADR 6126), never re-derived. Joined in the store at a fixed number of statements per page, whatever its size (ADR 9018). 404 when the run does not exist or is outside the caller's scope. */
export type PricingReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/report/pricing` */
export const pricingReport: OperationSpec<PricingReportParams, CursorPagePricingReportRow> = {
  operationId: "pricing_report_api_v1_inseason_runs__run_id__report_pricing_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/report/pricing",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/product-images/vocabulary` — The governed reasons an article may have no image — The absence vocabulary and its governance state. `governanceStatus` is `ratified`: merchandising governance ratified all five codes, unchanged, on `bata-data` #209. **No producer publishes a per-article verdict yet**, which is a separate, unclosed gap: the image index records what was captured, not a verdict on what was not, so every absence today still carries `reasonCode: null` with `determination: "undetermined"`. The vocabulary is published so that a client can render a code the day a producer supplies one. Render a reason from the `label` here or from the `reason` on the absence itself; both are in the caller’s locale. */
export type ProductImagesReadVocabularyParams = Record<string, never>;

/** `GET /api/v1/product-images/vocabulary` */
export const productImagesReadVocabulary: OperationSpec<ProductImagesReadVocabularyParams, AbsenceVocabulary> = {
  operationId: "read_vocabulary_api_v1_product_images_vocabulary_get",
  method: "GET",
  path: "/api/v1/product-images/vocabulary",
  tag: "product-images",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/strategic/project` — Project — Project a cell from its base and driver set, with the bridge. Computes from the payload, so a caller with no estate gets a real answer. */
export type ProjectParams = {
  readonly body: ProjectionRequest;
};

/** `POST /api/v1/strategic/project` */
export const project: OperationSpec<ProjectParams, ProjectionResponse> = {
  operationId: "project_api_v1_strategic_project_post",
  method: "POST",
  path: "/api/v1/strategic/project",
  tag: "strategic",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/registry/changes/{change_id}/promotions` — Promote Change — `17` §4 steps 3 to 6 — promote a sealed set into a higher tier. **There is none.** Issue 523, owner ruling 2026-10-03, ADR 9023. The estate has one registry tier, the one the deployment declares in ``BATA_REGISTRY_TIER`` (``production`` on production), and an approved set takes effect in it immediately. Infra ADR 0069 removed staging, so no tier lies beyond it. Every call answers ``409 platform.registry.no_promotion_tier`` with ``tierInForce``, whatever ``toTier`` names and whichever set it names, and writes nothing. The route stays so that the answer is explicit. A 404 would read as a path never built, and before this ruling the call answered ``promoter_is_not_the_service_account`` (bata-platform#125), which suggested a missing account could unblock it. The approval is what applies a set's values: ``record_approval`` calls ``apply_change_set`` in the same transaction. */
export type PromoteChangeParams = {
  readonly path: {
    readonly change_id: string;
  };
  readonly body: PromoteRequest;
};

/** `POST /api/v1/registry/changes/{change_id}/promotions` */
export const promoteChange: OperationSpec<PromoteChangeParams, ChangeReceipt> = {
  operationId: "promote_change_api_v1_registry_changes__change_id__promotions_post",
  method: "POST",
  path: "/api/v1/registry/changes/{change_id}/promotions",
  tag: "registry",
  pathParams: ["change_id"],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/postseason/promotions/calendar` — Promotion Calendar — Bata's commercial weeks of ``year`` with their headlines, in week order. 404 ``promotions_unavailable`` when no calendar has landed for the country; a landed calendar with nothing in ``year`` is an empty list. */
export type PromotionCalendarParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly year?: number;
  };
};

/** `GET /api/v1/postseason/promotions/calendar` */
export const promotionCalendar: OperationSpec<PromotionCalendarParams, PromotionCalendarModel> = {
  operationId: "promotion_calendar_api_v1_postseason_promotions_calendar_get",
  method: "GET",
  path: "/api/v1/postseason/promotions/calendar",
  tag: "postseason",
  pathParams: [],
  queryParams: ["country_key", "year"],
  hasBody: false,
};

/** `GET /api/v1/postseason/promotions/mechanics` — Promotion Mechanics — Per inferred mechanic × store channel: the net uplift at 80%, and the rate changes. The interval is ``exp(ln(1 + estimate) ± z·se) − 1``, with no bounds from fewer than two windows. ``basis`` names the comparison — the neighbouring days, other promotions, not "no promotion". In key order, never ranked. 404 ``promotions_unavailable`` when nothing has landed for the country. */
export type PromotionMechanicsParams = {
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/postseason/promotions/mechanics` */
export const promotionMechanics: OperationSpec<PromotionMechanicsParams, PromotionMechanicsModel> = {
  operationId: "promotion_mechanics_api_v1_postseason_promotions_mechanics_get",
  method: "GET",
  path: "/api/v1/postseason/promotions/mechanics",
  tag: "postseason",
  pathParams: [],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /api/v1/postseason/promotions/windows/{window_id}/articles` — Promotion Window Articles — The articles a window sold, per store channel, with each one's share of the units. Summed over the window's own days from the article-day panel in force, the rows tagged with the window; channel then article order, never ranked. 404 ``promotion_window_not_found`` when the window register in force has no such window; 404 ``promotions_unavailable`` when the panel has nothing landed on the window's days. */
export type PromotionWindowArticlesParams = {
  readonly path: {
    readonly window_id: string;
  };
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/postseason/promotions/windows/{window_id}/articles` */
export const promotionWindowArticles: OperationSpec<PromotionWindowArticlesParams, WindowArticlesModel> = {
  operationId: "promotion_window_articles_api_v1_postseason_promotions_windows__window_id__articles_get",
  method: "GET",
  path: "/api/v1/postseason/promotions/windows/{window_id}/articles",
  tag: "postseason",
  pathParams: ["window_id"],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /api/v1/postseason/promotions/windows/{window_id}/doors/{store_key}/subcategories` — Promotion Window Door Subcategories — One door's sub-categories in a window, each against the neighbouring days in the door. From bata-data's sub-category register (one batch per window, ADR 8017), in key order, never ranked. 404 ``promotion_window_not_found`` when the window register in force has no such window; 404 ``promotions_unavailable`` when the door register, or the window's sub-category batch, has not landed; 404 ``promotion_window_door_not_found`` when the door register has no row for the door around the window. */
export type PromotionWindowDoorSubcategoriesParams = {
  readonly path: {
    readonly window_id: string;
    readonly store_key: string;
  };
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/postseason/promotions/windows/{window_id}/doors/{store_key}/subcategories` */
export const promotionWindowDoorSubcategories: OperationSpec<PromotionWindowDoorSubcategoriesParams, DoorSubcategoriesModel> = {
  operationId: "promotion_window_door_subcategories_api_v1_postseason_promotions_windows__window_id__doors__store_key__subcategories_get",
  method: "GET",
  path: "/api/v1/postseason/promotions/windows/{window_id}/doors/{store_key}/subcategories",
  tag: "postseason",
  pathParams: ["window_id", "store_key"],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /api/v1/postseason/promotions/windows/{window_id}/doors` — Promotion Window Doors — The doors a window was compared over, per store channel, with why any did not enter. One row per door that traded on a window day or on a neighbouring day, in channel then door order: its trading days on each side, ``isCompared`` and ``notComparedReason``. 404 ``promotions_unavailable`` when the door register has not landed for the country; 404 ``promotion_window_not_found`` when the window register in force has no such window. */
export type PromotionWindowDoorsParams = {
  readonly path: {
    readonly window_id: string;
  };
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/postseason/promotions/windows/{window_id}/doors` */
export const promotionWindowDoors: OperationSpec<PromotionWindowDoorsParams, WindowDoorsModel> = {
  operationId: "promotion_window_doors_api_v1_postseason_promotions_windows__window_id__doors_get",
  method: "GET",
  path: "/api/v1/postseason/promotions/windows/{window_id}/doors",
  tag: "postseason",
  pathParams: ["window_id"],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /api/v1/postseason/promotions/windows` — Promotion Windows — The promotion windows sharing a day with ``[from, to]``, newest first. Both bounds are required and inclusive; there is no default range (G16). 422 ``promotions_range_invalid`` when ``from`` is after ``to``; 404 ``promotions_unavailable`` when no window has landed for the country. Each window carries its channel impacts, the commercial weeks it overlaps with their headlines, ``mechanicCode`` and ``mechanicRegistered``. Retrospective measurement: nothing is ranked or recommended. */
export type PromotionWindowsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly from?: string;
    readonly to?: string;
  };
};

/** `GET /api/v1/postseason/promotions/windows` */
export const promotionWindows: OperationSpec<PromotionWindowsParams, PromotionWindowsModel> = {
  operationId: "promotion_windows_api_v1_postseason_promotions_windows_get",
  method: "GET",
  path: "/api/v1/postseason/promotions/windows",
  tag: "postseason",
  pathParams: [],
  queryParams: ["country_key", "from", "to"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/proposals/groups` — Proposal Groups Report — The Allocation index's store and article views, grouped and ranked in the store (ADR 6179). The lines that pass the filters, added up per store, per article or per pair, ranked and capped at `limit`: what the views drew by grouping every line of the run in the browser. One row per group is read, never per line. 404 when the run does not exist or is outside the caller's scope. ADR 6211: the store × article view is every pair the filters keep, one page at a time in the store's order, resumed from `cursor`; a pair-only ranking or a cursor on another grain is 422. */
export type ProposalGroupsReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly by?: "store" | "article" | "store_article" | "reason_code";
    readonly rank?: "units" | "requested" | "uncovered" | "key" | "store" | "article" | "rationing_rank" | "sold" | "expected_impact";
    readonly direction?: "asc" | "desc" | null;
    readonly limit?: number;
    readonly cursor?: string | null;
    readonly store_key?: readonly (string)[];
    readonly article_key?: readonly (string)[];
    readonly pair?: readonly (string)[];
    readonly department_family?: string | null;
    readonly coverage?: "uncovered" | "covered" | null;
    readonly bound_by?: string | null;
    readonly mode?: string | null;
    readonly lines?: "served" | null;
    readonly reason_code?: string | null;
    readonly disposition?: string | null;
    readonly disposition_reason_code?: string | null;
    readonly size_scale?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/proposals/groups` */
export const proposalGroupsReport: OperationSpec<ProposalGroupsReportParams, ProposalGroupsResponse> = {
  operationId: "proposal_groups_report_api_v1_inseason_runs__run_id__proposals_groups_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/proposals/groups",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["by", "rank", "direction", "limit", "cursor", "store_key", "article_key", "pair", "department_family", "coverage", "bound_by", "mode", "lines", "reason_code", "disposition", "disposition_reason_code", "size_scale"],
  hasBody: false,
};

/** `GET /api/v1/inseason/dispositions/reason-codes` — Proposal Reason Vocabulary — The reason codes a planner may record against a proposal disposition, with prose. **What this closes.** ``reason_code`` is mandatory on ``POST /inseason/dispositions`` and until ADR 5000 nothing published a vocabulary a caller could fill it from — the exact gap :func:`price_reason_vocabulary` closed for price decisions, named here as open by `bata-platform#231` and closed in the same change that wires the check into :func:`record_dispositions`. **Its own route rather than a field on the disposition vocabulary**, for the same reason :func:`price_reason_vocabulary` is: the four dispositions are fixed and this vocabulary is not. **Not shared with ``GET /launch/reason-codes``**, deliberately, for the same reason :func:`price_reason_vocabulary`'s docstring gives for its own domain: that route publishes what *bound* the proposal, this one publishes why a *planner* agreed, adjusted, refused or held it, and filing one as the other is legible and wrong. The prose is resolved against ``Accept-Language`` on ADR 0057's terms. */
export type ProposalReasonVocabularyParams = Record<string, never>;

/** `GET /api/v1/inseason/dispositions/reason-codes` */
export const proposalReasonVocabulary: OperationSpec<ProposalReasonVocabularyParams, readonly (ProposalReasonOption)[]> = {
  operationId: "proposal_reason_vocabulary_api_v1_inseason_dispositions_reason_codes_get",
  method: "GET",
  path: "/api/v1/inseason/dispositions/reason-codes",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/proposals/by-door-size` — Proposals By Door Size Report — One run's proposals rolled up for the Allocation index, in the store (ADR 6179). The summary, the shortfall call-outs, the size axis and the door × size map the index drew by walking every proposal of the run (32 pages of 1,000 on the 2026-10-13 production crawl), folded by the screen's own rules over the stored lines: a screen that walked the pages would get these numbers. Not paged: its size is bounded by ``door_limit``, the run's size axis and the constraint and reason vocabularies — a few hundred rows for a 32,000-line run. Read with the proposals' authorisation (`read` on `plan_version`) and the run's market scope. 404 when the run does not exist or is outside the caller's scope. */
export type ProposalsByDoorSizeReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly door_limit?: number;
    readonly department_family?: string | null;
    readonly keys?: boolean;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/proposals/by-door-size` */
export const proposalsByDoorSizeReport: OperationSpec<ProposalsByDoorSizeReportParams, ProposalsByDoorSizeResponse> = {
  operationId: "proposals_by_door_size_report_api_v1_inseason_runs__run_id__proposals_by_door_size_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/proposals/by-door-size",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["door_limit", "department_family", "keys"],
  hasBody: false,
};

/** `POST /api/v1/registry/process-calendar/changes` — Propose Calendar Change — `17` §4 step 1 for the calendar — author a change set of period changes (ADR 2136). Writes no period. Each change is checked as its approval will check it: a start strictly after today (never backdated) and outside the run-ahead, a locked (started or run) period neither edited nor removed, and the market's whole calendar after the set (no overlap within a type, contiguous pricing periods, no start inside a blackout, windows on the 1st, a named promotional period, a governed mechanic). It takes effect on ``POST /registry/changes/{id}/approvals``; the author may approve it (ADR 9026). */
export type ProposeCalendarChangeParams = {
  readonly body: ProposeCalendarRequest;
};

/** `POST /api/v1/registry/process-calendar/changes` */
export const proposeCalendarChange: OperationSpec<ProposeCalendarChangeParams, CalendarReceipt> = {
  operationId: "propose_calendar_change_api_v1_registry_process_calendar_changes_post",
  method: "POST",
  path: "/api/v1/registry/process-calendar/changes",
  tag: "registry",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/registry/changes` — Propose Change — `17` §4 step 1 — author a parameter change set. Writes no parameter row. The set takes effect when it is approved, not when it is proposed, which is what makes the approval a decision rather than a formality. The previous value of every row is read from the store and recorded on the item here, so that the record a reader finds in eighteen months carries what the value actually was rather than what the proposer believed it was. */
export type ProposeChangeParams = {
  readonly body: ProposeRequest;
};

/** `POST /api/v1/registry/changes` */
export const proposeChange: OperationSpec<ProposeChangeParams, ChangeReceipt> = {
  operationId: "propose_change_api_v1_registry_changes_post",
  method: "POST",
  path: "/api/v1/registry/changes",
  tag: "registry",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/registry/exception-rule-changes` — Propose Exception Rule Change — `17` §4 step 1 for P4 — author an exception-rule change set (ADR 9101). Writes no rule. Per rule: activation (``isActive``), ``severity``, ``slaHours``, the ``perimeter`` and per-market ``thresholds``. The previous value of each is read from the store and recorded on its item. The set takes effect on ``POST /changes/{id}/approvals``, by a reviewer other than the author (DEC-13); rule attributes take effect on approval, thresholds from their ``validFrom``. */
export type ProposeExceptionRuleChangeParams = {
  readonly body: ProposeExceptionRulesRequest;
};

/** `POST /api/v1/registry/exception-rule-changes` */
export const proposeExceptionRuleChange: OperationSpec<ProposeExceptionRuleChangeParams, ChangeReceipt> = {
  operationId: "propose_exception_rule_change_api_v1_registry_exception_rule_changes_post",
  method: "POST",
  path: "/api/v1/registry/exception-rule-changes",
  tag: "registry",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/registry/objective-configs` — Propose Objective Config — `17` §4 step 1 for P2 — author an objective-configuration change set. A sibling route rather than a ``category`` field on ``POST /changes``, because the two carry different revisions: a category field would have to be paired with a union of payload shapes, and the shape a caller may send would then depend on a value inside the body rather than on the path they chose. The set is approved through the *same* ``POST /changes/{id}/approvals`` as a parameter set. The approval matrix is what differs — P2 takes one reviewer other than the author and cites evidence — and that lives in the matrix, not here. **Nothing about P2 is relaxed to make this route usable:** a service account authoring and a named person approving satisfies `17` §3 as written, which is why this arrived without a second deviation beside ADR 0124's. */
export type ProposeObjectiveConfigParams = {
  readonly body: ProposeObjectiveRequest;
};

/** `POST /api/v1/registry/objective-configs` */
export const proposeObjectiveConfig: OperationSpec<ProposeObjectiveConfigParams, ChangeReceipt> = {
  operationId: "propose_objective_config_api_v1_registry_objective_configs_post",
  method: "POST",
  path: "/api/v1/registry/objective-configs",
  tag: "registry",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/registry/price-ladder-changes` — Propose Price Ladder Change — `17` §4 step 1 for a ladder — author a change set of ladder versions (ADR 6189). bata-reqs issue 38 R3: the Zona Sale and markdown (promotions) ladders are edited like any parameter. Writes no ladder. Each version is checked as its approval will check it — the market, purpose, currency, window (never backdated) and rungs, and the supersession rules a landing is held to — and the version in force on its ``validFrom`` is recorded on its item as the value it replaces. It takes effect on ``POST /changes/{id}/approvals``; the author may approve it (ADR 9026), and the approver is recorded beside the author. */
export type ProposePriceLadderChangeParams = {
  readonly body: ProposeLadderRequest;
};

/** `POST /api/v1/registry/price-ladder-changes` */
export const proposePriceLadderChange: OperationSpec<ProposePriceLadderChangeParams, ChangeReceipt> = {
  operationId: "propose_price_ladder_change_api_v1_registry_price_ladder_changes_post",
  method: "POST",
  path: "/api/v1/registry/price-ladder-changes",
  tag: "registry",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/registry/run-scopes/changes` — Propose Run Scope Change — `17` §4 step 1 for the library — author a change set of entry changes (ADR 9035). Writes no version. Each change is checked as its approval will check it: the id (new, not reserved, never reused), the entry (not a system entry, not retired), the texts, and the definition against the rule language and the library **after** the set (a Scope may name a selection the same set creates); a selection a Scope still names, or a Scope production lists, is not retired. It takes effect on ``POST /registry/changes/{id}/approvals``; the author may approve it (ADR 9026). */
export type ProposeRunScopeChangeParams = {
  readonly body: ProposeRunScopeRequest;
};

/** `POST /api/v1/registry/run-scopes/changes` */
export const proposeRunScopeChange: OperationSpec<ProposeRunScopeChangeParams, RunScopeReceipt> = {
  operationId: "propose_run_scope_change_api_v1_registry_run_scopes_changes_post",
  method: "POST",
  path: "/api/v1/registry/run-scopes/changes",
  tag: "registry",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `PUT /api/v1/me/profile` — Put My Profile — Replace the caller's preferences and refresh the copy of their verified claims. The claims are the ones the authentication middleware read off the verified token for this request — the same place the principal came from. */
export type PutMyProfileParams = {
  readonly body: ProfilePreferencesInput;
};

/** `PUT /api/v1/me/profile` */
export const putMyProfile: OperationSpec<PutMyProfileParams, UserProfile> = {
  operationId: "put_my_profile_api_v1_me_profile_put",
  method: "PUT",
  path: "/api/v1/me/profile",
  tag: "profile",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/launch/queue-depth` — Queue depth per reason code — Line count, units and expected impact per reason code — a bulk action, costed. */
export type QueueDepthParams = {
  readonly query?: {
    readonly allocation_version_id?: string;
  };
};

/** `GET /api/v1/launch/queue-depth` */
export const queueDepth: OperationSpec<QueueDepthParams, readonly (QueueDepthModel)[]> = {
  operationId: "queue_depth_api_v1_launch_queue_depth_get",
  method: "GET",
  path: "/api/v1/launch/queue-depth",
  tag: "launch",
  pathParams: [],
  queryParams: ["allocation_version_id"],
  hasBody: false,
};

/** `POST /api/v1/exit/indifference/rank-lanes` — Rank consolidation lanes on cost per recovered margin point — reqs/05 §3.7's lane ranking. Cheapest per recovered margin point first, which is a sort order a country manager can cut for themselves; cost per unit is not, because it ranks small lots above valuable ones. Lanes whose move recovers nothing come back named rather than sorted to the expensive end. */
export type RankIndifferenceLanesParams = {
  readonly body: LaneRankingRequest;
};

/** `POST /api/v1/exit/indifference/rank-lanes` */
export const rankIndifferenceLanes: OperationSpec<RankIndifferenceLanesParams, LaneRankingResponse> = {
  operationId: "rank_indifference_lanes_api_v1_exit_indifference_rank_lanes_post",
  method: "POST",
  path: "/api/v1/exit/indifference/rank-lanes",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/runs/{run_id}/price-steps/ranked` — Ranked Price Steps Report — A run's price steps ranked, filtered and paged in the store (ADR 6215). What the price approval queue, the output's decision queue and its explain view ranked over every price step of the run in the browser: one page, never a walk. 404 when the run does not exist or is outside the caller's scope. */
export type RankedPriceStepsReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly rank?: "effective_week" | "recovery" | "depth" | "article";
    readonly direction?: "asc" | "desc" | null;
    readonly limit?: number;
    readonly cursor?: string | null;
    readonly cluster_key?: readonly (string)[];
    readonly article_key?: readonly (string)[];
    readonly price_action_id?: readonly (string)[];
    readonly price_stream?: string | null;
    readonly disposition?: string | null;
    readonly effective_week?: string | null;
    readonly department_family?: string | null;
    readonly target?: "on" | "over" | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/price-steps/ranked` */
export const rankedPriceStepsReport: OperationSpec<RankedPriceStepsReportParams, RankedPriceStepsResponse> = {
  operationId: "ranked_price_steps_report_api_v1_inseason_runs__run_id__price_steps_ranked_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/price-steps/ranked",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["rank", "direction", "limit", "cursor", "cluster_key", "article_key", "price_action_id", "price_stream", "disposition", "effective_week", "department_family", "target"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/proposals/ranked` — Ranked Proposals Report — The top lines of the Allocation table's ranking after its filters (ADR 6179). What the table drew by ranking every line of the run in the browser, ranked in the store: a page of ``limit`` lines, never a walk. ADR 6212: `cursor` resumes the ranking after the last line of a page, so the next page is one more read. Read with the proposals' authorisation and the run's market scope; 404 when the run does not exist or is outside the caller's scope. */
export type RankedProposalsReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly rank?: "units" | "requested" | "uncovered" | "confidence" | "store" | "article" | "ship_week" | "cover";
    readonly direction?: "asc" | "desc" | null;
    readonly limit?: number;
    readonly cursor?: string | null;
    readonly store_key?: readonly (string)[];
    readonly article_key?: readonly (string)[];
    readonly pair?: readonly (string)[];
    readonly department_family?: string | null;
    readonly coverage?: "uncovered" | "covered" | null;
    readonly bound_by?: string | null;
    readonly mode?: string | null;
    readonly lines?: "served" | null;
    readonly reason_code?: string | null;
    readonly disposition?: string | null;
    readonly disposition_reason_code?: string | null;
    readonly size_scale?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/proposals/ranked` */
export const rankedProposalsReport: OperationSpec<RankedProposalsReportParams, RankedProposalsResponse> = {
  operationId: "ranked_proposals_report_api_v1_inseason_runs__run_id__proposals_ranked_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/proposals/ranked",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["rank", "direction", "limit", "cursor", "store_key", "article_key", "pair", "department_family", "coverage", "bound_by", "mode", "lines", "reason_code", "disposition", "disposition_reason_code", "size_scale"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/transfers/ranked` — Ranked Transfers Report — A run's transfers ranked and filtered in the store, a page at a time (ADR 6214). What Stock transfers, the transfer «Perché» and the transfer approval queue ranked over every transfer of the run in the browser: one page of `limit`, resumed from `cursor`, never a walk, with — on request — the book every figure of those pages is read from. Read with the transfers' authorisation and the run's market scope; 404 when the run does not exist or is outside the caller's scope. */
export type RankedTransfersReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly donor_store_key?: readonly (string)[];
    readonly recipient_store_key?: readonly (string)[];
    readonly article_key?: readonly (string)[];
    readonly transfer_id?: readonly (string)[];
    readonly rank?: "net_benefit" | "lane_cost" | "run_damage" | "units" | "status";
    readonly direction?: "asc" | "desc" | null;
    readonly limit?: number;
    readonly cursor?: string | null;
    readonly purpose?: string | null;
    readonly disposition?: string | null;
    readonly net?: "pays" | "costs" | "even" | null;
    readonly department_family?: string | null;
    readonly book?: boolean;
    readonly article_limit?: number;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/transfers/ranked` */
export const rankedTransfersReport: OperationSpec<RankedTransfersReportParams, RankedTransfersResponse> = {
  operationId: "ranked_transfers_report_api_v1_inseason_runs__run_id__transfers_ranked_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/transfers/ranked",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["donor_store_key", "recipient_store_key", "article_key", "transfer_id", "rank", "direction", "limit", "cursor", "purpose", "disposition", "net", "department_family", "book", "article_limit"],
  hasBody: false,
};

/** `GET /api/v1/foundations/activity` — Read Activity — Every recorded act in the window, newest first (bata-platform#482, ADR 2009). One row per act — a bulk decision over forty lines is one row — read from the tables that record an actor today: in-season replenishment, transfer and price decisions; exit cadence and consolidation decisions; registry change sets (proposed, approved, rejected, withdrawn, and a simulation's adoption); the alert log (raised, assigned, released, snoozed, decided, reopened); write-back reports (exported, confirmed, withdrawn); simulations; reversals in ``action_log``. ``sources`` lists each table and whether it was readable in this store. **Bounded.** ``from`` and ``to`` are required, ``to`` inclusive, and span at most 92 days; an inverted or wider window is 422 ``platform.foundations.activity_window_invalid``. Pages are cursor-paginated (``limit`` default 100, at most 500); ordering is ``occurredAt`` then ``activityId``, both descending. **Who may read it.** ``read`` on ``audit_record``: the administrator and the auditor. Anybody else is 403; ``GET /me/capabilities`` answers ``activity``/``read``. */
export type ReadActivityParams = {
  readonly query?: {
    readonly from?: string;
    readonly to?: string;
    readonly actor?: string | null;
    readonly app?: ActivityApp | null;
    readonly action?: ActivityAction | null;
    readonly country?: string | null;
    readonly object_kind?: string | null;
    readonly cursor?: string | null;
    readonly limit?: number;
  };
};

/** `GET /api/v1/foundations/activity` */
export const readActivity: OperationSpec<ReadActivityParams, ActivityPage> = {
  operationId: "read_activity_api_v1_foundations_activity_get",
  method: "GET",
  path: "/api/v1/foundations/activity",
  tag: "foundations",
  pathParams: [],
  queryParams: ["from", "to", "actor", "app", "action", "country", "object_kind", "cursor", "limit"],
  hasBody: false,
};

/** `GET /api/v1/foundations/exceptions/department-families` — Read Alert Department Families — The families ``GET /foundations/exceptions?department_family=`` can take (ADR 2106). The market's pinned product class scheme on today's date. A market with no usable scheme is the same named refusal the filter raises (409), so a screen learns it before it offers a filter that cannot answer. */
export type ReadAlertDepartmentFamiliesParams = {
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/foundations/exceptions/department-families` */
export const readAlertDepartmentFamilies: OperationSpec<ReadAlertDepartmentFamiliesParams, AlertDepartmentFamilies> = {
  operationId: "read_alert_department_families_api_v1_foundations_exceptions_department_families_get",
  method: "GET",
  path: "/api/v1/foundations/exceptions/department-families",
  tag: "foundations",
  pathParams: [],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /api/v1/foundations/exceptions/precision` — Read Alert Precision — Dismissal rate per exception rule for one market — G1 test *e* (ADR 2122). Over every alert the market's queue has raised. A rule's rate is its ``reject`` decisions (:data:`planning.exception.reasons.DISMISSIVE_DISPOSITIONS`, published as ``dismissiveDispositions``) over its decided alerts; the ceiling is the registry row ``exception.dismissal_ceiling`` in force today, or G1's stated value. **Absence is never zero.** A rule with no decided alert has ``dismissalRate: null`` and ``measurability`` ``no_dispositions`` (or ``no_alerts_raised``), never a rate of nought, which would read as a rule nobody dismisses. Authorised as ``read`` on ``alert``, the queue's own grant, and rewritten on the alert's market: a market outside the caller's scope counts nothing, so every rule reads ``no_alerts_raised``. 404 ``alert_precision_unavailable`` when nothing is wired. */
export type ReadAlertPrecisionParams = {
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/foundations/exceptions/precision` */
export const readAlertPrecision: OperationSpec<ReadAlertPrecisionParams, AlertPrecisionReport> = {
  operationId: "read_alert_precision_api_v1_foundations_exceptions_precision_get",
  method: "GET",
  path: "/api/v1/foundations/exceptions/precision",
  tag: "foundations",
  pathParams: [],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/article-lifecycle-phase-inferred/sequence` — Read Article Lifecycle Phase Inferred Sequence — The last ``article_lifecycle_phase_inferred`` sequence this partition landed. */
export type ReadArticleLifecyclePhaseInferredSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/article-lifecycle-phase-inferred/sequence` */
export const readArticleLifecyclePhaseInferredSequence: OperationSpec<ReadArticleLifecyclePhaseInferredSequenceParams, FeedSequenceResponse> = {
  operationId: "read_article_lifecycle_phase_inferred_sequence_api_v1_landing_article_lifecycle_phase_inferred_sequence_get",
  method: "GET",
  path: "/api/v1/landing/article-lifecycle-phase-inferred/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/article-size-slots/sequence` — Read Article Size Slot Sequence — The last ``article_size_slot`` sequence this partition landed, and the next. Shipped with the ``POST``: G-1 refuses a ``delivery_seq`` that is not exactly one more than the last, and a producer with no read can only guess. */
export type ReadArticleSizeSlotSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/article-size-slots/sequence` */
export const readArticleSizeSlotSequence: OperationSpec<ReadArticleSizeSlotSequenceParams, FeedSequenceResponse> = {
  operationId: "read_article_size_slot_sequence_api_v1_landing_article_size_slots_sequence_get",
  method: "GET",
  path: "/api/v1/landing/article-size-slots/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/outbox/batches/{batch_id}/acknowledgement` — Read Batch Acknowledgement — The mirror's acknowledgement of one batch, or 404 when it has none (ADR 1011). */
export type ReadBatchAcknowledgementParams = {
  readonly path: {
    readonly batch_id: string;
  };
};

/** `GET /api/v1/outbox/batches/{batch_id}/acknowledgement` */
export const readBatchAcknowledgement: OperationSpec<ReadBatchAcknowledgementParams, OutboxAcknowledgementView> = {
  operationId: "read_batch_acknowledgement_api_v1_outbox_batches__batch_id__acknowledgement_get",
  method: "GET",
  path: "/api/v1/outbox/batches/{batch_id}/acknowledgement",
  tag: "outbox",
  pathParams: ["batch_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/registry/process-calendar` — Read Calendar — One market's calendar for one year, as it stands on ``as_of`` (ADR 2136). Every period overlapping the year, in start order, with its lock and the days its runs are due; the pending sets that would change it; the run-ahead in force; the day the calendar governs each stream from; and, per stream with nothing due on ``as_of``, why by name. ``as_of`` is required for the reason ``GET /registry/parameters`` gives. */
export type ReadCalendarParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly year?: number;
    readonly as_of?: string;
  };
};

/** `GET /api/v1/registry/process-calendar` */
export const readCalendar: OperationSpec<ReadCalendarParams, ProcessCalendarView> = {
  operationId: "read_calendar_api_v1_registry_process_calendar_get",
  method: "GET",
  path: "/api/v1/registry/process-calendar",
  tag: "registry",
  pathParams: [],
  queryParams: ["country_key", "year", "as_of"],
  hasBody: false,
};

/** `GET /api/v1/inseason/campaigns/response` — Read Campaign Response — The market's newest campaign response fit, or the named one. 404 ``planning.inseason.campaign.response_not_fitted`` when the market has none, or the named fit is unknown or out of scope — the designed state "no response fitted yet". */
export type ReadCampaignResponseParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly fit_id?: string | null;
  };
};

/** `GET /api/v1/inseason/campaigns/response` */
export const readCampaignResponse: OperationSpec<ReadCampaignResponseParams, CampaignResponseView> = {
  operationId: "read_campaign_response_api_v1_inseason_campaigns_response_get",
  method: "GET",
  path: "/api/v1/inseason/campaigns/response",
  tag: "inseason",
  pathParams: [],
  queryParams: ["country_key", "fit_id"],
  hasBody: false,
};

/** `GET /api/v1/inseason/campaigns/simulations/{simulation_id}/results` — Read Campaign Results — A campaign simulation's answer. 409 ``not_complete`` until its run has succeeded. Every figure is the median of the draws and its 80% interval. Alternatives are ranked on realised margin only (design D4); net sales and units are shown and never ranked. */
export type ReadCampaignResultsParams = {
  readonly path: {
    readonly simulation_id: string;
  };
};

/** `GET /api/v1/inseason/campaigns/simulations/{simulation_id}/results` */
export const readCampaignResults: OperationSpec<ReadCampaignResultsParams, CampaignResultsView> = {
  operationId: "read_campaign_results_api_v1_inseason_campaigns_simulations__simulation_id__results_get",
  method: "GET",
  path: "/api/v1/inseason/campaigns/simulations/{simulation_id}/results",
  tag: "inseason",
  pathParams: ["simulation_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/campaigns/scope` — Read Campaign Scope — How many articles and doors a scope resolves to, as the run will resolve it. Writes nothing. 409 ``base_forecast_unavailable`` when the base run's forecast can no longer be read. A sub-category is ``CATEGORY::SUB_CATEGORY`` (ADR 6071), or its plain name when that sits under one category only; 422 ``sub_category_ambiguous`` otherwise. ``district_key`` and ``include_article`` / ``exclude_article`` are ADR 6076's; an article key here is counted as the run will count it, and only the request refuses an unknown one. The lifecycle gate (ADR 6078) reads the phase for every month of ``[starts_on, ends_on]`` (``ends_on`` defaults to ``starts_on``) and ``excluded`` names what it keeps out. */
export type ReadCampaignScopeParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly starts_on?: string;
    readonly channel?: "OWN_STORE" | "OUTLET" | "BOTH";
    readonly stores_kind?: "all" | "clusters" | "districts" | "doors";
    readonly cluster_key?: readonly (string)[] | null;
    readonly district_key?: readonly (string)[] | null;
    readonly store_key?: readonly (string)[] | null;
    readonly include_category?: readonly (string)[] | null;
    readonly include_sub_category?: readonly (string)[] | null;
    readonly exclude_category?: readonly (string)[] | null;
    readonly exclude_sub_category?: readonly (string)[] | null;
    readonly include_article?: readonly (string)[] | null;
    readonly exclude_article?: readonly (string)[] | null;
    readonly ends_on?: string | null;
  };
};

/** `GET /api/v1/inseason/campaigns/scope` */
export const readCampaignScope: OperationSpec<ReadCampaignScopeParams, ScopeCountView> = {
  operationId: "read_campaign_scope_api_v1_inseason_campaigns_scope_get",
  method: "GET",
  path: "/api/v1/inseason/campaigns/scope",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id", "starts_on", "channel", "stores_kind", "cluster_key", "district_key", "store_key", "include_category", "include_sub_category", "exclude_category", "exclude_sub_category", "include_article", "exclude_article", "ends_on"],
  hasBody: false,
};

/** `GET /api/v1/inseason/campaigns/scope/articles` — Read Campaign Scope Articles — Which typed article keys the base run's market's article master carries (ADR 6076). Writes nothing. The known come back in the order typed with their name, labels and codes; the unknown are named, never dropped. Compose checks a planner's article list with it before the request, which refuses an unknown key (422 ``article_unknown``). Each known article the lifecycle gate keeps out of a campaign over ``[starts_on, ends_on]`` (default: this month) carries ``excludedReason`` (ADR 6078); the request refuses an include row naming one in Zona Sale or the outlet (422 ``article_in_markdown_phase``). */
export type ReadCampaignScopeArticlesParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly article_key?: readonly (string)[];
    readonly starts_on?: string | null;
    readonly ends_on?: string | null;
  };
};

/** `GET /api/v1/inseason/campaigns/scope/articles` */
export const readCampaignScopeArticles: OperationSpec<ReadCampaignScopeArticlesParams, ScopeArticlesView> = {
  operationId: "read_campaign_scope_articles_api_v1_inseason_campaigns_scope_articles_get",
  method: "GET",
  path: "/api/v1/inseason/campaigns/scope/articles",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id", "article_key", "starts_on", "ends_on"],
  hasBody: false,
};

/** `GET /api/v1/inseason/campaigns/scope/options` — Read Campaign Scope Options — What the scope builder may offer for the base run's market. Writes nothing. */
export type ReadCampaignScopeOptionsParams = {
  readonly query?: {
    readonly run_id?: string;
  };
};

/** `GET /api/v1/inseason/campaigns/scope/options` */
export const readCampaignScopeOptions: OperationSpec<ReadCampaignScopeOptionsParams, ScopeOptionsView> = {
  operationId: "read_campaign_scope_options_api_v1_inseason_campaigns_scope_options_get",
  method: "GET",
  path: "/api/v1/inseason/campaigns/scope/options",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id"],
  hasBody: false,
};

/** `GET /api/v1/inseason/campaigns/simulations/{simulation_id}` — Read Campaign Simulation — One campaign simulation and its run's state. 404 when absent or out of scope, alike. */
export type ReadCampaignSimulationParams = {
  readonly path: {
    readonly simulation_id: string;
  };
};

/** `GET /api/v1/inseason/campaigns/simulations/{simulation_id}` */
export const readCampaignSimulation: OperationSpec<ReadCampaignSimulationParams, CampaignSimulationView> = {
  operationId: "read_campaign_simulation_api_v1_inseason_campaigns_simulations__simulation_id__get",
  method: "GET",
  path: "/api/v1/inseason/campaigns/simulations/{simulation_id}",
  tag: "inseason",
  pathParams: ["simulation_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/landing/clearance-positions/sequence` — Read Clearance Position Sequence — The last ``exit_clearance_position`` sequence this country landed, and the next. **This feed shipped its ``POST`` without it**, which is the failure :func:`read_price_ladder_sequence` calls "the lesson this feed inherits rather than one it has to learn" — arriving again. G-1 refuses a batch whose ``delivery_seq`` is not exactly one greater than the last this partition landed, so a producer with no read has a rule it can only guess at, and the one earlier feed that guessed derived the number from calendar arithmetic that desynchronises permanently on the first re-materialisation of a day. It matters more on this feed than on a reference one. A clearance position is a **snapshot** and reqs/05 §3.4's consolidation lever ranks doors on it, so a producer that guesses, is refused, and moves on leaves the consolidation job reading yesterday's doors in the belief that it read today's — a wrong answer with a green run behind it. Unfiltered by state, as every sibling is: a quarantined batch still occupied its number, so the answer tells a producer both that its last attempt was refused and that the sequence moved on regardless. */
export type ReadClearancePositionSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/clearance-positions/sequence` */
export const readClearancePositionSequence: OperationSpec<ReadClearancePositionSequenceParams, FeedSequenceResponse> = {
  operationId: "read_clearance_position_sequence_api_v1_landing_clearance_positions_sequence_get",
  method: "GET",
  path: "/api/v1/landing/clearance-positions/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/commercial-calendar-week/sequence` — Read Commercial Calendar Week Sequence — The last ``commercial_calendar_week`` sequence this country landed. */
export type ReadCommercialCalendarWeekSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/commercial-calendar-week/sequence` */
export const readCommercialCalendarWeekSequence: OperationSpec<ReadCommercialCalendarWeekSequenceParams, FeedSequenceResponse> = {
  operationId: "read_commercial_calendar_week_sequence_api_v1_landing_commercial_calendar_week_sequence_get",
  method: "GET",
  path: "/api/v1/landing/commercial-calendar-week/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/foundations/cycle-runs` — Read Cycle Runs — Whether the in-season and exit cycles ran for one country, and when they run next. ADR 6035, bata-ui#148 step 1.2. Per cycle: every stage's newest ``platform_job_run`` for the country (state and timings, never output), the cadence the deployment declares, and the orchestrator's newest report of the schedule. Authorised as ``read`` on ``plan_version`` and rewritten by the caller's scope on the country named, so a country outside it reads as nothing ran and nothing reported. **Absence is rendered as absence.** A stage that never ran is ``lastRun: null``; a schedule never reported is ``orchestrator: null``; an undeclared cadence is ``declaredCron: null``. A report older than its interval is still returned with its ``reportedAt``, so a client can say "state unknown since …". Nothing here parses a cron or computes a tick: the next run is the orchestrator's answer or it is not given. */
export type ReadCycleRunsParams = {
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/foundations/cycle-runs` */
export const readCycleRuns: OperationSpec<ReadCycleRunsParams, CycleRunsResponse> = {
  operationId: "read_cycle_runs_api_v1_foundations_cycle_runs_get",
  method: "GET",
  path: "/api/v1/foundations/cycle-runs",
  tag: "foundations",
  pathParams: [],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/demand-exclusion-windows/sequence` — Read Demand Exclusion Window Sequence — The last ``demand_exclusion_window`` sequence this partition landed, and the next. Shipped with the ``POST``, as every B1 feed's is. Also the producer's probe: a platform without this route answers 404, and ``bata-data``'s publisher then lands nothing and says so rather than failing (ADR 9024's deploy order). */
export type ReadDemandExclusionWindowSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/demand-exclusion-windows/sequence` */
export const readDemandExclusionWindowSequence: OperationSpec<ReadDemandExclusionWindowSequenceParams, FeedSequenceResponse> = {
  operationId: "read_demand_exclusion_window_sequence_api_v1_landing_demand_exclusion_windows_sequence_get",
  method: "GET",
  path: "/api/v1/landing/demand-exclusion-windows/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/door-availability-week/sequence` — Read Door Availability Week Sequence — The last ``door_availability_week`` sequence this country landed. Shipped with the ``POST``, as every feed's is: the producer reads it to number its next delivery and to name the batch a full refresh supersedes. */
export type ReadDoorAvailabilityWeekSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/door-availability-week/sequence` */
export const readDoorAvailabilityWeekSequence: OperationSpec<ReadDoorAvailabilityWeekSequenceParams, FeedSequenceResponse> = {
  operationId: "read_door_availability_week_sequence_api_v1_landing_door_availability_week_sequence_get",
  method: "GET",
  path: "/api/v1/landing/door-availability-week/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/registry/process-calendar/due-runs` — Read Due Runs — What the calendar says is due for ``country_key`` on ``on`` (ADR 2136 §6). For the orchestrator only (``integration_service``, as ``/internal/jobs``): bata-data's daily trigger asks once per market and launches each run listed, with the parameters listed. A run already made for its period is never listed again, whichever trigger made it; an execution is not listed on a blackout day. A stream with nothing due says why: ``no_period_of_type`` (no calendar entry: never defaulted), ``no_next_period`` (the calendar ends) or ``run_ahead_not_governed``. */
export type ReadDueRunsParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly on?: string;
  };
};

/** `GET /api/v1/registry/process-calendar/due-runs` */
export const readDueRuns: OperationSpec<ReadDueRunsParams, DueRunsView> = {
  operationId: "read_due_runs_api_v1_registry_process_calendar_due_runs_get",
  method: "GET",
  path: "/api/v1/registry/process-calendar/due-runs",
  tag: "registry",
  pathParams: [],
  queryParams: ["country_key", "on"],
  hasBody: false,
};

/** `GET /api/v1/registry/run-scopes/entries/{kind}/{entry_id}` — Read Entry — One entry: its newest version, every version with the set that wrote it, where it is used. 404 when the market's library holds no such entry. */
export type ReadEntryParams = {
  readonly path: {
    readonly kind: "scope" | "store_selection" | "product_selection";
    readonly entry_id: string;
  };
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/registry/run-scopes/entries/{kind}/{entry_id}` */
export const readEntry: OperationSpec<ReadEntryParams, EntryDetailView> = {
  operationId: "read_entry_api_v1_registry_run_scopes_entries__kind___entry_id__get",
  method: "GET",
  path: "/api/v1/registry/run-scopes/entries/{kind}/{entry_id}",
  tag: "registry",
  pathParams: ["kind", "entry_id"],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /api/v1/exit/consolidation/simulations/{simulation_id}` — Read Exit Simulation — One simulation and its runs' states. 404 when absent or out of scope, alike. */
export type ReadExitSimulationParams = {
  readonly path: {
    readonly simulation_id: string;
  };
};

/** `GET /api/v1/exit/consolidation/simulations/{simulation_id}` */
export const readExitSimulation: OperationSpec<ReadExitSimulationParams, ExitSimulationView> = {
  operationId: "read_exit_simulation_api_v1_exit_consolidation_simulations__simulation_id__get",
  method: "GET",
  path: "/api/v1/exit/consolidation/simulations/{simulation_id}",
  tag: "exit",
  pathParams: ["simulation_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/landing/forecast-explanations/sequence` — Read Forecast Explanation Sequence — The last ``forecast_explanation`` sequence this partition landed, and the next. */
export type ReadForecastExplanationSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/forecast-explanations/sequence` */
export const readForecastExplanationSequence: OperationSpec<ReadForecastExplanationSequenceParams, FeedSequenceResponse> = {
  operationId: "read_forecast_explanation_sequence_api_v1_landing_forecast_explanations_sequence_get",
  method: "GET",
  path: "/api/v1/landing/forecast-explanations/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/forecast-quantiles/sequence` — Read Forecast Quantile Sequence — The last ``forecast_quantile`` sequence this country landed, and the next. Shipped with the ``POST``, as ``location-master``'s was: G-1 refuses a batch whose ``delivery_seq`` is not one more than the partition's last, and a producer that cannot read the number can only guess it. */
export type ReadForecastQuantileSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/forecast-quantiles/sequence` */
export const readForecastQuantileSequence: OperationSpec<ReadForecastQuantileSequenceParams, FeedSequenceResponse> = {
  operationId: "read_forecast_quantile_sequence_api_v1_landing_forecast_quantiles_sequence_get",
  method: "GET",
  path: "/api/v1/landing/forecast-quantiles/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/registry/process-calendar/history` — Read History — Every approved version of the market's periods (of ``year``'s periods, when given), oldest first, each with the set that wrote it: who proposed it, who approved it, why. */
export type ReadHistoryParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly year?: number | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/registry/process-calendar/history` */
export const readHistory: OperationSpec<ReadHistoryParams, CursorPagePeriodVersionView> = {
  operationId: "read_history_api_v1_registry_process_calendar_history_get",
  method: "GET",
  path: "/api/v1/registry/process-calendar/history",
  tag: "registry",
  pathParams: [],
  queryParams: ["country_key", "year", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/product-images/{article_key}` — Every presignable rendition of one article, with its provenance — The detail panel's read. Carries every rendition of one photograph, each with its own expiry, and the provenance of the source image as the index records it — `recorded: false` where it carries none. `sequence` selects which photograph; the default is the primary one, and `availableSequences` names the rest, since an article may carry several and their numbers have gaps. An article with no image is `absent` with a reason, which is the ordinary answer: the corpus covers about 2.4% of the 110,063-row article master and is biased towards articles listed on the e-commerce storefront today. `width` narrows the response to one rendition and must be 96, 240, 480 or 960; a width absent from `availableWidths` was absent at the source and is never substituted. */
export type ReadImageSetParams = {
  readonly path: {
    readonly article_key: string;
  };
  readonly query?: {
    readonly width?: number | null;
    readonly sequence?: number | null;
  };
};

/** `GET /api/v1/product-images/{article_key}` */
export const readImageSet: OperationSpec<ReadImageSetParams, ProductImageSet> = {
  operationId: "read_image_set_api_v1_product_images__article_key__get",
  method: "GET",
  path: "/api/v1/product-images/{article_key}",
  tag: "product-images",
  pathParams: ["article_key"],
  queryParams: ["width", "sequence"],
  hasBody: false,
};

/** `GET /api/v1/landing/landed-cost/sequence` — Read Landed Cost Sequence — The last ``landed_cost`` sequence this country landed, and the next. The sibling of :func:`read_price_ladder_sequence`, for the same reason and on its own path rather than a ``feed`` query parameter: the ``GET``s hold the "one feed, one route" line the ``POST``s do. ``last_delivery_seq`` counts **quarantined batches too**, deliberately — a refused batch still occupied its number, so a producer reading this learns both that its previous attempt was refused and that the sequence moved on regardless. */
export type ReadLandedCostSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/landed-cost/sequence` */
export const readLandedCostSequence: OperationSpec<ReadLandedCostSequenceParams, FeedSequenceResponse> = {
  operationId: "read_landed_cost_sequence_api_v1_landing_landed_cost_sequence_get",
  method: "GET",
  path: "/api/v1/landing/landed-cost/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/batches/{batch_id}` — Read Landing Batch — Whether a batch landed, is being landed now, or never arrived (ADR 1021). The read a producer makes **instead of re-sending** when a landing's response was lost (a client timeout, a dropped connection): see :class:`LandingBatchStatusResponse`. Read under the same role and scope as every ``/sequence`` read. The recorded verdict wins over an attempt in flight, so a batch that is both reads as recorded. */
export type ReadLandingBatchParams = {
  readonly path: {
    readonly batch_id: string;
  };
};

/** `GET /api/v1/landing/batches/{batch_id}` */
export const readLandingBatch: OperationSpec<ReadLandingBatchParams, LandingBatchStatusResponse> = {
  operationId: "read_landing_batch_api_v1_landing_batches__batch_id__get",
  method: "GET",
  path: "/api/v1/landing/batches/{batch_id}",
  tag: "landing",
  pathParams: ["batch_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/landing/lane-rate-cards/sequence` — Read Lane Rate Card Sequence — The last ``exit_lane_rate_card`` sequence this country landed, and the next. The same read for the tariff feed, and it has the same argument the ladder's does about a reference feed with no computable cadence: `14` §4 classes a rate card **C — periodic reference**, delivered "on change, minimum quarterly", so there is no date arithmetic a producer could stand in for this read with, even badly. Note what is *not* here, and why: ``/landing/hierarchy-schemes`` has no ``/sequence`` sibling and cannot honestly have one. It is not a row feed — :func:`land_hierarchy_scheme` says so in its own first paragraph — so it writes no ``feed_batch`` row, occupies no delivery-sequence space and has no manifest. A route in this shape would answer "the next sequence is 1" forever, which is a number that means nothing rather than a number that is missing. */
export type ReadLaneRateCardSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/lane-rate-cards/sequence` */
export const readLaneRateCardSequence: OperationSpec<ReadLaneRateCardSequenceParams, FeedSequenceResponse> = {
  operationId: "read_lane_rate_card_sequence_api_v1_landing_lane_rate_cards_sequence_get",
  method: "GET",
  path: "/api/v1/landing/lane-rate-cards/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/admin/user-activity/last-access` — Read Last Access — Each named person's last access: their newest sign-in, token exchange or refresh. For User management's «last access» column (ADR 9029). Over the broker's whole retention (two years); ``null`` when it holds none. ``user`` is required, repeated, one to fifty (422 ``platform.admin.last_access_users_invalid``). Administrator only, as every read here. */
export type ReadLastAccessParams = {
  readonly query?: {
    readonly user?: readonly (string)[] | null;
  };
};

/** `GET /api/v1/admin/user-activity/last-access` */
export const readLastAccess: OperationSpec<ReadLastAccessParams, UserLastAccessList> = {
  operationId: "read_last_access_api_v1_admin_user_activity_last_access_get",
  method: "GET",
  path: "/api/v1/admin/user-activity/last-access",
  tag: "admin",
  pathParams: [],
  queryParams: ["user"],
  hasBody: false,
};

/** `GET /api/v1/landing/lifecycle-curve-assignments/sequence` — Read Lifecycle Curve Assignment Sequence — The last ``inseason_lifecycle_curve_assignment`` sequence this partition landed. */
export type ReadLifecycleCurveAssignmentSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/lifecycle-curve-assignments/sequence` */
export const readLifecycleCurveAssignmentSequence: OperationSpec<ReadLifecycleCurveAssignmentSequenceParams, FeedSequenceResponse> = {
  operationId: "read_lifecycle_curve_assignment_sequence_api_v1_landing_lifecycle_curve_assignments_sequence_get",
  method: "GET",
  path: "/api/v1/landing/lifecycle-curve-assignments/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/lifecycle-curves/sequence` — Read Lifecycle Curve Sequence — The last ``inseason_lifecycle_curve`` sequence this partition landed. */
export type ReadLifecycleCurveSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/lifecycle-curves/sequence` */
export const readLifecycleCurveSequence: OperationSpec<ReadLifecycleCurveSequenceParams, FeedSequenceResponse> = {
  operationId: "read_lifecycle_curve_sequence_api_v1_landing_lifecycle_curves_sequence_get",
  method: "GET",
  path: "/api/v1/landing/lifecycle-curves/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/location-master/sequence` — Read Location Master Sequence — The last ``location_master`` sequence this country landed, and the next. Shipped with the ``POST`` rather than a PR behind it, which is the one thing this feed does differently from its two neighbours. G-1 refuses a batch whose ``delivery_seq`` is not exactly one greater than the last this partition landed; a write path without this read hands the producer a rule it can only guess at, and both previous feeds guessed — one of them from calendar arithmetic that desynchronises permanently the first time a partition is re-materialised. A door master is re-delivered on no cadence at all: it changes when a door opens, closes, is re-formatted or is re-assigned to another DC. There is no date arithmetic that could stand in for this read even badly. ``last_delivery_seq`` counts **quarantined batches too**, deliberately — a refused batch still occupied its number, so a producer reading this learns both that its previous attempt was refused and that the sequence moved on regardless. */
export type ReadLocationMasterSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/location-master/sequence` */
export const readLocationMasterSequence: OperationSpec<ReadLocationMasterSequenceParams, FeedSequenceResponse> = {
  operationId: "read_location_master_sequence_api_v1_landing_location_master_sequence_get",
  method: "GET",
  path: "/api/v1/landing/location-master/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/foundations/modules` — Read Modules — Each DEC-06 module's effective state for one country (W1-7, ADR 1004). ``enabled``, ``cadence`` and ``excluded_doors`` as the registry resolves them for the country today — the row in force, where it came from (country, estate or the default) and who approved it — so a screen can say "paused since X, approved by Y". Authorised as the registry's own ``read`` on ``parameter`` (DEC-41): planners hold it, and so does the orchestrator's ``integration_service``, which gates its triggers on this read. The grant is unbounded (the registry carries no plan number), so any country resolves; a bounded grant would still rewrite on the country named. */
export type ReadModulesParams = {
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/foundations/modules` */
export const readModules: OperationSpec<ReadModulesParams, ModulesResponse> = {
  operationId: "read_modules_api_v1_foundations_modules_get",
  method: "GET",
  path: "/api/v1/foundations/modules",
  tag: "foundations",
  pathParams: [],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /api/v1/compacting/simulations/{simulation_id}` — Read Move Run Simulation — One simulation and its state; poll it while it runs. 404 when absent or out of scope. */
export type ReadMoveRunSimulationParams = {
  readonly path: {
    readonly simulation_id: string;
  };
};

/** `GET /api/v1/compacting/simulations/{simulation_id}` */
export const readMoveRunSimulation: OperationSpec<ReadMoveRunSimulationParams, MoveRunSimulationView> = {
  operationId: "read_move_run_simulation_api_v1_compacting_simulations__simulation_id__get",
  method: "GET",
  path: "/api/v1/compacting/simulations/{simulation_id}",
  tag: "compacting",
  pathParams: ["simulation_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/me/feedback/{code}` — Read My Report — One of the caller's own reports in full, with the thread and the history. 404 otherwise. The history shows the statuses and when, never who on the team moved them. */
export type ReadMyReportParams = {
  readonly path: {
    readonly code: string;
  };
};

/** `GET /api/v1/me/feedback/{code}` */
export const readMyReport: OperationSpec<ReadMyReportParams, FeedbackDetail> = {
  operationId: "read_my_report_api_v1_me_feedback__code__get",
  method: "GET",
  path: "/api/v1/me/feedback/{code}",
  tag: "feedback",
  pathParams: ["code"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/landing/outlet-door-position/sequence` — Read Outlet Door Position Sequence — The last ``outlet_door_position`` sequence this country-day landed, and the next. */
export type ReadOutletDoorPositionSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/outlet-door-position/sequence` */
export const readOutletDoorPositionSequence: OperationSpec<ReadOutletDoorPositionSequenceParams, FeedSequenceResponse> = {
  operationId: "read_outlet_door_position_sequence_api_v1_landing_outlet_door_position_sequence_get",
  method: "GET",
  path: "/api/v1/landing/outlet-door-position/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/exit/plans/{exit_plan_id}` — One exit plan record — The row `/exit/plans` lists, fetched by its identifier. A list with no detail read makes a drill into one plan a re-page of the collection, and a bookmarked link to a plan unresolvable. A plan outside the caller's scope answers 404 rather than 403: a refusal that confirmed the record exists would answer the question it refuses (G3.3). */
export type ReadPlanParams = {
  readonly path: {
    readonly exit_plan_id: string;
  };
};

/** `GET /api/v1/exit/plans/{exit_plan_id}` */
export const readPlan: OperationSpec<ReadPlanParams, ExitPlanSummary> = {
  operationId: "read_plan_api_v1_exit_plans__exit_plan_id__get",
  method: "GET",
  path: "/api/v1/exit/plans/{exit_plan_id}",
  tag: "exit",
  pathParams: ["exit_plan_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/landing/postseason-availability-census/sequence` — Read Postseason Availability Census Sequence — The last ``postseason_availability_census`` sequence this country landed. */
export type ReadPostseasonAvailabilityCensusSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/postseason-availability-census/sequence` */
export const readPostseasonAvailabilityCensusSequence: OperationSpec<ReadPostseasonAvailabilityCensusSequenceParams, FeedSequenceResponse> = {
  operationId: "read_postseason_availability_census_sequence_api_v1_landing_postseason_availability_census_sequence_get",
  method: "GET",
  path: "/api/v1/landing/postseason-availability-census/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/postseason-availability-week/sequence` — Read Postseason Availability Week Sequence — The last ``postseason_availability_week`` sequence this country landed. */
export type ReadPostseasonAvailabilityWeekSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/postseason-availability-week/sequence` */
export const readPostseasonAvailabilityWeekSequence: OperationSpec<ReadPostseasonAvailabilityWeekSequenceParams, FeedSequenceResponse> = {
  operationId: "read_postseason_availability_week_sequence_api_v1_landing_postseason_availability_week_sequence_get",
  method: "GET",
  path: "/api/v1/landing/postseason-availability-week/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/postseason-availability-week-to-date/sequence` — Read Postseason Availability Week To Date Sequence — The last ``postseason_availability_week_to_date`` sequence this country landed. */
export type ReadPostseasonAvailabilityWeekToDateSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/postseason-availability-week-to-date/sequence` */
export const readPostseasonAvailabilityWeekToDateSequence: OperationSpec<ReadPostseasonAvailabilityWeekToDateSequenceParams, FeedSequenceResponse> = {
  operationId: "read_postseason_availability_week_to_date_sequence_api_v1_landing_postseason_availability_week_to_date_sequence_get",
  method: "GET",
  path: "/api/v1/landing/postseason-availability-week-to-date/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/price-ladder/sequence` — Read Price Ladder Sequence — The last ``price_ladder`` sequence this country landed, and the next. Shipped with its ``POST``, as the door master's was and as the first two feeds' were not. G-1 refuses a batch whose ``delivery_seq`` is not exactly one greater than the last this partition landed, and a write path without this read hands the producer a rule it can only guess at — one of the earlier feeds guessed from calendar arithmetic that desynchronises permanently on the first re-materialisation of a day. A ladder is `14` §4 cadence class **C**: delivered ahead of the period it governs, and re-delivered whenever a merchant changes a price point. There is no arithmetic that could stand in for this read even badly. */
export type ReadPriceLadderSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/price-ladder/sequence` */
export const readPriceLadderSequence: OperationSpec<ReadPriceLadderSequenceParams, FeedSequenceResponse> = {
  operationId: "read_price_ladder_sequence_api_v1_landing_price_ladder_sequence_get",
  method: "GET",
  path: "/api/v1/landing/price-ladder/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/price-observations/sequence` — Read Price Observation Sequence — The last ``price_observation`` sequence this country landed, and the next. **The read the gate always assumed somebody could make.** :func:`services.integrations.landing.land` refuses a batch whose ``delivery_seq`` is not exactly one greater than the last one this partition landed, and this router exposed no way to discover that number — so a re-materialisation in ``bata-data`` had the sequence carried across by hand, which is a gate whose input is a guess and a wedge waiting for the first multi-batch rebuild. Scoped like every other read in this service, and not by a filter in this handler: :func:`~services.repositories.access.scoped_statement` authorises the principal against the register and hands the scope it produced to :func:`~services.repositories.inseason.latest_price_batch_statement`, which rewrites the statement with it. A caller the register refuses gets a 403 from the shared handler before a connection is opened. Two gates, deliberately, and they answer different questions. The role check is the same :data:`REQUIRED_ROLE` the ``POST`` applies, so the credential that lands a batch is the credential that can read its own sequence and no wider principal is admitted to this router by having a permission row. The register is what bounds *which rows* come back. */
export type ReadPriceObservationSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/price-observations/sequence` */
export const readPriceObservationSequence: OperationSpec<ReadPriceObservationSequenceParams, FeedSequenceResponse> = {
  operationId: "read_price_observation_sequence_api_v1_landing_price_observations_sequence_get",
  method: "GET",
  path: "/api/v1/landing/price-observations/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/product-attribute-master/sequence` — Read Product Attribute Master Sequence — The last ``product_attribute_master`` sequence this country landed, and the next. Shipped with the ``POST`` rather than a release behind it — the lesson this feed inherits rather than one it has to learn. G-1 refuses a batch whose ``delivery_seq`` is not exactly one greater than the last this partition landed, and the first two feeds in this store shipped a write path with no way to read that number; one of them then derived it from calendar arithmetic that desynchronises permanently on the first re-materialisation. ``daily_delta`` is exactly the cadence that invites that mistake and must not be used for it. `13` M1 requires the trailing 24 months to be attributable, so a backfill delivery and a daily one are the same feed sharing one sequence, and no date arithmetic can stand in for this read even badly. ``last_delivery_seq`` counts **quarantined batches too**, deliberately — a refused batch still occupied its number, so a producer reading this learns both that its previous attempt was refused and that the sequence moved on regardless. */
export type ReadProductAttributeMasterSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/product-attribute-master/sequence` */
export const readProductAttributeMasterSequence: OperationSpec<ReadProductAttributeMasterSequenceParams, FeedSequenceResponse> = {
  operationId: "read_product_attribute_master_sequence_api_v1_landing_product_attribute_master_sequence_get",
  method: "GET",
  path: "/api/v1/landing/product-attribute-master/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/product-image-index/sequence` — Read Product Image Index Sequence — The last ``product_image_index`` sequence this country landed, and the next. Shipped with the ``POST``: G-1 refuses a ``delivery_seq`` that is not exactly one more than the last, and a producer with no read can only guess. */
export type ReadProductImageIndexSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/product-image-index/sequence` */
export const readProductImageIndexSequence: OperationSpec<ReadProductImageIndexSequenceParams, FeedSequenceResponse> = {
  operationId: "read_product_image_index_sequence_api_v1_landing_product_image_index_sequence_get",
  method: "GET",
  path: "/api/v1/landing/product-image-index/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/programme-cover-and-terminal-stock/sequence` — Read Programme Cover And Terminal Stock Sequence — The last cover-and-terminal-stock sequence this partition landed, and the next. */
export type ReadProgrammeCoverAndTerminalStockSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/programme-cover-and-terminal-stock/sequence` */
export const readProgrammeCoverAndTerminalStockSequence: OperationSpec<ReadProgrammeCoverAndTerminalStockSequenceParams, FeedSequenceResponse> = {
  operationId: "read_programme_cover_and_terminal_stock_sequence_api_v1_landing_programme_cover_and_terminal_stock_sequence_get",
  method: "GET",
  path: "/api/v1/landing/programme-cover-and-terminal-stock/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/programme-gate-evidence/sequence` — Read Programme Gate Evidence Sequence — The last gate-evidence sequence this partition landed, and the next. */
export type ReadProgrammeGateEvidenceSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/programme-gate-evidence/sequence` */
export const readProgrammeGateEvidenceSequence: OperationSpec<ReadProgrammeGateEvidenceSequenceParams, FeedSequenceResponse> = {
  operationId: "read_programme_gate_evidence_sequence_api_v1_landing_programme_gate_evidence_sequence_get",
  method: "GET",
  path: "/api/v1/landing/programme-gate-evidence/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/programme-lost-units/sequence` — Read Programme Lost Units Sequence — The last lost-units sequence this partition landed, and the next. */
export type ReadProgrammeLostUnitsSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/programme-lost-units/sequence` */
export const readProgrammeLostUnitsSequence: OperationSpec<ReadProgrammeLostUnitsSequenceParams, FeedSequenceResponse> = {
  operationId: "read_programme_lost_units_sequence_api_v1_landing_programme_lost_units_sequence_get",
  method: "GET",
  path: "/api/v1/landing/programme-lost-units/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/programme-matched-control-panel/sequence` — Read Programme Matched Control Panel Sequence — The last matched-control panel sequence this partition landed, and the next. */
export type ReadProgrammeMatchedControlPanelSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/programme-matched-control-panel/sequence` */
export const readProgrammeMatchedControlPanelSequence: OperationSpec<ReadProgrammeMatchedControlPanelSequenceParams, FeedSequenceResponse> = {
  operationId: "read_programme_matched_control_panel_sequence_api_v1_landing_programme_matched_control_panel_sequence_get",
  method: "GET",
  path: "/api/v1/landing/programme-matched-control-panel/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/programme-seasonal-naive-baseline/sequence` — Read Programme Seasonal Naive Baseline Sequence — The last seasonal-naive baseline sequence this partition landed, and the next. */
export type ReadProgrammeSeasonalNaiveBaselineSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/programme-seasonal-naive-baseline/sequence` */
export const readProgrammeSeasonalNaiveBaselineSequence: OperationSpec<ReadProgrammeSeasonalNaiveBaselineSequenceParams, FeedSequenceResponse> = {
  operationId: "read_programme_seasonal_naive_baseline_sequence_api_v1_landing_programme_seasonal_naive_baseline_sequence_get",
  method: "GET",
  path: "/api/v1/landing/programme-seasonal-naive-baseline/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/price-observations/promoted-batch` — Read Promoted Price Batch — The promoted, unsuperseded ``price_observation`` batch for one partition. **The lookup that makes supersession usable by a producer that did not write the batch it is replacing.** Since PR #27 the read side genuinely resolves ``manifest.supersedes_batch_id``, so naming a predecessor is what makes a re-materialisation replace a window instead of doubling it — and no HTTP route answered what to name. :func:`~services.integrations.landing.latest_promoted_batch_statement` computed it all along, indexed and tested, with no caller in ``services/api/`` at all. The consequence was not theoretical. The 2026-09-10 price-panel re-materialisation reconstructed each of six predecessors' ``batch_id`` from the producing module's own digest recipe, because there was nothing to ask. That was sound for a fixed, known, finite set with a fail-closed error mode — a wrong reconstruction names a batch no row holds, so ``supersedes_unknown`` refuses the manifest — but it is a migration mechanism, and any producer whose predecessor's digest inputs it cannot reproduce had no option whatsoever. ``period_key`` is required, and that is the whole point of the route. The sequence read beside it is keyed on ``country_key`` alone because the ``delivery_seq`` space is shared across a feed's partitions for one country, which is correct for its own question and wrong for this one: the batch it names is the last batch of the *feed*, not of the partition being replaced. Taking that ``batch_id`` as a predecessor is how a cross-period pointer gets written, which until this release the write gate did not refuse. Scoped the same way as every other read here — the register authorises the principal and rewrites the statement, rather than this handler filtering — and behind the same :data:`REQUIRED_ROLE` the ``POST`` applies, so the credential that lands a batch is the credential that can discover what it supersedes. */
export type ReadPromotedPriceBatchParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/price-observations/promoted-batch` */
export const readPromotedPriceBatch: OperationSpec<ReadPromotedPriceBatchParams, PromotedBatchResponse> = {
  operationId: "read_promoted_price_batch_api_v1_landing_price_observations_promoted_batch_get",
  method: "GET",
  path: "/api/v1/landing/price-observations/promoted-batch",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/promotion-article-day/sequence` — Read Promotion Article Day Sequence — The last ``promotion_article_day`` sequence this country landed for the day. */
export type ReadPromotionArticleDaySequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/promotion-article-day/sequence` */
export const readPromotionArticleDaySequence: OperationSpec<ReadPromotionArticleDaySequenceParams, FeedSequenceResponse> = {
  operationId: "read_promotion_article_day_sequence_api_v1_landing_promotion_article_day_sequence_get",
  method: "GET",
  path: "/api/v1/landing/promotion-article-day/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/promotion-mechanic-impact/sequence` — Read Promotion Mechanic Impact Sequence — The last ``promotion_mechanic_impact`` sequence this country landed. */
export type ReadPromotionMechanicImpactSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/promotion-mechanic-impact/sequence` */
export const readPromotionMechanicImpactSequence: OperationSpec<ReadPromotionMechanicImpactSequenceParams, FeedSequenceResponse> = {
  operationId: "read_promotion_mechanic_impact_sequence_api_v1_landing_promotion_mechanic_impact_sequence_get",
  method: "GET",
  path: "/api/v1/landing/promotion-mechanic-impact/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/promotion-window-door/sequence` — Read Promotion Window Door Sequence — The last ``promotion_window_door`` sequence this country landed. */
export type ReadPromotionWindowDoorSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/promotion-window-door/sequence` */
export const readPromotionWindowDoorSequence: OperationSpec<ReadPromotionWindowDoorSequenceParams, FeedSequenceResponse> = {
  operationId: "read_promotion_window_door_sequence_api_v1_landing_promotion_window_door_sequence_get",
  method: "GET",
  path: "/api/v1/landing/promotion-window-door/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/promotion-window-door-subcategory/sequence` — Read Promotion Window Door Subcategory Sequence — The last ``promotion_window_door_subcategory`` sequence this country landed for one window (``period_key`` = the window's first day, ``YYYYMMDD``). */
export type ReadPromotionWindowDoorSubcategorySequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/promotion-window-door-subcategory/sequence` */
export const readPromotionWindowDoorSubcategorySequence: OperationSpec<ReadPromotionWindowDoorSubcategorySequenceParams, FeedSequenceResponse> = {
  operationId: "read_promotion_window_door_subcategory_sequence_api_v1_landing_promotion_window_door_subcategory_sequence_get",
  method: "GET",
  path: "/api/v1/landing/promotion-window-door-subcategory/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/promotion-window-impact/sequence` — Read Promotion Window Impact Sequence — The last ``promotion_window_impact`` sequence this country landed. */
export type ReadPromotionWindowImpactSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/promotion-window-impact/sequence` */
export const readPromotionWindowImpactSequence: OperationSpec<ReadPromotionWindowImpactSequenceParams, FeedSequenceResponse> = {
  operationId: "read_promotion_window_impact_sequence_api_v1_landing_promotion_window_impact_sequence_get",
  method: "GET",
  path: "/api/v1/landing/promotion-window-impact/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/promotion-window/sequence` — Read Promotion Window Sequence — The last ``promotion_window`` sequence this country landed. */
export type ReadPromotionWindowSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/promotion-window/sequence` */
export const readPromotionWindowSequence: OperationSpec<ReadPromotionWindowSequenceParams, FeedSequenceResponse> = {
  operationId: "read_promotion_window_sequence_api_v1_landing_promotion_window_sequence_get",
  method: "GET",
  path: "/api/v1/landing/promotion-window/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/outbox/batches/{batch_id}/events` — Read Published Batch Events — One page of a published batch's events, ascending ``event_id``, after ``after_event_id``. 404 ``platform.outbox.batch_not_found`` for a batch that is not published, so a quarantined batch's events are no more reachable here than on any other read. */
export type ReadPublishedBatchEventsParams = {
  readonly path: {
    readonly batch_id: string;
  };
  readonly query?: {
    readonly after_event_id?: string | null;
    readonly limit?: number;
  };
};

/** `GET /api/v1/outbox/batches/{batch_id}/events` */
export const readPublishedBatchEvents: OperationSpec<ReadPublishedBatchEventsParams, OutboxEventPage> = {
  operationId: "read_published_batch_events_api_v1_outbox_batches__batch_id__events_get",
  method: "GET",
  path: "/api/v1/outbox/batches/{batch_id}/events",
  tag: "outbox",
  pathParams: ["batch_id"],
  queryParams: ["after_event_id", "limit"],
  hasBody: false,
};

/** `GET /api/v1/outbox/batches` — Read Published Batches — Published batches of one event type after ``since_delivery_seq``, each whole. A page over :data:`WHOLE_READ_MAX_EVENTS` events is shortened at a delivery position; a first position over it alone is refused with 409 — read ``/outbox/manifests`` and ``/outbox/batches/{batch_id}/events`` instead (ADR 1008). */
export type ReadPublishedBatchesParams = {
  readonly query?: {
    readonly event_type?: string;
    readonly since_delivery_seq?: number;
    readonly limit?: number;
  };
};

/** `GET /api/v1/outbox/batches` */
export const readPublishedBatches: OperationSpec<ReadPublishedBatchesParams, OutboxBatchPage> = {
  operationId: "read_published_batches_api_v1_outbox_batches_get",
  method: "GET",
  path: "/api/v1/outbox/batches",
  tag: "outbox",
  pathParams: [],
  queryParams: ["event_type", "since_delivery_seq", "limit"],
  hasBody: false,
};

/** `GET /api/v1/outbox/manifests` — Read Published Manifests — Published batch manifests of one event type after ``since_delivery_seq``, no events. The selection, the order, the cursor and the tie rule are ``/outbox/batches``'s. */
export type ReadPublishedManifestsParams = {
  readonly query?: {
    readonly event_type?: string;
    readonly since_delivery_seq?: number;
    readonly limit?: number;
  };
};

/** `GET /api/v1/outbox/manifests` */
export const readPublishedManifests: OperationSpec<ReadPublishedManifestsParams, OutboxManifestPage> = {
  operationId: "read_published_manifests_api_v1_outbox_manifests_get",
  method: "GET",
  path: "/api/v1/outbox/manifests",
  tag: "outbox",
  pathParams: [],
  queryParams: ["event_type", "since_delivery_seq", "limit"],
  hasBody: false,
};

/** `GET /api/v1/product-images` — Compact image references for a set of articles — no URLs — One compact reference per `articleKey`, in the order asked, carrying no presigned URL. This is the shape of the product-image field on an article row: a status, the primary sequence, the rendition widths that exist for it and a stable content token, so a list response stays small and cacheable. `primarySequence` is the lowest photograph number with a served rendition — numbers have gaps and do not start at 1, so it cannot be inferred. `availableWidths` is what exists: a width absent from it was absent at the source and is never substituted, so take the largest width present rather than assuming 960. Bounded: at least one and at most 200 article keys. Image presence is a fact about a storefront listing and is not a measure — it must not be aggregated, ranked or filtered on. */
export type ReadReferencesParams = {
  readonly query?: {
    readonly articleKey?: readonly (string)[] | null;
  };
};

/** `GET /api/v1/product-images` */
export const readReferences: OperationSpec<ReadReferencesParams, ProductImageReferences> = {
  operationId: "read_references_api_v1_product_images_get",
  method: "GET",
  path: "/api/v1/product-images",
  tag: "product-images",
  pathParams: [],
  queryParams: ["articleKey"],
  hasBody: false,
};

/** `GET /api/v1/landing/reforecast-signal-weeks/sequence` — Read Reforecast Signal Week Sequence — The last ``inseason_reforecast_signal_week`` sequence this week's partition landed. */
export type ReadReforecastSignalWeekSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/reforecast-signal-weeks/sequence` */
export const readReforecastSignalWeekSequence: OperationSpec<ReadReforecastSignalWeekSequenceParams, FeedSequenceResponse> = {
  operationId: "read_reforecast_signal_week_sequence_api_v1_landing_reforecast_signal_weeks_sequence_get",
  method: "GET",
  path: "/api/v1/landing/reforecast-signal-weeks/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/internal/jobs/relaunch-admission` — Read Relaunch Admission — The orchestrator's dry run of a missed-tick relaunch (ADR 6047, W1-4). The same rule ``POST /{job_name}/runs`` applies to an in-season stage carrying a ``cycle_tick``, so the dry run and the write cannot disagree. Same role as every route here; reads, records nothing. */
export type ReadRelaunchAdmissionParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly cycle_tick?: string;
  };
};

/** `GET /api/v1/internal/jobs/relaunch-admission` */
export const readRelaunchAdmission: OperationSpec<ReadRelaunchAdmissionParams, RelaunchAdmission> = {
  operationId: "read_relaunch_admission_api_v1_internal_jobs_relaunch_admission_get",
  method: "GET",
  path: "/api/v1/internal/jobs/relaunch-admission",
  tag: "internal",
  pathParams: [],
  queryParams: ["country_key", "cycle_tick"],
  hasBody: false,
};

/** `GET /api/v1/product-images/renditions` — Presigned renditions for a set of articles — One presigned set per `articleKey`, in the order asked, each for that article's primary sequence. The batch the virtualised grid resolves for the rows a planner can see. Bounded: at least one and at most 200 article keys. `width` narrows each set to one rendition; it must be 96, 240, 480 or 960, and the archived 1500-pixel original is refused rather than signed. A width absent from `availableWidths` was absent at the source and is never substituted. */
export type ReadRenditionsParams = {
  readonly query?: {
    readonly articleKey?: readonly (string)[] | null;
    readonly width?: number | null;
  };
};

/** `GET /api/v1/product-images/renditions` */
export const readRenditions: OperationSpec<ReadRenditionsParams, ProductImageSets> = {
  operationId: "read_renditions_api_v1_product_images_renditions_get",
  method: "GET",
  path: "/api/v1/product-images/renditions",
  tag: "product-images",
  pathParams: [],
  queryParams: ["articleKey", "width"],
  hasBody: false,
};

/** `GET /api/v1/feedback/{code}` — Read Report — One report in full: content, thread, history, its content digest, and what this viewer may do with it. */
export type ReadReportParams = {
  readonly path: {
    readonly code: string;
  };
};

/** `GET /api/v1/feedback/{code}` */
export const readReport: OperationSpec<ReadReportParams, TriageDetail> = {
  operationId: "read_report_api_v1_feedback__code__get",
  method: "GET",
  path: "/api/v1/feedback/{code}",
  tag: "feedback",
  pathParams: ["code"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/landing/retail-calendar/sequence` — Read Retail Calendar Sequence — The last ``retail_calendar`` sequence this country landed, and the next. Shipped with its ``POST``, as the fourth and fifth feeds' were and as the first two feeds' were not. G-1 refuses a batch whose ``delivery_seq`` is not exactly one greater than the last this partition landed, and a write path without this read hands the producer a rule it can only guess at — one of the earlier feeds guessed from calendar arithmetic that desynchronises permanently on the first re-materialisation of a day. There is no arithmetic that could stand in for this read even badly here. 13 M6's cadence is "annual publication, in-year amendments on change", so the gap between two deliveries is a business event rather than a period, and a producer inferring its sequence from the year would collide with itself on the first amendment. ``last_delivery_seq`` counts **quarantined batches too**, deliberately — a refused batch still occupied its number, so a producer reading this learns both that its previous attempt was refused and that the sequence moved on regardless. */
export type ReadRetailCalendarSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/retail-calendar/sequence` */
export const readRetailCalendarSequence: OperationSpec<ReadRetailCalendarSequenceParams, FeedSequenceResponse> = {
  operationId: "read_retail_calendar_sequence_api_v1_landing_retail_calendar_sequence_get",
  method: "GET",
  path: "/api/v1/landing/retail-calendar/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/retail-price/sequence` — Read Retail Price Sequence — The last ``retail_price`` sequence this partition landed, the next, and the batch in force — :func:`read_landed_cost_sequence` for M7's price half. */
export type ReadRetailPriceSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/retail-price/sequence` */
export const readRetailPriceSequence: OperationSpec<ReadRetailPriceSequenceParams, FeedSequenceResponse> = {
  operationId: "read_retail_price_sequence_api_v1_landing_retail_price_sequence_get",
  method: "GET",
  path: "/api/v1/landing/retail-price/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/returns-transactions/sequence` — Read Returns Transaction Sequence — The last ``returns_transaction`` sequence this country landed, and the next. Its own path rather than a ``feed`` query parameter on the route above: the ``GET``s hold the "one feed, one route" line the ``POST``s do. Not merely symmetry — the two feeds have independent sequences, and a producer handed the sales sequence for a returns batch would be refused by G-1 once per delivery until it stopped asking. */
export type ReadReturnsTransactionSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/returns-transactions/sequence` */
export const readReturnsTransactionSequence: OperationSpec<ReadReturnsTransactionSequenceParams, FeedSequenceResponse> = {
  operationId: "read_returns_transaction_sequence_api_v1_landing_returns_transactions_sequence_get",
  method: "GET",
  path: "/api/v1/landing/returns-transactions/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/internal/jobs/runs/{run_id}` — Read Run — The state of one run. What the Dagster asset polls. */
export type ReadRunParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/internal/jobs/runs/{run_id}` */
export const readRun: OperationSpec<ReadRunParams, JobRunView> = {
  operationId: "read_run_api_v1_internal_jobs_runs__run_id__get",
  method: "GET",
  path: "/api/v1/internal/jobs/runs/{run_id}",
  tag: "internal",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/registry/run-scopes/runs/{run_id}` — Read Run Scope — The Scopes one in-season run (or simulation) covered, as it recorded them (ADR 9037). What the cells file's notice names: the Scopes by name and version, the stores, items and cells they covered, the fingerprint, and the cells the run read and left out. 404 when the run recorded no Scopes (written before ADR 9037, or unseen) or is outside the caller's markets. */
export type ReadRunScopeParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/registry/run-scopes/runs/{run_id}` */
export const readRunScope: OperationSpec<ReadRunScopeParams, RunScopeRunView> = {
  operationId: "read_run_scope_api_v1_registry_run_scopes_runs__run_id__get",
  method: "GET",
  path: "/api/v1/registry/run-scopes/runs/{run_id}",
  tag: "registry",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/registry/run-scopes/changes/{change_id}` — Read Run Scope Change — What one change set does to the library (ADR 1003 §5): the change set's own view. Each item: the entry before and after, the stores, items and cells covered before and after on the masters as of ``as_of`` (a selection: its size, and every Scope it reaches with theirs), the Scopes that name a selection, and whether production lists a Scope. Pending or approved, "before" is each entry as the item's previous value and "after" as its new value. 404 when no set of that id changes the library in the caller's markets. */
export type ReadRunScopeChangeParams = {
  readonly path: {
    readonly change_id: string;
  };
  readonly query?: {
    readonly as_of?: string;
  };
};

/** `GET /api/v1/registry/run-scopes/changes/{change_id}` */
export const readRunScopeChange: OperationSpec<ReadRunScopeChangeParams, RunScopeChangeView> = {
  operationId: "read_run_scope_change_api_v1_registry_run_scopes_changes__change_id__get",
  method: "GET",
  path: "/api/v1/registry/run-scopes/changes/{change_id}",
  tag: "registry",
  pathParams: ["change_id"],
  queryParams: ["as_of"],
  hasBody: false,
};

/** `GET /api/v1/landing/sales-transactions/sequence` — Read Sales Transaction Sequence — The last ``sales_transaction`` sequence this country landed, and the next. Shipped with its ``POST``, as every feed since the fourth has been. G-1 refuses a batch whose ``delivery_seq`` is not exactly one greater than the last this partition landed, and a write path without this read hands the producer a rule it can only guess at. There is no arithmetic that could stand in for it even badly. This feed is daily with a monthly partition and reqs/00 §7's own mitigation expects months to be re-materialised, so a producer deriving its sequence from a date desynchronises permanently on the first re-run of a day — which is the trap the stock feed sprang. ``last_delivery_seq`` counts **quarantined batches too**, deliberately: a refused batch still occupied its number. */
export type ReadSalesTransactionSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/sales-transactions/sequence` */
export const readSalesTransactionSequence: OperationSpec<ReadSalesTransactionSequenceParams, FeedSequenceResponse> = {
  operationId: "read_sales_transaction_sequence_api_v1_landing_sales_transactions_sequence_get",
  method: "GET",
  path: "/api/v1/landing/sales-transactions/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/foundations/schedules` — Read Schedules — Every schedule the orchestrator last reported, readable to planners (W1-2, ADR 1003). The newest report set — publishes, refits, forecasts, elasticity, the cycles — each with its status, last tick and next tick verbatim, the decision cycle it drives and that cycle's newest tick state for the country (``/cycle-runs``' classifier), and its newest run's outcome where the orchestrator reported one. Same grant and scope rewrite as ``/cycle-runs``: a country outside the caller's scope reads no schedules. */
export type ReadSchedulesParams = {
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/foundations/schedules` */
export const readSchedules: OperationSpec<ReadSchedulesParams, SchedulesResponse> = {
  operationId: "read_schedules_api_v1_foundations_schedules_get",
  method: "GET",
  path: "/api/v1/foundations/schedules",
  tag: "foundations",
  pathParams: [],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/season-intakes/sequence` — Read Season Intake Sequence — The last ``exit_season_intake`` sequence this country landed, and the next. Shipped with the ``POST``, not after it: G-1 refuses a ``delivery_seq`` that is not exactly one more than the last, and a producer with no read can only guess. */
export type ReadSeasonIntakeSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/season-intakes/sequence` */
export const readSeasonIntakeSequence: OperationSpec<ReadSeasonIntakeSequenceParams, FeedSequenceResponse> = {
  operationId: "read_season_intake_sequence_api_v1_landing_season_intakes_sequence_get",
  method: "GET",
  path: "/api/v1/landing/season-intakes/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/sell-through-week/sequence` — Read Sell Through Week Sequence — The last ``sell_through_week`` sequence this country landed. Shipped with the ``POST``, as every feed's is: the producer reads it to number its next delivery and to name the batch a full refresh supersedes. ``period_key`` is the week's Monday as ``YYYYMMDD``. */
export type ReadSellThroughWeekSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/sell-through-week/sequence` */
export const readSellThroughWeekSequence: OperationSpec<ReadSellThroughWeekSequenceParams, FeedSequenceResponse> = {
  operationId: "read_sell_through_week_sequence_api_v1_landing_sell_through_week_sequence_get",
  method: "GET",
  path: "/api/v1/landing/sell-through-week/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/inseason/simulations/{simulation_id}` — Read Simulation — One simulation and its run's state. 404 when absent or out of scope, alike. */
export type ReadSimulationParams = {
  readonly path: {
    readonly simulation_id: string;
  };
};

/** `GET /api/v1/inseason/simulations/{simulation_id}` */
export const readSimulation: OperationSpec<ReadSimulationParams, SimulationView> = {
  operationId: "read_simulation_api_v1_inseason_simulations__simulation_id__get",
  method: "GET",
  path: "/api/v1/inseason/simulations/{simulation_id}",
  tag: "inseason",
  pathParams: ["simulation_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/landing/preseason-size-availability-week/sequence` — Read Size Availability Week Sequence — The last ``preseason_size_availability_week`` sequence this country landed. Shipped with the ``POST`` rather than a follow-up PR — the lesson every feed before it left behind, restated by :func:`_read_sequence` itself. Unfiltered by state, as every sibling is: a quarantined batch still occupied its number. */
export type ReadSizeAvailabilityWeekSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/preseason-size-availability-week/sequence` */
export const readSizeAvailabilityWeekSequence: OperationSpec<ReadSizeAvailabilityWeekSequenceParams, FeedSequenceResponse> = {
  operationId: "read_size_availability_week_sequence_api_v1_landing_preseason_size_availability_week_sequence_get",
  method: "GET",
  path: "/api/v1/landing/preseason-size-availability-week/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/size-dimension/sequence` — Read Size Dimension Sequence — The last ``size_dimension`` sequence this partition landed, and the next. Shipped with the ``POST``: G-1 refuses a ``delivery_seq`` that is not exactly one more than the last, and a producer with no read can only guess. */
export type ReadSizeDimensionSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/size-dimension/sequence` */
export const readSizeDimensionSequence: OperationSpec<ReadSizeDimensionSequenceParams, FeedSequenceResponse> = {
  operationId: "read_size_dimension_sequence_api_v1_landing_size_dimension_sequence_get",
  method: "GET",
  path: "/api/v1/landing/size-dimension/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/stock-positions/sequence` — Read Stock Position Sequence — The last ``stock_position`` sequence this country landed, and the next. The sibling of :func:`read_price_observation_sequence`, and it exists for the same reason: G-1 refuses a batch whose ``delivery_seq`` is not exactly one greater than the last this partition landed, and the ``POST`` beside it shipped with no way to read that number. **The guess is sharper on this feed than on the first one, which is why this is not merely symmetry.** ``bata-data`` derives this feed's sequence from ``days_between()`` date arithmetic against a fixed epoch — a number computed from the calendar rather than read from the store. The two agree only while exactly one batch is delivered per day, in order, and never re-delivered. The first re-materialisation of a day breaks the agreement permanently: the store expects ``last + 1``, the arithmetic returns the number that day already had, and every subsequent day then fails G-1 for the first one's sake. A daily feed re-runs a day sooner or later; this is the read that makes recovering from it an observation rather than a hand-carried correction. ``last_delivery_seq`` counts **quarantined batches too**, deliberately. A refused batch still occupied its number, so a producer reading this learns both that its previous attempt was refused and that the sequence moved on regardless — see :func:`~services.repositories.inseason. latest_stock_batch_statement`, which is unfiltered by state for that reason. Scoped through the register rather than filtered in the handler, and behind the same :data:`REQUIRED_ROLE` the ``POST`` applies, exactly as the price sequence read is. Returns :data:`PROBLEM_RESPONSES` and not :data:`LANDING_RESPONSES`: a read cannot emit the ``413``, and a contract that advertised one would be a branch `bata-ui`'s generated client writes for nothing. */
export type ReadStockPositionSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/stock-positions/sequence` */
export const readStockPositionSequence: OperationSpec<ReadStockPositionSequenceParams, FeedSequenceResponse> = {
  operationId: "read_stock_position_sequence_api_v1_landing_stock_positions_sequence_get",
  method: "GET",
  path: "/api/v1/landing/stock-positions/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/landing/preseason-store-feature-panel/sequence` — Read Store Feature Panel Sequence — The last ``preseason_store_feature_panel`` sequence this country landed for a window. ``period_key`` is the window's start as ``YYYYMMDD``. Unfiltered by state, as every sibling is: a quarantined batch still occupied its number. */
export type ReadStoreFeaturePanelSequenceParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly period_key?: number;
  };
};

/** `GET /api/v1/landing/preseason-store-feature-panel/sequence` */
export const readStoreFeaturePanelSequence: OperationSpec<ReadStoreFeaturePanelSequenceParams, FeedSequenceResponse> = {
  operationId: "read_store_feature_panel_sequence_api_v1_landing_preseason_store_feature_panel_sequence_get",
  method: "GET",
  path: "/api/v1/landing/preseason-store-feature-panel/sequence",
  tag: "landing",
  pathParams: [],
  queryParams: ["country_key", "period_key"],
  hasBody: false,
};

/** `GET /api/v1/registry/process-calendar/template` — Read Template — The import template for a market's year, prefilled with its periods as they stand. One sheet, ``calendar``: ``type | start | end | name | mechanic``, one row per period (the headers are codes, never translated); and ``instructions``, in the caller's language. */
export type ReadTemplateParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly year?: number;
    readonly as_of?: string;
  };
};

/** `GET /api/v1/registry/process-calendar/template` */
export const readTemplate: OperationSpec<ReadTemplateParams, TemplateView> = {
  operationId: "read_template_api_v1_registry_process_calendar_template_get",
  method: "GET",
  path: "/api/v1/registry/process-calendar/template",
  tag: "registry",
  pathParams: [],
  queryParams: ["country_key", "year", "as_of"],
  hasBody: false,
};

/** `GET /api/v1/internal/feeds/unsuperseded-partitions` — Read Unsuperseded Partitions — W0-3b: every double-counted accumulating partition of one country. */
export type ReadUnsupersededPartitionsParams = {
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/internal/feeds/unsuperseded-partitions` */
export const readUnsupersededPartitions: OperationSpec<ReadUnsupersededPartitionsParams, readonly (DoubleCountedPartitionView)[]> = {
  operationId: "read_unsuperseded_partitions_api_v1_internal_feeds_unsuperseded_partitions_get",
  method: "GET",
  path: "/api/v1/internal/feeds/unsuperseded-partitions",
  tag: "internal",
  pathParams: [],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /api/v1/admin/user-activity/{user_id}/actions` — Read User Actions — One person's state changes in the window, by kind, most frequent first (ADR 9029). From ``audit_event`` (ADR 1010): the method and route template of each kind, the object kind it acts on, how many and the newest. The person's own profile and session writes are pseudonymised in that record and not counted. Same bounds as ``GET /admin/user-activity``. */
export type ReadUserActionsParams = {
  readonly path: {
    readonly user_id: string;
  };
  readonly query?: {
    readonly from?: string;
    readonly to?: string;
    readonly cursor?: string | null;
    readonly limit?: number;
  };
};

/** `GET /api/v1/admin/user-activity/{user_id}/actions` */
export const readUserActions: OperationSpec<ReadUserActionsParams, UserActionPage> = {
  operationId: "read_user_actions_api_v1_admin_user_activity__user_id__actions_get",
  method: "GET",
  path: "/api/v1/admin/user-activity/{user_id}/actions",
  tag: "admin",
  pathParams: ["user_id"],
  queryParams: ["from", "to", "cursor", "limit"],
  hasBody: false,
};

/** `GET /api/v1/admin/user-activity` — Read User Activity — Each person's sign-ins, sessions and acts over the window (ADR 9029). A person is listed when the broker logged a sign-in, failed sign-in, token exchange, refresh or sign-out of theirs in the window, a session of theirs started in it, or the audit record holds an act of theirs in it. ``unattributedFailedLogins`` counts the failed sign-ins the broker could tie to no user (an unknown name). **Bounded.** ``from`` and ``to`` are required, both inclusive, at most 92 days apart (422 ``platform.admin.user_activity_window_invalid``); at most 50 rows per page. A window holding more broker events than one read walks is 422 ``platform.admin.identity_events_too_many``. A tier with no broker credential, or a broker that does not answer, is 503 ``platform.admin.identity_events_unavailable``. **Who may read it.** ``read`` on ``user_activity``: the administrator alone. */
export type ReadUserActivityParams = {
  readonly query?: {
    readonly from?: string;
    readonly to?: string;
    readonly user?: string | null;
    readonly sort?: UserActivitySort;
    readonly cursor?: string | null;
    readonly limit?: number;
  };
};

/** `GET /api/v1/admin/user-activity` */
export const readUserActivity: OperationSpec<ReadUserActivityParams, UserActivityPage> = {
  operationId: "read_user_activity_api_v1_admin_user_activity_get",
  method: "GET",
  path: "/api/v1/admin/user-activity",
  tag: "admin",
  pathParams: [],
  queryParams: ["from", "to", "user", "sort", "cursor", "limit"],
  hasBody: false,
};

/** `GET /api/v1/admin/user-activity/{user_id}/sessions` — Read User Sessions — One person's sessions that started in the window, newest first (ADR 9029). Rebuilt from the broker's session id: the sign-in starts it, each refresh keeps it alive, a sign-out ends it; otherwise it ended at its last event plus the idle timeout, or at its start plus the maximum lifespan, whichever came first — or it is still open. Lengths are estimates (``sessionRule``). Same bounds and refusals as ``GET /admin/user-activity``. */
export type ReadUserSessionsParams = {
  readonly path: {
    readonly user_id: string;
  };
  readonly query?: {
    readonly from?: string;
    readonly to?: string;
    readonly cursor?: string | null;
    readonly limit?: number;
  };
};

/** `GET /api/v1/admin/user-activity/{user_id}/sessions` */
export const readUserSessions: OperationSpec<ReadUserSessionsParams, UserSessionPage> = {
  operationId: "read_user_sessions_api_v1_admin_user_activity__user_id__sessions_get",
  method: "GET",
  path: "/api/v1/admin/user-activity/{user_id}/sessions",
  tag: "admin",
  pathParams: ["user_id"],
  queryParams: ["from", "to", "cursor", "limit"],
  hasBody: false,
};

/** `GET /api/v1/registry/run-scopes/vocabularies` — Read Vocabularies — What the rule editor offers for a market on ``as_of`` (ADR 1003 §2). Every attribute a rule may filter on, with its kind and clause kinds; for a coded or flag attribute its values in the masters with how many stores or articles hold each (``UNKNOWN`` included, as a clause matches it), category and sub-category codes with the master's label beside them, district codes, department families of the pinned product class scheme; the market's cluster schemes and versions with their clusters' sizes; the list cap (2,000). */
export type ReadVocabulariesParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly as_of?: string;
  };
};

/** `GET /api/v1/registry/run-scopes/vocabularies` */
export const readVocabularies: OperationSpec<ReadVocabulariesParams, VocabulariesView> = {
  operationId: "read_vocabularies_api_v1_registry_run_scopes_vocabularies_get",
  method: "GET",
  path: "/api/v1/registry/run-scopes/vocabularies",
  tag: "registry",
  pathParams: [],
  queryParams: ["country_key", "as_of"],
  hasBody: false,
};

/** `GET /api/v1/registry/run-scopes/entries/{kind}/{entry_id}/where-used` — Read Where Used — Where one entry is used (ADR 1003 §5): the Scopes naming a selection, and whether production lists a Scope. An entry used either way cannot be retired. */
export type ReadWhereUsedParams = {
  readonly path: {
    readonly kind: "scope" | "store_selection" | "product_selection";
    readonly entry_id: string;
  };
  readonly query?: {
    readonly country_key?: string;
  };
};

/** `GET /api/v1/registry/run-scopes/entries/{kind}/{entry_id}/where-used` */
export const readWhereUsed: OperationSpec<ReadWhereUsedParams, WhereUsedView> = {
  operationId: "read_where_used_api_v1_registry_run_scopes_entries__kind___entry_id__where_used_get",
  method: "GET",
  path: "/api/v1/registry/run-scopes/entries/{kind}/{entry_id}/where-used",
  tag: "registry",
  pathParams: ["kind", "entry_id"],
  queryParams: ["country_key"],
  hasBody: false,
};

/** `GET /health/ready` — Readiness — Readiness probe. Now that a dependency exists, this checks it. The previous docstring promised that "dependency checks — store reachable, migrations applied — are added by the chapter that introduces the dependency, so that a readiness probe never claims more than it verifies", and this is that chapter: an unreachable store answers ``503`` and the orchestrator keeps traffic away, rather than the process accepting requests it will answer with an empty page. Migrations are deliberately **not** checked. They are applied by ``bata-data`` under an expand/contract discipline (G7.6), so a running process legitimately precedes the migration that adds a column it does not yet read; refusing readiness on that would make every expand migration an outage. */
export type ReadinessParams = Record<string, never>;

/** `GET /health/ready` */
export const readiness: OperationSpec<ReadinessParams, HealthResponse> = {
  operationId: "readiness_health_ready_get",
  method: "GET",
  path: "/health/ready",
  tag: "platform",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/launch/reason-codes` — Reason codes this engine emits — The published vocabulary, most-binding first. Each maps to a catalogue key. */
export type ReasonCodesParams = Record<string, never>;

/** `GET /api/v1/launch/reason-codes` */
export const reasonCodes: OperationSpec<ReasonCodesParams, readonly (string)[]> = {
  operationId: "reason_codes_api_v1_launch_reason_codes_get",
  method: "GET",
  path: "/api/v1/launch/reason-codes",
  tag: "launch",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/rebalance-summary` — Rebalance Summary — §4.5 size-run repair's outcome for the tick of one in-season run (ADR 6030). ``run_id`` is a run from ``GET /inseason/runs``. The outcome is the newest ``inseason.rebalance`` recording for the run's market and window end; see :class:`RebalanceSummary` for why it is resolved rather than joined and what a ``null`` measure means. 404 when the run does not exist or is outside the caller's scope; 200 with ``recorded: false`` when it exists and no repair outcome was recorded for its tick. */
export type RebalanceSummaryParams = {
  readonly query?: {
    readonly run_id?: string;
  };
};

/** `GET /api/v1/inseason/rebalance-summary` */
export const rebalanceSummary: OperationSpec<RebalanceSummaryParams, RebalanceSummary> = {
  operationId: "rebalance_summary_api_v1_inseason_rebalance_summary_get",
  method: "GET",
  path: "/api/v1/inseason/rebalance-summary",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id"],
  hasBody: false,
};

/** `GET /api/v1/exit/lifecycle-transitions/{recommendation_id}` — Recommendation Evidence — One recommendation's evidence: every signal read and every door, with its run. */
export type RecommendationEvidenceParams = {
  readonly path: {
    readonly recommendation_id: string;
  };
};

/** `GET /api/v1/exit/lifecycle-transitions/{recommendation_id}` */
export const recommendationEvidence: OperationSpec<RecommendationEvidenceParams, TransitionRecommendationEvidenceModel> = {
  operationId: "recommendation_evidence_api_v1_exit_lifecycle_transitions__recommendation_id__get",
  method: "GET",
  path: "/api/v1/exit/lifecycle-transitions/{recommendation_id}",
  tag: "exit",
  pathParams: ["recommendation_id"],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/foundations/recompute` — Recompute — The minimal recompute set for a set of edits (reqs/00 D6). Exposed as an API call rather than only as an internal step because G3.5 requires the planning engines to be callable headlessly: a batch client must be able to ask what an edit would invalidate without opening a screen. */
export type RecomputeParams = {
  readonly body: RecomputeRequest;
};

/** `POST /api/v1/foundations/recompute` */
export const recompute: OperationSpec<RecomputeParams, RecomputeResponse> = {
  operationId: "recompute_api_v1_foundations_recompute_post",
  method: "POST",
  path: "/api/v1/foundations/recompute",
  tag: "foundations",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/foundations/reconcile` — Reconcile — Disaggregate a target to the leaves and re-aggregate it (reqs/00 §8.2). ``reversible`` is the acceptance criterion answered for this request: the round trip is computed in exact rational arithmetic and the response says whether it returned the original value, rather than leaving the caller to compare two rounded floats and draw their own conclusion. */
export type ReconcileParams = {
  readonly body: ReconcileRequest;
};

/** `POST /api/v1/foundations/reconcile` */
export const reconcile: OperationSpec<ReconcileParams, ReconcileResponse> = {
  operationId: "reconcile_api_v1_foundations_reconcile_post",
  method: "POST",
  path: "/api/v1/foundations/reconcile",
  tag: "foundations",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/postseason/reconstruct` — Reconstruct unconstrained demand from a stock panel — EM censored negative-binomial demand recovery (reqs/06 6.4). Not-ranged and not-reported weeks are excluded from the likelihood entirely; stocked-out weeks are right-censored at observed sales and weighted by the available fraction of the week. Reconstructed demand is never below observed sales. */
export type ReconstructDemandParams = {
  readonly body: RecoveryRequest;
};

/** `POST /api/v1/postseason/reconstruct` */
export const reconstructDemand: OperationSpec<ReconstructDemandParams, RecoveryResponse> = {
  operationId: "reconstruct_demand_api_v1_postseason_reconstruct_post",
  method: "POST",
  path: "/api/v1/postseason/reconstruct",
  tag: "postseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/foundations/exceptions/{alert_id}/assignment` — Record Alert Assignment — Assign an open alert, or clear its assignee, without deciding it (ADR 2102). * authorised as ``approve`` on ``alert`` until the register carries an ``assign`` grant (bata-platform#436, ASK-3): the capability ``assign`` on ``alert`` names this route and answers from this grant, so the button and the route cannot disagree; * 404 ``alert_not_found`` for an alert absent or outside the caller's scope; * 409 ``alert_not_open`` on a decided alert, 409 ``alert_changed`` on a race; * the ``Idempotency-Key`` is the event's identifier. */
export type RecordAlertAssignmentParams = {
  readonly path: {
    readonly alert_id: string;
  };
  readonly body: AlertAssignmentRequest;
};

/** `POST /api/v1/foundations/exceptions/{alert_id}/assignment` */
export const recordAlertAssignment: OperationSpec<RecordAlertAssignmentParams, AlertEventSummary> = {
  operationId: "record_alert_assignment_api_v1_foundations_exceptions__alert_id__assignment_post",
  method: "POST",
  path: "/api/v1/foundations/exceptions/{alert_id}/assignment",
  tag: "foundations",
  pathParams: ["alert_id"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/foundations/exceptions/{alert_id}/dispositions` — Record Alert Disposition — Record a planner's decision on one alert (ADR 2004) — G1's second interaction. **What this closes.** ``GET /foundations/exceptions`` served the queue and nobody could close an item in it. This is the queue's decision half, on the transfer disposition write's rules (ADR 6031): * authorised as ``approve`` on ``alert`` — the register's own row for this act — with the actor from the verified principal (no identity is a 401, no grant a 403); * the alert must sit in the caller's scope; one that does not, or does not exist, is one 404 (``planning.foundations.alert_not_found``, G3.3); * one decision per alert: a second is a 409 (``planning.foundations.alert_already_disposed``) and writes nothing; * the ``Idempotency-Key`` is the decision's identifier, so a retry is one act; * the reason is checked against the governed vocabulary and its binding to the disposition before anything is read (422, ``planning.foundations.alert_reason_not_governed``). The decision is recorded on an append-only trail and on the queue's own state in one transaction; the alert leaves the open queue whatever the decision, a deferral included — a deferred alert has been looked at, and G1's precision report counts only ``reject`` against the rule. */
export type RecordAlertDispositionParams = {
  readonly path: {
    readonly alert_id: string;
  };
  readonly body: AlertDispositionRequest;
};

/** `POST /api/v1/foundations/exceptions/{alert_id}/dispositions` */
export const recordAlertDisposition: OperationSpec<RecordAlertDispositionParams, AlertDispositionSummary> = {
  operationId: "record_alert_disposition_api_v1_foundations_exceptions__alert_id__dispositions_post",
  method: "POST",
  path: "/api/v1/foundations/exceptions/{alert_id}/dispositions",
  tag: "foundations",
  pathParams: ["alert_id"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/foundations/exceptions/group-actions` — Record Alert Group Action — Assign, release, snooze or close every alert of one group in one request (ADR 2109). Each matched alert is judged on its own by the single acts' rules (the lifecycle state machine, the governed snooze limit of its market, scope) and gets its own event, carrying ``group_action_id``, on its history; an alert the act cannot move is skipped and counted by reason, never failing the batch. One transaction per act. * authorised as the single acts: ``assign``/``unassign``/``snooze`` as ``assign`` on ``alert`` (ADR 2107), ``dispose`` as ``approve`` on ``alert`` — 401 / 403 otherwise; * 409 ``alert_group_changed`` when the filter matches other than ``expectedCount`` alerts now (``currentCount`` on the document) — nothing written; * 422 ``alert_group_too_large`` above the bound (``maximumCount``); 422 ``alert_reason_not_governed``, ``snooze_date_not_future`` and ``alert_department_needs_market`` as the single acts and the queue refuse them; * the ``Idempotency-Key`` is ``groupActionId``: a retry answers the recorded act. */
export type RecordAlertGroupActionParams = {
  readonly body: AlertGroupActionRequest;
};

/** `POST /api/v1/foundations/exceptions/group-actions` */
export const recordAlertGroupAction: OperationSpec<RecordAlertGroupActionParams, AlertGroupActionResult> = {
  operationId: "record_alert_group_action_api_v1_foundations_exceptions_group_actions_post",
  method: "POST",
  path: "/api/v1/foundations/exceptions/group-actions",
  tag: "foundations",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/foundations/exceptions/{alert_id}/reopen` — Record Alert Reopen — Withdraw a decided alert's decision, appending a ``reopened`` event (ADR 2102). The decision stays on the log; the alert is undecided again and may be decided anew. Authorised as the decision is (``approve`` on ``alert``). **Refused as ungoverned (422 ``alert_reason_not_governed``) unless the reason is one the ``exception.reopen_reason_vocabulary`` registry row in force names** (ADR 2104): the owner ratifies the vocabulary through the registry, so with no row every reopen is refused. 409 ``alert_not_decided`` on an alert with no current decision. */
export type RecordAlertReopenParams = {
  readonly path: {
    readonly alert_id: string;
  };
  readonly body: AlertReopenRequest;
};

/** `POST /api/v1/foundations/exceptions/{alert_id}/reopen` */
export const recordAlertReopen: OperationSpec<RecordAlertReopenParams, AlertEventSummary> = {
  operationId: "record_alert_reopen_api_v1_foundations_exceptions__alert_id__reopen_post",
  method: "POST",
  path: "/api/v1/foundations/exceptions/{alert_id}/reopen",
  tag: "foundations",
  pathParams: ["alert_id"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/foundations/exceptions/{alert_id}/snooze` — Record Alert Snooze — Take an open alert out of the queue until a date (ADR 2102) — the alert ``defer``. * the reason must be a governed snooze reason (``acts`` contains ``snooze`` on ``GET /foundations/exceptions/reason-codes``), else 422 ``alert_reason_not_governed`` before anything is read; * 422 ``snooze_date_not_future`` for today or earlier, 422 ``snooze_beyond_limit`` beyond ``exception.snooze_max_days`` for the alert's market when a row is in force; * 409 ``alert_not_open`` on a decided alert; authorised as the assignment is. */
export type RecordAlertSnoozeParams = {
  readonly path: {
    readonly alert_id: string;
  };
  readonly body: AlertSnoozeRequest;
};

/** `POST /api/v1/foundations/exceptions/{alert_id}/snooze` */
export const recordAlertSnooze: OperationSpec<RecordAlertSnoozeParams, AlertEventSummary> = {
  operationId: "record_alert_snooze_api_v1_foundations_exceptions__alert_id__snooze_post",
  method: "POST",
  path: "/api/v1/foundations/exceptions/{alert_id}/snooze",
  tag: "foundations",
  pathParams: ["alert_id"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/exit/consolidation/dispositions` — Retired: store-to-store moves are decided in the one run's list — Retired by bata-reqs ADR 9002 stage 3 (platform ADR 9049): every store-to-store move is a line of the one run's list, decided at `POST /compacting/moves/dispositions`. This path answers 410 `planning.compacting.route_retired`; the lane book's reads keep their history. */
export type RecordConsolidationDispositionsParams = {
  readonly body: ConsolidationDispositionRequest;
};

/** `POST /api/v1/exit/consolidation/dispositions` */
export const recordConsolidationDispositions: OperationSpec<RecordConsolidationDispositionsParams, ConsolidationDispositionSummary> = {
  operationId: "record_consolidation_dispositions_api_v1_exit_consolidation_dispositions_post",
  method: "POST",
  path: "/api/v1/exit/consolidation/dispositions",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/exit/lifecycle-transitions/{recommendation_id}/dispositions` — Accept or reject a transition recommendation — bata-reqs issue 35 P2a (ADR 7026). An acceptance writes the article's phase decision (ZONA_SALES from effectiveMonth), which the phase reader prefers to the inference from that month on; a rejection records the answer and pins no phase. Refused, writing nothing: a back-dated or mid-month effectiveMonth, an ungoverned reason, a recommendation already answered or outside the caller's scope. */
export type RecordDispositionParams = {
  readonly path: {
    readonly recommendation_id: string;
  };
  readonly body: TransitionDispositionRequest;
};

/** `POST /api/v1/exit/lifecycle-transitions/{recommendation_id}/dispositions` */
export const recordDisposition: OperationSpec<RecordDispositionParams, TransitionDispositionResponse> = {
  operationId: "record_disposition_api_v1_exit_lifecycle_transitions__recommendation_id__dispositions_post",
  method: "POST",
  path: "/api/v1/exit/lifecycle-transitions/{recommendation_id}/dispositions",
  tag: "exit",
  pathParams: ["recommendation_id"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/dispositions` — Record Dispositions — Record a planner's disposition over a set of in-season proposals. The whole set is written in one transaction or none of it is: an action that recorded thirty-nine of forty would leave the planner believing they had disposed of forty, and the fortieth would sit in the queue looking new. Nothing here commits stock. This is the *decision* half of reqs/07 §3.5's ``recommendation → decision → committed action`` chain. An ``approve`` or ``adjust`` mints one write-back command per written proposal in the same transaction (ADR 6037), state ``approved``; it appears on ``/inseason/write-back`` and in the run's execution pack with its own uncollapsed state, and only a planner's report moves it. **``reason_code`` is now checked against a governed set, closing the gap this docstring used to document as open (bata-platform#231, bata-platform ADR 5000).** Neither existing vocabulary could be reused here — :data:`~planning.markdown.reasons.PRICE_DECISION_REASONS` is `04` §4.4's price-decision vocabulary and has no member admitting ``adjust``, which this route (unlike the price-action one) legitimately allows via :attr:`DispositionLine.adjusted_units`; ``planning.replenishment.reasons``'s ``PULL_REASON_CODES`` is why a door *asked*, set by the engine before a planner ever sees the queue, not why a planner agreed or disagreed. ADR 5000 authors :data:`~planning.allocation.reasons.PROPOSAL_DECISION_REASONS` for exactly this gap — reason codes derived from :data:`~planning.allocation.types.ENGINE_REASON_CODES`, the constraints a proposal disputes or corrects — and this route validates against it via :func:`~planning.allocation.reasons.is_governed`. ``GET /inseason/dispositions/reason-codes`` is where a caller who may read it finds the governed set. */
export type RecordDispositionsParams = {
  readonly body: DispositionRequest;
};

/** `POST /api/v1/inseason/dispositions` */
export const recordDispositions: OperationSpec<RecordDispositionsParams, DispositionSummary> = {
  operationId: "record_dispositions_api_v1_inseason_dispositions_post",
  method: "POST",
  path: "/api/v1/inseason/dispositions",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/dispositions/by-filter` — Record Dispositions By Filter — Decide every pending line a previewed filter matches (ADR 6103, DEC-15). The filter is the decision's identity and the set it resolved to is its record: the write re-resolves the filter inside its transaction and proceeds only when the digest is the preview's — otherwise 409 ``planning.inseason.selection_changed`` naming the current digest and count, and nothing is written. The lines then go through the queue's own write, so per-line scope, supersession, the already-disposed refusal and the write-back mint (ADR 6037) are the explicit-id path's. ``adjust`` is refused (per line only); the reason code is governed by the queue's vocabulary. Authorised as the queue write is (``approve`` on the plan). */
export type RecordDispositionsByFilterParams = {
  readonly body: FilterDispositionRequest;
};

/** `POST /api/v1/inseason/dispositions/by-filter` */
export const recordDispositionsByFilter: OperationSpec<RecordDispositionsByFilterParams, FilterDispositionSummary> = {
  operationId: "record_dispositions_by_filter_api_v1_inseason_dispositions_by_filter_post",
  method: "POST",
  path: "/api/v1/inseason/dispositions/by-filter",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/compacting/moves/dispositions` — Record a planner's decision over lines of the one run's list — bata-reqs ADR 9002 stage 3 (platform ADR 9049): the one approval process for every store-to-store move. The whole set is written in one transaction or none of it is; an approval or adjustment mints one write-back command per line. */
export type RecordMoveLineDispositionsParams = {
  readonly body: MoveLineDispositionRequest;
};

/** `POST /api/v1/compacting/moves/dispositions` */
export const recordMoveLineDispositions: OperationSpec<RecordMoveLineDispositionsParams, MoveLineDispositionSummary> = {
  operationId: "record_move_line_dispositions_api_v1_compacting_moves_dispositions_post",
  method: "POST",
  path: "/api/v1/compacting/moves/dispositions",
  tag: "compacting",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/exit/outlet-exits/{recommendation_id}/dispositions` — Accept or reject an outlet exit recommendation — bata-reqs issue 35 P4 (ADR 7028). An acceptance writes the article's phase decision (OUTLET from effectiveMonth) with the recommendation's outlet price; the phase reader prefers it to the inference from that month on, chapter 04's markdown stops posing the article, and lifecycle.outlet_transfer moves its stock on the 1st. A rejection records the answer and pins no phase. Refused, writing nothing: a back-dated or mid-month effectiveMonth, an ungoverned reason, a recommendation already answered or outside the caller's scope. */
export type RecordOutletDispositionParams = {
  readonly path: {
    readonly recommendation_id: string;
  };
  readonly body: OutletDispositionRequest;
};

/** `POST /api/v1/exit/outlet-exits/{recommendation_id}/dispositions` */
export const recordOutletDisposition: OperationSpec<RecordOutletDispositionParams, OutletDispositionResponse> = {
  operationId: "record_outlet_disposition_api_v1_exit_outlet_exits__recommendation_id__dispositions_post",
  method: "POST",
  path: "/api/v1/exit/outlet-exits/{recommendation_id}/dispositions",
  tag: "exit",
  pathParams: ["recommendation_id"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/price-actions/dispositions` — Record Price Action Dispositions — Record a planner's decision over a set of recommended price steps. **What this closes.** ``GET /inseason/price-actions`` has served recommended price steps and ``GET /inseason/markdown/path`` has priced a full path for a real option since the ladder landed — and a planner could act on neither. ``POST /inseason/dispositions`` keys on ``proposal_id`` and is replenishment's. This is the markdown queue's decision half of reqs/07 §3.5's ``recommendation → decision → committed action`` chain. **And the committed-action half, in the same transaction.** An approval mints a write-back command (§14 §5 O4), which is the step between a recorded decision and an instruction that reaches a pricing system. Minting it later, from a sweep, would lose every approval the sweep missed — ADR 0072's argument about the forecast archive, applied to a command. **Nothing here moves a price.** The command is raised in state ``approved`` and only an observation from the target may advance it; §14 test E10 forbids any surface rendering ``dispatched``, ``delivered`` or ``unknown`` as sent or done, and this response carries no state at all. ``GET /inseason/write-back`` is where a command's state lives. The whole set is written in one transaction or none of it is, on :func:`record_dispositions`' terms and for its reason. The vocabulary is the one ``GET /inseason/dispositions/vocabulary`` publishes, unextended. ``adjust`` is refused — the counter-price it carries is only a decision if it is a rung on the ratified ladder, and the stored price action does not identify which ladder governs it. */
export type RecordPriceActionDispositionsParams = {
  readonly body: PriceActionDispositionRequest;
};

/** `POST /api/v1/inseason/price-actions/dispositions` */
export const recordPriceActionDispositions: OperationSpec<RecordPriceActionDispositionsParams, PriceActionDispositionSummary> = {
  operationId: "record_price_action_dispositions_api_v1_inseason_price_actions_dispositions_post",
  method: "POST",
  path: "/api/v1/inseason/price-actions/dispositions",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/transfers/dispositions` — Record Transfer Dispositions — Retired: 410 ``planning.compacting.route_retired`` (bata-reqs ADR 9002 stage 3, ADR 9049). The transfer queue was one of the two approval queues for store-to-store moves (ADR 6031). Since the one run, every store-to-store move is a line of one list decided in one approval process, ``POST /compacting/moves/dispositions`` (stage 3 rulings 1, 2 and 7), and no transfer is written here any more. The path answers 410 naming that route; the transfer reads keep their history. */
export type RecordTransferDispositionsParams = {
  readonly body: TransferDispositionRequest;
};

/** `POST /api/v1/inseason/transfers/dispositions` */
export const recordTransferDispositions: OperationSpec<RecordTransferDispositionsParams, TransferDispositionSummary> = {
  operationId: "record_transfer_dispositions_api_v1_inseason_transfers_dispositions_post",
  method: "POST",
  path: "/api/v1/inseason/transfers/dispositions",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/write-back/group-transitions` — Record Write Back Group Transition — Export, confirm as sent or cancel every command of one group in one request. Owner ruling DEC-105, ADR 6054, the convention of ADR 2109. Each matched command is judged on its own by the single reports' rules (one step at a time, a cancellation only from an open state) and gets its own transition, carrying ``group_action_id``; a command the act cannot move is skipped and counted by reason, never failing the batch. One transaction per act. * authorised as the single reports: ``dispatched`` as ``export`` on the plan, ``acknowledged`` as ``commit``, ``cancelled`` as ``approve`` — 401 / 403 otherwise; * ``acknowledged`` only as "executed as sent" (``executedAsSent: true``, each command's executed units = its authorised units); otherwise 422 ``write_back_group_executed_as_sent_required``; * ``cancelled`` with a reason outside ``GET /inseason/write-back/cancellation-reason-codes`` is 422 ``cancellation_reason_not_governed``; * 409 ``write_back_group_changed`` when the filter matches other than ``expectedCount`` commands now (``currentCount`` on the document); 422 ``write_back_group_too_large`` above the bound (``maximumCount``) — nothing written either way; * the ``Idempotency-Key`` is ``groupActionId``: a retry answers the recorded act. */
export type RecordWriteBackGroupTransitionParams = {
  readonly body: WriteBackGroupTransitionRequest;
};

/** `POST /api/v1/inseason/write-back/group-transitions` */
export const recordWriteBackGroupTransition: OperationSpec<RecordWriteBackGroupTransitionParams, WriteBackGroupTransitionResult> = {
  operationId: "record_write_back_group_transition_api_v1_inseason_write_back_group_transitions_post",
  method: "POST",
  path: "/api/v1/inseason/write-back/group-transitions",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/postseason/recovery/{recovery_run_id}/control-totals` — Control totals for one recovery run — Observed, recovered and unconstrained units summed in the store over the run's persisted cells — the plan-store half of ADR 0091 D3's reconciliation. */
export type RecoveryControlTotalsParams = {
  readonly path: {
    readonly recovery_run_id: string;
  };
};

/** `GET /api/v1/postseason/recovery/{recovery_run_id}/control-totals` */
export const recoveryControlTotals: OperationSpec<RecoveryControlTotalsParams, ControlTotalsResponse> = {
  operationId: "recovery_control_totals_api_v1_postseason_recovery__recovery_run_id__control_totals_get",
  method: "GET",
  path: "/api/v1/postseason/recovery/{recovery_run_id}/control-totals",
  tag: "postseason",
  pathParams: ["recovery_run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/postseason/recovery/season-total` — A season's stock-out recovery, summed over the run in force at each door — The sum of /recovery/coverage: each door once, from the newest run not superseded that covers it. Units are null with unitsAbsentReason no_coverage when no door is covered, never zero. Stock-out recovery only: the assortment and late-ranging potential are separate classes and are not added. methodVersions and doorsCensoredWithoutRecovery carry the caveats. */
export type RecoverySeasonTotalParams = {
  readonly query?: {
    readonly season?: string;
  };
};

/** `GET /api/v1/postseason/recovery/season-total` */
export const recoverySeasonTotal: OperationSpec<RecoverySeasonTotalParams, RecoverySeasonTotalResponse> = {
  operationId: "recovery_season_total_api_v1_postseason_recovery_season_total_get",
  method: "GET",
  path: "/api/v1/postseason/recovery/season-total",
  tag: "postseason",
  pathParams: [],
  queryParams: ["season"],
  hasBody: false,
};

/** `GET /api/v1/registry/parameters` — List Parameters — The rows in force on ``as_of`` — ``valid_from <= as_of < valid_to``. ``as_of`` is required, not defaulted to today. G9 makes a stored value a claim about a moment, and "what did the engine read last Tuesday" is only a query if the date is an argument; a read that defaulted to the clock would answer a different question on every call and would make a support conversation about a July run unanswerable. ``known_at`` asks what the registry *held* at that instant (ADR 9006): a run's ``requested_at`` returns exactly the rows it read, whatever was approved or corrected since. Omitted, the answer is as known now. */
export type RegistryListParametersParams = {
  readonly query?: {
    readonly as_of?: string;
    readonly parameter_key?: string | null;
    readonly known_at?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/registry/parameters` */
export const registryListParameters: OperationSpec<RegistryListParametersParams, CursorPageParameterRow> = {
  operationId: "list_parameters_api_v1_registry_parameters_get",
  method: "GET",
  path: "/api/v1/registry/parameters",
  tag: "registry",
  pathParams: [],
  queryParams: ["as_of", "parameter_key", "known_at", "limit", "cursor"],
  hasBody: false,
};

/** `POST /api/v1/registry/changes/{change_id}/rejections` — Reject Change — Reject a pending set: it will never take effect (W2-1, ADR 9012). Whoever may approve may reject — the approval route's own grant — but not the set's author, who withdraws instead (``author_must_withdraw``). One appended row in ``registry_change_closure``; no parameter row is touched, and the set then reads ``rejected``. A set that is not pending (approved, promoted, already closed) is ``not_pending``. Every defect comes back at once on ``refusals``. */
export type RejectChangeParams = {
  readonly path: {
    readonly change_id: string;
  };
  readonly body: ClosureRequest;
};

/** `POST /api/v1/registry/changes/{change_id}/rejections` */
export const rejectChange: OperationSpec<RejectChangeParams, ChangeReceipt> = {
  operationId: "reject_change_api_v1_registry_changes__change_id__rejections_post",
  method: "POST",
  path: "/api/v1/registry/changes/{change_id}/rejections",
  tag: "registry",
  pathParams: ["change_id"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/compacting/simulations/{simulation_id}/relaunch` — Relaunch Move Run Simulation — A new simulation from this one, with the edits given (module docstring). 202. ``overlay`` replaces the original's whole overlay when given; ``scope`` its Scope. The new simulation names this one in ``relaunchedFrom``. Refusals as ``POST /compacting/simulations``, and 404 ``planning.compacting.simulation_not_found``. */
export type RelaunchMoveRunSimulationParams = {
  readonly path: {
    readonly simulation_id: string;
  };
  readonly body: MoveRunSimulationRelaunch;
};

/** `POST /api/v1/compacting/simulations/{simulation_id}/relaunch` */
export const relaunchMoveRunSimulation: OperationSpec<RelaunchMoveRunSimulationParams, MoveRunSimulationView> = {
  operationId: "relaunch_move_run_simulation_api_v1_compacting_simulations__simulation_id__relaunch_post",
  method: "POST",
  path: "/api/v1/compacting/simulations/{simulation_id}/relaunch",
  tag: "compacting",
  pathParams: ["simulation_id"],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/by-store` — Replenishment By Store Report — One department family of a run, per store: lines, units, requested and unmet (ADR 6171). ``GET /inseason/proposals?run_id=&department_family=`` added up per store, in the store — the same classification the filter and the run digest share — so the Department page needs no walk of the family's lines. Ordered by ``store_key``, cursor-paged; a fixed number of statements whatever the family's size. A market whose scheme cannot classify answers ``absent_reason`` and no store, never an empty list that reads as "nothing proposed". 404 when the run does not exist or is outside the caller's scope. */
export type ReplenishmentByStoreReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly department_family?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/by-store` */
export const replenishmentByStoreReport: OperationSpec<ReplenishmentByStoreReportParams, ReplenishmentByStorePage> = {
  operationId: "replenishment_by_store_report_api_v1_inseason_runs__run_id__report_replenishment_by_store_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/report/replenishment/by-store",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["department_family", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment` — Replenishment Report — One run's replenishment report, one proposal line per row, one page at a time. Ordered by store, article, size in run order (``size_run_position``; a size the dimension does not place last, by ``size_key``) and proposal. Joined in the store at a fixed number of statements per page, whatever its size (ADR 9018). 404 when the run does not exist or is outside the caller's scope. */
export type ReplenishmentReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment` */
export const replenishmentReport: OperationSpec<ReplenishmentReportParams, CursorPageReplenishmentReportRow> = {
  operationId: "replenishment_report_api_v1_inseason_runs__run_id__report_replenishment_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/report/replenishment",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `POST /api/v1/me/feedback/{code}/messages` — Reply To My Report — Write on the thread of one of the caller's own open reports, and optionally amend it. A reply to a report in ``needs_info`` moves it back to ``received`` (ADR 1020). ``amend`` is accepted only while the report is ``received`` or ``needs_info`` (409 ``platform.feedback.content_frozen`` otherwise). At most ``feedback_messages_per_day`` replies per person in a rolling 24 hours. The answer carries no text. */
export type ReplyToMyReportParams = {
  readonly path: {
    readonly code: string;
  };
  readonly body: AuthorReply;
};

/** `POST /api/v1/me/feedback/{code}/messages` */
export const replyToMyReport: OperationSpec<ReplyToMyReportParams, MessageOutcome> = {
  operationId: "reply_to_my_report_api_v1_me_feedback__code__messages_post",
  method: "POST",
  path: "/api/v1/me/feedback/{code}/messages",
  tag: "feedback",
  pathParams: ["code"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/write-back/{command_id}/transitions` — Report Write Back Transition — A planner reports that a command was exported, or executed in Oracle (ADR 6037). The first caller of the write-back transition writer. ``dispatched`` when a pack containing the command was exported (authorised as ``export`` on the plan); ``acknowledged`` when a planner confirmed it was executed (``commit`` on the plan). The source recorded on the transition is the verified principal. * The moves are ``approved → dispatched → acknowledged``, one step at a time; anything else is a 409, ``planning.inseason.write_back_transition_out_of_order``, naming ``currentState``. The seven states never collapse (§14 test E10). * Reporting the state the command is already in appends nothing and answers ``recorded: false`` — so re-exporting a pack is safe, and mints nothing. * An unknown command and another market's are one 404, ``planning.inseason.write_back_command_not_found`` (G3.3). * The ``Idempotency-Key`` is required; the shared ledger replays a retry. */
export type ReportWriteBackTransitionParams = {
  readonly path: {
    readonly command_id: string;
  };
  readonly body: WriteBackTransitionRequest;
};

/** `POST /api/v1/inseason/write-back/{command_id}/transitions` */
export const reportWriteBackTransition: OperationSpec<ReportWriteBackTransitionParams, WriteBackTransitionSummary> = {
  operationId: "report_write_back_transition_api_v1_inseason_write_back__command_id__transitions_post",
  method: "POST",
  path: "/api/v1/inseason/write-back/{command_id}/transitions",
  tag: "inseason",
  pathParams: ["command_id"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/campaigns/simulations` — Request Campaign Simulation — Record a campaign simulation and queue its run. 202 when recorded, 200 when it existed. Advisory (design D3): nothing the platform runs reads it, and it has no adoption. The same envelope, alternatives, base run, response fit and scenario asked twice is one simulation. What the response model cannot answer is not refused here: the run records each such alternative's refusal beside the others. */
export type RequestCampaignSimulationParams = {
  readonly body: CampaignSimulationRequest;
};

/** `POST /api/v1/inseason/campaigns/simulations` */
export const requestCampaignSimulation: OperationSpec<RequestCampaignSimulationParams, CampaignSimulationView> = {
  operationId: "request_campaign_simulation_api_v1_inseason_campaigns_simulations_post",
  method: "POST",
  path: "/api/v1/inseason/campaigns/simulations",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/exit/consolidation/simulations` — Request Exit Simulation — Retired: 410 ``planning.compacting.route_retired`` (bata-reqs ADR 9002 stage 3, ADR 9049). Stage 3 ruling 1: one simulation of the whole run. Exit consolidation's own simulation is retired with its writer; ``POST /compacting/simulations`` simulates the one run, every store-to-store move of the market. The reads of earlier exit simulations keep their history. */
export type RequestExitSimulationParams = {
  readonly body: ExitSimulationRequest;
};

/** `POST /api/v1/exit/consolidation/simulations` */
export const requestExitSimulation: OperationSpec<RequestExitSimulationParams, ExitSimulationView> = {
  operationId: "request_exit_simulation_api_v1_exit_consolidation_simulations_post",
  method: "POST",
  path: "/api/v1/exit/consolidation/simulations",
  tag: "exit",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/compacting/simulations` — Request Move Run Simulation — Queue a simulation of the one run (module docstring). 202: accepted, run by the runner. 422 ``planning.compacting.simulation_scope_refused`` (``reason``, ``scopeId``) for a Scope the market's library does not hold, holds retired, or not at that version; 422 ``…simulation_overlay_key_refused`` (``parameterKey``, ``reason``) for an overlay key it does not admit; 409 ``…simulation_cycle_window``; 429 ``…simulation_capacity_exhausted``. */
export type RequestMoveRunSimulationParams = {
  readonly body: MoveRunSimulationRequest;
};

/** `POST /api/v1/compacting/simulations` */
export const requestMoveRunSimulation: OperationSpec<RequestMoveRunSimulationParams, MoveRunSimulationView> = {
  operationId: "request_move_run_simulation_api_v1_compacting_simulations_post",
  method: "POST",
  path: "/api/v1/compacting/simulations",
  tag: "compacting",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/internal/jobs/{job_name}/runs` — Request Run — Record a request to run ``job_name`` over a window. Executes nothing. */
export type RequestRunParams = {
  readonly path: {
    readonly job_name: string;
  };
  readonly body: JobRunRequest;
};

/** `POST /api/v1/internal/jobs/{job_name}/runs` */
export const requestRun: OperationSpec<RequestRunParams, JobRunView> = {
  operationId: "request_run_api_v1_internal_jobs__job_name__runs_post",
  method: "POST",
  path: "/api/v1/internal/jobs/{job_name}/runs",
  tag: "internal",
  pathParams: ["job_name"],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/inseason/simulations` — Request Simulation — Record a simulation and queue its run. 202: accepted, evaluated by the runner. The same question asked twice — stage, base window, registry as known when the base was requested, overlay and scenario — is one evaluation, and answers the simulation already recorded. At most two simulations are in flight estate-wide; a third is refused with 429 rather than queued behind the cycle. **The scheduled cycle has priority (W2-9, ADR 6046).** 409 ``planning.inseason.simulation.cycle_window`` while a cycle stage is queued or running, or within ``inseason.simulation.cycle_window_minutes`` of a cycle tick the orchestrator reported; ``tryAfter`` says when to ask again. **Owner-governed valuation keys (ADR 6046 amendment 2026-10-29).** A distribute overlay may name ``objective.move_valuation`` and ``objective.season_end_realisation_rate`` only when the caller holds the change-set approver's grant (``administer`` on ``parameter``): 403 otherwise. Such a key needs no row in force at the base: the run then reads the overlaid value as the market's row, and ``overlay_without_base_row`` names it. */
export type RequestSimulationParams = {
  readonly body: SimulationRequest;
};

/** `POST /api/v1/inseason/simulations` */
export const requestSimulation: OperationSpec<RequestSimulationParams, SimulationView> = {
  operationId: "request_simulation_api_v1_inseason_simulations_post",
  method: "POST",
  path: "/api/v1/inseason/simulations",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `POST /api/v1/run-configurations/{configuration_id}/versions` — Revise Run Configuration — Save a new version over ``supersedes_version``. The old one stays readable. */
export type ReviseRunConfigurationParams = {
  readonly path: {
    readonly configuration_id: string;
  };
  readonly body: RunConfigurationRevision;
};

/** `POST /api/v1/run-configurations/{configuration_id}/versions` */
export const reviseRunConfiguration: OperationSpec<ReviseRunConfigurationParams, RunConfiguration> = {
  operationId: "revise_run_configuration_api_v1_run_configurations__configuration_id__versions_post",
  method: "POST",
  path: "/api/v1/run-configurations/{configuration_id}/versions",
  tag: "run-configurations",
  pathParams: ["configuration_id"],
  queryParams: [],
  hasBody: true,
};

/** `DELETE /api/v1/feedback/{code}/approval` — Revoke Approval — Revoke an approval: ``approved_for_development`` back to ``ready``, approvers only. The approval's columns are cleared; the history row keeps the digest that had been approved. */
export type RevokeApprovalParams = {
  readonly path: {
    readonly code: string;
  };
};

/** `DELETE /api/v1/feedback/{code}/approval` */
export const revokeApproval: OperationSpec<RevokeApprovalParams, ApprovalOutcome> = {
  operationId: "revoke_approval_api_v1_feedback__code__approval_delete",
  method: "DELETE",
  path: "/api/v1/feedback/{code}/approval",
  tag: "feedback",
  pathParams: ["code"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/digest` — Run Digest — One run's proposals, price steps and transfers, rolled up for charts (ADR 6039). One request powers the Cockpit's in-season charts: proposals and units by department family (the pinned product class scheme, ADR 6038), by pull reason code and by ``bound_by``; the top ``top`` stores by units and by unmet need; the fill rate (Σ``units`` / Σ``requested_units``, ADR 9015); the stores that asked and were proposed nothing; price steps by depth band; transfers by purpose. Computed on read from the stored rows the paged reads serve — never the job's output — so the digest always equals those pages added up. Money is per currency. An absent figure is ``null`` with its reason, never 0. 404 when the run does not exist or is outside the caller's scope. */
export type RunDigestParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly top?: number;
    readonly depth_band_points?: number;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/digest` */
export const runDigest: OperationSpec<RunDigestParams, InSeasonRunDigest> = {
  operationId: "run_digest_api_v1_inseason_runs__run_id__digest_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/digest",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["top", "depth_band_points"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/names` — Run Names Report — Names for the stores and articles a screen draws from one run's positions (ADR 6177). A position the run holds without a proposal line has no `store_name` or `article_name` to read off a line, and the only other source was a walk of `report/replenishment`. This names any asked key with **the rule a proposal line's name is resolved by** (ADR 6080: the door master in force, the attribute row in force on the run's date, the report's reasons), so the same key reads the same name on every screen. One run header and the two name statements, whatever the number of keys. 404 when the run does not exist or is outside the caller's scope; 422 when no key is asked or a list is over the cap. */
export type RunNamesReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly store_key?: readonly (string)[];
    readonly article_key?: readonly (string)[];
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/names` */
export const runNamesReport: OperationSpec<RunNamesReportParams, RunNamesResponse> = {
  operationId: "run_names_report_api_v1_inseason_runs__run_id__names_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/names",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["store_key", "article_key"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/provenance` — Run Provenance — What one run read: its parameters and fingerprint, stock batch and forecast run. Recorded by ``inseason.distribute`` and ``inseason.price`` on the run they write, and by ``inseason.reforecast`` on the archived forecast run the cycle names (ADR 6121). **Only what was recorded**: a run older than the record answers ``recorded: false`` with ``not_recorded_by_run`` — never today's registry. ADR 6217, additively: ``seasonal_index`` is the seasonal index the pull forecast run the run's own stage read was scaled by — the chain's, each category's, the target weeks and the bounds — as that forecast run's landed provenance states it. 404 when the run does not exist or is outside the caller's scope. */
export type RunProvenanceParams = {
  readonly path: {
    readonly run_id: string;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/provenance` */
export const runProvenance: OperationSpec<RunProvenanceParams, RunProvenanceSummary> = {
  operationId: "run_provenance_api_v1_inseason_runs__run_id__provenance_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/provenance",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/sales-history/by-run` — Run Sales History — Every door x article of one run with its sales over the governed window (ADR 6186). **The single read's figure, for the whole run at once.** For each distinct ``(store_key, article_key)`` among the run's proposal lines — the rows ``GET /inseason/proposals?run_id=`` lists — the units sold over the weeks of the governed default window that the sales feed has wholly landed: exactly what the store x article drill sums from ``GET /inseason/sales-history`` with no ``from``/``to`` (DEC-76, ADR 6120), so a screen can rank the run by past sales without one request per pair. Sales only, never net of returns; the demand-exclusion register is not applied, as the single read does not apply it. The window is the last ``inseason.evidence.sales_history_weeks`` complete ISO weeks the sales feed has landed for the run's market, resolved as the single read resolves it for a door of that market; with no usable row in force the read is 409 ``planning.inseason.sales_history_window_not_set``. There is no caller-named window: the figure is the governed one or it is not this figure. 404 ``planning.inseason.run_not_found`` when the run does not exist or is outside the caller's scope (one answer for both, ADR 6030); 404 ``planning.inseason.sales_history_unavailable`` when no source is installed. */
export type RunSalesHistoryParams = {
  readonly query?: {
    readonly run_id?: string;
  };
};

/** `GET /api/v1/inseason/sales-history/by-run` */
export const runSalesHistory: OperationSpec<RunSalesHistoryParams, RunSalesHistory> = {
  operationId: "run_sales_history_api_v1_inseason_sales_history_by_run_get",
  method: "GET",
  path: "/api/v1/inseason/sales-history/by-run",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/stock-summary` — Run Stock Summary — One run's whole stock ledger in figures, and its size-run map (ADR 6073). ``GET /inseason/stock-positions`` pages the same rows; this read summarises all of them in the store, so a screen states figures over a ledger of hundreds of thousands of positions without walking it (bata-platform issue 607, bata-ui issue 319). Not paged: its size is bounded by ``top`` and by the run's size axis. Absent is never zero: a sum over no measured row and a median over no cover are ``null``. 404 when the run does not exist or is outside the caller's scope. */
export type RunStockSummaryParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly top?: number;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/stock-summary` */
export const runStockSummary: OperationSpec<RunStockSummaryParams, StockSummary> = {
  operationId: "run_stock_summary_api_v1_inseason_runs__run_id__stock_summary_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/stock-summary",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["top"],
  hasBody: false,
};

/** `GET /api/v1/inseason/sales-history` — Sales History — One door x article's landed sales and returns in ISO weeks (ADR 6101, ADR 6120). **Bounded by what the caller names, or by the governed default, and nothing else.** ``store_key`` and ``article_key`` are required. The window is either named whole (``from`` and ``to``; one alone is 422) or not at all, and then it is the last ``inseason.evidence.sales_history_weeks`` complete ISO weeks the sales feed has landed for the door's market (DEC-76) — a registry row, never a code default: with none in force the read is 409 ``planning.inseason.sales_history_window_not_set``. ``window_basis`` says which applied. The window is closed on both ends, as a business date is a day, and at most :data:`SALES_HISTORY_MAX_DAYS` long. Read from the plan store's ``sales_transaction`` and ``returns_transaction`` over the promoted, unsuperseded batches of the door's market, so a re-landed month replaces its predecessor rather than doubling it. Each week states whether the feed covers it: a landed week with no sale is a counted zero, an unlanded one is ``null``. ``sales_landed``/``returns_landed`` state each feed's overall bounds, so "the door sold nothing" and "nothing has landed" are different answers. 404 when no door master the caller may read lists the store. */
export type SalesHistoryParams = {
  readonly query?: {
    readonly store_key?: string;
    readonly article_key?: string;
    readonly from?: string | null;
    readonly to?: string | null;
    readonly by?: SalesHistoryGrain;
  };
};

/** `GET /api/v1/inseason/sales-history` */
export const salesHistory: OperationSpec<SalesHistoryParams, SalesHistory> = {
  operationId: "sales_history_api_v1_inseason_sales_history_get",
  method: "GET",
  path: "/api/v1/inseason/sales-history",
  tag: "inseason",
  pathParams: [],
  queryParams: ["store_key", "article_key", "from", "to", "by"],
  hasBody: false,
};

/** `GET /api/v1/mlplatform/sell-probability/refusals` — Positions the same scope could not score, and why — The companion of the scores read, over exactly the same scope and the same required parameters. `unmeasured` is a NULL on-hand — a stock feed that did not land — and `unforecast` is a subject the model never estimated. Kept apart because they have different owners and different fixes. */
export type SellProbabilityRefusalsParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly store_key?: string;
    readonly period?: string;
    readonly model_version_id?: string;
    readonly article_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/mlplatform/sell-probability/refusals` */
export const sellProbabilityRefusals: OperationSpec<SellProbabilityRefusalsParams, CursorPagePositionRefusalRow> = {
  operationId: "sell_probability_refusals_api_v1_mlplatform_sell_probability_refusals_get",
  method: "GET",
  path: "/api/v1/mlplatform/sell-probability/refusals",
  tag: "mlplatform",
  pathParams: [],
  queryParams: ["run_id", "store_key", "period", "model_version_id", "article_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/mlplatform/sell-probability` — Probability that the next unit sells, for one door's positions — Computed on the fly from the stored quantile forecast and the cycle's stock position; never stored. Every row carries a `bandKey`, including the censored ones, and `isComparable` says which rows can be ranked against each other. Positions that could not be scored are not dropped — they are served by `/mlplatform/sell-probability/refusals` for the same scope. */
export type SellProbabilityScoresParams = {
  readonly query?: {
    readonly run_id?: string;
    readonly store_key?: string;
    readonly period?: string;
    readonly model_version_id?: string;
    readonly article_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/mlplatform/sell-probability` */
export const sellProbabilityScores: OperationSpec<SellProbabilityScoresParams, CursorPageSellProbabilityRow> = {
  operationId: "sell_probability_scores_api_v1_mlplatform_sell_probability_get",
  method: "GET",
  path: "/api/v1/mlplatform/sell-probability",
  tag: "mlplatform",
  pathParams: [],
  queryParams: ["run_id", "store_key", "period", "model_version_id", "article_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/service-exchange/{forecast_run_id}` — Service Exchange — One forecast run's service exchange: population and points (bata-platform#571). ``truncate`` and ``round_up`` at the run's stored levels; ``whole_pair`` (ADR 6059's distribution) at 0.5, 0.6, 0.7, 0.8, 0.85, 0.9 and 0.95, ``fromStoredLevel`` saying which levels the run stored. Demand is pairs sold, a lower bound where a cell stocked out. 404 with the standard run-not-found problem for a run never recorded or outside the caller's scope; 404 ``service_exchange_unavailable`` when no source is installed. */
export type ServiceExchangeParams = {
  readonly path: {
    readonly forecast_run_id: string;
  };
};

/** `GET /api/v1/inseason/service-exchange/{forecast_run_id}` */
export const serviceExchange: OperationSpec<ServiceExchangeParams, ServiceExchangeModel> = {
  operationId: "service_exchange_api_v1_inseason_service_exchange__forecast_run_id__get",
  method: "GET",
  path: "/api/v1/inseason/service-exchange/{forecast_run_id}",
  tag: "inseason",
  pathParams: ["forecast_run_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/price-actions` — Simulation Price Actions — Every price step a price simulation wrote, one cursor page at a time (ADR 6181). ``GET /inseason/price-actions?run_id=``' own schema and page key. Disposition fields are ``null``: a scenario step is never decided. 409 until the simulation succeeded; 422 ``stage_mismatch`` for a distribute simulation. */
export type SimulationPriceActionsParams = {
  readonly path: {
    readonly simulation_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/price-actions` */
export const simulationPriceActions: OperationSpec<SimulationPriceActionsParams, CursorPagePriceActionSummary> = {
  operationId: "simulation_price_actions_api_v1_inseason_simulations__simulation_id__price_actions_get",
  method: "GET",
  path: "/api/v1/inseason/simulations/{simulation_id}/price-actions",
  tag: "inseason",
  pathParams: ["simulation_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/report/pricing` — Simulation Pricing Report — ``GET /inseason/runs/{run_id}/report/pricing`` for a price simulation (ADR 6181). The original price report in its schema, over the scenario's steps and the explanation the simulation's run recorded. 409 until the simulation succeeded; 422 ``stage_mismatch`` for a distribute simulation. */
export type SimulationPricingReportParams = {
  readonly path: {
    readonly simulation_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/report/pricing` */
export const simulationPricingReport: OperationSpec<SimulationPricingReportParams, CursorPagePricingReportRow> = {
  operationId: "simulation_pricing_report_api_v1_inseason_simulations__simulation_id__report_pricing_get",
  method: "GET",
  path: "/api/v1/inseason/simulations/{simulation_id}/report/pricing",
  tag: "inseason",
  pathParams: ["simulation_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/proposals` — Simulation Proposals — Every proposal line a distribute simulation wrote, one cursor page at a time (ADR 6181). ``GET /inseason/proposals?run_id=``' own schema, page key and ``total`` (every line the scenario wrote), so a client that walks the live list walks this one unchanged -- the export of a simulation is the export of a run. The base run's lines are **not** here and a live run's never are; the live list asked for this simulation's id still answers nothing, because the scenario is behind the fence and only this route opens it. A scenario line is never decided: ``disposition`` and its companions are ``null``, as on a pending live line, and nothing on it can be approved, adjusted or written back. 409 until the simulation succeeded; 422 ``stage_mismatch`` for a price simulation; a simulation that wrote no run answers an empty page (``wrote_run`` on the simulation says so). */
export type SimulationProposalsParams = {
  readonly path: {
    readonly simulation_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/proposals` */
export const simulationProposals: OperationSpec<SimulationProposalsParams, ProposalPage> = {
  operationId: "simulation_proposals_api_v1_inseason_simulations__simulation_id__proposals_get",
  method: "GET",
  path: "/api/v1/inseason/simulations/{simulation_id}/proposals",
  tag: "inseason",
  pathParams: ["simulation_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/report/replenishment` — Simulation Replenishment Report — ``GET /inseason/runs/{run_id}/report/replenishment`` for a distribute simulation. The original run's report, row for row in its schema and order, over the scenario's lines (ADR 6181). The run, its lines and its stored positions are the scenario's; the sales, landed stock, transit, recovered demand and masters are the live ones, as they are for the original -- the report reads them by the run's window and not by its identity. 409 until the simulation succeeded; 422 ``stage_mismatch`` for a price simulation. */
export type SimulationReplenishmentReportParams = {
  readonly path: {
    readonly simulation_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/report/replenishment` */
export const simulationReplenishmentReport: OperationSpec<SimulationReplenishmentReportParams, CursorPageReplenishmentReportRow> = {
  operationId: "simulation_replenishment_report_api_v1_inseason_simulations__simulation_id__report_replenishment_get",
  method: "GET",
  path: "/api/v1/inseason/simulations/{simulation_id}/report/replenishment",
  tag: "inseason",
  pathParams: ["simulation_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/rows` — Simulation Rows — The base run's lines beside the scenario's, for one article — "for example" (W2-7). DEC-09(b): next to the ADR 6038 drivers, a planner sees what the overlay did to one store × article, line by line: units, requested units and the drivers on each side. A distribute simulation needs ``store_key``; a price simulation's steps carry no store, so it must be absent (422 ``rows_filter_invalid``). 409 until the simulation succeeded. The scenario's lines are read inside the fence's scenario escape only; the base's are a live read like any other. */
export type SimulationRowsParams = {
  readonly path: {
    readonly simulation_id: string;
  };
  readonly query?: {
    readonly article_key?: string;
    readonly store_key?: string | null;
  };
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/rows` */
export const simulationRows: OperationSpec<SimulationRowsParams, SimulationRowsView> = {
  operationId: "simulation_rows_api_v1_inseason_simulations__simulation_id__rows_get",
  method: "GET",
  path: "/api/v1/inseason/simulations/{simulation_id}/rows",
  tag: "inseason",
  pathParams: ["simulation_id"],
  queryParams: ["article_key", "store_key"],
  hasBody: false,
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/transfers` — Simulation Transfers — Every transfer move of a distribute simulation beside the base run's, a page at a time. ADR 6046 amendment 2026-10-29 (bata-reqs ADR 9002 stage 1's backtest: moves gained and lost, value per move). ``/rows`` is decision 1's "for example" read of one store × article; this walks every move of both runs, in ``(article_key, donor_store_key, recipient_store_key, size_key, currency_code)`` order, each paired with the other run's move of the same key or ``null``, with each side's net benefit and ``move_valuation``. ``article_key`` and ``store_key`` (either end) narrow both sides alike. Read as ``/rows`` is: the base side live and fenced, the scenario side through the fence's scenario escape. 409 until the simulation succeeded; 422 ``stage_mismatch`` for a price simulation; a simulation that wrote no run pairs every base move with ``null``. */
export type SimulationTransfersParams = {
  readonly path: {
    readonly simulation_id: string;
  };
  readonly query?: {
    readonly article_key?: string | null;
    readonly store_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/transfers` */
export const simulationTransfers: OperationSpec<SimulationTransfersParams, CursorPageTransferMoveDiff> = {
  operationId: "simulation_transfers_api_v1_inseason_simulations__simulation_id__transfers_get",
  method: "GET",
  path: "/api/v1/inseason/simulations/{simulation_id}/transfers",
  tag: "inseason",
  pathParams: ["simulation_id"],
  queryParams: ["article_key", "store_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/values` — Simulation Values — The articles or stores a simulation's comparison can be asked about (ADR 6181). The keys on **either** side -- the base run's lines and the scenario's -- sorted, with their names where the masters have them, so a picker offers what ``GET .../rows`` can answer instead of free text. ``store`` is a distribute simulation's alone (422 ``rows_filter_invalid``: a price step carries no store). At most ``limit`` (default 50, ceiling 500, the row comparison's per-side cap) of the matching ``total``. 409 until the simulation succeeded. */
export type SimulationValuesParams = {
  readonly path: {
    readonly simulation_id: string;
  };
  readonly query?: {
    readonly dimension?: "article" | "store";
    readonly q?: string | null;
    readonly limit?: number;
  };
};

/** `GET /api/v1/inseason/simulations/{simulation_id}/values` */
export const simulationValues: OperationSpec<SimulationValuesParams, SimulationValuesView> = {
  operationId: "simulation_values_api_v1_inseason_simulations__simulation_id__values_get",
  method: "GET",
  path: "/api/v1/inseason/simulations/{simulation_id}/values",
  tag: "inseason",
  pathParams: ["simulation_id"],
  queryParams: ["dimension", "q", "limit"],
  hasBody: false,
};

/** `GET /api/v1/launch/size-run-report` — Size-run integrity report — Doors served, dropped and complete — the measurement behind gate D3. */
export type SizeRunReportParams = {
  readonly query?: {
    readonly allocation_version_id?: string | null;
  };
};

/** `GET /api/v1/launch/size-run-report` */
export const sizeRunReport: OperationSpec<SizeRunReportParams, readonly (SizeRunReportModel)[]> = {
  operationId: "size_run_report_api_v1_launch_size_run_report_get",
  method: "GET",
  path: "/api/v1/launch/size-run-report",
  tag: "launch",
  pathParams: [],
  queryParams: ["allocation_version_id"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/stock-positions/by-store-article` — Stock By Store Article Report — One run's stock summed over all sizes, for a set of store x article pairs (ADR 6081). The batched form of `GET /inseason/stock-positions?run_id&store_key&article_key`, for a screen that shows the stock of an article in a store across **every** size, with or without a proposal line, and would otherwise make one call per row. One grouped statement over the run's stored positions and one over the landed transit of the stock batch the run read, whatever the number of pairs. Every asked pair is answered once, in the order asked; see :class:`StockPairRow` for what a partial sum looks like. 404 when the run does not exist or is outside the caller's scope; 422 for a malformed pair or more than the cap. */
export type StockByStoreArticleReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly pair?: readonly (string)[];
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/stock-positions/by-store-article` */
export const stockByStoreArticleReport: OperationSpec<StockByStoreArticleReportParams, StockByPairResponse> = {
  operationId: "stock_by_store_article_report_api_v1_inseason_runs__run_id__stock_positions_by_store_article_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/stock-positions/by-store-article",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["pair"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/stock-positions/by-store` — Stock By Store Report — One run's stock per store: on hand, in transit and a cover histogram (ADR 6172). `GET /inseason/runs/{run_id}/stock-summary` at the store's grain, so a store's stock page states its figures and draws its histogram without paging the store's positions. Same rows, same definitions, same absences: a sum over no measured row is `null`, never 0. Ordered by `store_key`, cursor-paged; a fixed number of statements whatever the run's size. 404 when the run does not exist or is outside the caller's scope. */
export type StockByStoreReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly cover_edge?: readonly (number)[];
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/stock-positions/by-store` */
export const stockByStoreReport: OperationSpec<StockByStoreReportParams, StockByStorePage> = {
  operationId: "stock_by_store_report_api_v1_inseason_runs__run_id__stock_positions_by_store_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/stock-positions/by-store",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["cover_edge", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/exit/indifference/lane-ranking` — Rank the stored comparisons for one market and one day — reqs/05 §3.7's lane ranking over the `exit.indifference` job's output, cheapest per recovered margin point first. The market and the day are required rather than optional: G16 makes a read whose perimeter the caller cannot state an unbounded read, and a ranking over every market and every window would be one. Lanes whose move recovers nothing come back named rather than sorted to the expensive end, which is what keeps an unpriced lot off the bottom of a currency column. */
export type StoredLaneRankingParams = {
  readonly query?: {
    readonly country_key?: string;
    readonly as_of?: string;
    readonly cluster_key?: string | null;
  };
};

/** `GET /api/v1/exit/indifference/lane-ranking` */
export const storedLaneRanking: OperationSpec<StoredLaneRankingParams, LaneRankingResponse> = {
  operationId: "stored_lane_ranking_api_v1_exit_indifference_lane_ranking_get",
  method: "GET",
  path: "/api/v1/exit/indifference/lane-ranking",
  tag: "exit",
  pathParams: [],
  queryParams: ["country_key", "as_of", "cluster_key"],
  hasBody: false,
};

/** `GET /api/v1/inseason/markdown/candidates` — The stored markdown candidate queue for one cycle — reqs/05 §3.2's queue over the lots the cycle actually considered, read from `inseason.price`'s output rather than from a candidate set the caller supplies — a planner opening the screen has not got the candidate set, the estate has. Two groups, ranked and unranked, because an unpriced lot sorts into a named group and never to the bottom of a currency column, where the bottom reads as nothing at stake. The lots the optimiser refused are returned with the refusal's own code: that population has no price action to hang off and is the half a planner most needs. Every row says `computation: "stored"` and the wait it was priced against. */
export type StoredMarkdownCandidatesParams = {
  readonly query?: {
    readonly run_id?: string;
  };
};

/** `GET /api/v1/inseason/markdown/candidates` */
export const storedMarkdownCandidates: OperationSpec<StoredMarkdownCandidatesParams, StoredCandidateQueue> = {
  operationId: "stored_markdown_candidates_api_v1_inseason_markdown_candidates_get",
  method: "GET",
  path: "/api/v1/inseason/markdown/candidates",
  tag: "inseason",
  pathParams: [],
  queryParams: ["run_id"],
  hasBody: false,
};

/** `GET /api/v1/exit/stranded/count-by-country` — Stranded lots per country — the number the landing surface leads with — reqs/05 §3.8: "the count of stranded lots by country" is the number a merchant leads with. `as_of` is required: G16 makes a read whose perimeter the caller cannot state an unbounded read, and a count with no day would be a count over every window this table has ever held. `undetermined` counts travel beside `stranded`, never folded into it — an operator seeing `stranded` alone would read a country whose readiness feed has not landed as a country with nothing to worry about. */
export type StrandedCountByCountryParams = {
  readonly query?: {
    readonly as_of?: string;
    readonly country_key?: string | null;
  };
};

/** `GET /api/v1/exit/stranded/count-by-country` */
export const strandedCountByCountry: OperationSpec<StrandedCountByCountryParams, StrandedCountResponse> = {
  operationId: "stranded_count_by_country_api_v1_exit_stranded_count_by_country_get",
  method: "GET",
  path: "/api/v1/exit/stranded/count-by-country",
  tag: "exit",
  pathParams: [],
  queryParams: ["as_of", "country_key"],
  hasBody: false,
};

/** `GET /api/v1/strategic/reservations` — Reservations — Booked supplier capacity and its consumption — reqs/01 D7, visible to §2.6. */
export type StrategicReservationsParams = {
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/strategic/reservations` */
export const strategicReservations: OperationSpec<StrategicReservationsParams, CursorPageReservationRow> = {
  operationId: "reservations_api_v1_strategic_reservations_get",
  method: "GET",
  path: "/api/v1/strategic/reservations",
  tag: "strategic",
  pathParams: [],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `POST /api/v1/postseason/review/summarise` — Compute one season-review row — The review measures for one grain cell (reqs/06 6.1), including GMROI on average inventory at cost across the season rather than on the closing position, which systematically flatters fast-exiting options. */
export type SummariseReviewParams = {
  readonly body: ReviewSummaryRequest;
};

/** `POST /api/v1/postseason/review/summarise` */
export const summariseReview: OperationSpec<SummariseReviewParams, SeasonReviewRow> = {
  operationId: "summarise_review_api_v1_postseason_review_summarise_post",
  method: "POST",
  path: "/api/v1/postseason/review/summarise",
  tag: "postseason",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/supplier/reservations` — Slots the platform has booked against the calling supplier, in one season — reqs/01 D7's bookable reservations, from the supplier's side. `seasonKey` is required for the reason `periodKey` is on the capacity read. */
export type SupplierReservationsParams = {
  readonly query?: {
    readonly season_key?: string;
    readonly as_of_period?: string;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/supplier/reservations` */
export const supplierReservations: OperationSpec<SupplierReservationsParams, CursorPageSupplierReservationRow> = {
  operationId: "reservations_api_v1_supplier_reservations_get",
  method: "GET",
  path: "/api/v1/supplier/reservations",
  tag: "supplier",
  pathParams: [],
  queryParams: ["season_key", "as_of_period", "limit", "cursor"],
  hasBody: false,
};

/** `POST /api/v1/strategic/tariff-scenario` — Tariff Scenario — reqs/01 §8 criterion 6's scenario: one component moves and nothing else does. */
export type TariffScenarioParams = {
  readonly body: TariffScenarioRequest;
};

/** `POST /api/v1/strategic/tariff-scenario` */
export const tariffScenario: OperationSpec<TariffScenarioParams, TariffScenarioResponse> = {
  operationId: "tariff_scenario_api_v1_strategic_tariff_scenario_post",
  method: "POST",
  path: "/api/v1/strategic/tariff-scenario",
  tag: "strategic",
  pathParams: [],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/runs/{run_id}/transfers/{transfer_id}/explanation` — Transfer Explanation — Why one transfer line: both doors' stock and cover, the floor and what bound it (ADR 6127). **Only what the run recorded.** The basis is the one ``inseason.distribute`` stored beside the line; the positions are the run's own ``inseason_stock_position`` rows; the cap is the run's own move-cap record. A line older than the basis answers ``not_recorded_by_run``. 404 when the line does not exist in the run, or the run is outside the caller's scope. */
export type TransferExplanationParams = {
  readonly path: {
    readonly run_id: string;
    readonly transfer_id: string;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/transfers/{transfer_id}/explanation` */
export const transferExplanation: OperationSpec<TransferExplanationParams, TransferExplanationSummary> = {
  operationId: "transfer_explanation_api_v1_inseason_runs__run_id__transfers__transfer_id__explanation_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/transfers/{transfer_id}/explanation",
  tag: "inseason",
  pathParams: ["run_id", "transfer_id"],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/report/transfer-explanations` — Transfer Explanations Report — Every transfer line's "why" for one run, one flat row per line, one page at a time. The bulk twin of ``GET /inseason/runs/{run_id}/transfers/{transfer_id}/explanation`` (ADR 6129): each row carries every field that read returns for the line at its size, plus the decision and the run's supersession. Ordered as the transfers report is — donor, article, size in run order, recipient, transfer. A fixed number of statements per page, whatever its size. The filters narrow as on ``GET /inseason/transfers``; a value nothing carries is an empty page. 404 when the run does not exist or is outside the caller's scope. */
export type TransferExplanationsReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly purpose?: string | null;
    readonly disposition?: string | null;
    readonly store_key?: string | null;
    readonly article_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/report/transfer-explanations` */
export const transferExplanationsReport: OperationSpec<TransferExplanationsReportParams, CursorPageTransferExplanationReportRow> = {
  operationId: "transfer_explanations_report_api_v1_inseason_runs__run_id__report_transfer_explanations_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/report/transfer-explanations",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["purpose", "disposition", "store_key", "article_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/transfers/reason-codes` — Transfer Reason Vocabulary — The reason codes a planner may record against a transfer disposition, with prose. ``reason_code`` is mandatory on ``POST /inseason/transfers/dispositions``; this is where a caller fills it from. Its own vocabulary rather than the proposal one, because every opposing proposal reason counters an allocation constraint no transfer is bound by (:mod:`planning.transfer.reasons`). Prose resolved against ``Accept-Language`` on ADR 0057's terms. */
export type TransferReasonVocabularyParams = Record<string, never>;

/** `GET /api/v1/inseason/transfers/reason-codes` */
export const transferReasonVocabulary: OperationSpec<TransferReasonVocabularyParams, readonly (TransferReasonOption)[]> = {
  operationId: "transfer_reason_vocabulary_api_v1_inseason_transfers_reason_codes_get",
  method: "GET",
  path: "/api/v1/inseason/transfers/reason-codes",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/report/transfers/by-store` — Transfers By Store Report — One run's transfers per door: pairs out and in, lines, articles, before and after. The transfers report (``…/report/transfers``) grouped by door, in the store: the same decided pairs and the same per-cell *before* and *after*, each touched cell summed once — so a screen and a file built on either read agree. Pending lines count as proposed. ``totals`` covers every door and every touched cell of the run, not only this page, and carries the coherence check ``pairs_balanced`` (pairs out = pairs in). Ordered by ``store_key``, cursor-paged. Five statements whatever the run's size. 404 when the run does not exist or is outside the caller's scope. ``role`` keeps the doors the totals count as donors (a line out) or recipients (a line in), by the very predicates they are counted with, so the items add up to ``donor_stores`` / ``recipient_stores`` (ADR 6193). */
export type TransfersByStoreReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly role?: "donor" | "recipient" | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/report/transfers/by-store` */
export const transfersByStoreReport: OperationSpec<TransfersByStoreReportParams, TransfersByStorePage> = {
  operationId: "transfers_by_store_report_api_v1_inseason_runs__run_id__report_transfers_by_store_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/report/transfers/by-store",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["role", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/report/transfers` — Transfers Report — One run's transfers report, one transfer line per row, one page at a time. Ordered by donor, article, size in run order (``size_run_position``; a size the dimension does not place last, by ``size_key``), recipient and transfer. Both doors' stock before and after the run's decided moves at the line's size. Joined in the store at a fixed number of statements per page, whatever its size (ADR 9018). 404 when the run does not exist or is outside the caller's scope. */
export type TransfersReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/report/transfers` */
export const transfersReport: OperationSpec<TransfersReportParams, CursorPageTransferReportRow> = {
  operationId: "transfers_report_api_v1_inseason_runs__run_id__report_transfers_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/report/transfers",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["limit", "cursor"],
  hasBody: false,
};

/** `PATCH /api/v1/feedback/{code}` — Triage Report — Move a report's status, relabel its kind, and/or write the note its author sees. Records who and when on the report, one history row and the audit row in the same transaction. ``Idempotency-Key`` is required. 404 for a code no report has. The arrow must be in ADR 1020's state machine (422 ``platform.feedback.transition_refused`` with ``allowed``); ``approved_for_development`` is reachable only through the approval route. ``ready`` needs the rubric satisfied (422 ``platform.feedback.incomplete``). The answer is the triage state only (:class:`TriageOutcome`): it is kept in the idempotency ledger, so it carries no text. */
export type TriageReportParams = {
  readonly path: {
    readonly code: string;
  };
  readonly body: TriageRequest;
};

/** `PATCH /api/v1/feedback/{code}` */
export const triageReport: OperationSpec<TriageReportParams, TriageOutcome> = {
  operationId: "triage_report_api_v1_feedback__code__patch",
  method: "PATCH",
  path: "/api/v1/feedback/{code}",
  tag: "feedback",
  pathParams: ["code"],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/uncovered/by-store-article` — Uncovered By Store Article Report — A run's unmet need, one row per store x article, with the totals (ADR 6207). The uncovered report's ``unserved_need_only`` cells added up per store x article: the pairs not sent, the cells and the cells per reason, «Perché» › «Non inviate»'s list. Ordered by ``order``; cursor-paged at the store x article grain, a fixed number of statements per page (ADR 9018). The totals are over every row the filters keep. Scope-rewritten on the run's market. 404 when the run does not exist or is outside the caller's scope. */
export type UncoveredByStoreArticleReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly order?: "unmet" | "store" | "article";
    readonly store_key?: readonly (string)[] | null;
    readonly article_key?: readonly (string)[] | null;
    readonly uncovered_reason?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/uncovered/by-store-article` */
export const uncoveredByStoreArticleReport: OperationSpec<UncoveredByStoreArticleReportParams, UncoveredPairsPage> = {
  operationId: "uncovered_by_store_article_report_api_v1_inseason_runs__run_id__report_replenishment_uncovered_by_store_article_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/report/replenishment/uncovered/by-store-article",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["order", "store_key", "article_key", "uncovered_reason", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/uncovered` — Uncovered Report — The cells one run recorded and wrote no proposal line for, with why (ADR 6057). The companion of the replenishment report: that one is a row per line, this one a row per recorded cell without a line — the need the run did not cover and the reason it stored. Ordered by store, article, then size in run order. A fixed number of statements per page (ADR 9018). A run written before ADR 6057 recorded no reason and answers an empty page. 404 when the run does not exist or is outside the caller's scope. */
export type UncoveredReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly uncovered_reason?: string | null;
    readonly unserved_need_only?: boolean;
    readonly out_of_stock_only?: boolean;
    readonly store_key?: readonly (string)[] | null;
    readonly article_key?: readonly (string)[] | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/uncovered` */
export const uncoveredReport: OperationSpec<UncoveredReportParams, CursorPageUncoveredReportRow> = {
  operationId: "uncovered_report_api_v1_inseason_runs__run_id__report_replenishment_uncovered_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/report/replenishment/uncovered",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["uncovered_reason", "unserved_need_only", "out_of_stock_only", "store_key", "article_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/unforecast` — Unforecast Report — The ranged sizes one run had no forecast for, named and not targeted (ADR 6182). The companion of the uncovered report: that one is a row per cell the run read and wrote no line for; this one is a row per ranged size the run could not read at all, because the forecast has none — so it has no position, target or need, and the pull's arithmetic is unchanged by it. Ordered by store, article, then size in run order. A fixed number of statements per page (ADR 9018). A run written before ADR 6182 recorded none and answers an empty page. 404 when the run does not exist or is outside the caller's scope. */
export type UnforecastReportParams = {
  readonly path: {
    readonly run_id: string;
  };
  readonly query?: {
    readonly reason?: string | null;
    readonly store_key?: string | null;
    readonly article_key?: string | null;
    readonly limit?: number | null;
    readonly cursor?: string | null;
  };
};

/** `GET /api/v1/inseason/runs/{run_id}/report/replenishment/unforecast` */
export const unforecastReport: OperationSpec<UnforecastReportParams, CursorPageUnforecastSizeRow> = {
  operationId: "unforecast_report_api_v1_inseason_runs__run_id__report_replenishment_unforecast_get",
  method: "GET",
  path: "/api/v1/inseason/runs/{run_id}/report/replenishment/unforecast",
  tag: "inseason",
  pathParams: ["run_id"],
  queryParams: ["reason", "store_key", "article_key", "limit", "cursor"],
  hasBody: false,
};

/** `GET /api/v1/inseason/units-sent` — Units Sent Report — Each store's weekly units sent over the season to date, per market (bata-reqs ADR 9000). Per market: the spread of units sent per store-week (``p50``, ``p90``, ``max`` over the store-weeks that sent anything), each source's own spread, each week's total, one row per sending store (weeks with sends, ``p50``, ``p90``, ``max``, total) and every store of the market that sent nothing. ``basis`` is ``proposed_lines``. A market with no landed season containing ``as_of`` carries ``refusal: season_not_landed``. 404 ``units_sent_unavailable`` when no source is installed. */
export type UnitsSentReportParams = {
  readonly query?: {
    readonly as_of?: string | null;
    readonly country_key?: string | null;
  };
};

/** `GET /api/v1/inseason/units-sent` */
export const unitsSentReport: OperationSpec<UnitsSentReportParams, UnitsSentReportModel> = {
  operationId: "units_sent_report_api_v1_inseason_units_sent_get",
  method: "GET",
  path: "/api/v1/inseason/units-sent",
  tag: "inseason",
  pathParams: [],
  queryParams: ["as_of", "country_key"],
  hasBody: false,
};

/** `GET /version` — Version — Version, image digest, commit SHA and build timestamp (G7.5). */
export type VersionParams = Record<string, never>;

/** `GET /version` */
export const version: OperationSpec<VersionParams, VersionResponse> = {
  operationId: "version_version_get",
  method: "GET",
  path: "/version",
  tag: "platform",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `GET /api/v1/postseason/vocabulary` — The vocabularies this chapter publishes — Scorecard components, the availability states and which of them enter the recovery likelihood, and the accuracy metrics excluded by design. Published so a client enumerates rather than hard-codes them. */
export type VocabularyParams = Record<string, never>;

/** `GET /api/v1/postseason/vocabulary` */
export const vocabulary: OperationSpec<VocabularyParams, ScorecardComponentsResponse> = {
  operationId: "vocabulary_api_v1_postseason_vocabulary_get",
  method: "GET",
  path: "/api/v1/postseason/vocabulary",
  tag: "postseason",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/registry/changes/{change_id}/withdrawals` — Withdraw Change — The author withdraws their own pending set (W2-1, ADR 9012). Authorised on the proposal route's grant; anybody but the author is refused (``only_the_author_withdraws`` — closing somebody else's proposal is a rejection and is recorded as one). The set then reads ``withdrawn``. */
export type WithdrawChangeParams = {
  readonly path: {
    readonly change_id: string;
  };
  readonly body: ClosureRequest;
};

/** `POST /api/v1/registry/changes/{change_id}/withdrawals` */
export const withdrawChange: OperationSpec<WithdrawChangeParams, ChangeReceipt> = {
  operationId: "withdraw_change_api_v1_registry_changes__change_id__withdrawals_post",
  method: "POST",
  path: "/api/v1/registry/changes/{change_id}/withdrawals",
  tag: "registry",
  pathParams: ["change_id"],
  queryParams: [],
  hasBody: true,
};

/** `GET /api/v1/inseason/write-back/summary` — Write Back Summary — Counts of the write-back log by state, and how many need attention (ADR 6170). The summary of ``GET /inseason/write-back``: the same table, the same read grant and the same scope rewrite, grouped in the store (one statement). It replaces a walk of the whole log to count states. ``needs_attention`` is a command the target rejected or could not account for (``unknown``), or one whose deadline has passed. Not paged: its size is the number of lifecycle states. 404 when no source is installed. */
export type WriteBackSummaryParams = Record<string, never>;

/** `GET /api/v1/inseason/write-back/summary` */
export const writeBackSummary: OperationSpec<WriteBackSummaryParams, WriteBackSummary> = {
  operationId: "write_back_summary_api_v1_inseason_write_back_summary_get",
  method: "GET",
  path: "/api/v1/inseason/write-back/summary",
  tag: "inseason",
  pathParams: [],
  queryParams: [],
  hasBody: false,
};

/** `POST /api/v1/feedback/{code}/messages` — Write On Thread — Write on an open report's thread; with ``request_info``, ask the author (``needs_info``). The message, the move, its history row and the audit row commit together. The answer carries no text. */
export type WriteOnThreadParams = {
  readonly path: {
    readonly code: string;
  };
  readonly body: TeamMessage;
};

/** `POST /api/v1/feedback/{code}/messages` */
export const writeOnThread: OperationSpec<WriteOnThreadParams, MessageOutcome> = {
  operationId: "write_on_thread_api_v1_feedback__code__messages_post",
  method: "POST",
  path: "/api/v1/feedback/{code}/messages",
  tag: "feedback",
  pathParams: ["code"],
  queryParams: [],
  hasBody: true,
};
